// src/components/message/Message.tsx
import { memo as memo7, useMemo as useMemo8, useRef as useRef9, useState as useState13 } from "react";
import toast3 from "react-hot-toast";
import { toPng } from "html-to-image";
import { FILE_MIME_TYPE_MAP as FILE_MIME_TYPE_MAP2 } from "@bty/global-types/file";
import { cn as cn29 } from "@bty/util";

// src/components/avatar/Avatar.tsx
import { memo } from "react";
import { cn } from "@bty/util";
import { jsx, jsxs } from "react/jsx-runtime";
var Avatar = memo((props) => {
  const {
    size = 40,
    color,
    icon,
    iconSize = 16,
    className,
    name,
    avatar: _avatar,
    shape = "circle"
  } = props;
  const style = {
    width: size,
    height: size,
    backgroundColor: color || "transparent",
    fontSize: iconSize
  };
  const isImage = typeof icon === "string" && (icon == null ? void 0 : icon.startsWith("http"));
  const cls = cn("ui-flex-center ui-text-yeah", {
    "ui-rounded-full": shape === "circle",
    "ui-rounded-[6px]": shape === "square"
  });
  return /* @__PURE__ */ jsxs("div", { className: cn("ui-flex ui-items-center ui-justify-start", className), children: [
    isImage ? /* @__PURE__ */ jsx(
      "img",
      {
        className: "ui-rounded-full ui-object-cover ui-flex-center",
        src: icon,
        style,
        alt: "avatar"
      }
    ) : /* @__PURE__ */ jsx("div", { style, className: cls, children: icon }),
    name && /* @__PURE__ */ jsx("div", { className: "ui-mx-[8px] ui-text-[14px] ui-text-yeah-light", children: name })
  ] });
});

// src/assets/svg/regenerate.svg
import * as React from "react";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var SvgRegenerate = (props) => /* @__PURE__ */ jsxs2("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className: "kx6mem47n__design-iconfont", width: 128, height: 128, ...props, children: [
  /* @__PURE__ */ jsx2("defs", { children: /* @__PURE__ */ jsx2("clipPath", { id: "kx6mem47n__ul728u14t__sfs4v8urja", children: /* @__PURE__ */ jsx2("rect", { width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsx2("g", { clipPath: "url(#kx6mem47n__ul728u14t__sfs4v8urja)", children: /* @__PURE__ */ jsx2("path", { d: "M4.79712220703125,7.74248703125L4.79712220703125,7.74248703125L2.29712220703125,8.74248703125C2.10012720703125,8.82128703125,1.87989520703125,8.81859703125,1.68487720703125,8.735027031249999C1.48985920703125,8.651447031250001,1.33603020703125,8.49381703125,1.25723090703125,8.29681703125C1.21943230703125,8.20232703125,1.20001220703125,8.101477031249999,1.20001220703125,7.99970703125Q1.20001226663595,5.18305703125,3.19168220703125,3.19137703125Q5.18336220703125,1.199706614017,8.00001220703125,1.19970703125Q10.81641220703125,1.19970613718,12.80801220703125,3.19101703125L12.80801220703125,3.19101703125C12.95841220703125,3.34140703125,13.04261220703125,3.54489703125,13.04261220703125,3.75706703125C13.04261220703125,3.96923703125,12.95841220703125,4.17271703125,12.80831220703125,4.32274703125C12.66771220703125,4.463377031249999,12.47971220703125,4.5465870312500005,12.28111220703125,4.55613703125C12.26831220703125,4.55675703125,12.25551220703125,4.55706703125,12.24261220703125,4.55706703125C12.03051220703125,4.55706703125,11.82701220703125,4.472777031250001,11.67701220703125,4.32274703125Q10.15392220703125,2.79970703125,8.00001220703125,2.79970703125Q5.84610220703125,2.79970703125,4.32306220703125,4.32274703125Q3.25730220703125,5.38850703125,2.9373122070312503,6.76315703125L4.20219220703125,6.25720703125L4.20219220703125,6.25720703125C4.29423220703125,6.22039703125,4.39151220703125,6.20101703125,4.48987220703125,6.19976703125L4.50001220703125,6.19970703125C4.60835220703125,6.19970703125,4.71557220703125,6.22171703125,4.81515220703125,6.26438703125C5.01016220703125,6.34796703125,5.163992207031249,6.50559703125,5.24279220703125,6.70259703125C5.27932220703125,6.79392703125,5.29870220703125,6.89120703125,5.29995220703125,6.98956703125L5.30001220703125,6.99970703125C5.30001220703125,7.10804703125,5.27800220703125,7.21525703125,5.23533220703125,7.31483703125C5.15175220703125,7.50985703125,4.99412220703125,7.66368703125,4.79712220703125,7.74248703125ZM11.20291220703125,8.256927031250001L11.20291220703125,8.256927031250001L13.70291220703125,7.25692703125C13.89991220703125,7.17812703125,14.12011220703125,7.18080703125,14.31511220703125,7.26438703125C14.51021220703125,7.34796703125,14.66401220703125,7.50559703125,14.74281220703125,7.70259703125C14.78061220703125,7.79708703125,14.80001220703125,7.89792703125,14.80001220703125,7.99970703125Q14.80001220703125,10.81635703125,12.80831220703125,12.80800703125Q10.81666220703125,14.79970703125,8.00001220703125,14.79970703125Q5.18336220703125,14.79970703125,3.19168220703125,12.80800703125C3.04165220703125,12.65800703125,2.9573722070312503,12.45450703125,2.9573722070312503,12.24230703125C2.9573722070312503,12.03020703125,3.04165220703125,11.82670703125,3.19168220703125,11.67670703125C3.34171220703125,11.52660703125,3.54520220703125,11.44230703125,3.75737220703125,11.44230703125C3.96954220703125,11.44230703125,4.17303220703125,11.52660703125,4.32305220703125,11.67670703125L4.32305220703125,11.67670703125Q5.84663220703125,13.19970703125,8.00001220703125,13.19970703125Q10.15392220703125,13.19970703125,11.67701220703125,11.67670703125Q12.74271220703125,10.61090703125,13.06271220703125,9.23625703125L11.79791220703125,9.74219703125L11.79791220703125,9.74219703125C11.70581220703125,9.77901703125,11.60851220703125,9.79839703125,11.51011220703125,9.79964703125L11.50001220703125,9.79970703125C11.39171220703125,9.79970703125,11.28441220703125,9.77769703125,11.18488220703125,9.73501703125C10.98986220703125,9.65144703125,10.83603220703125,9.49381703125,10.75723220703125,9.29681703125C10.72070220703125,9.20548703125,10.70132220703125,9.10819703125,10.70007220703125,9.00984703125L10.70001220703125,8.99970703125C10.70001220703125,8.891367031249999,10.72202220703125,8.78414703125,10.76469220703125,8.684567031250001C10.84827220703125,8.489557031250001,11.00590220703125,8.33572703125,11.20291220703125,8.256927031250001Z", fillRule: "evenodd", fill: "currentColor" }) })
] });

// src/assets/svg/copy2.svg
import * as React2 from "react";
import { jsx as jsx3 } from "react/jsx-runtime";
var SvgCopy2 = (props) => /* @__PURE__ */ jsx3("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 14, height: 14, viewBox: "0 0 14 14", ...props, children: /* @__PURE__ */ jsx3("g", { children: /* @__PURE__ */ jsx3("g", { children: /* @__PURE__ */ jsx3("g", { children: /* @__PURE__ */ jsx3("path", { d: "M10.69419296875,3.306099952316284Q10.63084296875,2.312179952316284,9.90948296875,1.590811952316284Q9.11867296875,0.7999999523162842,8.00029296875,0.7999999523162842L3.50029296875,0.7999999523162842Q2.38191296875,0.7999999523162842,1.5911049687499998,1.590811952316284Q0.80029296875,2.381619952316284,0.80029296875,3.4999999523162844L0.80029296875,7.999999952316284Q0.80029296875,9.118379952316284,1.5911049687499998,9.909189952316284Q2.31247296875,10.630549952316285,3.30639296875,10.693899952316285Q3.36974296875,11.687799952316285,4.0911029687500005,12.409199952316284Q4.88191296875,13.199999952316285,6.00029296875,13.199999952316285L10.50029296875,13.199999952316285Q11.61869296875,13.199999952316285,12.40949296875,12.409199952316284Q13.20029296875,11.618399952316285,13.20029296875,10.499999952316283L13.20029296875,5.999999952316284Q13.20029296875,4.881619952316284,12.40949296875,4.090809952316285Q11.68809296875,3.369449952316284,10.69419296875,3.306099952316284ZM9.28639296875,3.299999952316284Q9.22754296875,2.888779952316284,8.91953296875,2.580759952316284Q8.53877296875,2.199999952316284,8.00029296875,2.199999952316284L3.50029296875,2.199999952316284Q2.96181296875,2.199999952316284,2.58105296875,2.580759952316284Q2.20029296875,2.961519952316284,2.20029296875,3.4999999523162844L2.20029296875,7.999999952316284Q2.20029296875,8.538479952316283,2.58105296875,8.919239952316284Q2.88907296875,9.227249952316285,3.30029296875,9.286099952316285L3.30029296875,5.999999952316284Q3.30029296875,4.881619952316284,4.0911029687500005,4.090809952316285Q4.88191296875,3.299999952316284,6.00029296875,3.299999952316284L9.28639296875,3.299999952316284ZM4.70029296875,10.499999952316283Q4.70029296875,11.038499952316284,5.08105296875,11.419199952316283Q5.46181296875,11.799999952316284,6.00029296875,11.799999952316284L10.50029296875,11.799999952316284Q11.03879296875,11.799999952316284,11.41949296875,11.419199952316283Q11.80029296875,11.038499952316284,11.80029296875,10.499999952316283L11.80029296875,5.999999952316284Q11.80029296875,5.4615199523162845,11.41949296875,5.080759952316284Q11.03879296875,4.6999999523162845,10.50029296875,4.6999999523162845L6.00029296875,4.6999999523162845Q5.46181296875,4.6999999523162845,5.08105296875,5.080759952316284Q4.70029296875,5.4615199523162845,4.70029296875,5.999999952316284L4.70029296875,10.499999952316283Z", fillRule: "evenodd", fill: "currentColor", fillOpacity: 1 }) }) }) }) });

// src/assets/svg/unlike.svg
import * as React3 from "react";
import { jsx as jsx4 } from "react/jsx-runtime";
var SvgUnlike = (props) => /* @__PURE__ */ jsx4("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 11.313069343566895, height: 10.5, viewBox: "0 0 11.313069343566895 10.5", ...props, children: /* @__PURE__ */ jsx4("g", { transform: "matrix(1,0,0,-1,0,21)", children: /* @__PURE__ */ jsx4("path", { d: "M7.09303,13.41667L9.55587,13.41667Q10.4213,13.41667,10.9466,14.10443Q11.4719,14.79219,11.2442,15.62712L10.1306,19.71045Q9.77888,21,8.44224,21L1.75,21Q1.02513,21,0.512563,20.48744Q0,19.97487,0,19.25L0,15.16667Q0,14.441790000000001,0.512563,13.92923Q1.02513,13.41667,1.75,13.41667L2.6009,13.41667Q2.90462,13.41667,3.07879,13.16785L4.32597,11.38617Q4.94628,10.5,6.02799,10.5Q6.79256,10.5,7.23496,11.123564Q7.67737,11.74713,7.42479,12.46877L7.09303,13.41667ZM5.9683,14.21464Q6.22987,14.58333,6.68193,14.58333L9.55587,14.58333Q9.84435,14.58333,10.0195,14.81259Q10.1946,15.04184,10.1187,15.32015L9.00502,19.403489999999998Q8.88779,19.83333,8.44224,19.83333L3.5,19.83333L3.5,14.34895Q3.80484,14.16506,4.03456,13.83689L5.28174,12.05521Q5.55372,11.66667,6.02799,11.66667Q6.18981,11.66667,6.28345,11.79864Q6.37709,11.93062,6.32363,12.08336L5.85606,13.41928Q5.70672,13.84595,5.9683,14.21464ZM2.33333,14.58333L1.75,14.58333Q1.16667,14.58333,1.16667,15.16667L1.16667,19.25Q1.16667,19.83333,1.75,19.83333L2.33333,19.83333L2.33333,14.58333Z", fillRule: "evenodd", fill: "currentColor" }) }) });

// src/base/components/Tools/CopilotTools.tsx
import { cn as cn2 } from "@bty/util";
import { jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
function CopilotToolsBar({ list = [] }) {
  return /* @__PURE__ */ jsx5("div", { className: "ui-px-[16px] ui-mb-[14px] ui-py-[8px] ui-bg-white ui-rounded-[8px] ui-box-border", children: list.map((v, i) => {
    return /* @__PURE__ */ jsxs3(
      "div",
      {
        className: cn2("ui-flex", {
          "ui-mb-[16px]": i !== list.length - 1,
          "ui-mb-[6px]": i === list.length - 1,
          "ui-mt-[6px]": i === 0
        }),
        children: [
          /* @__PURE__ */ jsx5(
            "img",
            {
              className: "ui-w-[12px] ui-h-[12px]",
              src: "https://resource.bantouyan.com/battleyeah-ai/chat-mobile/success.png",
              alt: "success"
            }
          ),
          /* @__PURE__ */ jsxs3("div", { className: "ui-flex-1  ui-flex ui-ml-[12px] ", children: [
            /* @__PURE__ */ jsxs3("h3", { className: "ui-font-bold ui-whitespace-nowrap", children: [
              v.title,
              "\uFF1A"
            ] }),
            /* @__PURE__ */ jsx5("div", { className: "ui-leading-[1]", children: v.desc })
          ] })
        ]
      },
      v.title
    );
  }) });
}

// src/base/components/Tools/Tools.tsx
import { useMemo, useState } from "react";
import { cn as cn4 } from "@bty/util";

// src/assets/svg/warning-red.svg
import * as React4 from "react";
import { jsx as jsx6 } from "react/jsx-runtime";
var SvgWarningRed = (props) => /* @__PURE__ */ jsx6("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 2.6666667461395264, height: 10.665328979492188, viewBox: "0 0 2.6666667461395264 10.665328979492188", ...props, children: /* @__PURE__ */ jsx6("g", { children: /* @__PURE__ */ jsx6("path", { d: "M2.66667,9.33216C2.66667,10.0684,2.06971,10.6653,1.33333,10.6653C0.596954,10.6653,0,10.0684,0,9.33216C0,8.59588,0.596954,7.999,1.33333,7.999C2.06971,7.999,2.66667,8.59588,2.66667,9.33216ZM0.333333,5.66596L0.333333,0.999875C0.333333,0.447659,0.781049,0,1.33333,0C1.88562,0,2.33333,0.447659,2.33333,0.999875L2.33333,5.66596C2.33333,6.21817,1.88562,6.66583,1.33333,6.66583C0.781049,6.66583,0.333333,6.21817,0.333333,5.66596Z", fill: "#FFFFFF", fillOpacity: 1 }) }) });

// src/assets/svg/tool-loading.svg
import * as React5 from "react";
import { jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
var SvgToolLoading = (props) => /* @__PURE__ */ jsxs4("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 20, height: 20, viewBox: "0 0 20 20", ...props, children: [
  /* @__PURE__ */ jsx7("defs", { children: /* @__PURE__ */ jsxs4("linearGradient", { x1: 0.1374782919883728, y1: 0.0771213099360466, x2: 0.5, y2: 1, id: "master_svg0_19391_187846", children: [
    /* @__PURE__ */ jsx7("stop", { offset: "0%", stopColor: "#515AFF", stopOpacity: 1 }),
    /* @__PURE__ */ jsx7("stop", { offset: "100%", stopColor: "#7B61FF", stopOpacity: 1 })
  ] }) }),
  /* @__PURE__ */ jsxs4("g", { children: [
    /* @__PURE__ */ jsx7("g", {}),
    /* @__PURE__ */ jsx7("g", { children: /* @__PURE__ */ jsx7("path", { d: "M10,0C15.52285,0,20,4.47715,20,10L20,10C20,10.5533,19.552300000000002,11.001,19,11.001C18.44771,11.001,18,10.5533,18,10.001L18,10.001C18,5.60931,14.462869999999999,2.04476,10.08267,2.00042C10.05486,2.00014,10.02822,2.00096,10.00042,2.00098C10.00028,2.00098,10.00014,2.00098,10,2.00098C9.447715,2.00098,9,1.55326,9,1.00098C9,0.448692,9.447715,0.000976562,10,0C9.999351,0.00000448577,9.997937,1.87635e-7,9.998586,9.78685e-8C9.999057,3.26232e-8,9.999529,0,10,0Z", fillRule: "evenodd", fill: "url(#master_svg0_19391_187846)", fillOpacity: 1 }) })
  ] })
] });

// src/assets/svg/arrow-down.svg
import * as React6 from "react";
import { jsx as jsx8 } from "react/jsx-runtime";
var SvgArrowDown = (props) => /* @__PURE__ */ jsx8("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 6.9066667556762695, height: 4, viewBox: "0 0 6.9066667556762695 4", ...props, children: /* @__PURE__ */ jsx8("g", { children: /* @__PURE__ */ jsx8("path", { d: "M0.211991,0.203002C0.468949,-0.043061,0.871047,-0.0654304,1.15439,0.135894L1.23557,0.203002L3.45278,2.32641L5.67109,0.203002C5.92805,-0.043061,6.33015,-0.0654304,6.6135,0.135894L6.69468,0.203002C6.95163,0.449065,6.97499,0.834114,6.76476,1.10545L6.69468,1.18318L3.96512,3.797C3.70817,4.04306,3.30607,4.06543,3.02272,3.86411L2.94154,3.797L0.211991,1.18318C-0.0706636,0.912513,-0.0706636,0.473671,0.211991,0.203002Z", fill: "currentColor", fillOpacity: 1 }) }) });

// src/base/components/AppLogo.tsx
import { rgba } from "polished";
import { cn as cn3 } from "@bty/util";
import { jsx as jsx9 } from "react/jsx-runtime";
var IconFont = ({ name, ...rest }) => {
  return /* @__PURE__ */ jsx9("svg", { ...rest, className: `icon ${rest.className ?? ""}`, children: /* @__PURE__ */ jsx9("use", { xlinkHref: `#icon-${name}` }) });
};
var AppLogo = (props) => {
  const {
    value,
    color = "#fff",
    size,
    type,
    fillSize = 25,
    className,
    onClick,
    defaultImageUrl = "https://resource.bantouyan.com/betteryeah/agent/avatars/avatar-1.png"
  } = props;
  const imageUrl = type === "image" || (value == null ? void 0 : value.startsWith("http")) ? value : defaultImageUrl;
  const isImage = type === "image" || (value == null ? void 0 : value.startsWith("http"));
  const ComponentMap = {
    emoji: /* @__PURE__ */ jsx9("span", { style: { fontSize: fillSize }, children: value }),
    image: /* @__PURE__ */ jsx9(
      "img",
      {
        src: imageUrl,
        alt: "",
        className: cn3("ui-w-full ui-h-full ui-object-cover", {
          "ui-rounded-full": !isImage
        })
      }
    ),
    icon: /* @__PURE__ */ jsx9(
      IconFont,
      {
        className: "ui-block ui-w-[1em] ui-h-[1em] ui-fill-current",
        style: { fontSize: fillSize, color },
        name: value
      }
    )
  };
  return /* @__PURE__ */ jsx9(
    "div",
    {
      onClick,
      className: cn3(
        "ui-flex ui-items-center ui-justify-center ui-shrink-0 ui-rounded-[8px] ui-overflow-hidden",
        className
      ),
      style: {
        background: isImage ? "transparent" : type === "emoji" ? color : rgba(color, 0.12),
        width: size ?? 48,
        height: size ?? 48
      },
      children: isImage ? ComponentMap.image : ComponentMap[type]
    }
  );
};

// src/utils/isSearch.ts
function isSearch(function_code) {
  return function_code === "search_by_google" || function_code === "search_by_bing";
}

// src/base/components/Tools/Tools.tsx
import { jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
function ToolBar({
  status,
  icon,
  color,
  title,
  onClick,
  data,
  type = "icon",
  style = {},
  children
}) {
  const [showChildren, setShowChildren] = useState(false);
  const logoSize = useMemo(() => {
    return status === "loading" ? 14 : 16;
  }, [status]);
  const isSearch2 = useMemo(() => {
    return isSearch(data == null ? void 0 : data.function_code);
  }, [data == null ? void 0 : data.function_code]);
  const handleSearchPluginClick = () => {
    if (status === "loading")
      return;
    if (status === "error") {
      onClick == null ? void 0 : onClick();
      return;
    }
    setShowChildren(!showChildren);
  };
  return /* @__PURE__ */ jsxs5(
    "div",
    {
      style,
      className: "ui-relative ui-max-w-full ui-px-[7px] ui-py-[7px] ui-bg-tools-bg ui-rounded-[12px] ui-box-border ui-w-fit ui-cursor-pointer ui-min-w-[120px]",
      onClick: isSearch2 ? handleSearchPluginClick : onClick,
      children: [
        /* @__PURE__ */ jsxs5("div", { className: "ui-flex ui-text-[#8D8D99] ui-items-center", children: [
          status === "error" && /* @__PURE__ */ jsx10("div", { className: "ui-inline-flex ui-items-center ui-justify-center ui-w-[14px] ui-h-[14px] ui-rounded-full ui-bg-[#FF5219]", children: /* @__PURE__ */ jsx10(SvgWarningRed, { className: "ui-scale-75" }) }),
          status !== "error" && /* @__PURE__ */ jsxs5(
            "div",
            {
              className: cn4(
                "ui-relative ui-inline-flex ui-items-center ui-justify-center",
                {
                  "!ui-ml-[5px]": status === "loading"
                }
              ),
              children: [
                status === "loading" && /* @__PURE__ */ jsx10("div", { className: "ui-absolute ui-w-[20px] ui-h-[20px] ui-rounded-full ui-animate-spin", children: /* @__PURE__ */ jsx10(SvgToolLoading, {}) }),
                /* @__PURE__ */ jsx10(
                  AppLogo,
                  {
                    type,
                    value: icon,
                    className: "!ui-rounded-full",
                    color,
                    fillSize: 14,
                    size: logoSize
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ jsx10("p", { className: "ui-m-0 ui-ml-[4px] ui-text-[12px]/[12px] ui-mr-[5px]", children: title + (isSearch2 && !showChildren ? ":" : "") }),
          isSearch2 && status === "error" && /* @__PURE__ */ jsx10("div", { className: "ui-text-[12px]/[12px] ui-ml-[3px]", children: "\u641C\u7D22\u5931\u8D25" }),
          isSearch2 && status === "loading" && /* @__PURE__ */ jsx10("div", { className: "ui-text-[12px]/[12px] ui-ml-[3px]", children: "\u6B63\u5728\u641C\u7D22" }),
          isSearch2 && status === "success" && !showChildren && /* @__PURE__ */ jsx10("div", { className: "ui-text-[12px]/[12px] ui-ml-[3px]", children: "5\u4E2A\u641C\u7D22\u6765\u6E90" }),
          isSearch2 && status === "success" && /* @__PURE__ */ jsx10(
            SvgArrowDown,
            {
              className: cn4(
                "ui-ml-[8px] !ui-w-[7px] !ui-h-[4px] ui-fill-[#8D8D99]",
                showChildren ? "ui-rotate-180 ui-absolute ui-top-[12px] ui-right-[12px]" : ""
              )
            }
          )
        ] }),
        isSearch2 ? showChildren ? children : null : children
      ]
    }
  );
}

// src/base/components/Tools/SearchToolContent.tsx
import { useRef, useState as useState3, useEffect } from "react";
import { debounce, isNil } from "lodash-es";

// src/assets/svg/right.svg
import * as React7 from "react";
import { jsx as jsx11 } from "react/jsx-runtime";
var SvgRight = (props) => /* @__PURE__ */ jsx11("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 5.333333700863558, height: 9.333334088307351, viewBox: "0 0 5.333333700863558 9.333334088307351", ...props, children: /* @__PURE__ */ jsx11("g", { transform: "matrix(2.2348338291067193e-8,1,-1,-2.2348338291067193e-8,5.333333492279052,-5.33333337308791)", children: /* @__PURE__ */ jsx11("path", { d: "M5.619807492279053,0.2706691191911405C5.967048492279053,-0.057414580808859486,6.5104234922790525,-0.08724048080885949,6.893323492279053,0.1811921191911405L7.003023492279053,0.2706691191911405L9.999253492279053,3.1018801191911405L12.996973492279054,0.2706691191911405C13.344213492279053,-0.057414580808859486,13.887593492279052,-0.08724048080885949,14.270493492279053,0.1811921191911405L14.380193492279053,0.2706691191911405C14.727433492279053,0.5987541191911405,14.759003492279053,1.1121501191911405,14.474893492279053,1.4739301191911405L14.380193492279053,1.5775801191911405L10.691613492279053,5.062660119191141C10.344363492279053,5.39075011919114,9.800993492279053,5.42057011919114,9.418093492279052,5.152140119191141L9.308393492279052,5.062660119191141L5.619807492279053,1.5775801191911405C5.237842192279053,1.2166801191911405,5.237842192279053,0.6315621191911405,5.619807492279053,0.2706691191911405Z", fillOpacity: 1 }) }) });

// src/assets/svg/left.svg
import * as React8 from "react";
import { jsx as jsx12 } from "react/jsx-runtime";
var SvgLeft = (props) => /* @__PURE__ */ jsx12("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 5.333333700863559, height: 9.333334088307351, viewBox: "0 0 5.333333700863559 9.333334088307351", ...props, children: /* @__PURE__ */ jsx12("g", { transform: "matrix(2.2348338291067193e-8,1,1,-2.2348338291067193e-8,-1.191911405129531e-7,1.1919114317667703e-7)", children: /* @__PURE__ */ jsx12("path", { d: "M0.286474,0.2706691191911405C0.633715,-0.057414580808859486,1.17709,-0.08724048080885949,1.55999,0.1811921191911405L1.66969,0.2706691191911405L4.66592,3.1018801191911405L7.66364,0.2706691191911405C8.01088,-0.057414580808859486,8.55426,-0.08724048080885949,8.93716,0.1811921191911405L9.04686,0.2706691191911405C9.3941,0.5987541191911405,9.42567,1.1121501191911405,9.14156,1.4739301191911405L9.04686,1.5775801191911405L5.35828,5.062660119191141C5.01103,5.39075011919114,4.46766,5.42057011919114,4.08476,5.152140119191141L3.97506,5.062660119191141L0.286474,1.5775801191911405C-0.0954913,1.2166801191911405,-0.0954913,0.6315621191911405,0.286474,0.2706691191911405Z", fillOpacity: 1 }) }) });

// src/base/components/Tools/BrandImage.tsx
import { useState as useState2 } from "react";
import { cn as cn5 } from "@bty/util";

// src/assets/svg/link.svg
import * as React9 from "react";
import { jsx as jsx13, jsxs as jsxs6 } from "react/jsx-runtime";
var SvgLink = (props) => /* @__PURE__ */ jsxs6("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 24, height: 24, viewBox: "0 0 24 24", ...props, children: [
  /* @__PURE__ */ jsx13("defs", { children: /* @__PURE__ */ jsx13("clipPath", { id: "master_svg0_2358_01947", children: /* @__PURE__ */ jsx13("rect", { x: 0, y: 0, width: 24, height: 24, rx: 0 }) }) }),
  /* @__PURE__ */ jsx13("g", { clipPath: "url(#master_svg0_2358_01947)", children: /* @__PURE__ */ jsx13("g", { children: /* @__PURE__ */ jsx13("path", { d: "M17.656045696640014,10.58541034729004L15.534045696640014,12.70742034729004C15.143545696640015,13.09794034729004,15.143545696640015,13.731090347290039,15.534045696640014,14.12159034729004C15.924545696640015,14.512190347290039,16.557745696640012,14.512190347290039,16.948245696640015,14.12159034729004L19.070245696640015,11.999620347290039C21.022845696640015,10.047000347290039,21.022845696640015,6.881180347290039,19.070245696640015,4.9285603472900394C17.117645696640015,2.975935347290039,13.951845696640016,2.975935347290039,11.999175696640014,4.9285603472900394L9.877165696640015,7.050570347290039C9.486645696640014,7.441090347290039,9.486645696640014,8.07425034729004,9.877165696640015,8.464780347290038C10.267695696640015,8.85530034729004,10.900855696640015,8.85530034729004,11.291385696640015,8.464780347290038L13.413395696640015,6.342770347290039Q14.292045696640015,5.464090347290039,15.534745696640014,5.464090347290039Q16.777345696640015,5.464090347290039,17.656045696640014,6.342770347290039Q18.534745696640016,7.221450347290039,18.534745696640016,8.464090347290039Q18.534745696640016,9.706730347290039,17.656045696640014,10.58541034729004ZM9.171945696640016,13.413990347290039C8.781425696640014,13.80449034729004,8.781425696640014,14.437690347290038,9.171945696640016,14.82819034729004C9.562475696640014,15.218690347290039,10.195635696640014,15.218690347290039,10.586165696640014,14.82819034729004L14.828845696640014,10.58556034729004C15.219345696640014,10.195040347290039,15.219345696640014,9.56187034729004,14.828845696640014,9.171350347290039C14.438245696640015,8.780820347290039,13.805145696640015,8.780820347290039,13.414585696640014,9.171350347290039L9.171945696640016,13.413990347290039ZM4.928115696640015,11.999620347290039L7.048745696640015,9.878990347290038C7.439265696640015,9.48847034729004,8.072435696640014,9.48847034729004,8.462955696640016,9.878990347290038C8.853475696640015,10.26952034729004,8.853475696640015,10.902680347290039,8.462955696640016,11.293210347290039L6.342325696640015,13.413840347290039Q5.463645696640015,14.29249034729004,5.463645696640015,15.535190347290039Q5.463645696640015,16.77779034729004,6.342325696640015,17.65649034729004Q7.221005696640015,18.53519034729004,8.463645696640015,18.53519034729004Q9.706285696640014,18.53519034729004,10.584965696640015,17.65649034729004L12.705595696640014,15.535890347290039C13.096115696640014,15.14529034729004,13.729245696640014,15.14529034729004,14.119845696640015,15.535890347290039C14.510345696640014,15.92639034729004,14.510345696640014,16.559490347290037,14.119845696640015,16.95009034729004L11.999175696640014,19.07069034729004C10.046555696640015,21.02329034729004,6.880735696640015,21.02329034729004,4.928115696640015,19.07069034729004C2.9754906966400148,17.11809034729004,2.9754906966400148,13.95229034729004,4.928115696640015,11.999620347290039Z", fillRule: "evenodd", fillOpacity: 1 }) }) })
] });

// src/base/components/Tools/BrandImage.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
function BrandImage({ src, className = "", iconClassName = "" }) {
  const [hasError, setHasError] = useState2(false);
  return /* @__PURE__ */ jsx14(
    "div",
    {
      className: cn5(
        "ui-bg-[#626999] ui-overflow-hidden ui-bg-opacity-[0.2] ui-flex ui-items-center ui-justify-center",
        className
      ),
      children: !(src == null ? void 0 : src.length) || hasError ? /* @__PURE__ */ jsx14(
        SvgLink,
        {
          className: cn5(
            "ui-fill-[rgba(98,105,153,0.8)] ui-w-[10px] ui-h-[10px]",
            iconClassName
          )
        }
      ) : /* @__PURE__ */ jsx14(
        "img",
        {
          className: "ui-w-full ui-h-full",
          src,
          onError: () => setHasError(true)
        }
      )
    }
  );
}
var BrandImage_default = BrandImage;

// src/base/components/Tools/SearchToolContent.tsx
import { jsx as jsx15, jsxs as jsxs7 } from "react/jsx-runtime";
function SearchToolContent(props) {
  var _a, _b;
  const { onHrefTagClick, onToolClick, toolData, allowLogger } = props;
  const [renderScrollBtn, setRenderScrollBtn] = useState3({
    left: false,
    right: true
  });
  const scrollContainer = useRef(null);
  const getOverflowWidth = () => {
    const scrollCon = scrollContainer.current;
    const overflowLeft = scrollCon.scrollLeft;
    const overflowRight = scrollCon.scrollWidth - scrollCon.clientWidth - scrollCon.scrollLeft;
    return [overflowLeft, overflowRight];
  };
  useEffect(() => {
    if (!scrollContainer.current)
      return;
    const onScroll = debounce(() => {
      if (!scrollContainer.current)
        return;
      const [overflowLeft, overflowRight] = getOverflowWidth();
      const renderLeft = overflowLeft > 4;
      const renderRight = overflowRight > 4;
      setRenderScrollBtn({ left: renderLeft, right: renderRight });
    }, 300);
    scrollContainer.current.addEventListener("scroll", onScroll);
    return () => {
      var _a2, _b2;
      return (_b2 = (_a2 = scrollContainer.current) == null ? void 0 : _a2.removeEventListener) == null ? void 0 : _b2.call(_a2, "scroll", onScroll);
    };
  }, [scrollContainer.current]);
  const handleScroll = (position) => {
    if (!scrollContainer.current)
      return;
    const [overflowLeft] = getOverflowWidth();
    const distance = 496;
    scrollContainer.current.scrollTo({
      left: position === "right" ? overflowLeft + distance : overflowLeft - distance,
      behavior: "smooth"
    });
  };
  return /* @__PURE__ */ jsxs7(
    "div",
    {
      onClick: (e) => e.stopPropagation(),
      className: "ui-mt-[7px] ui-relative ui-w-full",
      children: [
        allowLogger ? /* @__PURE__ */ jsx15(
          "div",
          {
            onClick: () => onToolClick == null ? void 0 : onToolClick(toolData),
            className: "ui-right-[21px] ui-top-[-24px] ui-absolute ui-w-[64px] ui-px-[8px] ui-py-[3px] ui-text-[#8D8D99] ui-bg-[#626999] ui-text-[12px] ui-bg-opacity-[0.12] ui-rounded-[6px] hover:ui-text-[#17171D]",
            children: "\u67E5\u770B\u65E5\u5FD7"
          }
        ) : null,
        renderScrollBtn.left && /* @__PURE__ */ jsx15(
          "div",
          {
            style: {
              background: "linear-gradient(270deg, rgba(229, 241, 255, 0) 0%, #E5F1FF 60%)"
            },
            className: "ui-absolute ui-top-[0px] ui-left-[-7px] ui-h-full ui-w-[48px]",
            children: /* @__PURE__ */ jsx15(
              "div",
              {
                onClick: () => handleScroll("left"),
                className: "ui-flex ui-justify-center ui-items-center hover:ui-bg-[#7B67EE] ui-cursor-pointer ui-mt-[40px] ui-ml-[8px] ui-w-[20px] ui-h-[20px] ui-rounded-[20px] ui-bg-[#9EA2C0]",
                children: /* @__PURE__ */ jsx15(SvgRight, { className: "!ui-w-[13px] !ui-h-[8px] !ui-fill-[#e5f1ff] hover:ui-fill-[#ffffff]" })
              }
            )
          }
        ),
        renderScrollBtn.right && /* @__PURE__ */ jsx15(
          "div",
          {
            style: {
              background: "linear-gradient(270deg, #E5F1FF 40%, rgba(229, 241, 255, 0) 100%)"
            },
            className: "ui-absolute ui-top-[0px] ui-right-[-7px] ui-h-full ui-w-[48px]",
            children: /* @__PURE__ */ jsx15(
              "div",
              {
                onClick: () => handleScroll("right"),
                className: "ui-flex ui-justify-center ui-items-center hover:ui-bg-[#7B67EE] ui-cursor-pointer ui-mt-[40px] ui-ml-[20px] ui-w-[20px] ui-h-[20px] ui-rounded-[20px] ui-bg-[#9EA2C0]",
                children: /* @__PURE__ */ jsx15(SvgLeft, { className: "!ui-w-[13px] !ui-h-[8px] ui-fill-[#e5f1ff] hover:ui-fill-[#ffffff]" })
              }
            )
          }
        ),
        /* @__PURE__ */ jsx15(
          "div",
          {
            ref: (ref) => scrollContainer.current = ref,
            style: { scrollbarWidth: "none" },
            className: "ui-width-full ui-overflow-x-auto",
            children: /* @__PURE__ */ jsx15("div", { className: "ui-w-fit ui-flex ui-gap-[12px]", children: (((_b = (_a = toolData == null ? void 0 : toolData.data) == null ? void 0 : _a.content) == null ? void 0 : _b.output) ?? []).map(
              (item) => {
                var _a2, _b2;
                return /* @__PURE__ */ jsxs7(
                  "div",
                  {
                    className: "ui-flex ui-flex-col ui-justify-between ui-cursor-pointer ui-box-border ui-p-[12px] ui-w-[242px] ui-h-[99px] ui-bg-[#ffffff] ui-rounded-[6px] hover:ui-bg-[#F6F7FF]",
                    onClick: () => {
                      isNil(onHrefTagClick) ? window.open(item.url) : onHrefTagClick(item.url, true);
                    },
                    children: [
                      /* @__PURE__ */ jsx15("div", { className: "clamp-line-2 ui-text-[14px] ui-leading-[22px] ui-c-[#17171D]", children: item.title }),
                      /* @__PURE__ */ jsxs7("div", { className: "ui-flex ui-justify-between", children: [
                        /* @__PURE__ */ jsxs7("div", { className: "ui-flex ui-gap-[8px] ui-items-center", children: [
                          /* @__PURE__ */ jsx15(
                            BrandImage_default,
                            {
                              src: item.icon,
                              className: "ui-rounded-[2px] ui-w-[14px] ui-h-[14px]",
                              iconClassName: "ui-text-[10px]"
                            }
                          ),
                          /* @__PURE__ */ jsx15("span", { className: "ui-text-[12px] ui-leading-[12px] ui-text-[#9E9E9E]", children: ((_a2 = item.name) == null ? void 0 : _a2.length) ? item.name : (_b2 = item.url) == null ? void 0 : _b2.replace("http://", "").replace("https://", "") })
                        ] }),
                        /* @__PURE__ */ jsx15("div", { className: "ui-rounded-[4px] ui-w-[14px] ui-h-[14px] ui-text-center ui-leading-[14px] ui-text-[12px] ui-bg-[#626999] ui-bg-opacity-[0.12] ui-text-[#b5b8ce]", children: item.index })
                      ] })
                    ]
                  },
                  item.index
                );
              }
            ) })
          }
        )
      ]
    }
  );
}

// src/base/components/File/index.tsx
import prettyBytes from "pretty-bytes";
import {
  FILE_MIME_TYPE_MAP
} from "@bty/global-types/file";
import { getFileVariant, cn as cn8 } from "@bty/util";
import { FileIcon } from "@bty/ui-components";
import { useEffect as useEffect2, useRef as useRef2, useState as useState4 } from "react";
import { useSize } from "ahooks";

// src/base/components/Image/index.tsx
import RcImage from "rc-image";
import { cn as cn6 } from "@bty/util";

// src/assets/svg/image-preview/flip-x.svg
import * as React10 from "react";
import { jsx as jsx16 } from "react/jsx-runtime";
var SvgFlipX = (props) => /* @__PURE__ */ jsx16("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "swap", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...props, children: /* @__PURE__ */ jsx16("path", { d: "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" }) });

// src/assets/svg/image-preview/flip-y.svg
import * as React11 from "react";
import { jsx as jsx17 } from "react/jsx-runtime";
var SvgFlipY = (props) => /* @__PURE__ */ jsx17("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "swap", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", style: {
  transform: "rotate(90deg)"
}, ...props, children: /* @__PURE__ */ jsx17("path", { d: "M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z" }) });

// src/assets/svg/image-preview/rotate-left.svg
import * as React12 from "react";
import { jsx as jsx18, jsxs as jsxs8 } from "react/jsx-runtime";
var SvgRotateLeft = (props) => /* @__PURE__ */ jsxs8("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "rotate-left", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...props, children: [
  /* @__PURE__ */ jsx18("defs", { children: /* @__PURE__ */ jsx18("style", {}) }),
  /* @__PURE__ */ jsx18("path", { d: "M672 418H144c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H188V494h440v326z" }),
  /* @__PURE__ */ jsx18("path", { d: "M819.3 328.5c-78.8-100.7-196-153.6-314.6-154.2l-.2-64c0-6.5-7.6-10.1-12.6-6.1l-128 101c-4 3.1-3.9 9.1 0 12.3L492 318.6c5.1 4 12.7.4 12.6-6.1v-63.9c12.9.1 25.9.9 38.8 2.5 42.1 5.2 82.1 18.2 119 38.7 38.1 21.2 71.2 49.7 98.4 84.3 27.1 34.7 46.7 73.7 58.1 115.8a325.95 325.95 0 016.5 140.9h74.9c14.8-103.6-11.3-213-81-302.3z" })
] });

// src/assets/svg/image-preview/rotate-right.svg
import * as React13 from "react";
import { jsx as jsx19, jsxs as jsxs9 } from "react/jsx-runtime";
var SvgRotateRight = (props) => /* @__PURE__ */ jsxs9("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "rotate-right", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...props, children: [
  /* @__PURE__ */ jsx19("defs", { children: /* @__PURE__ */ jsx19("style", {}) }),
  /* @__PURE__ */ jsx19("path", { d: "M480.5 251.2c13-1.6 25.9-2.4 38.8-2.5v63.9c0 6.5 7.5 10.1 12.6 6.1L660 217.6c4-3.2 4-9.2 0-12.3l-128-101c-5.1-4-12.6-.4-12.6 6.1l-.2 64c-118.6.5-235.8 53.4-314.6 154.2A399.75 399.75 0 00123.5 631h74.9c-.9-5.3-1.7-10.7-2.4-16.1-5.1-42.1-2.1-84.1 8.9-124.8 11.4-42.2 31-81.1 58.1-115.8 27.2-34.7 60.3-63.2 98.4-84.3 37-20.6 76.9-33.6 119.1-38.8z" }),
  /* @__PURE__ */ jsx19("path", { d: "M880 418H352c-17.7 0-32 14.3-32 32v414c0 17.7 14.3 32 32 32h528c17.7 0 32-14.3 32-32V450c0-17.7-14.3-32-32-32zm-44 402H396V494h440v326z" })
] });

// src/assets/svg/image-preview/zoom-in.svg
import * as React14 from "react";
import { jsx as jsx20 } from "react/jsx-runtime";
var SvgZoomIn = (props) => /* @__PURE__ */ jsx20("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "zoom-in", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...props, children: /* @__PURE__ */ jsx20("path", { d: "M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" }) });

// src/assets/svg/image-preview/zoom-out.svg
import * as React15 from "react";
import { jsx as jsx21 } from "react/jsx-runtime";
var SvgZoomOut = (props) => /* @__PURE__ */ jsx21("svg", { viewBox: "64 64 896 896", focusable: "false", "data-icon": "zoom-out", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...props, children: /* @__PURE__ */ jsx21("path", { d: "M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z" }) });

// src/assets/svg/image-preview/close.svg
import * as React16 from "react";
import { jsx as jsx22 } from "react/jsx-runtime";
var SvgClose = (props) => /* @__PURE__ */ jsx22("svg", { fillRule: "evenodd", viewBox: "64 64 896 896", focusable: "false", "data-icon": "close", width: "1em", height: "1em", fill: "currentColor", "aria-hidden": "true", ...props, children: /* @__PURE__ */ jsx22("path", { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" }) });

// src/base/components/Image/index.tsx
import "rc-image/assets/index.css";
import { jsx as jsx23 } from "react/jsx-runtime";
function stopPageScale(e) {
  if (e == null ? void 0 : e.ctrlKey) {
    e == null ? void 0 : e.preventDefault();
  }
}
function Image2(props) {
  const { className, url, alt, preview = false, onClick } = props;
  return (
    // 外面包装两层层是为了欢迎语中渲染:
    // 1.点击图片不触发Message的消息发送
    // 2.为了可以通过外层css控制图片独占一行
    // 3.图片独占一行时，点击空白区域，不触发图片的预览，必须点击图片本身才会触发预览
    /* @__PURE__ */ jsx23("div", { className: "rc-image-wrap ui-inline-block", children: /* @__PURE__ */ jsx23(
      "div",
      {
        className: "rc-image-safe-wrap ui-inline-block",
        onClick: (e) => {
          e.stopPropagation();
          onClick == null ? void 0 : onClick(e);
        },
        children: /* @__PURE__ */ jsx23(
          RcImage,
          {
            className: cn6(className, { "ui-cursor-zoom-in": !!preview }),
            src: url,
            alt,
            rootClassName: "[&_.rc-image-preview-mask]:ui-bg-black [&_.rc-image-preview-mask]:ui-bg-opacity-[0.45] [&_.rc-image-preview-mask]:ui-backdrop-blur-lg",
            preview: preview ? {
              icons: {
                rotateLeft: /* @__PURE__ */ jsx23(SvgRotateLeft, {}),
                rotateRight: /* @__PURE__ */ jsx23(SvgRotateRight, {}),
                zoomIn: /* @__PURE__ */ jsx23(SvgZoomIn, {}),
                zoomOut: /* @__PURE__ */ jsx23(SvgZoomOut, {}),
                flipX: /* @__PURE__ */ jsx23(SvgFlipX, {}),
                flipY: /* @__PURE__ */ jsx23(SvgFlipY, {})
              },
              onVisibleChange: (status) => {
                if (status) {
                  document.body.addEventListener("wheel", stopPageScale, {
                    passive: false
                  });
                } else {
                  document.body.removeEventListener("wheel", stopPageScale);
                }
              },
              closeIcon: /* @__PURE__ */ jsx23(SvgClose, {})
            } : false
          }
        )
      }
    ) })
  );
}

// src/shadcn/ui/popover.tsx
import * as React17 from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { cn as cn7 } from "@bty/util";
import { jsx as jsx24 } from "react/jsx-runtime";
var Popover = PopoverPrimitive.Root;
var PopoverTrigger = PopoverPrimitive.Trigger;
var PopoverContent = React17.forwardRef(({ className, align = "center", sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx24(PopoverPrimitive.Portal, { children: /* @__PURE__ */ jsx24(
  PopoverPrimitive.Content,
  {
    ref,
    align,
    sideOffset,
    className: cn7(
      "z-50  rounded-md border bg-popover p-[14px] text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      className
    ),
    ...props,
    children: props.children
  }
) }));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

// src/assets/svg/img-placeholder.svg
import * as React18 from "react";
import { jsx as jsx25, jsxs as jsxs10 } from "react/jsx-runtime";
var SvgImgPlaceholder = (props) => /* @__PURE__ */ jsxs10("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", className: "lf9qjh6sj__design-iconfont", width: 128, height: 128, ...props, children: [
  /* @__PURE__ */ jsx25("defs", { children: /* @__PURE__ */ jsx25("clipPath", { id: "lf9qjh6sj__8leyuivif__ujt0krdv7a", children: /* @__PURE__ */ jsx25("rect", { width: 20, height: 20, rx: 0 }) }) }),
  /* @__PURE__ */ jsx25("g", { clipPath: "url(#lf9qjh6sj__8leyuivif__ujt0krdv7a)", children: /* @__PURE__ */ jsx25("path", { d: "M0.9990234375,2.9998779296875L0.9990234375,16.9998779296875Q0.9990234375,17.0981779296875,1.0086539875,17.1958779296875Q1.0182845375,17.2936779296875,1.0374528375,17.3900779296875Q1.0566212375,17.4863779296875,1.0851427375,17.5804779296875Q1.1136644375,17.6744779296875,1.1512644375,17.7652779296875Q1.1888644375,17.8559779296875,1.2351804375,17.9426779296875Q1.2814974375000001,18.0292779296875,1.3360844375,18.1109779296875Q1.3906714375,18.1926779296875,1.4530024375,18.2686779296875Q1.5153344375,18.3445779296875,1.5848094375000001,18.4140779296875Q1.6542854375,18.4835779296875,1.7302364375,18.5458779296875Q1.8061874375,18.6082779296875,1.8878824375,18.6627779296875Q1.9695774375,18.7173779296875,2.0562334375,18.7636779296875Q2.1428834375,18.8100779296875,2.2336534375,18.8476779296875Q2.3244334374999998,18.8852779296875,2.4184534375,18.9137779296875Q2.5124734374999997,18.9422779296875,2.6088434375,18.9614779296875Q2.7052134375000003,18.9805779296875,2.8029934375,18.9902779296875Q2.9007734375,18.9998779296875,2.9990234375,18.9998779296875L16.9990234375,18.9998779296875Q17.0973234375,18.9998779296875,17.1950234375,18.9902779296875Q17.2928234375,18.9805779296875,17.3892234375,18.9614779296875Q17.4855234375,18.9422779296875,17.5796234375,18.9137779296875Q17.6736234375,18.8852779296875,17.7644234375,18.8476779296875Q17.8551234375,18.8100779296875,17.9418234375,18.7636779296875Q18.0284234375,18.7173779296875,18.1101234375,18.6627779296875Q18.1918234375,18.6082779296875,18.2678234375,18.5458779296875Q18.3437234375,18.4835779296875,18.4132234375,18.4140779296875Q18.4827234375,18.3445779296875,18.5450234375,18.2686779296875Q18.6074234375,18.1926779296875,18.6619234375,18.1109779296875Q18.7165234375,18.0292779296875,18.7628234375,17.9426779296875Q18.8092234375,17.8559779296875,18.8468234375,17.7652779296875Q18.8844234375,17.6744779296875,18.9129234375,17.5804779296875Q18.9414234375,17.4863779296875,18.9606234375,17.3900779296875Q18.9797234375,17.2936779296875,18.9894234375,17.1958779296875Q18.9990234375,17.0981779296875,18.9990234375,16.9998779296875L18.9990234375,2.9998779296875Q18.9990234375,2.9016279296875,18.9894234375,2.8038479296875Q18.9797234375,2.7060679296875003,18.9606234375,2.6096979296875Q18.9414234375,2.5133279296874997,18.9129234375,2.4193079296875Q18.8844234375,2.3252879296874998,18.8468234375,2.2345079296875Q18.8092234375,2.1437379296875,18.7628234375,2.0570879296875Q18.7165234375,1.9704319296875,18.6619234375,1.8887369296875Q18.6074234375,1.8070419296875,18.5450234375,1.7310909296875Q18.4827234375,1.6551399296875,18.4132234375,1.5856639296875001Q18.3437234375,1.5161889296875,18.2678234375,1.4538569296875Q18.1918234375,1.3915259296875,18.1101234375,1.3369389296875Q18.0284234375,1.2823519296875001,17.9418234375,1.2360349296875Q17.8551234375,1.1897189296875,17.7644234375,1.1521189296875Q17.6736234375,1.1145189296875,17.5796234375,1.0859972296875Q17.4855234375,1.0574757296875,17.3892234375,1.0383073296875Q17.2928234375,1.0191390296875,17.1950234375,1.0095084796875Q17.0973234375,0.9998779296875,16.9990234375,0.9998779296875L2.9990234375,0.9998779296875Q2.9007734375,0.9998779296875,2.8029934375,1.0095084796875Q2.7052134375000003,1.0191390296875,2.6088434375,1.0383073296875Q2.5124734374999997,1.0574757296875,2.4184534375,1.0859972296875Q2.3244334374999998,1.1145189296875,2.2336534375,1.1521189296875Q2.1428834375,1.1897189296875,2.0562334375,1.2360349296875Q1.9695774375,1.2823519296875001,1.8878824375,1.3369389296875Q1.8061874375,1.3915259296875,1.7302364375,1.4538569296875Q1.6542854375,1.5161889296875,1.5848094375000001,1.5856639296875001Q1.5153344375,1.6551399296875,1.4530024375,1.7310909296875Q1.3906714375,1.8070419296875,1.3360844375,1.8887369296875Q1.2814974375000001,1.9704319296875,1.2351804375,2.0570879296875Q1.1888644375,2.1437379296875,1.1512644375,2.2345079296875Q1.1136644375,2.3252879296874998,1.0851427375,2.4193079296875Q1.0566212375,2.5133279296874997,1.0374528375,2.6096979296875Q1.0182845375,2.7060679296875003,1.0086539875,2.8038479296875Q0.9990234375,2.9016279296875,0.9990234375,2.9998779296875ZM7.9990234375,6.0001179296875Q7.9990234375,6.0983779296875,7.9893934375,6.1961579296875Q7.9797634375,6.2939379296875,7.9605934375,6.3903079296875Q7.9414234375,6.4866679296875,7.9129034375,6.5806879296875Q7.8843834375,6.6747179296875,7.8467834375,6.7654879296875Q7.8091834375,6.8562679296875,7.7628634375,6.9429179296875Q7.7165534375,7.0295679296875,7.6619634375,7.1112579296875Q7.6073734375,7.1929579296875,7.5450434375,7.2689079296875Q7.4827134375,7.3448579296875,7.4132334375,7.4143379296875Q7.3437634375,7.4838079296875,7.2678134375,7.5461479296875Q7.1918634375,7.6084779296875,7.1101634375,7.6630579296875Q7.0284734375,7.7176479296875,6.9418134375,7.7639679296875Q6.8551634375,7.8102779296875,6.7643934375,7.8478779296875Q6.6736134375,7.8854779296875,6.5795934375,7.9139979296875Q6.4855734375,7.9425279296875,6.3892034375,7.9616879296875Q6.2928334375,7.9808579296875,6.1950534375,7.9904879296875Q6.0972734375,8.0001179296875,5.9990234375,8.0001179296875Q5.9007734375,8.0001179296875,5.8029934375,7.9904879296875Q5.7052034375,7.9808579296875,5.6088434375,7.9616879296875Q5.5124734375,7.9425279296875,5.4184534375,7.9139979296875Q5.3244334375,7.8854779296875,5.2336534375,7.8478779296875Q5.1428834375,7.8102779296875,5.0562334375,7.7639679296875Q4.969573437499999,7.7176479296875,4.8878834375,7.6630579296875Q4.8061834375,7.6084779296875,4.7302334375,7.5461479296875Q4.6542834375,7.4838079296875,4.584813437499999,7.4143379296875Q4.5153334375,7.3448579296875,4.4530034375,7.2689079296875Q4.3906734375,7.1929579296875,4.3360834375,7.1112579296875Q4.2814934375,7.0295679296875,4.2351834375,6.9429179296875Q4.1888634375,6.8562679296875,4.1512634375,6.7654879296875Q4.1136634375,6.6747179296875,4.0851434375,6.5806879296875Q4.0566234375,6.4866679296875,4.0374534375,6.3903079296875Q4.0182834375,6.2939379296875,4.0086534375,6.1961579296875Q3.9990234375,6.0983779296875,3.9990234375,6.0001179296875Q3.9990234375,5.9018679296875,4.0086534375,5.8040879296875Q4.0182834375,5.7063079296875,4.0374534375,5.6099379296875Q4.0566234375,5.5135779296875,4.0851434375,5.4195479296875Q4.1136634375,5.3255279296875,4.1512634375,5.2347579296875Q4.1888634375,5.1439779296875,4.2351834375,5.0573279296875Q4.2814934375,4.9706779296875006,4.3360834375,4.8889779296875Q4.3906734375,4.8072879296875,4.4530034375,4.7313379296875Q4.5153334375,4.6553879296875,4.584813437499999,4.5859079296875Q4.6542834375,4.5164279296875005,4.7302334375,4.454097929687499Q4.8061834375,4.3917679296875,4.8878834375,4.3371779296875Q4.969573437499999,4.282597929687499,5.0562334375,4.2362779296875Q5.1428834375,4.1899579296875,5.2336534375,4.152357929687501Q5.3244334375,4.1147679296875,5.4184534375,4.0862379296875Q5.5124734375,4.057717929687501,5.6088434375,4.0385479296875Q5.7052034375,4.0193879296875,5.8029934375,4.0097579296875Q5.9007734375,4.0001179296875,5.9990234375,4.0001179296875Q6.0972734375,4.0001179296875,6.1950534375,4.009747929687499Q6.2928334375,4.0193879296875,6.3892034375,4.0385479296875Q6.4855734375,4.057717929687501,6.5795934375,4.0862379296875Q6.6736134375,4.114757929687499,6.7643934375,4.152357929687501Q6.8551634375,4.1899579296875,6.9418134375,4.2362779296875Q7.0284734375,4.282597929687499,7.1101634375,4.3371779296875Q7.1918634375,4.3917679296875,7.2678134375,4.454097929687499Q7.3437634375,4.5164279296875005,7.4132334375,4.5859079296875Q7.4827134375,4.6553879296875,7.5450434375,4.7313379296875Q7.6073734375,4.8072879296875,7.6619634375,4.8889779296875Q7.7165534375,4.9706779296875006,7.7628634375,5.0573279296875Q7.8091834375,5.1439779296875,7.8467834375,5.2347579296875Q7.8843834375,5.3255279296875,7.9129034375,5.4195479296875Q7.9414234375,5.5135779296875,7.9605934375,5.6099379296875Q7.9797634375,5.7063079296875,7.9893934375,5.8040879296875Q7.9990234375,5.9018679296875,7.9990234375,6.0001179296875ZM7.7366034375,11.7912779296875L9.0905034375,13.8756779296875L11.4913234375,9.9119779296875C11.8805234375,9.2694279296875,12.8128234375,9.2694279296875,13.2020234375,9.9119779296875L16.2728234375,14.9817779296875C16.676523437500002,15.6482779296875,16.196723437499998,16.4998779296875,15.4175234375,16.4998779296875L9.2758334375,16.4998779296875C9.2208034375,16.4998779296875,9.1672634375,16.4956779296875,9.1154234375,16.4874779296875C9.0630534375,16.4957779296875,9.0089134375,16.5000779296875,8.9532234375,16.5000779296875L4.842883437499999,16.5000779296875C4.0496034375,16.5000779296875,3.5721534375,15.6206779296875,4.0042434375,14.9554779296875L6.0593434375,11.7912779296875C6.4536334375,11.1841779296875,7.3422934375,11.1841779296875,7.7366034375,11.7912779296875Z", fillRule: "evenodd" }) })
] });

// src/base/components/File/index.tsx
import { jsx as jsx26, jsxs as jsxs11 } from "react/jsx-runtime";
var loadingImg = "https://resource.bantouyan.com/betteryeah/chat/circle.png";
function LoadingIcon() {
  return /* @__PURE__ */ jsx26(
    "img",
    {
      className: "ui-block ui-w-[16px] ui-h-[16px] ui-animate-spin",
      src: loadingImg
    }
  );
}
var DEFAULT_FILE_ICON = "https://resource.bantouyan.com/battleyeah-ai/chat/link.png";
function File({
  className,
  name,
  type,
  size,
  suffix,
  showToolTips,
  url,
  icon,
  previewSize = "normal",
  imageRender = false,
  onFileClick,
  afterNode
}) {
  const innerSize = size ? prettyBytes(size) : 0;
  const variant = type === "init" ? "init" : getFileVariant(type);
  const [innerIcon, setInnerIcon] = useState4(icon);
  const [open, setOpen] = useState4(false);
  const ref = useRef2(null);
  const divRef = useRef2(null);
  const divSize = useSize(divRef);
  useEffect2(() => {
    if (icon) {
      setInnerIcon(icon);
    }
  }, [icon, type]);
  const renderIcon = () => {
    switch (variant) {
      case "init":
        return /* @__PURE__ */ jsx26(LoadingIcon, {});
      case "image":
        return imageRender ? null : /* @__PURE__ */ jsx26(
          FileIcon,
          {
            variant,
            className: "ui-text-[20px] ui-w-[20px] ui-h-[20px"
          }
        );
      default:
        return /* @__PURE__ */ jsx26(
          FileIcon,
          {
            variant,
            className: "ui-text-[20px] ui-w-[20px] ui-h-[20px"
          }
        );
    }
  };
  return /* @__PURE__ */ jsxs11(Popover, { open, children: [
    /* @__PURE__ */ jsx26(
      PopoverContent,
      {
        className: "!ui-p-0 !ui-border-0 !ui-mr-[8px]",
        style: { outline: "none" },
        children: /* @__PURE__ */ jsx26(
          "div",
          {
            ref,
            style: { width: (divSize == null ? void 0 : divSize.width) || 0 },
            className: "ui-bg-white ui-px-[12px]  ui-box-border ui- ui-py-[8px] ui-rounded-[8px] ui-text-[#17171d] ui-text-[14px] ui-shadow-[0px_8px_24px_0px_rgba(0,0,0,0.2)] ui-backdrop-blur-lg ui-cursor-pointer",
            children: name
          }
        )
      }
    ),
    /* @__PURE__ */ jsx26(PopoverTrigger, { className: "ui-border-0 ui-border-none ui-w-full", children: /* @__PURE__ */ jsxs11(
      "div",
      {
        className: cn8(
          "ui-flex ui-max-w-full ui-self-start ui-relative ui-items-center ui-flex-1"
        ),
        ref: divRef,
        onMouseEnter: () => type === FILE_MIME_TYPE_MAP.reference && showToolTips && setOpen(true),
        onMouseLeave: () => setOpen(false),
        onClick: () => {
          onFileClick == null ? void 0 : onFileClick({
            url,
            type
          });
        },
        children: [
          !imageRender && /* @__PURE__ */ jsxs11(
            "div",
            {
              className: cn8(
                "ui-box-border ui-rounded-lg ui-py-[8px] ui-text-[14px] ui-bg-pale ui-pl-[12px] ui-pr-[12px] ui-backdrop-blur-[240px] ui-flex ui-items-center hover:ui-bg-[rgba(98,105,153,0.08)] ui-cursor-pointer ui-relative",
                className
              ),
              children: [
                /* @__PURE__ */ jsx26("span", { className: "ui-mr-[6px]  ui-shrink-0 ui-text-xl", children: innerIcon ? /* @__PURE__ */ jsx26(
                  "img",
                  {
                    className: "ui-w-[16px]",
                    src: innerIcon,
                    onError: () => {
                      setInnerIcon(DEFAULT_FILE_ICON);
                    }
                  }
                ) : renderIcon() }),
                !imageRender && /* @__PURE__ */ jsx26(
                  "span",
                  {
                    className: cn8(
                      "ui-mr-auto ui-overflow-hidden  ui-text-[14px] ui-text-yeah ui-text-ellipsis ui-text-left",
                      {
                        "ui-whitespace-nowrap": type !== FILE_MIME_TYPE_MAP.reference,
                        "ui-line-clamp-2": type === FILE_MIME_TYPE_MAP.reference
                      }
                    ),
                    children: name
                  }
                ),
                !!size && /* @__PURE__ */ jsx26("span", { className: "ui-ml-[14px] ui-mr-[7px] ui-shrink-0 ui-text-xs ui-text-yeah-light", children: innerSize }),
                suffix
              ]
            }
          ),
          variant === "image" && imageRender && /* @__PURE__ */ jsxs11(
            "div",
            {
              className: cn8(
                "ui-rounded-lg ui-bg-pale ui-backdrop-blur-[240px] ui-flex-center-y ui-mt-[8px] ui-cursor-pointer"
              ),
              children: [
                /* @__PURE__ */ jsx26("span", { className: "", children: url ? /* @__PURE__ */ jsx26(
                  Image2,
                  {
                    preview: true,
                    className: cn8("ui-rounded-[8px] ui-object-contain", {
                      "ui-max-h-[240px]": previewSize === "normal",
                      "ui-max-w-[240px]": previewSize === "normal",
                      "ui-max-w-[60px]": previewSize !== "normal",
                      "ui-max-h-[60px]": previewSize !== "normal"
                    }),
                    url
                  }
                ) : /* @__PURE__ */ jsx26(SvgImgPlaceholder, { className: "ui-w-[60px] ui-h-[60px] ui-fill-[rgb(217,215,237)]" }) }),
                suffix
              ]
            }
          ),
          afterNode
        ]
      }
    ) })
  ] });
}

// src/base/hooks/useCopyToClipboard.ts
import { useState as useState5 } from "react";
function useCopyToClipboard(duration) {
  const [isCopied, setIsCopied] = useState5(false);
  const copyToClipboard = (value) => {
    var _a;
    if (typeof window === "undefined" || !((_a = navigator.clipboard) == null ? void 0 : _a.writeText)) {
      return;
    }
    if (!value) {
      return;
    }
    navigator.clipboard.writeText(value).then(() => {
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, duration || 2e3);
    });
  };
  return { isCopied, copyToClipboard };
}
var useCopyToClipboard_default = useCopyToClipboard;

// src/assets/svg/right-arrow.svg
import * as React19 from "react";
import { jsx as jsx27, jsxs as jsxs12 } from "react/jsx-runtime";
var SvgRightArrow = (props) => /* @__PURE__ */ jsxs12("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: [
  /* @__PURE__ */ jsx27("defs", { children: /* @__PURE__ */ jsx27("clipPath", { id: "master_svg0_19371_139748", children: /* @__PURE__ */ jsx27("rect", { x: 0, y: 0, width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsx27("g", { clipPath: "url(#master_svg0_19371_139748)", children: /* @__PURE__ */ jsxs12("g", { children: [
    /* @__PURE__ */ jsx27("g", { children: /* @__PURE__ */ jsx27("path", { d: "M1.8273401260375977,8.132744445800782Q1.8273401260375977,7.492744445800781,2.467340126037598,7.492744445800781L11.427340126037597,7.492744445800781Q12.067340126037598,7.492744445800781,12.067340126037598,8.132744445800782Q12.067340126037598,8.77274444580078,11.427340126037597,8.77274444580078L2.467340126037598,8.77274444580078Q1.8273403644565978,8.77274444580078,1.8273401260375977,8.132744445800782Z", fill: "currentColor", fillOpacity: 1 }) }),
    /* @__PURE__ */ jsx27("g", { children: /* @__PURE__ */ jsx27("path", { d: "M12.028402391662597,8.116100695800782L8.853046391662598,4.940750695800781C8.595675491662597,4.692168695800781,8.592101091662597,4.280864695800782,8.845113391662597,4.0278516958007815C9.098125391662597,3.7748403958007812,9.509429391662598,3.778414195800781,9.758002391662597,4.035784695800781L13.378482391662597,7.656260695800781C13.635872391662598,7.905130695800781,13.639042391662597,8.316740695800782,13.385522391662597,8.569540695800782L9.764722391662598,12.18938069580078C9.514829391662598,12.43937069580078,9.109593391662598,12.439440695800782,8.859607391662598,12.189540695800781C8.609621091662598,11.93965069580078,8.609549491662598,11.53441069580078,8.859446391662598,11.284420695800781L12.028082391662597,8.115780695800781L12.028402391662597,8.116100695800782Z", fill: "currentColor", fillOpacity: 1 }) })
  ] }) })
] });

// src/components/message/type/Markdown/Markdown.tsx
import { debounce as debounce2 } from "lodash-es";
import { memo as memo4, useContext, useEffect as useEffect6, useMemo as useMemo4, useRef as useRef7, useState as useState9 } from "react";
import ReactMarkdown from "react-markdown";
import SyntaxHighlighter from "react-syntax-highlighter";
import { atomOneDark } from "react-syntax-highlighter/dist/esm/styles/hljs";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import { useMutationObserver } from "ahooks";
import RemarkBreaks from "remark-breaks";
import { cn as cn16 } from "@bty/util";

// src/base/components/Tooltip.tsx
import { cn as cn10 } from "@bty/util";

// src/shadcn/ui/tooltip.tsx
import * as React20 from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn as cn9 } from "@bty/util";
import { jsx as jsx28 } from "react/jsx-runtime";
var TooltipProvider = TooltipPrimitive.Provider;
var TooltipPortal = TooltipPrimitive.Portal;
var Tooltip = TooltipPrimitive.Root;
var TooltipArrow = TooltipPrimitive.Arrow;
var TooltipTrigger = TooltipPrimitive.Trigger;
var TooltipContent = React20.forwardRef(({ className, sideOffset = 4, ...props }, ref) => /* @__PURE__ */ jsx28(
  TooltipPrimitive.Content,
  {
    ref,
    sideOffset,
    className: cn9(
      "ui-z-50 ui-rounded-md ui-border ui-bg-popover ui-px-[10.5px] ui-py-[5.25px] ui-text-sm ui-text-popover-foreground ui-shadow-md ui-animate-in ui-fade-in-0 ui-zoom-in-95 data-[state=closed]:ui-animate-out data-[state=closed]:ui-fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:ui-slide-in-from-top-2 data-[side=left]:ui-slide-in-from-right-2 data-[side=right]:ui-slide-in-from-left-2 data-[side=top]:ui-slide-in-from-bottom-2",
      className
    ),
    ...props
  }
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

// src/base/components/Tooltip.tsx
import { jsx as jsx29, jsxs as jsxs13 } from "react/jsx-runtime";
function Tooltip2({
  arrowClassName,
  className,
  style,
  open,
  title,
  side,
  children
}) {
  return /* @__PURE__ */ jsx29(TooltipProvider, { delayDuration: 500, children: /* @__PURE__ */ jsxs13(Tooltip, { open, children: [
    /* @__PURE__ */ jsx29(TooltipTrigger, { style, asChild: true, children }),
    /* @__PURE__ */ jsx29(TooltipPortal, { children: /* @__PURE__ */ jsxs13(
      TooltipContent,
      {
        className: cn10(
          "ui-border-0 ui-bg-popover ui-text-white ui-shadow-[0px_8px_24px_0px_rgba(0,0,0,0.2)]",
          className
        ),
        side,
        children: [
          /* @__PURE__ */ jsx29("span", { className: "ui-text-[12px] ui-leading-[17.5px] ui-text-white ", children: title }),
          /* @__PURE__ */ jsx29(TooltipArrow, { className: cn10("ui-fill-popover", arrowClassName) })
        ]
      }
    ) })
  ] }) });
}

// src/assets/svg/copy.svg
import * as React21 from "react";
import { jsx as jsx30 } from "react/jsx-runtime";
var SvgCopy = (props) => /* @__PURE__ */ jsx30("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: /* @__PURE__ */ jsx30("g", { children: /* @__PURE__ */ jsx30("g", { children: /* @__PURE__ */ jsx30("g", { children: /* @__PURE__ */ jsx30("g", { children: /* @__PURE__ */ jsx30("g", { children: /* @__PURE__ */ jsx30("path", { d: "M2,8.98889C2,9.823450000000001,2.676548,10.5,3.51111,10.5L4.200200000000001,10.5L4.200200000000001,7.03353C4.200200000000001,5.468719999999999,5.468719999999999,4.200200000000001,7.03353,4.200200000000001L10.5,4.200200000000001L10.5,3.51111C10.5,2.676548,9.823450000000001,2,8.98889,2L3.51111,2C2.676548,2,2,2.676548,2,3.51111L2,8.98889ZM5.5,7.38889L5.5,12.1111Q5.5,12.2039,5.5091,12.2963Q5.518190000000001,12.3886,5.53629,12.4796Q5.554399999999999,12.5706,5.5813299999999995,12.6594Q5.60827,12.7482,5.64378,12.834Q5.67929,12.9197,5.72304,13.0015Q5.76678,13.0834,5.81833,13.1605Q5.86989,13.2377,5.9287600000000005,13.3094Q5.987629999999999,13.3811,6.05324,13.4468Q6.11886,13.5124,6.19059,13.5712Q6.26232,13.6301,6.33948,13.6817Q6.41663,13.7332,6.49847,13.777Q6.58031,13.8207,6.66604,13.8562Q6.75177,13.8917,6.84057,13.9187Q6.92937,13.9456,7.02038,13.9637Q7.1114,13.9818,7.20375,13.9909Q7.29609,14,7.38889,14L12.1111,14Q12.2039,14,12.2963,13.9909Q12.3886,13.9818,12.4796,13.9637Q12.5706,13.9456,12.6594,13.9187Q12.7482,13.8917,12.834,13.8562Q12.9197,13.8207,13.0015,13.777Q13.0834,13.7332,13.1605,13.6817Q13.2377,13.6301,13.3094,13.5712Q13.3811,13.5124,13.4468,13.4468Q13.5124,13.3811,13.5712,13.3094Q13.6301,13.2377,13.6817,13.1605Q13.7332,13.0834,13.777,13.0015Q13.8207,12.9197,13.8562,12.834Q13.8917,12.7482,13.9187,12.6594Q13.9456,12.5706,13.9637,12.4796Q13.9818,12.3886,13.9909,12.2963Q14,12.2039,14,12.1111L14,7.38889Q14,7.29609,13.9909,7.20375Q13.9818,7.1114,13.9637,7.02038Q13.9456,6.92937,13.9187,6.84057Q13.8917,6.75177,13.8562,6.66604Q13.8207,6.58031,13.777,6.49847Q13.7332,6.41663,13.6817,6.33948Q13.6301,6.26232,13.5712,6.19059Q13.5124,6.11886,13.4468,6.05324Q13.3811,5.987629999999999,13.3094,5.9287600000000005Q13.2377,5.86989,13.1605,5.81833Q13.0834,5.76678,13.0015,5.72304Q12.9197,5.67929,12.834,5.64378Q12.7482,5.60827,12.6594,5.5813299999999995Q12.5706,5.554399999999999,12.4796,5.53629Q12.3886,5.518190000000001,12.2963,5.5091Q12.2039,5.5,12.1111,5.5L7.38889,5.5Q7.29609,5.5,7.20375,5.5091Q7.1114,5.518190000000001,7.02038,5.53629Q6.92937,5.554399999999999,6.84057,5.58134Q6.75177,5.60827,6.66604,5.64378Q6.58031,5.67929,6.49847,5.72304Q6.41663,5.76678,6.33948,5.81834Q6.26232,5.86989,6.19059,5.9287600000000005Q6.11886,5.987629999999999,6.05324,6.05324Q5.987629999999999,6.11886,5.9287600000000005,6.19059Q5.86989,6.26232,5.81833,6.33948Q5.76678,6.41663,5.72304,6.49847Q5.67929,6.58031,5.64378,6.66604Q5.60827,6.75177,5.5813299999999995,6.84057Q5.554399999999999,6.92937,5.53629,7.02038Q5.518190000000001,7.1114,5.5091,7.20375Q5.5,7.29609,5.5,7.38889Z", fillRule: "evenodd", fill: "currentColor", fillOpacity: 1 }) }) }) }) }) }) });

// src/assets/svg/success.svg
import * as React22 from "react";
import { jsx as jsx31, jsxs as jsxs14 } from "react/jsx-runtime";
var SvgSuccess = (props) => /* @__PURE__ */ jsx31("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: /* @__PURE__ */ jsx31("g", { children: /* @__PURE__ */ jsxs14("g", { children: [
  /* @__PURE__ */ jsx31("g", { style: {
    opacity: 0
  }, children: /* @__PURE__ */ jsx31("rect", { x: 0, y: 0, width: 16, height: 16, rx: 0, fill: "#D8D8D8", fillOpacity: 1 }) }),
  /* @__PURE__ */ jsx31("g", { children: /* @__PURE__ */ jsx31("path", { d: "M15,8Q15,8.17184,14.9916,8.34347Q14.9831,8.51511,14.9663,8.686119999999999Q14.9494,8.85713,14.9242,9.02711Q14.899,9.19709,14.8655,9.36563Q14.832,9.53417,14.7902,9.70086Q14.7485,9.86755,14.6986,10.03199Q14.6487,10.19643,14.5908,10.35823Q14.5329,10.52002,14.4672,10.67878Q14.4014,10.83754,14.3279,10.99288Q14.2545,11.1482,14.1734,11.2998Q14.0924,11.4513,14.0041,11.5987Q13.9158,11.7461,13.8203,11.889Q13.7248,12.0319,13.6225,12.1699Q13.5201,12.3079,13.4111,12.4408Q13.3021,12.5736,13.1867,12.7009Q13.0713,12.8282,12.9497,12.9497Q12.8282,13.0713,12.7009,13.1867Q12.5736,13.3021,12.4408,13.4111Q12.3079,13.5201,12.1699,13.6225Q12.0319,13.7248,11.889,13.8203Q11.7461,13.9158,11.5987,14.0041Q11.4513,14.0924,11.2998,14.1734Q11.1482,14.2545,10.99288,14.3279Q10.83754,14.4014,10.67878,14.4672Q10.52002,14.5329,10.35823,14.5908Q10.19643,14.6487,10.03199,14.6986Q9.86755,14.7485,9.70086,14.7902Q9.53417,14.832,9.36563,14.8655Q9.19709,14.899,9.02711,14.9242Q8.85713,14.9494,8.686119999999999,14.9663Q8.51511,14.9831,8.34347,14.9916Q8.17184,15,8,15Q7.82816,15,7.65653,14.9916Q7.48489,14.9831,7.31388,14.9663Q7.14287,14.9494,6.97289,14.9242Q6.80291,14.899,6.63437,14.8655Q6.46583,14.832,6.29914,14.7902Q6.13245,14.7485,5.96801,14.6986Q5.80357,14.6487,5.64177,14.5908Q5.47998,14.5329,5.32122,14.4672Q5.16246,14.4014,5.00711,14.3279Q4.85177,14.2545,4.70022,14.1734Q4.5486699999999995,14.0924,4.40128,14.0041Q4.25389,13.9158,4.11101,13.8203Q3.96813,13.7248,3.8301,13.6225Q3.69208,13.5201,3.55925,13.4111Q3.42641,13.3021,3.29909,13.1867Q3.17176,13.0713,3.05025,12.9497Q2.92874,12.8282,2.81334,12.7009Q2.69794,12.5736,2.58893,12.4408Q2.4799100000000003,12.3079,2.3775500000000003,12.1699Q2.2751799999999998,12.0319,2.17971,11.889Q2.0842400000000003,11.7461,1.9959,11.5987Q1.907556,11.4513,1.826551,11.2998Q1.745546,11.1482,1.672075,10.99288Q1.598604,10.83754,1.532843,10.67878Q1.4670830000000001,10.52002,1.409191,10.35823Q1.3513,10.19643,1.301418,10.03199Q1.251535,9.86755,1.209781,9.70086Q1.168027,9.53417,1.134503,9.36563Q1.100979,9.19709,1.0757644,9.02711Q1.0505502,8.85713,1.0337069,8.686119999999999Q1.0168636,8.51511,1.0084318,8.34347Q1,8.17184,1,8Q1,7.82816,1.0084318,7.65653Q1.0168636,7.48489,1.0337069,7.31388Q1.0505502,7.14287,1.0757644,6.97289Q1.100979,6.80291,1.134503,6.63437Q1.168027,6.46583,1.209781,6.29914Q1.251535,6.13245,1.301418,5.96801Q1.3513,5.80357,1.409191,5.64177Q1.4670830000000001,5.47998,1.532843,5.32122Q1.598604,5.16246,1.672075,5.00711Q1.745546,4.85177,1.826551,4.70022Q1.907556,4.5486699999999995,1.995899,4.40128Q2.0842400000000003,4.25389,2.17971,4.11101Q2.2751799999999998,3.96813,2.3775500000000003,3.8301Q2.4799100000000003,3.69208,2.58893,3.55925Q2.69794,3.42641,2.81334,3.29909Q2.92874,3.17176,3.05025,3.05025Q3.17176,2.92874,3.29909,2.81334Q3.42641,2.69794,3.55925,2.58893Q3.69208,2.4799100000000003,3.8301,2.3775500000000003Q3.96813,2.2751799999999998,4.11101,2.17971Q4.25389,2.0842400000000003,4.40128,1.9959Q4.5486699999999995,1.907556,4.70022,1.826551Q4.85177,1.745546,5.00711,1.672075Q5.16246,1.598604,5.32122,1.532843Q5.47998,1.4670830000000001,5.64177,1.409191Q5.80357,1.3513,5.96801,1.301418Q6.13245,1.251535,6.29914,1.209781Q6.46583,1.168027,6.63437,1.134503Q6.80291,1.100979,6.97289,1.0757644Q7.14287,1.0505502,7.31388,1.0337069Q7.48489,1.0168636,7.65653,1.0084318Q7.82816,1,8,1Q8.17184,1,8.34347,1.0084318Q8.51511,1.0168636,8.686119999999999,1.0337069Q8.85713,1.0505502,9.02711,1.0757644Q9.19709,1.100979,9.36563,1.134503Q9.53417,1.168027,9.70086,1.209781Q9.86755,1.251535,10.03199,1.301418Q10.19643,1.3513,10.35823,1.409191Q10.52002,1.4670830000000001,10.67878,1.532843Q10.83754,1.598604,10.99288,1.672075Q11.1482,1.745546,11.2998,1.826551Q11.4513,1.907556,11.5987,1.995899Q11.7461,2.0842400000000003,11.889,2.17971Q12.0319,2.2751799999999998,12.1699,2.3775500000000003Q12.3079,2.4799100000000003,12.4408,2.58893Q12.5736,2.69794,12.7009,2.81334Q12.8282,2.92874,12.9497,3.05025Q13.0713,3.17176,13.1867,3.29909Q13.3021,3.42641,13.4111,3.55925Q13.5201,3.69208,13.6225,3.8301Q13.7248,3.96813,13.8203,4.11101Q13.9158,4.25389,14.0041,4.40128Q14.0924,4.5486699999999995,14.1734,4.70022Q14.2545,4.85177,14.3279,5.00711Q14.4014,5.16246,14.4672,5.32122Q14.5329,5.47998,14.5908,5.64177Q14.6487,5.80357,14.6986,5.96801Q14.7485,6.13245,14.7902,6.29914Q14.832,6.46583,14.8655,6.63437Q14.899,6.80291,14.9242,6.97289Q14.9494,7.14287,14.9663,7.31388Q14.9831,7.48489,14.9916,7.65653Q15,7.82816,15,8Z", fill: "#00B078", fillOpacity: 1 }) }),
  /* @__PURE__ */ jsx31("g", { children: /* @__PURE__ */ jsx31("path", { d: "M11.638168046875,5.36176590625C11.884808046875001,5.60841290625,11.897798046875,6.00024090625,11.677108046875,6.26217390625L11.638168046875,6.30457390625L7.304828046875,10.63790390625C7.043598046875,10.89914390625,6.623318046875,10.89625390625,6.365398046875001,10.641323906250001L6.327968046875,10.60119390625L4.327964046875,8.27555390625C4.087893446875,7.99639390625,4.119580446875,7.57547390625,4.398739046875,7.33540390625C4.663940046875,7.10734390625,5.057080046875,7.12453390625,5.301558046875,7.36616390625L5.338888046875,7.40618390625L6.870098046875,9.18650390625L10.695358046875,5.36176590625C10.955708046875,5.10141650625,11.377818046875,5.10141650625,11.638168046875,5.36176590625Z", fill: "#FFFFFF", fillOpacity: 1 }) })
] }) }) });

// src/components/message/CodeBlockTool.tsx
import { jsx as jsx32, jsxs as jsxs15 } from "react/jsx-runtime";
function CodeBlockTool({ language, code, onCopyClick }) {
  const { isCopied, copyToClipboard } = useCopyToClipboard_default();
  return /* @__PURE__ */ jsxs15("div", { className: "ui-h-[28px] ui-rounded-t-lg ui-bg-[#454652] ui-px-[10.5px] ui-flex-center-y ui-text-[14px]", children: [
    /* @__PURE__ */ jsx32("span", { className: "ui-mr-auto ui-text-xs ui-font-medium ui-text-[#f7f7ff]", children: language }),
    /* @__PURE__ */ jsx32(Tooltip2, { title: "\u590D\u5236\u4EE3\u7801", children: /* @__PURE__ */ jsx32(
      "div",
      {
        className: "ui-flex-center ui-cursor-pointer ui-h-[24px] ui-w-[24px] !ui-bg-transparent ui-p-0 ui-text-base ui-text-yeah-icon_dark hover:ui-text-[#f7f7ff]",
        onClick: (event) => {
          event.stopPropagation();
          if (code) {
            copyToClipboard(code);
            onCopyClick == null ? void 0 : onCopyClick(code);
          }
        },
        children: isCopied ? /* @__PURE__ */ jsx32(SvgSuccess, {}) : /* @__PURE__ */ jsx32(SvgCopy, {})
      }
    ) })
  ] });
}
var CodeBlockTool_default = CodeBlockTool;

// src/components/message/hooks/clipboard.ts
import { useEffect as useEffect3 } from "react";
function useRemoveExtraNewlines(targetElement) {
  function handleCopy(e) {
    const selection = document.getSelection();
    const str = selection == null ? void 0 : selection.toString().trim();
    if (e.clipboardData && str) {
      e.clipboardData.setData("text/plain", str);
      e.preventDefault();
    }
  }
  useEffect3(() => {
    if (targetElement) {
      targetElement.addEventListener("copy", handleCopy);
      return () => {
        targetElement.removeEventListener("copy", handleCopy);
      };
    }
  }, [targetElement]);
}

// src/components/messageList/OriginMessageList.tsx
import {
  forwardRef as forwardRef3,
  useCallback,
  useEffect as useEffect4,
  useImperativeHandle,
  useRef as useRef3,
  useState as useState6,
  createContext
} from "react";
import Scrollbar from "smooth-scrollbar";
import { cn as cn12 } from "@bty/util";

// src/components/message/TaskStartedMessage.tsx
import { memo as memo2 } from "react";
import dayjs from "dayjs";
import { cn as cn11 } from "@bty/util";
import { jsx as jsx33, jsxs as jsxs16 } from "react/jsx-runtime";
var TaskStartedMessage = memo2((props) => {
  const { className, task, toTaskDetail } = props;
  return /* @__PURE__ */ jsxs16(
    "div",
    {
      className: cn11(
        "ui-p-[9px] ui-bg-[#eff0f9] ui-text-[12px]/[12px] ui-text-[#9E9E9E] ui-rounded-[12px]",
        className
      ),
      children: [
        /* @__PURE__ */ jsx33("span", { children: dayjs(task.timestamp).format("MM-DD HH:MM") }),
        /* @__PURE__ */ jsx33("span", { children: "\xA0\xA0\u5F00\u59CB\u6267\u884C\u4EFB\u52A1" }),
        /* @__PURE__ */ jsxs16(
          "span",
          {
            className: "ui-text-yeah-primary ui-cursor-pointer ui-leading-[1.5]",
            onClick: toTaskDetail,
            children: [
              "\xA0",
              task.title
            ]
          }
        ),
        /* @__PURE__ */ jsx33("span", { children: "\uFF0C\u7A0D\u540E\u4E3A\u4F60\u63A8\u9001\u6267\u884C\u7ED3\u679C" })
      ]
    }
  );
});

// src/components/messageList/OriginMessageList.tsx
import { Fragment, jsx as jsx34, jsxs as jsxs17 } from "react/jsx-runtime";
var ScrollbarContext = createContext({
  current: void 0
});
var OriginMessageList = forwardRef3((props, ref) => {
  const {
    initialNotScroll = false,
    allowLogger = false,
    data = [],
    className,
    onLoadMore = () => {
    },
    toolComponent,
    onMessageActionClick,
    onMessageToolClick,
    onMessageTaskClick,
    generating,
    hideMessageActions,
    onRegenerate,
    onHrefTagClick,
    onQuestionSend,
    paddingX = 96,
    uniqueId,
    onFileClick,
    onRelatedQuestionsToggle,
    formMessageConfig,
    onFileUpload,
    pluginItemOnMessageRender,
    dislikeOnMessageRender
  } = props;
  const messagesEndRef = useRef3(null);
  const scrollRef = useRef3(null);
  const scrollBarRef = useRef3(null);
  const timeoutRef = useRef3(null);
  const initScrollRef = useRef3(false);
  const savedScrollTopRef = useRef3(0);
  const intervalRef = useRef3(0);
  const startTimeRef = useRef3(0);
  const [isScrolling, setScrolling] = useState6(false);
  const preScrollTopRef = useRef3(0);
  const [stopScroll, setStopScroll] = useState6(false);
  const scrollDown = (force = false) => {
    if ((!isScrolling || intervalRef.current) && scrollBarRef.current || force) {
      setTimeout(() => {
        scrollBarRef.current.scrollTo(0, scrollBarRef.current.limit.y);
      }, 50);
    }
  };
  useImperativeHandle(ref, () => ({ scrollToBottom: () => scrollDown(true) }), [
    scrollDown
  ]);
  const onScroll = useCallback(() => {
    var _a;
    setScrolling(true);
    if (scrollRef.current) {
      if (scrollBarRef.current) {
        scrollBarRef.current.limit.x = 0;
      }
      if (scrollBarRef.current && ((_a = scrollBarRef.current) == null ? void 0 : _a.scrollTop) === 0) {
        const scrollbar = scrollBarRef.current;
        const oldScrollHeight = scrollbar.limit.y;
        if (savedScrollTopRef.current === 0) {
          savedScrollTopRef.current = oldScrollHeight;
        }
        onLoadMore == null ? void 0 : onLoadMore();
      }
      if (preScrollTopRef.current && preScrollTopRef.current > scrollBarRef.current.scrollTop) {
        setStopScroll(true);
      }
      if (scrollBarRef.current.offset.y === scrollBarRef.current.limit.y) {
        setStopScroll(false);
      }
    }
    timeoutRef.current && clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      setScrolling(false);
    }, 100);
    preScrollTopRef.current = scrollBarRef.current.scrollTop;
  }, [onLoadMore]);
  useEffect4(() => {
    const observer = new IntersectionObserver(([_entry]) => {
    }, {
      root: null,
      threshold: 0.5
    });
    const messagesEndElement = messagesEndRef.current;
    if (messagesEndElement) {
      observer.observe(messagesEndElement);
    }
    return () => {
      if (messagesEndElement) {
        observer.unobserve(messagesEndElement);
      }
    };
  }, [messagesEndRef]);
  useEffect4(() => {
    if (messagesEndRef.current && generating && data && !stopScroll) {
      scrollDown();
    }
    if (!generating && stopScroll) {
      setStopScroll(false);
    }
  }, [messagesEndRef, generating, data, stopScroll]);
  useEffect4(() => {
    if (initialNotScroll)
      return;
    let rafId;
    const doScroll = () => {
      scrollBarRef.current.scrollTo(0, scrollBarRef.current.limit.y);
      const now = Date.now();
      if (now - startTimeRef.current > 1e3) {
        cancelAnimationFrame(rafId);
      } else {
        rafId = requestAnimationFrame(doScroll);
      }
    };
    if (intervalRef.current) {
      startTimeRef.current = Date.now();
    }
    rafId = requestAnimationFrame(doScroll);
    startTimeRef.current = Date.now();
    return () => {
      rafId && cancelAnimationFrame(rafId);
    };
  }, [uniqueId, initialNotScroll]);
  const hideScrollBar = useCallback(() => {
    if (scrollBarRef.current) {
      scrollBarRef.current.track.yAxis.thumb.element.style.display = "none";
      setTimeout(() => {
        scrollBarRef.current.track.yAxis.thumb.element.style.display = "block";
      }, 3e3);
    }
  }, []);
  useEffect4(() => {
    if (scrollRef.current && !scrollBarRef.current) {
      const scrollbar = Scrollbar.init(scrollRef.current, {
        damping: 0.5,
        // continuousScrolling: true,
        alwaysShowTracks: false
      });
      scrollbar.limit.x = 0;
      scrollBarRef.current = scrollbar;
      hideScrollBar();
      scrollbar.addListener(onScroll);
    }
  }, [scrollRef.current, onScroll]);
  useEffect4(() => {
    if (!initScrollRef.current && data.length > 1) {
      !initialNotScroll && scrollDown();
      initScrollRef.current = true;
    }
    setTimeout(() => {
      if (savedScrollTopRef.current > 0) {
        scrollBarRef.current.scrollTo(
          0,
          scrollBarRef.current.limit.y - savedScrollTopRef.current
        );
        savedScrollTopRef.current = 0;
      }
    }, 300);
  }, [data, initialNotScroll]);
  return /* @__PURE__ */ jsx34(ScrollbarContext.Provider, { value: scrollBarRef, children: /* @__PURE__ */ jsx34(
    "div",
    {
      ref: scrollRef,
      className: cn12(
        "chat-message-list-container  scrollable-container ui-relative ui-w-full ui-h-full ui-overflow-scroll ui-flex ui-justify-center ui-box-border",
        className
      ),
      style: { padding: `0 ${paddingX}px` },
      children: /* @__PURE__ */ jsxs17("div", { className: "ui-w-full", children: [
        data == null ? void 0 : data.map((item, i, array) => {
          var _a;
          const isLast = i === array.length - 1;
          const hideActions = hideMessageActions ?? (isLast ? false : void 0);
          return /* @__PURE__ */ jsxs17(
            "div",
            {
              className: cn12(
                "message-list-item ui-w-full ui-flex ui-flex-col ui-items-stretch ui-pb-[24px] first:ui-pt-[28px]",
                { "!ui-pb-[70px]": isLast }
              ),
              children: [
                item.type === "separator" && /* @__PURE__ */ jsx34(MessageSeparator, { content: item.content }),
                item.type === "message" && /* @__PURE__ */ jsx34(Fragment, { children: item.messageType === "task" && ((_a = item.task) == null ? void 0 : _a.status) === "STARTED" ? /* @__PURE__ */ jsx34(
                  TaskStartedMessage,
                  {
                    className: "ui-mt-[12px] ui-mx-auto",
                    task: item.task,
                    toTaskDetail: () => onMessageTaskClick == null ? void 0 : onMessageTaskClick(item.task, item.metaData)
                  }
                ) : /* @__PURE__ */ jsx34(
                  Message,
                  {
                    ...item,
                    allowLogger,
                    hideActions,
                    toolComponent,
                    onActionClick: onMessageActionClick,
                    onToolClick: onMessageToolClick,
                    onTaskClick: onMessageTaskClick,
                    onHrefTagClick,
                    onRegenerate,
                    pluginItemOnMessageRender,
                    dislikeOnMessageRender,
                    onQuestionSend,
                    onFileClick,
                    onRelatedQuestionsToggle,
                    formMessageComponentMap: formMessageConfig == null ? void 0 : formMessageConfig.formMessageComponentMap,
                    onFileUpload,
                    formDisabled: formMessageConfig == null ? void 0 : formMessageConfig.disabled,
                    onFormSubmit: formMessageConfig == null ? void 0 : formMessageConfig.onMessageFormSubmit
                  }
                ) })
              ]
            },
            item.id
          );
        }),
        /* @__PURE__ */ jsx34("div", { className: "ui-h-[10px]", ref: messagesEndRef })
      ] })
    }
  ) });
});

// src/components/message/type/plugin/removeStrikethrough.ts
import { visit } from "unist-util-visit";
function removeStrikethrough() {
  return (tree) => {
    visit(tree, (node, index, parent) => {
      if (node.type === "delete") {
        const textNode = {
          // @ts-expect-error text
          type: "text",
          // @ts-expect-error child.value
          value: `~${node.children.map((child) => child.value).join("")}~`
        };
        if (parent && typeof index === "number") {
          parent.children.splice(index, 1, textNode);
        }
      }
    });
  };
}

// src/components/message/type/plugin/renderCite.ts
import { visit as visit2 } from "unist-util-visit";
function replaceSubstring(str, start, end, replacement) {
  const prefix = str.substring(0, start);
  const suffix = str.substring(end);
  return prefix + replacement + suffix;
}
function renderCite() {
  return (tree) => {
    visit2(tree, (node, index, parent) => {
      const referenceRegex = /\[(\d+)\]/g;
      if ((parent == null ? void 0 : parent.type) === "code" || (parent == null ? void 0 : parent.tagName) === "pre" || (parent == null ? void 0 : parent.tagName) === "code") {
        return;
      }
      if ((node == null ? void 0 : node.type) === "text" && referenceRegex.exec(node.value)) {
        const references = node.value.match(referenceRegex) ?? [];
        const parts = [];
        let strIndex = 0;
        let str = node.value;
        while (strIndex < str.length) {
          const r = references.shift();
          if (r) {
            const referenceIndex = str.indexOf(r);
            parts.push(str.slice(strIndex, referenceIndex), r);
            strIndex = referenceIndex + r.length;
            str = replaceSubstring(
              str,
              referenceIndex,
              strIndex,
              new Array(r.length).fill("_").join("")
            );
          } else {
            parts.push(str.slice(strIndex));
            strIndex = str.length;
          }
        }
        const finalNodes = parts.map((p) => {
          var _a;
          if (referenceRegex.test(p)) {
            return {
              type: "element",
              tagName: "cite",
              children: [{ type: "text", value: (_a = p.match(/\[(\d+)\]/)) == null ? void 0 : _a[1] }]
            };
          } else {
            return {
              type: "text",
              value: p
            };
          }
        });
        parent.children.splice(index, 1, ...finalNodes);
      }
    });
  };
}
var renderCite_default = renderCite;

// src/components/message/type/Markdown/Markdown.tsx
import "katex/dist/katex.min.css";

// src/components/message/type/Markdown/MarkdownVideo.tsx
import { useMemo as useMemo2, useRef as useRef4, useState as useState7 } from "react";
import toast from "react-hot-toast";

// src/assets/svg/play.svg
import * as React24 from "react";
import { jsx as jsx35 } from "react/jsx-runtime";
var SvgPlay = (props) => /* @__PURE__ */ jsx35("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 17, height: 20, viewBox: "0 0 17 20", ...props, children: /* @__PURE__ */ jsx35("g", { children: /* @__PURE__ */ jsx35("g", { children: /* @__PURE__ */ jsx35("path", { d: "M16.3953,8.9282L1.89532,0.179452C1.50928,-0.0532497,1.02785,-0.0600856,0.635354,0.161563C0.242774,0.383356,0.0000118017,0.799154,0.0000114441,1.24977L0.0000114441,18.7473C-0.00191689,19.199,0.24059,19.6164,0.63395,19.8385C1.02731,20.0606,1.51001,20.0526,1.89579,19.8176L16.3958,11.0688C17.2015,10.5827,17.2015,9.41428,16.3958,8.9282L16.3953,8.9282Z", fill: "currentColor", fillOpacity: 1, style: {
  mixBlendMode: "passthrough"
} }) }) }) });

// src/components/message/CopyBtn.tsx
import { cn as cn13 } from "@bty/util";
import { jsx as jsx36 } from "react/jsx-runtime";
function CopyButton(props) {
  return /* @__PURE__ */ jsx36(
    "span",
    {
      className: cn13(
        "copy-btn ui-shrink-0 ui-rounded ui-text-opacity-60 ui-text-[#626999] ui-flex ui-items-center ui-justify-center ui-cursor-pointer hover:ui-bg-yeah-icon_light/8 ui-w-[24px] ui-h-[24px]",
        props.className
      ),
      onClick: props.onClick,
      children: /* @__PURE__ */ jsx36(SvgCopy2, { width: 14, height: 14 })
    }
  );
}

// src/utils/copy.ts
async function copyImage(url) {
  const img = new Image();
  img.crossOrigin = "anonymous";
  return new Promise((resolve, reject) => {
    img.onload = function() {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx == null ? void 0 : ctx.drawImage(img, 0, 0);
      canvas.toBlob(function(blob) {
        navigator.clipboard.write([new ClipboardItem({ "image/png": blob || "" })]).then(function() {
          resolve(true);
        }).catch(function(err) {
          console.log("\u590D\u5236\u56FE\u7247\u5931\u8D25", err);
          reject(false);
        });
      }, "image/png");
    };
    img.onerror = function() {
      console.error("\u56FE\u7247\u52A0\u8F7D\u5931\u8D25");
      reject(false);
    };
    img.src = url;
  });
}
function copyVideo(src) {
  const blob = new Blob([src], { type: "text/plain" });
  navigator.clipboard.write([
    new ClipboardItem({
      "text/plain": blob
    })
  ]);
}

// src/components/message/type/Markdown/MarkdownVideo.tsx
import { jsx as jsx37, jsxs as jsxs18 } from "react/jsx-runtime";
function safeDecodeURIComponent(uri) {
  try {
    return decodeURIComponent(uri);
  } catch (e) {
    return uri;
  }
}
function MarkdownVideo({ src }) {
  const url = useMemo2(() => safeDecodeURIComponent(src), [src]);
  const videoRef = useRef4(null);
  const [isPlayed, setIsPlayed] = useState7(false);
  const handlePlay = () => {
    var _a;
    setIsPlayed(true);
    (_a = videoRef.current) == null ? void 0 : _a.play();
  };
  const onCopy = () => {
    copyVideo(url);
    toast.success("\u5DF2\u590D\u5236\u5730\u5740\u5230\u526A\u5207\u677F", {
      id: "clipboard"
    });
  };
  return /* @__PURE__ */ jsxs18("div", { className: "ui-inline-flex ui-gap-x-[8px] ui-items-end [&>.copy-btn]:hover:!ui-visible", children: [
    /* @__PURE__ */ jsxs18("div", { className: "ui-relative ui-w-fit ui-h-fit", children: [
      !isPlayed && /* @__PURE__ */ jsx37("div", { className: "ui-absolute ui-z-[2] ui-w-full ui-h-full ui-flex ui-items-center ui-justify-center", children: /* @__PURE__ */ jsx37(
        "div",
        {
          onClick: handlePlay,
          className: "ui-rounded-[12px] ui-w-[44px] ui-h-[44px] ui-bg-[#000]/[0.6] ui-border-[#E1E1E5] ui-border-opacity-60 ui-border-[1px] ui-flex ui-items-center ui-justify-center ui-cursor-pointer",
          children: /* @__PURE__ */ jsx37(SvgPlay, { className: "ui-text-[#fff] ui-w-[17px] ui-ml-[2px]" })
        }
      ) }),
      /* @__PURE__ */ jsx37(
        "video",
        {
          ref: videoRef,
          className: "ui-max-w-[260px] ui-max-h-[461px] ui-p-0 ui-m-0 ui-rounded-[12px]",
          src: url,
          controls: isPlayed
        }
      )
    ] }),
    /* @__PURE__ */ jsx37(CopyButton, { className: "ui-invisible", onClick: onCopy })
  ] });
}

// src/components/message/type/Markdown/MarkdownImage.tsx
import toast2 from "react-hot-toast";
import { cn as cn14 } from "@bty/util";
import { jsx as jsx38, jsxs as jsxs19 } from "react/jsx-runtime";
function MarkdownImage({
  alt,
  src,
  preview = true
}) {
  const url = src || "";
  const isVideo = /\.(mp4|webm|ogg)$/.test(url);
  const onCopy = async () => {
    if (isVideo) {
      copyVideo(url);
    } else {
      await copyImage(url);
    }
    toast2.success(isVideo ? "\u5DF2\u590D\u5236\u5730\u5740\u5230\u526A\u5207\u677F" : "\u590D\u5236\u6210\u529F", {
      id: "clipboard"
    });
  };
  return isVideo ? /* @__PURE__ */ jsx38(MarkdownVideo, { src: url }) : /* @__PURE__ */ jsxs19("div", { className: "ui-inline-flex ui-gap-x-[8px] ui-items-end [&>.copy-btn]:hover:!ui-visible", children: [
    /* @__PURE__ */ jsxs19(
      "div",
      {
        className: cn14(
          "!ui-w-[260px] ui-max-h-[461px] ui-rounded-[12px] ui-leading-[0px] ui-m-0 ui-overflow-hidden ui-relative",
          "[&_*]:!ui-leading-[0px] [&_.rc-image-safe-wrap]:!ui-block [&_.rc-image--wrap]:!ui-block"
        ),
        children: [
          /* @__PURE__ */ jsx38(
            "div",
            {
              className: cn14(
                "ui-w-full ui-h-full ui-absolute ui-bg-[#000]/[2%] ui-z-[1]",
                {
                  "ui-pointer-events-none": preview
                }
              )
            }
          ),
          /* @__PURE__ */ jsx38(
            Image2,
            {
              className: "ui-object-cover !ui-h-full ui-object-top ui-m-0",
              preview,
              url,
              alt
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx38(CopyButton, { onClick: onCopy, className: "ui-invisible" })
  ] });
}

// src/components/message/type/Markdown/MarkdownAnchor.tsx
import { jsx as jsx39 } from "react/jsx-runtime";
var VIDEO_EXTENSIONS = ["mp4", "webm", "ogg"];
var IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "bmp"];
function MarkdownAnchor({
  href,
  onClick,
  imagePreview = true,
  children
}) {
  if (VIDEO_EXTENSIONS.some((ext) => href == null ? void 0 : href.endsWith(ext))) {
    return /* @__PURE__ */ jsx39(MarkdownVideo, { src: href });
  }
  if (IMAGE_EXTENSIONS.some((ext) => href == null ? void 0 : href.endsWith(ext))) {
    return /* @__PURE__ */ jsx39(MarkdownImage, { src: href || "", alt: href, preview: imagePreview });
  }
  return /* @__PURE__ */ jsx39(
    "a",
    {
      className: "ui-font-medium ui-text-[14px] ui-text-yeah-primary ui-underline ui-underline-offset-2",
      href,
      target: "_blank",
      rel: "noreferrer",
      onClick: (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (onClick && href) {
          onClick(href);
        } else {
          window.open(href);
        }
      },
      children
    }
  );
}

// src/components/message/type/Markdown/MarkdownParagraph.tsx
import { useMemo as useMemo3 } from "react";
import { jsx as jsx40 } from "react/jsx-runtime";
function extractVideoSrc(html) {
  const videoSrcRegex = /<video[^>]*src=['"]([^'"]+)['"][^>]*>/gi;
  const srcList = [];
  let match;
  while ((match = videoSrcRegex.exec(html)) !== null) {
    srcList.push(match[1]);
  }
  return srcList;
}
var MarkdownParagraph = ({ children }) => {
  const hasVideoTag = children == null ? void 0 : children.some((child) => {
    return typeof child === "string" && child.startsWith("<video");
  });
  const hasVideoSourceTag = useMemo3(() => {
    return hasVideoTag ? children == null ? void 0 : children.some((child) => {
      return typeof child === "string" && child.startsWith("<source");
    }) : false;
  }, [hasVideoTag, children]);
  const src = useMemo3(() => {
    var _a;
    return hasVideoTag ? (_a = extractVideoSrc(children.join(""))) == null ? void 0 : _a[0] : "";
  }, [children, hasVideoTag]);
  if (hasVideoSourceTag)
    return /* @__PURE__ */ jsx40(
      "div",
      {
        className: "ui-whitespace-pre-wrap ui-text-[14px] ui-leading-[24px] ui-max-w-[260px]  ui-max-h-[461px]",
        dangerouslySetInnerHTML: { __html: children.join("") }
      }
    );
  return hasVideoTag ? /* @__PURE__ */ jsx40(MarkdownVideo, { src }) : /* @__PURE__ */ jsx40("div", { className: "ui-leading-[24px] ui-text-[14px] ui-text-justify", children });
};

// src/components/message/type/Markdown/MarkdownLi.tsx
import { jsx as jsx41 } from "react/jsx-runtime";
var MarkdownLi = ({ children }) => {
  const hasVideoTag = children == null ? void 0 : children.some((child) => {
    return typeof child === "string" && child.startsWith("<video");
  });
  return hasVideoTag ? /* @__PURE__ */ jsx41(
    "li",
    {
      className: "ui-leading-[21px] ui-text-[14px]",
      dangerouslySetInnerHTML: { __html: children.join("") }
    }
  ) : /* @__PURE__ */ jsx41("li", { className: "ui-leading-[21px] ui-text-[14px]", children });
};

// src/components/message/type/Markdown/MarkdownCite.tsx
import { useEffect as useEffect5, useRef as useRef5, useState as useState8 } from "react";
import { isNil as isNil2 } from "lodash-es";
import * as Popover2 from "@radix-ui/react-popover";
import { useHover } from "ahooks";
import { cn as cn15 } from "@bty/util";

// src/assets/svg/super-link.svg
import * as React25 from "react";
import { jsx as jsx42, jsxs as jsxs20 } from "react/jsx-runtime";
var SvgSuperLink = (props) => /* @__PURE__ */ jsxs20("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: [
  /* @__PURE__ */ jsx42("defs", { children: /* @__PURE__ */ jsx42("clipPath", { id: "master_svg0_2211_1101", children: /* @__PURE__ */ jsx42("rect", { x: 0, y: 0, width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsx42("g", { clipPath: "url(#master_svg0_2211_1101)", children: /* @__PURE__ */ jsx42("g", { children: /* @__PURE__ */ jsx42("g", { children: /* @__PURE__ */ jsx42("path", { d: "M8.666671752929688,4.33331298828125L8.666671752929688,3.99998298828125Q8.666671752929688,3.44769298828125,8.276151752929687,3.05717298828125Q7.885621752929688,2.66664298828125,7.333341752929687,2.66664298828125L3.3333417529296874,2.66664298828125Q2.7810517529296876,2.66664298828125,2.3905317529296877,3.05717298828125Q2.0000017529296876,3.44769298828125,2.0000017529296876,3.99998298828125L2.0000017529296876,9.33331298828125Q2.0000017529296876,9.88560298828125,2.3905317529296877,10.27612298828125Q2.7810517529296876,10.66664298828125,3.3333417529296874,10.66664298828125L3.6666717529296875,10.66664298828125L3.6666717529296875,6.99998298828125Q3.6666717529296875,5.89541298828125,4.447721752929688,5.1143629882812505Q5.2287717529296875,4.33331298828125,6.333341752929687,4.33331298828125L8.666671752929688,4.33331298828125ZM9.999391752929688,4.97117298828125C9.999801752929688,4.96162298828125,10.000001752929688,4.9520129882812505,10.000001752929688,4.94236298828125L10.000001752929688,3.99998298828125Q10.000001752929688,2.89541298828125,9.218961752929687,2.11436198828125Q8.437911752929686,1.33331298828125,7.333341752929687,1.33331298828125L3.3333417529296874,1.33331298828125Q2.2287717529296875,1.33331298828125,1.4477207529296874,2.11436198828125Q0.6666717529296875,2.89541298828125,0.6666717529296875,3.99998298828125L0.6666717529296875,9.33331298828125Q0.6666717529296875,10.43788298828125,1.4477207529296874,11.21893298828125Q2.2287717529296875,12.00001298828125,3.3333417529296874,12.00001298828125L3.6666717529296875,12.00001298828125L3.6666717529296875,12.33331298828125Q3.6666717529296875,13.43791298828125,4.447721752929688,14.21891298828125Q5.2287717529296875,15.00001298828125,6.333341752929687,15.00001298828125L11.666671752929688,15.00001298828125Q12.771271752929687,15.00001298828125,13.552271752929688,14.21891298828125Q14.333371752929688,13.43791298828125,14.333371752929688,12.33331298828125L14.333371752929688,9.33331298828125C14.333371752929688,8.96512298828125,14.034871752929687,8.66664298828125,13.666671752929688,8.66664298828125C13.298471752929688,8.66664298828125,12.999971752929687,8.96512298828125,12.999971752929687,9.33331298828125L12.999971752929687,12.33331298828125Q12.999971752929687,12.88561298828125,12.609471752929688,13.27611298828125Q12.218971752929688,13.66661298828125,11.666671752929688,13.66661298828125L6.333341752929687,13.66661298828125Q5.781051752929687,13.66661298828125,5.390531752929688,13.27611298828125Q5.000001752929688,12.88561298828125,5.000001752929688,12.33331298828125L5.000001752929688,6.99998298828125Q5.000001752929688,6.44769298828125,5.390531752929688,6.05717298828125Q5.781051752929687,5.66664298828125,6.333341752929687,5.66664298828125L9.333341752929687,5.66664298828125C9.701531752929688,5.66664298828125,10.000001752929688,5.36817298828125,10.000001752929688,4.99998298828125C10.000001752929688,4.99032298828125,9.999801752929688,4.98072298828125,9.999391752929688,4.97117298828125ZM11.333371752929688,3.33331298828125L14.666671752929688,3.33331298828125C15.034871752929687,3.33331298828125,15.333371752929688,3.63179298828125,15.333371752929688,3.99998298828125L15.333371752929688,7.33331298828125C15.333371752929688,7.70150298828125,15.034871752929687,7.99998298828125,14.666671752929688,7.99998298828125C14.298471752929688,7.99998298828125,13.999971752929687,7.70150298828125,13.999971752929687,7.33331298828125L13.999971752929687,5.59849298828125L9.132221752929688,10.46628298828125C8.871871752929687,10.72663298828125,8.449761752929687,10.72662298828125,8.189411752929686,10.46628298828125C7.929061752929687,10.20593298828125,7.929061752929687,9.78382298828125,8.189411752929686,9.52347298828125L13.046271752929687,4.66664298828125L11.333371752929688,4.66664298828125C10.965171752929688,4.66664298828125,10.666671752929688,4.36817298828125,10.666671752929688,3.99998298828125C10.666671752929688,3.63179298828125,10.965171752929688,3.33331298828125,11.333371752929688,3.33331298828125Z", fillRule: "evenodd", fillOpacity: 1 }) }) }) })
] });

// src/components/message/type/Markdown/MarkdownCite.tsx
import { jsx as jsx43, jsxs as jsxs21 } from "react/jsx-runtime";
function MarkdownCite(props) {
  var _a, _b, _c, _d, _e;
  const { children, appendSetDataSource, onHrefTagClick } = props;
  const triggerRef = useRef5(null);
  const isHovering = useHover(triggerRef);
  const isHoveringRef = useRef5(isHovering);
  const [open, setOpen] = useState8(false);
  const [isContentHovering, setIsContentHovering] = useState8(false);
  const isContentHoveringRef = useRef5(isContentHovering);
  const [dataSource, setDataSource] = useState8([]);
  useEffect5(() => {
    appendSetDataSource(
      (pre) => pre.concat(setDataSource)
    );
  }, []);
  useEffect5(() => {
    isHoveringRef.current = isHovering;
    if (isHovering) {
      setOpen(true);
    } else {
      setTimeout(() => {
        if (!isContentHoveringRef.current) {
          setOpen(false);
        }
      }, 100);
    }
  }, [isHovering]);
  useEffect5(() => {
    isContentHoveringRef.current = isContentHovering;
    if (!isContentHovering) {
      setTimeout(() => {
        if (!isHoveringRef.current) {
          setOpen(false);
        }
      }, 100);
    }
  }, [isContentHovering]);
  const [index] = children;
  if (!(dataSource == null ? void 0 : dataSource.length))
    return `[${index}]`;
  const data = dataSource.find((item) => Number(item.index) === Number(index));
  if (!data)
    return `[${index}]`;
  return /* @__PURE__ */ jsxs21(Popover2.Root, { open, children: [
    /* @__PURE__ */ jsx43(Popover2.Trigger, { asChild: true, children: /* @__PURE__ */ jsx43(
      "span",
      {
        ref: triggerRef,
        onClick: (e) => e.stopPropagation(),
        className: `ui-mx-[2px] ui-cursor-pointer ui-inline-block ui-w-[14px] ui-h-[14px] ui-text-center ui-text-[12px] ui-leading-[14px] ui-bg-[#626999] ${open ? "ui-bg-opacity-[0.25]" : "ui-bg-opacity-[0.12]"} ui-rounded-[4px] ${open ? "ui-text-[#8e93b7]" : "ui-text-[#b2b5ce]"}`,
        children: index
      }
    ) }),
    /* @__PURE__ */ jsx43(Popover2.Portal, { children: /* @__PURE__ */ jsx43(
      Popover2.Content,
      {
        onMouseLeave: () => setIsContentHovering(false),
        onMouseEnter: () => setIsContentHovering(true),
        className: "ui-z-[1002] ui-pt-[8px]",
        children: /* @__PURE__ */ jsxs21(
          "div",
          {
            onClick: () => {
              isNil2(onHrefTagClick) ? window.open(data.url) : onHrefTagClick(data.url, true);
            },
            style: {
              border: "1px solid rgba(141, 141, 153, 0.08)",
              boxShadow: "0px 12px 32px 0px rgba(153, 162, 176, 0.24)"
            },
            className: "ui-cursor-pointer ui-p-[16px] ui-rounded-[8px] ui-bg-[#ffffff] ui-w-[361px]",
            children: [
              /* @__PURE__ */ jsxs21("div", { className: "ui-flex ui-mb-[8px] ui-justify-between", children: [
                /* @__PURE__ */ jsxs21("div", { className: "ui-flex", children: [
                  /* @__PURE__ */ jsx43(
                    BrandImage_default,
                    {
                      src: data.icon,
                      className: "ui-w-[16px] ui-h-[16px] ui-rounded-[4px]"
                    }
                  ),
                  /* @__PURE__ */ jsx43("span", { className: "ui-ml-[4px] ui-text-[12px] ui-text-[#9E9E9E] ui-leading-[16px]", children: ((_a = data.name) == null ? void 0 : _a.length) ? data.name : (_e = (_d = (_c = (_b = data.url) == null ? void 0 : _b.replace) == null ? void 0 : _c.call(_b, "http://", "")) == null ? void 0 : _d.replace) == null ? void 0 : _e.call(_d, "https://", "") })
                ] }),
                isContentHovering ? /* @__PURE__ */ jsx43(SvgSuperLink, { className: "ui-w-[16px] ui-h-[16px] ui-fill-[#a0a5c2]" }) : null
              ] }),
              /* @__PURE__ */ jsx43(
                "div",
                {
                  className: cn15(
                    "clamp-line-2",
                    "ui-mb-[8px] ui-text-[#17171D] ui-text-[16px] ui-font-medium ui-leading-[20px]"
                  ),
                  children: data.title
                }
              ),
              /* @__PURE__ */ jsx43(
                "div",
                {
                  className: cn15(
                    "clamp-line-2",
                    "ui-text-[14px] ui-leading-[22px] ui-text-[#8D8D99] ui-font-light"
                  ),
                  children: data.snippet
                }
              )
            ]
          }
        )
      }
    ) })
  ] });
}
var MarkdownCite_default = MarkdownCite;

// src/components/message/type/Markdown/MarkdownH1.tsx
import { memo as memo3 } from "react";
import { jsx as jsx44 } from "react/jsx-runtime";
var MarkdownH1 = memo3(({ children }) => {
  return /* @__PURE__ */ jsx44("h1", { className: "ui-font-bold ui-text-[24px] ui-my-[12px]", children });
});
var MarkdownH2 = memo3(({ children }) => {
  return /* @__PURE__ */ jsx44("h1", { className: "ui-font-bold ui-text-[20px] ui-my-[12px]", children });
});
var MarkdownH3 = memo3(({ children }) => {
  return /* @__PURE__ */ jsx44("h1", { className: "ui-font-bold ui-text-[18px] ui-my-[12px]", children });
});
var MarkdownH4 = memo3(({ children }) => {
  return /* @__PURE__ */ jsx44("h1", { className: "ui-font-bold ui-text-[16px] ui-my-[12px]", children });
});
var MarkdownH5 = memo3(({ children }) => {
  return /* @__PURE__ */ jsx44("h1", { className: "ui-font-normal ui-text-[16px] ui-my-[12px]", children });
});

// src/components/message/type/Markdown/MarkDownTable.tsx
import { useRef as useRef6 } from "react";
import { toBlob } from "html-to-image";
import { jsx as jsx45, jsxs as jsxs22 } from "react/jsx-runtime";
var MarkDownTable = (props) => {
  const tableElRef = useRef6(null);
  const onCopy = async () => {
    if (tableElRef) {
      const table = tableElRef.current;
      const tableHeader = table.querySelector("thead");
      const columnCount = tableHeader == null ? void 0 : tableHeader.querySelectorAll("th").length;
      try {
        table.classList.add("draw");
        const blob = await toBlob(table, {
          width: columnCount ? columnCount * 200 : table.offsetWidth,
          height: table.offsetHeight
        });
        navigator.clipboard.write([
          new ClipboardItem({
            "image/png": blob || ""
          })
        ]);
        table.classList.remove("draw");
      } catch (e) {
        console.error("\u5C06\u8868\u683C\u8F6C\u6362\u4E3A\u56FE\u7247\u65F6\u51FA\u9519:", e);
        table.classList.remove("draw");
      }
    }
  };
  return /* @__PURE__ */ jsxs22("div", { className: "ui-flex ui-w-fit ui-gap-x-[8px] ui-items-end [&>.copy-btn]:hover:!ui-visible", children: [
    /* @__PURE__ */ jsx45("table", { ref: tableElRef, children: props.children }),
    /* @__PURE__ */ jsx45(
      CopyButton,
      {
        onClick: onCopy,
        className: "ui-invisible ui-relative ui-top-[-30px]"
      }
    )
  ] });
};

// src/components/message/type/Markdown/Markdown.tsx
import { Fragment as Fragment2, jsx as jsx46, jsxs as jsxs23 } from "react/jsx-runtime";
function escapeBrackets(text) {
  const pattern = /(```[\s\S]*?```|`.*?`)|\\\[([\s\S]*?[^\\])\\\]|\\\((.*?)\\\)/g;
  return text.replace(
    pattern,
    (match, codeBlock, squareBracket, roundBracket) => {
      if (codeBlock) {
        return codeBlock;
      } else if (squareBracket) {
        return `$$${squareBracket}$$`;
      } else if (roundBracket) {
        return `$$${roundBracket}$$`;
      }
      return match;
    }
  );
}
var MemoizedReactMarkdown = memo4(
  ReactMarkdown,
  (prevProps, nextProps) => prevProps.children === nextProps.children && prevProps.className === nextProps.className
);
var MarkdownMessage = memo4(
  ({
    className,
    cursor,
    content,
    renderHtml = false,
    onCodeCopy,
    onHrefTagClick,
    imagePreview = true,
    tools = []
    // file,
    // onFileClick,
  }) => {
    const iframeRef = useRef7(null);
    const [htmlRender, setHtmlRender] = useState9(false);
    const setHtmlWidthRef = useRef7();
    const [searchData, setSearchData] = useState9([]);
    const [setDataSourceList, appendSetDataSource] = useState9([]);
    const escapedContent = useMemo4(() => escapeBrackets(content), [content]);
    useEffect6(() => {
      var _a;
      if (!htmlRender)
        return;
      const avatar = (_a = document.querySelector('.scroll-content img[alt="avatar"]')) == null ? void 0 : _a.parentNode;
      const ele = document.querySelector(
        ".chat-message-list-container > .scroll-content"
      );
      const message = document.querySelector(".__message-item");
      if (!ele || !avatar || !message)
        return;
      const avatarWidth = Number.parseInt(getComputedStyle(avatar).marginLeft) + Number.parseInt(getComputedStyle(avatar).marginRight) + avatar.offsetWidth;
      const messagePadding = Number.parseInt(getComputedStyle(message).paddingLeft) + Number.parseInt(getComputedStyle(message).paddingRight);
      const messageMaxWidth = Number.parseInt(
        getComputedStyle(message).maxWidth
      );
      const observer = new ResizeObserver(
        debounce2((entries) => {
          var _a2;
          for (const entry of entries) {
            const newWidth = entry.contentRect.width;
            const chartWidth = newWidth - avatarWidth - 8 - messagePadding;
            const maxWidth = messageMaxWidth - messagePadding;
            (_a2 = setHtmlWidthRef.current) == null ? void 0 : _a2.call(
              setHtmlWidthRef,
              chartWidth > maxWidth ? maxWidth : chartWidth
            );
          }
        }, 300)
      );
      observer.observe(ele);
      return () => observer.disconnect();
    }, [htmlRender]);
    const warpElRef = useRef7(null);
    useEffect6(() => {
      var _a, _b;
      if (!(tools == null ? void 0 : tools.length))
        return;
      const searchTool = (tools ?? []).find((item) => {
        var _a2;
        return isSearch((_a2 = item == null ? void 0 : item.data) == null ? void 0 : _a2.function_code);
      });
      const searchDataOutput = ((_b = (_a = searchTool == null ? void 0 : searchTool.data) == null ? void 0 : _a.content) == null ? void 0 : _b.output) ?? [];
      if (!(searchDataOutput == null ? void 0 : searchDataOutput.length))
        return;
      setSearchData(searchDataOutput);
    }, [tools]);
    useEffect6(() => {
      setDataSourceList.map((setDataSource) => setDataSource == null ? void 0 : setDataSource(searchData));
    }, [setDataSourceList, searchData]);
    const renderCiteComp = useMemo4(() => {
      return ({ children }) => /* @__PURE__ */ jsx46(
        MarkdownCite_default,
        {
          onHrefTagClick,
          appendSetDataSource,
          children
        }
      );
    }, [appendSetDataSource, onHrefTagClick]);
    const renderCode = useMemo4(() => {
      return ({ inline, className: className2, children, ...props }) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const scrollBarRef = useContext(ScrollbarContext);
        const [htmlWidth, setHtmlWidth] = useState9(0);
        const [htmlHeight, setHtmlHeight] = useState9(0);
        setHtmlWidthRef.current = setHtmlWidth;
        useMutationObserver(
          (mutations) => {
            var _a2, _b2, _c2, _d2;
            const doc = ((_a2 = iframeRef.current) == null ? void 0 : _a2.contentDocument) || ((_c2 = (_b2 = iframeRef.current) == null ? void 0 : _b2.contentWindow) == null ? void 0 : _c2.document);
            setHtmlHeight(((_d2 = doc == null ? void 0 : doc.documentElement) == null ? void 0 : _d2.scrollHeight) || 0);
            if (scrollBarRef.current && mutations[0].type === "attributes" && mutations[0].attributeName === "height") {
              scrollBarRef.current.update();
              const maxOffsetY = scrollBarRef.current.limit.y;
              scrollBarRef.current.scrollTo(0, maxOffsetY);
            }
          },
          iframeRef,
          { attributes: true }
        );
        if (inline) {
          return /* @__PURE__ */ jsx46("code", { ...props, className: className2, children });
        }
        const match = /language-(\w+)/.exec(className2 || "");
        let language = (match == null ? void 0 : match[1]) || "";
        if (language === "markdown") {
          language = "";
        }
        const code = String(children).replace(/\n$/, "");
        if (language === "htmlRender") {
          const tags = ((_a = className2 == null ? void 0 : className2.replace("language-", "")) == null ? void 0 : _a.split("-")) || [];
          const isChart = tags.includes("chart");
          const renderSize = {
            renderMode: "auto"
          };
          if (isChart) {
            if (tags.findIndex((item) => item.startsWith("ratio")) !== -1) {
              const ratioStr = (_c = (_b = tags.find((item) => item.startsWith("ratio"))) == null ? void 0 : _b.split(":")) == null ? void 0 : _c[1];
              if (ratioStr && !Number.isNaN(Number(ratioStr))) {
                renderSize.renderMode = "ratio";
                renderSize.ratio = Number(ratioStr);
              }
            } else if (tags.findIndex((item) => item.startsWith("height")) !== -1 && tags.findIndex((item) => item.startsWith("width")) !== -1) {
              const heightStr = (_e = (_d = tags.find((item) => item.startsWith("height"))) == null ? void 0 : _d.split(":")) == null ? void 0 : _e[1];
              const widthStr = (_g = (_f = tags.find((item) => item.startsWith("width"))) == null ? void 0 : _f.split(":")) == null ? void 0 : _g[1];
              if (heightStr && widthStr && !Number.isNaN(Number(heightStr)) && !Number.isNaN(Number(widthStr))) {
                renderSize.renderMode = "fixed";
                renderSize.size = {
                  height: Number(heightStr),
                  width: Number(widthStr)
                };
              }
            }
          }
          setHtmlRender(true);
          const width = isChart && renderSize.renderMode === "fixed" ? renderSize.size.width : htmlWidth;
          const height = isChart ? renderSize.renderMode === "auto" ? htmlWidth : renderSize.renderMode === "ratio" ? htmlWidth / renderSize.ratio : renderSize.size.height : htmlHeight;
          return /* @__PURE__ */ jsx46(
            "iframe",
            {
              ref: iframeRef,
              className: "ui-border-0 ui-p-0 ui-m-0",
              srcDoc: code,
              width,
              height,
              onLoad: () => {
                if (iframeRef.current && iframeRef.current.contentWindow) {
                  iframeRef.current.contentWindow.addEventListener(
                    "mousewheel",
                    (e) => {
                      if (scrollBarRef.current) {
                        scrollBarRef.current.setPosition(
                          scrollBarRef.current.offset.x,
                          scrollBarRef.current.offset.y + e.deltaY
                        );
                      }
                    }
                  );
                }
              }
            }
          );
        }
        if (!code) {
          return;
        }
        return /* @__PURE__ */ jsxs23(Fragment2, { children: [
          /* @__PURE__ */ jsx46(
            CodeBlockTool_default,
            {
              language,
              code,
              onCopyClick: onCodeCopy
            }
          ),
          /* @__PURE__ */ jsx46(
            SyntaxHighlighter,
            {
              style: atomOneDark,
              customStyle: {
                borderRadius: "0 0 8px 8px"
              },
              language,
              PreTag: "div",
              wrapLongLines: true,
              children: code
            }
          )
        ] });
      };
    }, []);
    const renderAnchor = useMemo4(
      () => (props) => /* @__PURE__ */ jsx46(
        MarkdownAnchor,
        {
          ...props,
          onClick: onHrefTagClick,
          imagePreview
        }
      ),
      [imagePreview]
    );
    const renderImage = useMemo4(
      () => (props) => {
        return /* @__PURE__ */ jsx46(
          MarkdownImage,
          {
            src: props.src || "",
            ...props,
            preview: imagePreview
          }
        );
      },
      [imagePreview]
    );
    const renderVideo = useMemo4(
      () => (props) => {
        return /* @__PURE__ */ jsx46(MarkdownVideo, { src: props.src || "" });
      },
      []
    );
    useRemoveExtraNewlines(warpElRef.current);
    const rehypePlugins = renderHtml ? [
      [rehypeKatex, { strict: false, throwOnError: false }],
      renderCite_default,
      [rehypeRaw, { allowDangerousHtml: false }]
    ] : [[rehypeKatex, { strict: false, throwOnError: false }], renderCite_default];
    return /* @__PURE__ */ jsx46("div", { ref: warpElRef, className, children: /* @__PURE__ */ jsx46("div", { className: "ui-rounded-xl ui-text-[14px]/7 ui-text-yeah ui-rounded-tl-sm", children: /* @__PURE__ */ jsx46(
      MemoizedReactMarkdown,
      {
        className: cn16(
          "chat-markdown-message  ui-prose ui-max-w-none ui-break-words ui-markdown ui-break-all ui-overflow-x-auto ui-overflow-y-hidden [&_.katex-display]:ui-overflow-x-auto [&_.katex-display]:ui-overflow-y-hidden",
          cursor ? "result-streaming" : ""
        ),
        components: {
          cite: renderCiteComp,
          a: renderAnchor,
          p: MarkdownParagraph,
          li: MarkdownLi,
          img: renderImage,
          code: renderCode,
          h1: MarkdownH1,
          h2: MarkdownH2,
          h3: MarkdownH3,
          h4: MarkdownH4,
          h5: MarkdownH5,
          // br: MarkdownBr,
          video: renderVideo,
          table: MarkDownTable,
          em: ({ children }) => /* @__PURE__ */ jsxs23("span", { children: [
            "*",
            children[0],
            "*"
          ] })
        },
        rehypePlugins,
        remarkPlugins: [
          remarkGfm,
          [remarkMath, { singleDollarTextMath: false }],
          removeStrikethrough,
          RemarkBreaks
        ],
        remarkRehypeOptions: {
          footnoteLabel: "\u811A\u6CE8",
          footnoteBackLabel: null,
          footnoteBackContent: null
        },
        linkTarget: "_blank",
        children: escapedContent
      }
    ) }) });
  }
);

// src/components/message/QuestionGuideList.tsx
import { jsx as jsx47, jsxs as jsxs24 } from "react/jsx-runtime";
function QuestionGuideList(props) {
  const { questions, onQuestionClick } = props;
  return /* @__PURE__ */ jsx47("div", { children: questions.map((question, i) => /* @__PURE__ */ jsxs24(
    "div",
    {
      className: "ui-mt-[8px]  ui-max-w-[100%] ui-min-w-[302px] ui-w-fit ui-py-[4px] ui-px-[12px] ui-flex ui-items-center ui-justify-between ui-leading-[14px] ui-rounded-[8px] ui-border-[1px] ui-border-solid ui-border-[#e1e1e5] ui-border-opacity-80 ui-text-[12px] ui-text-[#17171d] hover:ui-bg-[#626999]/[0.08] ui-cursor-pointer",
      onClick: () => onQuestionClick(question),
      children: [
        /* @__PURE__ */ jsx47(MarkdownMessage, { content: question, cursor: false }),
        /* @__PURE__ */ jsx47(SvgRightArrow, { className: "ui-ml-[28px] ui-shrink-0 ui-text-primary" })
      ]
    },
    i
  )) });
}

// src/components/message/type/Text.tsx
import { cn as cn17 } from "@bty/util";
import { jsx as jsx48, jsxs as jsxs25 } from "react/jsx-runtime";
function Text({
  className,
  content,
  file,
  fileClassName,
  onFileClick
}) {
  return /* @__PURE__ */ jsxs25("div", { className: cn17(className), children: [
    /* @__PURE__ */ jsx48("p", { className: "ui-w-ful ui-whitespace-pre-line ui-break-words ui-leading-[26px] ui-text-yeah ui-text-base/6", children: content }),
    file && /* @__PURE__ */ jsx48(
      File,
      {
        className: cn17(
          "ui-mt-[10px] ui-w-full ui-max-w-full ui-pr-[10.5px]",
          fileClassName
        ),
        name: file.name,
        type: file.type,
        url: file.url,
        onFileClick
      }
    )
  ] });
}

// src/components/message/MessageAction.tsx
import { memo as memo5 } from "react";
import { cn as cn18 } from "@bty/util";

// src/assets/svg/edit2.svg
import * as React27 from "react";
import { jsx as jsx49 } from "react/jsx-runtime";
var SvgEdit2 = (props) => /* @__PURE__ */ jsx49("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 14, height: 14, viewBox: "0 0 14 14", ...props, children: /* @__PURE__ */ jsx49("g", { children: /* @__PURE__ */ jsx49("g", { children: /* @__PURE__ */ jsx49("path", { d: "M11.6099,2.8026400000000002L10.19736,1.390071C9.67727,0.869976,8.83403,0.869976,8.31393,1.390071L1.390071,8.31393C1.138438,8.565570000000001,0.9979779,8.907440000000001,1.000021995,9.2633L1.00997996,10.99694C1.0131228,11.5441,1.455906,11.9869,2.00306,11.99L3.7367,12C4.092560000000001,12.002,4.43444,11.8616,4.68607,11.6099L11.6099,4.68607C12.13,4.16597,12.13,3.32274,11.6099,2.8026400000000002ZM9.25565,2.42826L10.57174,3.74435L3.71626,10.59984L2.40768,10.59232L2.40016,9.28374L9.25565,2.42826ZM12.9998,12.7L6.9998,12.7C6.61321,12.7,6.2998,12.3866,6.2998,12C6.2998,11.6134,6.61321,11.3,6.9998,11.3L12.9998,11.3C13.3864,11.3,13.6998,11.6134,13.6998,12C13.6998,12.3866,13.3864,12.7,12.9998,12.7Z", fillRule: "evenodd", fill: "currentColor", fillOpacity: 1 }) }) }) });

// src/components/message/MessageAction.tsx
import { jsx as jsx50, jsxs as jsxs26 } from "react/jsx-runtime";
var ACTIONS = [
  {
    action: "edit",
    icon: /* @__PURE__ */ jsx50(SvgEdit2, { width: 14, height: 14 }),
    tooltip: "\u518D\u6B21\u8F93\u5165"
  },
  {
    action: "copy",
    icon: /* @__PURE__ */ jsx50(SvgCopy2, { width: 14, height: 14 }),
    tooltip: "\u590D\u5236"
  }
];
var MessageAction = memo5(
  ({
    className,
    topOffset,
    actions,
    position = "left",
    onActionClick,
    children
  }) => {
    const innerActions = actions ? ACTIONS.filter((item) => actions.includes(item.action)) : ACTIONS;
    return /* @__PURE__ */ jsxs26(
      "div",
      {
        className: cn18(
          "ui-group",
          "ui-flex ui-items-end ui-justify-end ui-gap-[6px]",
          className,
          { "ui-flex-row-reverse": position === "left" }
        ),
        children: [
          position === "right" && /* @__PURE__ */ jsx50("div", { className: "ui-flex", children: innerActions.map((item) => /* @__PURE__ */ jsx50(Tooltip2, { title: item.tooltip, children: /* @__PURE__ */ jsx50(
            "div",
            {
              className: "ui-flex-center ui-cursor-pointer ui-rounded ui-invisible ui-h-[24px] ui-w-[24px] ui-shrink-0 ui-p-0 ui-text-base !ui-text-yeah-icon_light hover:ui-bg-yeah-icon_light/8 group-hover:ui-visible",
              style: { marginTop: topOffset },
              onClick: (event) => {
                event.stopPropagation();
                onActionClick == null ? void 0 : onActionClick(item.action);
              },
              children: item.icon
            },
            item.action
          ) }, item.action)) }),
          children
        ]
      }
    );
  }
);

// src/components/message/ToolIcon.tsx
import { cn as cn19 } from "@bty/util";
import { jsx as jsx51 } from "react/jsx-runtime";
function ToolIcon(props) {
  const { IconSVG, tooltip, onClick, active, disabled } = props;
  return /* @__PURE__ */ jsx51(Tooltip2, { title: tooltip, children: /* @__PURE__ */ jsx51(
    "div",
    {
      className: cn19(
        "ui-w-[24px] ui-h-[24px] ui-flex ui-items-center ui-justify-center ui-rounded-[4px] ",
        {
          "hover:bg-[rgba(98,105,153,0.08)] ui-cursor-pointer": !disabled,
          "ui-cursor-not-allowed": disabled
        }
      ),
      onClick: () => !disabled && (onClick == null ? void 0 : onClick()),
      children: /* @__PURE__ */ jsx51(
        IconSVG,
        {
          width: 14,
          height: 14,
          className: cn19("ui-text-opacity-60", {
            "ui-text-[#626999] ": !active,
            "ui-text-primary": active
          })
        }
      )
    }
  ) });
}

// src/components/message/constants.ts
var DEFAULT_GIF_IMAGE = "https://resource.bantouyan.com/battleyeah-ai/agent/loading.gif";
var GRAY_GIF_IMAGE = "https://resource.bantouyan.com/battleyeah-ai/agent/loading.gif";
var QUESTION_LOADING_GIF = "https://resource.bantouyan.com/battleyeah-ai/chat/loading.svg";

// src/components/message/FormMessage.tsx
import { SchemaForm } from "@bty/ui-components";
import { useMemo as useMemo7, useState as useState12 } from "react";
import { cn as cn28 } from "@bty/util";

// src/shadcn/ui/button.tsx
import * as React28 from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn as cn20 } from "@bty/util";
import { jsx as jsx52 } from "react/jsx-runtime";
var buttonVariants = cva(
  "ui-inline-flex ui-border-none ui-items-center  ui-justify-center ui-rounded-[8px] ui-text-sm ui-font-medium ui-ring-offset-background ui-transition-colors focus-visible:ui-outline-none focus-visible:ui-ring-2 focus-visible:ui-ring-ring focus-visible:ui-ring-offset-2 disabled:ui-pointer-events-none disabled:ui-opacity-50",
  {
    variants: {
      variant: {
        default: "ui-bg-primary ui-text-primary-foreground hover:ui-bg-primary/90 hover:bg-primary/90",
        destructive: "ui-bg-destructive ui-text-destructive-foreground hover:ui-bg-destructive/90",
        outline: "ui-border !ui-border-[1px] !ui-border-solid !ui-border-[#E1E1E5] ui-bg-background hover:ui-bg-[#626999]/[0.08] hover:ui-text-accent-foreground",
        secondary: "ui-bg-secondary ui-text-secondary-foreground hover:ui-bg-secondary/80",
        ghost: "hover:ui-bg-accent hover:ui-text-accent-foreground",
        link: "ui-text-primary ui-underline-offset-4 hover:ui-underline"
      },
      size: {
        default: "ui-h-[35px] ui-px-[14px] ui-py-[7px] !ui-text-[14px]",
        sm: "ui-h-[31.5px] ui-rounded-md ui-px-[10.5px]",
        lg: "ui-h-[38.5px] ui-rounded-md px-[28px]",
        icon: "ui-h-[40px] ui-w-[40px]",
        small: "ui-px-[8px] ui-py-[6px] !ui-text-[12px] !ui-leading-[12px] !ui-rounded-[6px] focus-visible:!ui-ring-0 focus-visible:!ui-ring-offset-0"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
var Button = React28.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return /* @__PURE__ */ jsx52(
      Comp,
      {
        className: cn20(buttonVariants({ variant, size, className })),
        ref,
        ...props
      }
    );
  }
);
Button.displayName = "Button";

// src/assets/svg/loading.svg
import * as React29 from "react";
import { jsx as jsx53, jsxs as jsxs27 } from "react/jsx-runtime";
var SvgLoading = (props) => /* @__PURE__ */ jsxs27("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 20, height: 20, viewBox: "0 0 20 20", ...props, children: [
  /* @__PURE__ */ jsx53("defs", { children: /* @__PURE__ */ jsx53("clipPath", { id: "master_svg0_417_20488", children: /* @__PURE__ */ jsx53("rect", { x: 0, y: 0, width: 20, height: 20, rx: 0 }) }) }),
  /* @__PURE__ */ jsx53("g", { clipPath: "url(#master_svg0_417_20488)", children: /* @__PURE__ */ jsx53("g", { children: /* @__PURE__ */ jsx53("path", { d: "M15.6569,4.34315Q13.3137,2,10,2Q9.90151,2,9.80491,2.019215Q9.70831,2.03843,9.61732,2.076121Q9.52632,2.1138120000000002,9.44443,2.16853Q9.36254,2.223249,9.29289,2.292893Q9.22325,2.362537,9.16853,2.44443Q9.11381,2.526322,9.07612,2.617317Q9.03843,2.708311,9.019210000000001,2.80491Q9,2.9015086,9,3Q9,3.0984914,9.019210000000001,3.19509Q9.03843,3.291689,9.07612,3.382683Q9.11381,3.473678,9.16853,3.55557Q9.22325,3.637463,9.29289,3.707107Q9.36254,3.776751,9.44443,3.83147Q9.52632,3.8861879999999998,9.61732,3.923879Q9.70831,3.96157,9.80491,3.980785Q9.90151,4,10,4Q12.48528,4,14.2426,5.75736Q16,7.51472,16,10Q16,12.48528,14.2426,14.2426Q12.48528,16,10,16Q7.51472,16,5.75736,14.2426Q4,12.48528,4,10Q4,9.9015,3.980785,9.80491Q3.96157,9.70831,3.923879,9.61731Q3.8861879999999998,9.52632,3.83147,9.44443Q3.776751,9.36253,3.707107,9.29289Q3.637463,9.22325,3.55557,9.16853Q3.473678,9.11381,3.382683,9.07612Q3.291689,9.03843,3.19509,9.019210000000001Q3.0984914,9,3,9Q2.9015086,9,2.80491,9.019210000000001Q2.708311,9.03843,2.617317,9.07612Q2.526322,9.11381,2.44443,9.16853Q2.362537,9.22325,2.292893,9.29289Q2.223249,9.36254,2.16853,9.44443Q2.1138120000000002,9.52632,2.076121,9.61732Q2.03843,9.70831,2.019215,9.80491Q2,9.90151,2,10Q2,13.3137,4.34315,15.6569Q6.68629,18,10,18Q13.3137,18,15.6569,15.6569Q18,13.3137,18,10Q18,6.68629,15.6569,4.34315Z", fillRule: "evenodd", fill: "currentColor" }) }) })
] });

// src/components/message/FormMessageComponentMap.tsx
import { cloneElement } from "react";
import { cn as cn27 } from "@bty/util";

// src/base/components/form/Input.tsx
import * as React30 from "react";
import { cn as cn22 } from "@bty/util";

// src/base/components/form/baseStyle.ts
import { cn as cn21 } from "@bty/util";
function baseInputStyle(hasError) {
  return cn21(
    "ui-bg-[#f6f7f9] focus-within:ui-bg-white ui-rounded-lg ui-py-[3px] ui-px-[12px] ui-text-[14px] ui-box-border",
    "ui-outline-none ui-border-[1px] ui-border-[#f6f7f9] ui-border-solid",
    "hover:ui-bg-white hover:ui-border-primary ui-cursor-pointer",
    "disabled:ui-cursor-not-allowed disabled:ui-opacity-80",
    "placeholder:ui-text-[#b7b7bf]",
    {
      "!ui-border-yeah-danger focus-within:!ui-border-yeah-danger focus-within:ui-shadow-[0_0_0_2px_var(--input-error-shadow)]": hasError,
      "focus-within:ui-border-primary focus-within:ui-shadow-[0_0_0_2px_var(--input-shadow)]": !hasError
    }
  );
}

// src/base/components/form/Input.tsx
import { jsx as jsx54 } from "react/jsx-runtime";
var Input = React30.forwardRef(
  ({ className, validateStatus, ...restProps }, ref) => {
    const hasError = validateStatus === "error";
    const classNames = cn22(baseInputStyle(hasError), className);
    return /* @__PURE__ */ jsx54("input", { ref, className: classNames, ...restProps });
  }
);

// src/base/components/form/TextArea.tsx
import * as React31 from "react";
import { cn as cn23 } from "@bty/util";
import { jsx as jsx55 } from "react/jsx-runtime";
var TextArea = React31.forwardRef(
  ({ className, validateStatus, ...restProps }, ref) => {
    const hasError = validateStatus === "error";
    const classNames = cn23(
      baseInputStyle(hasError),
      "ui-m-[0px] ui-block",
      className
    );
    return /* @__PURE__ */ jsx55("textarea", { ref, className: classNames, ...restProps });
  }
);

// src/base/components/form/JsonEditor.tsx
import * as React32 from "react";
import { useMemo as useMemo5 } from "react";
import { jsx as jsx56 } from "react/jsx-runtime";
var JsonEditor = React32.forwardRef((props, ref) => {
  const value = useMemo5(() => {
    var _a;
    if (typeof props.value === "string") {
      return props.value;
    } else {
      try {
        return JSON.stringify(props.value);
      } catch (e) {
        return (_a = props.value) == null ? void 0 : _a.toString();
      }
    }
  }, [props.value]);
  return /* @__PURE__ */ jsx56(TextArea, { ref, ...props, value });
});

// src/base/components/form/Select.tsx
import { useMemo as useMemo6, useRef as useRef8, useState as useState10 } from "react";
import * as Popover3 from "@radix-ui/react-popover";
import { cn as cn24 } from "@bty/util";

// src/assets/svg/check-mark.svg
import * as React33 from "react";
import { jsx as jsx57 } from "react/jsx-runtime";
var SvgCheckMark = (props) => /* @__PURE__ */ jsx57("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: /* @__PURE__ */ jsx57("g", { children: /* @__PURE__ */ jsx57("g", { children: /* @__PURE__ */ jsx57("g", { children: /* @__PURE__ */ jsx57("path", { d: "M5.758826980857849,12.764528968200684C5.652526980857849,12.712518968200683,5.552866980857849,12.642328968200683,5.464506980857849,12.553968968200683L1.2218619808578493,8.311328968200684C0.7922859808578491,7.881748968200683,0.7922859808578491,7.185268968200684,1.2218619808578493,6.755688968200683C1.6514389808578491,6.326118968200683,2.347916980857849,6.326118968200683,2.7774969808578494,6.755688968200683L6.2437569808578495,10.221948968200683L13.24464698085785,3.2211069682006834C13.674146980857849,2.7915299682006838,14.370646980857849,2.7915299682006838,14.80024698085785,3.2211069682006834C15.229846980857848,3.650682968200684,15.229846980857848,4.347168968200684,14.80024698085785,4.776738968200684L7.022056980857849,12.554918968200683C6.6803169808578495,12.896658968200684,6.169646980857849,12.966568968200683,5.758826980857849,12.764528968200684Z", fill: "currentColor", fillRule: "evenodd", fillOpacity: 1 }) }) }) }) });

// src/assets/svg/close.svg
import * as React34 from "react";
import { jsx as jsx58, jsxs as jsxs28 } from "react/jsx-runtime";
var SvgClose2 = (props) => /* @__PURE__ */ jsx58("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: /* @__PURE__ */ jsx58("g", { children: /* @__PURE__ */ jsxs28("g", { children: [
  /* @__PURE__ */ jsx58("g", {}),
  /* @__PURE__ */ jsx58("g", { children: /* @__PURE__ */ jsx58("path", { d: "M13.74881171875,2.250679C14.08311171875,2.584917,14.08311171875,3.12682,13.74881171875,3.46106L9.20989171875,7.9994L13.74881171875,12.5389C14.08311171875,12.8732,14.08311171875,13.4151,13.74881171875,13.7493C13.41461171875,14.0836,12.87271171875,14.0836,12.53841171875,13.7493L7.99951171875,9.20978L3.46057171875,13.7493C3.12633171875,14.0836,2.58442871875,14.0836,2.25019071875,13.7493C1.91595211875,13.4151,1.91595211875,12.8732,2.25019071875,12.5389L6.78913171875,7.9994L2.25019071875,3.46106C1.91595211875,3.12682,1.91595211875,2.584917,2.25019071875,2.250679C2.58442871875,1.9164404,3.12633171875,1.9164404,3.46057171875,2.250679L7.99951171875,6.78901L12.53841171875,2.250679C12.87271171875,1.9164404,13.41461171875,1.9164404,13.74881171875,2.250679Z", fillRule: "evenodd", fill: "currentColor", fillOpacity: 1 }) })
] }) }) });

// src/base/components/form/Select.tsx
import { jsx as jsx59, jsxs as jsxs29 } from "react/jsx-runtime";
function Select(props) {
  var _a;
  const {
    validateStatus,
    placeholder,
    options = [],
    onChange,
    disabled,
    type
  } = props;
  const [open, setOpen] = useState10(false);
  const container = useRef8(null);
  const value = useMemo6(() => {
    const $value = props.value;
    if (type === "single") {
      return typeof $value === "string" ? $value : $value == null ? void 0 : $value.toString();
    } else {
      return Array.isArray($value) ? $value : [];
    }
  }, [props.value]);
  const isSelected = type === "single" ? !!value : value && value.length > 0;
  const hasError = validateStatus === "error";
  const isMulti = type === "multi";
  const onSelect = (selectValue) => {
    if (!disabled) {
      if (isMulti) {
        const newValue = [...value ?? []];
        const selectIndex = newValue.findIndex((i) => i === selectValue);
        if (selectIndex !== -1) {
          newValue.splice(selectIndex, 1);
        } else {
          newValue.push(selectValue);
        }
        onChange == null ? void 0 : onChange(newValue);
      } else {
        onChange == null ? void 0 : onChange(selectValue);
        setOpen(false);
      }
    }
  };
  const singleSelector = () => {
    return /* @__PURE__ */ jsx59(
      "div",
      {
        className: cn24(
          "ui-pl-[8px] ui-py-[6px] ui-text-[14px] ui-m-0 ui-pr-[10px] ui-leading-[1] ui-truncate ui-min-h-[26px] ui-w-full ui-flex-1",
          {
            "ui-text-[#b7b7bf]": !isSelected,
            "ui-text-[#8d8d99]": open
          }
        ),
        children: isSelected ? value : placeholder
      }
    );
  };
  const multiSelector = () => {
    return /* @__PURE__ */ jsx59("div", { className: "ui-flex-1 ui-min-h-[26px]", children: isSelected ? /* @__PURE__ */ jsx59("div", { className: "ui-flex ui-gap-[4px] ui-flex-wrap", children: value.map((item) => {
      return /* @__PURE__ */ jsxs29(
        "div",
        {
          className: cn24(
            "ui-text-[14px] ui-bg-[#e4e5ed] ui-rounded-[6px] ui-px-[6px] ui-leading-[1]",
            "ui-flex ui-h-[26px] ui-items-center"
          ),
          children: [
            /* @__PURE__ */ jsx59("span", { children: item }),
            /* @__PURE__ */ jsx59(
              SvgClose2,
              {
                className: "ui-w-[12px] ui-ml-[2px] ui-text-[#8D8D99]",
                onClick: () => {
                  const _newValue = [...value];
                  const selectIndex = _newValue.findIndex((i) => i === item);
                  if (selectIndex !== -1) {
                    _newValue.splice(selectIndex, 1);
                    onChange == null ? void 0 : onChange(_newValue);
                  }
                }
              }
            )
          ]
        },
        item
      );
    }) }) : /* @__PURE__ */ jsx59("div", { className: "ui-py-[6px] ui-pl-[8px] ui-text-[14px] ui-leading-[1] ui-text-[#b7b7bf]", children: placeholder }) });
  };
  return /* @__PURE__ */ jsx59("div", { className: "ui-w-full", ref: container, children: /* @__PURE__ */ jsxs29(Popover3.Root, { open, onOpenChange: setOpen, children: [
    /* @__PURE__ */ jsx59(
      Popover3.Trigger,
      {
        asChild: true,
        onClick: () => {
          if (!disabled) {
            setOpen(true);
          }
        },
        children: /* @__PURE__ */ jsxs29(
          "div",
          {
            className: cn24(
              baseInputStyle(hasError),
              "!ui-p-[4px] ui-border ui-transition-all ui-duration-200 ui-ease-in-out ui-w-full ui-flex ui-items-center",
              {
                "!ui-bg-white !ui-border-primary ui-shadow-[0_0_0_2px_var(--input-shadow)]": open,
                "ui-shadow-[0_0_0_2px_var(--input-error-shadow)]": open && hasError
              }
            ),
            children: [
              isMulti ? multiSelector() : singleSelector(),
              /* @__PURE__ */ jsx59(
                SvgArrowDown,
                {
                  className: cn24("ui-mr-[8px]", {
                    "ui-text-[#8d8d99]": open
                  })
                }
              )
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ jsx59(Popover3.Portal, { container: container.current, children: /* @__PURE__ */ jsx59(
      Popover3.Content,
      {
        sideOffset: 5,
        style: {
          width: (_a = container.current) == null ? void 0 : _a.clientWidth,
          boxShadow: "rgba(14, 18, 22, 0.35) 0px 10px 38px -10px, rgba(14, 18, 22, 0.2) 0px 10px 20px -15px"
        },
        className: "ui-w-full ui-outline-0 ui-bg-white ui-animate-in ui-fade-in ui-duration-150 ui-rounded-lg",
        children: /* @__PURE__ */ jsx59("div", { className: "ui-flex ui-box-border ui-flex-col ui-p-[4px] ui-flex-1 ui-w-full", children: options.length ? options.map((item) => {
          const isSelect = isMulti ? value == null ? void 0 : value.includes(item.value) : value === item.value;
          return /* @__PURE__ */ jsxs29(
            "div",
            {
              className: cn24(
                "ui-px-[10px] ui-py-[7px] ui-cursor-pointer hover:ui-bg-[#F2F2F7] ui-text-[14px]",
                "ui-box-border ui-rounded-lg ui-flex ui-items-center ui-justify-between",
                {
                  "ui-bg-[#f5f3ff] ui-font-500": isSelect
                }
              ),
              onClick: () => onSelect(item.value),
              children: [
                /* @__PURE__ */ jsx59("span", { children: item.label }),
                isSelect && /* @__PURE__ */ jsx59(
                  SvgCheckMark,
                  {
                    className: cn24(
                      "ui-text-primary ui-mt-[1px] ui-w-[14px]",
                      {
                        "ui-op-0": !isSelect
                      }
                    )
                  }
                )
              ]
            },
            item.value
          );
        }) : /* @__PURE__ */ jsx59("div", { className: "ui-py-[30px] ui-w-full ui-text-[14px] ui-text-[#8d8d99] ui-text-center", children: "\u6682\u65E0\u6570\u636E" }) })
      }
    ) })
  ] }) });
}

// src/base/components/form/TagViewSelect.tsx
import { cn as cn25 } from "@bty/util";
import { jsx as jsx60 } from "react/jsx-runtime";
function TagViewSelect(props) {
  const { type, options, value, onChange, disabled } = props;
  const isMulti = type === "multi";
  const onSelect = (selectValue) => {
    if (disabled)
      return;
    if (type === "multi") {
      const newValue = [...value ?? []];
      const selectIndex = newValue.findIndex((i) => i === selectValue);
      if (selectIndex !== -1) {
        newValue.splice(selectIndex, 1);
      } else {
        newValue.push(selectValue);
      }
      onChange == null ? void 0 : onChange(newValue);
    } else {
      onChange == null ? void 0 : onChange(selectValue);
    }
  };
  return /* @__PURE__ */ jsx60("div", { className: "ui-flex ui-flex-wrap ui-gap-[8px]", children: options.map((option) => {
    const isSelect = isMulti ? value == null ? void 0 : value.includes(option.value) : value === option.value;
    return /* @__PURE__ */ jsx60(
      "div",
      {
        className: cn25(
          "ui-px-[10px] ui-py-[7px] ui-rounded-[8px] ui-max-w-full ui-text-[14px] ui-leading-[20px] ui-bg-[#f2f2f7] ui-cursor-pointer",
          "ui-border-solid ui-border-[1px] ui-border-[#f2f2f7]",
          {
            "!ui-cursor-not-allowed": disabled,
            "hover:!ui-border-primary": !isSelect && !disabled,
            "!ui-bg-[#eae7ff] ui-font-500": isSelect
          }
        ),
        onClick: () => onSelect(option.value),
        children: option.label
      },
      option.value
    );
  }) });
}

// src/components/message/FormMessageFileUpload.tsx
import Upload from "rc-upload";
import { useState as useState11 } from "react";
import { getFileVariantFromUrlOrFileName, cn as cn26 } from "@bty/util";
import { FileIcon as FileIcon2 } from "@bty/ui-components";

// src/assets/svg/file-upload.svg
import * as React35 from "react";
import { jsx as jsx61, jsxs as jsxs30 } from "react/jsx-runtime";
var SvgFileUpload = (props) => /* @__PURE__ */ jsxs30("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 24, height: 28, viewBox: "0 0 24 28", ...props, children: [
  /* @__PURE__ */ jsxs30("defs", { children: [
    /* @__PURE__ */ jsxs30("linearGradient", { x1: 0.5, y1: 0, x2: 0.5, y2: 1, id: "master_svg0_18892_018919", children: [
      /* @__PURE__ */ jsx61("stop", { offset: "0%", stopColor: "#626999", stopOpacity: 0.17000000178813934 }),
      /* @__PURE__ */ jsx61("stop", { offset: "100%", stopColor: "#626999", stopOpacity: 0.2800000011920929 })
    ] }),
    /* @__PURE__ */ jsx61("clipPath", { id: "master_svg1_18892_018992", children: /* @__PURE__ */ jsx61("rect", { x: 6, y: 12, width: 12, height: 12, rx: 0 }) }),
    /* @__PURE__ */ jsxs30("linearGradient", { x1: 0, y1: 1, x2: 0.4574218690395355, y2: 0.4697265625, id: "master_svg2_18892_018179", children: [
      /* @__PURE__ */ jsx61("stop", { offset: "0%", stopColor: "#FFFFFF", stopOpacity: 1 }),
      /* @__PURE__ */ jsx61("stop", { offset: "100%", stopColor: "#FFFFFF", stopOpacity: 0 })
    ] })
  ] }),
  /* @__PURE__ */ jsxs30("g", { children: [
    /* @__PURE__ */ jsx61("g", { children: /* @__PURE__ */ jsx61("path", { d: "M0,26L0,2C0,0.895431,0.895431,0,2,0L13.1716,0C13.702,0,14.2107,0.210714,14.5858,0.585786L23.4142,9.41421C23.7893,9.78929,24,10.298,24,10.8284L24,26C24,27.1046,23.1046,28,22,28L2,28C0.895431,28,0,27.1046,0,26", fillRule: "evenodd", fill: "url(#master_svg0_18892_018919)", fillOpacity: 1 }) }),
    /* @__PURE__ */ jsx61("g", { clipPath: "url(#master_svg1_18892_018992)", children: /* @__PURE__ */ jsx61("g", { children: /* @__PURE__ */ jsx61("g", { children: /* @__PURE__ */ jsx61("path", { d: "M13.71967,17.030832290649414L12.75,16.061162290649413L12.75,19.583892290649416C12.75,19.952092290649414,12.41422,20.250562290649412,12,20.250562290649412C11.58579,20.250562290649412,11.25,19.952092290649414,11.25,19.583892290649416L11.25,16.061162290649413L10.28033,17.030832290649414C10.13967,17.171482290649415,9.94891,17.250502290649415,9.75,17.250502290649415C9.55109,17.250502290649415,9.36033,17.171482290649415,9.21967,17.030832290649414C9.07902,16.890182290649413,9,16.699422290649416,9,16.500502290649415C9,16.301592290649413,9.07902,16.110822290649413,9.21967,15.970172290649414L11.2045,13.985337290649413Q11.53401,13.655832290649414,12,13.655832290649414Q12.46599,13.655832290649414,12.7955,13.985337290649413L14.780090000000001,15.969942290649414C14.92098,16.110822290649413,15,16.301592290649413,15,16.500502290649415C15,16.699422290649416,14.92098,16.890182290649413,14.78033,17.030832290649414C14.648489999999999,17.162682290649414,14.47227,17.240682290649413,14.28603,17.249632290649416C14.27403,17.250212290649415,14.26202,17.250502290649415,14.25,17.250502290649415C14.05109,17.250502290649415,13.860330000000001,17.171482290649415,13.71967,17.030832290649414ZM8.25,21.000562290649412C7.835787,21.000562290649412,7.5,21.336342290649412,7.5,21.750562290649412C7.5,22.164772290649417,7.835787,22.500522290649414,8.25,22.500522290649414L15.75,22.500522290649414C16.16417,22.500522290649414,16.5,22.164772290649417,16.5,21.750562290649412C16.5,21.336342290649412,16.16417,21.000562290649412,15.75,21.000562290649412L8.25,21.000562290649412Z", fillRule: "evenodd", fill: "#FFFFFF", fillOpacity: 1 }) }) }) }),
    /* @__PURE__ */ jsx61("g", { children: /* @__PURE__ */ jsx61("path", { d: "M14,9C14,9.55229,14.447715,10,15,10L24,10L14,0L14,9Z", fill: "url(#master_svg2_18892_018179)", fillOpacity: 1 }) })
  ] })
] });

// src/assets/svg/trash.svg
import * as React36 from "react";
import { jsx as jsx62, jsxs as jsxs31 } from "react/jsx-runtime";
var SvgTrash = (props) => /* @__PURE__ */ jsx62("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: /* @__PURE__ */ jsxs31("g", { children: [
  /* @__PURE__ */ jsx62("g", {}),
  /* @__PURE__ */ jsx62("g", { children: /* @__PURE__ */ jsx62("path", { "data-type": "delete", d: "M6.19439,1.15283203125Q6.12326,1.15283203125,6.05349,1.16670933125Q5.98372,1.18058663125,5.91801,1.20780793125Q5.85229,1.23502923125,5.79314,1.27454803125Q5.734,1.31406803125,5.6837,1.3643660312499999Q5.6334,1.41466403125,5.59388,1.47380903125Q5.55436,1.53295403125,5.52714,1.59867203125Q5.4999199999999995,1.66439003125,5.48604,1.73415603125Q5.47217,1.80392203125,5.47217,1.87505403125Q5.47217,1.94618703125,5.48604,2.01595303125Q5.4999199999999995,2.08571903125,5.52714,2.15143703125Q5.55436,2.21715203125,5.59388,2.27630203125Q5.6334,2.33544203125,5.6837,2.38574203125Q5.734,2.43604203125,5.79314,2.47556203125Q5.85229,2.51508203125,5.91801,2.54230203125Q5.98372,2.56952203125,6.05349,2.58340203125Q6.12326,2.59727203125,6.19439,2.59727203125L9.8055,2.59727203125Q9.87663,2.59727203125,9.9464,2.58340203125Q10.01616,2.56952203125,10.08188,2.54230203125Q10.1476,2.51508203125,10.20675,2.47556203125Q10.26589,2.43604203125,10.31619,2.38574203125Q10.36649,2.33544203125,10.40601,2.27630203125Q10.44553,2.21715203125,10.47275,2.15143703125Q10.49997,2.08571903125,10.51385,2.01595303125Q10.52772,1.94618703125,10.52772,1.87505403125Q10.52772,1.80392203125,10.51385,1.73415603125Q10.49997,1.66439003125,10.47275,1.59867203125Q10.44553,1.53295403125,10.40601,1.47380903125Q10.36649,1.41466403125,10.31619,1.3643660312499999Q10.26589,1.31406803125,10.20675,1.27454803125Q10.1476,1.23502923125,10.08188,1.20780793125Q10.01616,1.18058663125,9.9464,1.16670933125Q9.87663,1.15283203125,9.8055,1.15283203125L6.19439,1.15283203125ZM2.222222,5.48612203125C1.82335,5.48612203125,1.5,5.16277203125,1.5,4.7637220312499995C1.5,4.36485203125,1.82335,4.041502031249999,2.222222,4.041502031249999L13.7778,4.041502031249999C14.1767,4.041502031249999,14.5,4.36485203125,14.5,4.7637220312499995C14.5,5.16277203125,14.1767,5.48612203125,13.7778,5.48612203125L12.8713,5.48612203125Q12.8644,6.43877203125,12.872,12.33823203125C12.8735,13.53613203125,11.903,14.51413203125,10.70511,14.51413203125L5.29167,14.51413203125C4.0950500000000005,14.51413203125,3.125,13.54413203125,3.125,12.34753203125L3.125,5.48612203125L2.222222,5.48612203125ZM6.55568,12.65043203125C6.95453,12.65043203125,7.27786,12.32703203125,7.27786,11.92823203125L7.27793,7.29136203125C7.27794,6.89249203125,6.95459,6.56914203125,6.55571,6.56914203125C6.15684,6.56914203125,5.8335,6.89248203125,5.8335,7.29135203125L5.8335,11.92823203125C5.8335,12.32703203125,6.15683,12.65043203125,6.55568,12.65043203125ZM10.17044,11.92823203125C10.17043,12.32703203125,9.8471,12.65043203125,9.448260000000001,12.65043203125C9.04941,12.65043203125,8.72607,12.32703203125,8.72607,11.92823203125L8.72607,7.29135203125C8.72607,6.89248203125,9.04942,6.56914203125,9.44829,6.56914203125C9.84717,6.56914203125,10.17051,6.89249203125,10.17051,7.29136203125L10.17044,11.92823203125Z", fillRule: "evenodd", fill: "currentColor", fillOpacity: 1 }) })
] }) });

// src/components/message/FormMessageFileUpload.tsx
import { jsx as jsx63, jsxs as jsxs32 } from "react/jsx-runtime";
function FormMessageFileUpload(props) {
  var _a, _b, _c;
  const {
    className,
    value,
    onChange,
    supportFileConfig,
    validateStatus,
    onFileUpload,
    disabled
  } = props;
  const hasError = validateStatus === "error";
  const [file, setFile] = useState11(null);
  if (value) {
    let valuePathArr = [];
    try {
      valuePathArr = ((_b = (_a = new URL(value)) == null ? void 0 : _a.pathname) == null ? void 0 : _b.split("/")) ?? [];
    } catch (err) {
      console.error(err);
    }
    const valueFileName = valuePathArr[valuePathArr.length - 1];
    const variant = getFileVariantFromUrlOrFileName(
      value,
      supportFileConfig == null ? void 0 : supportFileConfig.type,
      file == null ? void 0 : file.name
    );
    return /* @__PURE__ */ jsxs32("div", { className: "ui-flex ui-w-full ui-items-center ui-px-[10px] ui-py-[2px] ui-box-border ui-overflow-hidden ui-rounded-[6px] ui-bg-[#f6f6f9]", children: [
      /* @__PURE__ */ jsxs32("div", { className: "ui-flex ui-w-full ui-items-center ui-flex-1 ui-overflow-hidden", children: [
        /* @__PURE__ */ jsx63("div", { className: "ui-w-[30px] ui-h-[30px] ui-rounded-[4px] ui-overflow-hidden", children: variant === "image" ? /* @__PURE__ */ jsx63(
          "img",
          {
            src: value,
            className: "ui-w-full ui-h-full ui-object-cover",
            alt: file == null ? void 0 : file.name
          }
        ) : /* @__PURE__ */ jsx63(FileIcon2, { variant, className: "ui-w-[30px] ui-h-[30px]" }) }),
        /* @__PURE__ */ jsx63("div", { className: "ui-flex-1 ui-w-full ui-font-400 ui-text-[14px] ui-ml-[8px] ui-truncate", children: (file == null ? void 0 : file.name) ?? valueFileName })
      ] }),
      !disabled && /* @__PURE__ */ jsx63(
        SvgTrash,
        {
          className: "ui-cursor-pointer ui-flex-shrink-0 ui-ml-[12px] ui-w-[14px] ui-text-[#9da1c0]",
          onClick: () => {
            setFile(null);
            onChange == null ? void 0 : onChange("");
          }
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsx63(
    Upload,
    {
      disabled,
      accept: (_c = supportFileConfig == null ? void 0 : supportFileConfig.support) == null ? void 0 : _c.join(","),
      customRequest: async (options) => {
        var _a2;
        const file2 = options.file;
        const res = await onFileUpload({ file: file2 });
        if ((_a2 = res == null ? void 0 : res.data) == null ? void 0 : _a2.file_url) {
          setFile(file2);
          onChange == null ? void 0 : onChange(res.data.file_url);
        }
      },
      children: /* @__PURE__ */ jsxs32(
        "div",
        {
          className: cn26(
            className,
            "ui-bg-[#f6f6f9] hover:ui-bg-white",
            "ui-h-90px ui-w-full ui-flex ui-flex-col ui-items-center ui-box-border ui-p-[20px] ui-cursor-pointer",
            "ui-border-dashed ui-border-[1px] ui-rounded-[6px] ui-border-[#e5e5e9] hover:ui-border-primary",
            { "!ui-border-yeah-danger": hasError }
          ),
          children: [
            /* @__PURE__ */ jsx63(SvgFileUpload, { className: "ui-w-[24px]" }),
            /* @__PURE__ */ jsxs32("div", { className: "ui-mt-[10px] ui-text-[14px] ui-leading-[20px]", children: [
              /* @__PURE__ */ jsxs32("span", { children: [
                "\u62D6\u62FD\u3010",
                (supportFileConfig == null ? void 0 : supportFileConfig.name) ?? "\u6587\u4EF6",
                "\u3011\u5230\u8FD9\uFF0C\u6216"
              ] }),
              /* @__PURE__ */ jsx63("span", { className: "ui-text-primary ui-ml-[4px] ui-cursor-pointer", children: "\u70B9\u6B64\u4E0A\u4F20" })
            ] })
          ]
        }
      )
    }
  );
}

// src/components/message/FormMessageComponentMap.tsx
import { jsx as jsx64, jsxs as jsxs33 } from "react/jsx-runtime";
var FormItem = (props) => {
  const { children, schema, control, meta } = props;
  const hasError = meta.errors.length > 0;
  const ClonedChildren = cloneElement(children, {
    ...control,
    placeholder: schema.placeholder,
    disabled: meta.disabled,
    validateStatus: hasError ? "error" : "",
    className: cn27(children.props.className, schema.className)
  });
  return /* @__PURE__ */ jsxs33("div", { className: "ui-mb-[16px] ui-w-full ui-box-border", children: [
    /* @__PURE__ */ jsxs33("div", { className: "ui-pb-[8px] ui-flex ui-items-center", children: [
      /* @__PURE__ */ jsx64("span", { className: "ui-text-[14px] ui-text-yeah ui-font-400 ui-leading-[1]", children: schema.label }),
      schema.required && /* @__PURE__ */ jsx64("span", { className: "ui-text-[#FF5219] ui-font-400 ui-ml-[3px] ui-text-[14px] ui-leading-[14px] ui-h-[14px]", children: "*" })
    ] }),
    ClonedChildren,
    /* @__PURE__ */ jsx64(
      "div",
      {
        className: cn27(
          "ui-flex ui-flex-col ui-h-0 ui-op-0 ui-transition-all-200 ui-ease-in-out",
          {
            "!ui-h-auto !ui-op-100 ui-mt-[4px]": hasError
          }
        ),
        children: meta.errors.map((error, index) => /* @__PURE__ */ jsx64(
          "div",
          {
            className: "ui-text-[#FF5219] ui-text-[12px] ui-pt-[8px] ui-pb-[12px] ui-leading-[1]",
            children: error
          },
          error + index
        ))
      }
    ),
    hasError && /* @__PURE__ */ jsx64("div", { className: "ui-mb-[-16px]" })
  ] });
};
function getFormItemComponentMap(onFileUpload) {
  return {
    input: (schema, control, meta) => {
      return /* @__PURE__ */ jsx64(FormItem, { control, schema, meta, children: /* @__PURE__ */ jsx64(Input, { className: "!ui-w-full", autoFocus: schema.autoFocus }) });
    },
    textarea: (schema, control, meta) => {
      return /* @__PURE__ */ jsx64(FormItem, { control, schema, meta, children: /* @__PURE__ */ jsx64(
        TextArea,
        {
          className: "ui-w-full ui-resize-none",
          rows: 3,
          autoFocus: schema.autoFocus
        }
      ) });
    },
    json: (schema, control, meta) => {
      return /* @__PURE__ */ jsx64(FormItem, { control, schema, meta, children: /* @__PURE__ */ jsx64(JsonEditor, { className: "ui-w-full ui-resize-none", rows: 5 }) });
    },
    select: (schema, control, meta) => {
      return /* @__PURE__ */ jsx64(FormItem, { control, schema, meta, children: schema.viewMode === "flat" ? /* @__PURE__ */ jsx64(TagViewSelect, { type: "single", options: schema.options }) : /* @__PURE__ */ jsx64(Select, { type: "single", options: schema.options }) });
    },
    multiSelect: (schema, control, meta) => {
      return /* @__PURE__ */ jsx64(FormItem, { control, schema, meta, children: schema.viewMode === "flat" ? /* @__PURE__ */ jsx64(TagViewSelect, { type: "multi", options: schema.options }) : /* @__PURE__ */ jsx64(Select, { type: "multi", options: schema.options }) });
    },
    file: (schema, control, meta) => {
      return onFileUpload ? /* @__PURE__ */ jsx64(FormItem, { control, schema, meta, children: /* @__PURE__ */ jsx64(
        FormMessageFileUpload,
        {
          onFileUpload,
          supportFileConfig: schema.supportFileConfig,
          supportFileTypes: schema == null ? void 0 : schema.supportFileTypes
        }
      ) }) : /* @__PURE__ */ jsx64("div", { className: "ui-mb-[16px] ui-text-[14px] ui-text-[#8d8d99]", children: "\u6682\u4E0D\u652F\u6301\u56FE\u7247\u4E0A\u4F20" });
    }
  };
}

// src/components/message/FormMessage.tsx
import { jsx as jsx65, jsxs as jsxs34 } from "react/jsx-runtime";
function FormMessage(props) {
  const {
    formConfig,
    flowId,
    recordId,
    formWelcome,
    formItemComponentMap,
    onFormSubmit,
    formData,
    disabled,
    onFileUpload
  } = props;
  const [isSubmit, setIsSubmit] = useState12(props.isSubmit);
  const [isFold, setIsFold] = useState12(true);
  const [loading, setLoading] = useState12(false);
  const [form] = SchemaForm.useForm();
  const formSchema = useMemo7(() => {
    return formConfig.map((item) => ({
      ...item,
      name: item.variableName
    }));
  }, [formConfig]);
  const onSubmit = async () => {
    if (!recordId) {
      console.error("form submit error, miss required field [recordId]");
      return;
    }
    setLoading(true);
    try {
      const values = await form.validateFields();
      await (onFormSubmit == null ? void 0 : onFormSubmit(flowId, recordId, values));
      setIsSubmit(true);
    } catch (e) {
      console.error("form submit error:", e);
    } finally {
      setLoading(false);
    }
  };
  const disabledResult = disabled || isSubmit || loading;
  if (isSubmit && isFold) {
    return /* @__PURE__ */ jsxs34(
      "div",
      {
        className: cn28(
          "ui-py-[2px] ui-pl-[12px] ui-pr-[4px] ui-bg-[#fff] ui-rounded-[8px] ui-mt-[8px] ui-min-w-[150px]",
          "ui-font-400 ui-flex ui-items-center ui-justify-between ui-text-[12px]/[12px] ui-text-[#8d8d99] "
        ),
        onClick: () => setIsFold(false),
        children: [
          /* @__PURE__ */ jsx65("span", { children: "\u8868\u5355\u5DF2\u63D0\u4EA4" }),
          /* @__PURE__ */ jsx65("span", { className: "ui-w-[24px] ui-h-[24px] ui-rounded-[4px] hover:ui-bg-[#626999]/[0.12] ui-flex ui-items-center ui-justify-center", children: /* @__PURE__ */ jsx65(SvgArrowDown, { className: "ui-text-[#8d8d99] ui-rotate-[270deg]" }) })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs34(
    "div",
    {
      className: cn28(
        "ui-mt-[8px] ui-bg-[#fff] ui-rounded-[8px] ui-p-[12px] ui-min-w-[300px] ui-max-w-[500px] ui-relative",
        {
          "!ui-pt-[6px]": formWelcome.trim()
        }
      ),
      children: [
        isSubmit && !isFold && /* @__PURE__ */ jsx65(
          "span",
          {
            className: "ui-w-[24px] ui-h-[24px] ui-rounded-[4px] hover:ui-bg-[#626999]/[0.12] ui-flex ui-items-center ui-justify-center ui-absolute ui-top-[6px] ui-right-[6px]",
            onClick: () => setIsFold(true),
            children: /* @__PURE__ */ jsx65(SvgArrowDown, { className: "ui-text-[#8d8d99] ui-rotate-[180deg]" })
          }
        ),
        formWelcome.trim() && /* @__PURE__ */ jsx65(
          "div",
          {
            className: "ui-font-400 ui-mb-[16px] ui-text-[14px] ui-min-w-[400px] ui-leading-[24px]",
            onClick: () => setIsFold(true),
            children: formWelcome
          }
        ),
        /* @__PURE__ */ jsx65(
          SchemaForm,
          {
            form,
            disabled: disabledResult,
            schema: formSchema,
            initialValues: formData ?? {},
            fieldComponentsMap: formItemComponentMap ?? getFormItemComponentMap(onFileUpload)
          }
        ),
        /* @__PURE__ */ jsxs34(
          Button,
          {
            className: cn28("ui-w-full ui-h-[36px]", {
              "!ui-border-[#7B67EE] hover:!ui-border-[#7B67EE]/60 ui-text-[#7B67EE] hover:ui-bg-[#fff] hover:!ui-text-[#7B67EE]/60": !disabledResult,
              "ui-text-[#7B67EE]/60 !ui-border-[#7B67EE]/60": disabledResult
            }),
            onClick: onSubmit,
            variant: "outline",
            disabled: disabledResult,
            children: [
              isSubmit ? "\u5DF2\u63D0\u4EA4" : "\u63D0\u4EA4",
              loading && /* @__PURE__ */ jsx65(SvgLoading, { className: "ui-ml-[8px] ui-w-[14px] ui-h-[14px] ui-animate-spin" })
            ]
          }
        )
      ]
    }
  );
}

// src/assets/svg/more.svg
import * as React37 from "react";
import { jsx as jsx66, jsxs as jsxs35 } from "react/jsx-runtime";
var SvgMore = (props) => /* @__PURE__ */ jsxs35("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: [
  /* @__PURE__ */ jsx66("defs", { children: /* @__PURE__ */ jsx66("clipPath", { id: "master_svg0_1452_19579", children: /* @__PURE__ */ jsx66("rect", { x: 0, y: 0, width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsx66("g", { clipPath: "url(#master_svg0_1452_19579)", children: /* @__PURE__ */ jsxs35("g", { children: [
    /* @__PURE__ */ jsx66("g", { style: {
      opacity: 0
    }, children: /* @__PURE__ */ jsx66("g", { children: /* @__PURE__ */ jsx66("rect", { x: 0, y: 0, width: 16, height: 16, rx: 0, fill: "currentColor", fillOpacity: 1 }) }) }),
    /* @__PURE__ */ jsx66("g", { children: /* @__PURE__ */ jsx66("g", { children: /* @__PURE__ */ jsx66("path", { d: "M4.66667,8.000078046875Q4.66667,8.065588046875,4.66025,8.130768046875Q4.65383,8.195958046874999,4.64105,8.260198046875Q4.6282700000000006,8.324448046875,4.609249999999999,8.387128046875Q4.59024,8.449808046875,4.56517,8.510328046875Q4.54011,8.570838046875,4.5092300000000005,8.628608046875Q4.47835,8.686378046875,4.44196,8.740838046875Q4.40557,8.795308046875,4.36401,8.845938046875Q4.3224599999999995,8.896578046875,4.27614,8.942888046875Q4.22983,8.989208046875,4.17919,9.030758046875Q4.12856,9.072318046875,4.07409,9.108708046875Q4.019629999999999,9.145098046874999,3.9618599999999997,9.175978046875Q3.90409,9.206858046875,3.84358,9.231918046875Q3.78306,9.256988046875,3.72038,9.275998046875Q3.6577,9.295018046875,3.59345,9.307798046875Q3.52921,9.320578046875,3.46402,9.326998046875Q3.39884,9.333418046875,3.33333,9.333418046875Q3.26783,9.333418046875,3.2026399999999997,9.326998046875Q3.13746,9.320578046875,3.07321,9.307798046875Q3.0089699999999997,9.295018046875,2.946287,9.275998046875Q2.883605,9.256988046875,2.823089,9.231918046875Q2.762572,9.206858046875,2.704804,9.175978046875Q2.647036,9.145098046874999,2.592573,9.108708046875Q2.53811,9.072318046875,2.487476,9.030758046875Q2.436842,8.989208046875,2.390524,8.942888046875Q2.344207,8.896578046875,2.302653,8.845938046875Q2.261098,8.795308046875,2.224707,8.740838046875Q2.188316,8.686378046875,2.157438,8.628608046875Q2.126561,8.570838046875,2.101494,8.510328046875Q2.0764272,8.449808046875,2.0574129,8.387128046875Q2.0383985,8.324448046875,2.0256195,8.260198046875Q2.0128407,8.195958046874999,2.00642037,8.130768046875Q2,8.065588046875,2,8.000078046875Q2,7.934578046875,2.00642037,7.869388046875Q2.0128407,7.804208046875,2.0256195,7.7399580468749996Q2.0383985,7.675718046875,2.0574129,7.613035046875Q2.0764272,7.550353046875,2.101494,7.4898370468749995Q2.126561,7.4293200468750005,2.157438,7.371552046875Q2.188316,7.313784046875,2.224707,7.259321046875Q2.261098,7.204858046875,2.302653,7.154224046875Q2.344207,7.103590046875,2.390524,7.057272046875Q2.436842,7.010955046875,2.487476,6.969401046875Q2.53811,6.927846046875,2.592573,6.891455046875Q2.647036,6.855064046875,2.704804,6.824186046875Q2.762572,6.793309046875,2.823089,6.768242046875Q2.883605,6.743175046875,2.946287,6.724161146875Q3.0089699999999997,6.705146346875,3.07321,6.692367546875Q3.13746,6.679588746875,3.2026399999999997,6.673168186875Q3.26783,6.666748046875,3.33333,6.666748046875Q3.39884,6.666748046875,3.46402,6.673168186875Q3.52921,6.679588746875,3.59345,6.692367546875Q3.6577,6.705146346875,3.72038,6.724161146875Q3.78306,6.743175046875,3.84358,6.768242046875Q3.90409,6.793309046875,3.9618599999999997,6.824186046875Q4.019629999999999,6.855064046875,4.07409,6.891455046875Q4.12856,6.927846046875,4.17919,6.969401046875Q4.22983,7.010955046875,4.27614,7.057272046875Q4.3224599999999995,7.103590046875,4.36401,7.154224046875Q4.40557,7.204858046875,4.44196,7.259321046875Q4.47835,7.313784046875,4.5092300000000005,7.371552046875Q4.54011,7.4293200468750005,4.56517,7.4898370468749995Q4.59024,7.550353046875,4.609249999999999,7.613035046875Q4.6282700000000006,7.675718046875,4.64105,7.7399580468749996Q4.65383,7.804208046875,4.66025,7.869388046875Q4.66667,7.934578046875,4.66667,8.000078046875ZM9.333169999999999,8.000078046875Q9.333169999999999,8.065588046875,9.32675,8.130768046875Q9.32033,8.195958046874999,9.307549999999999,8.260198046875Q9.29477,8.324448046875,9.27576,8.387128046875Q9.25674,8.449808046875,9.23168,8.510328046875Q9.206610000000001,8.570838046875,9.17573,8.628608046875Q9.14485,8.686378046875,9.108460000000001,8.740838046875Q9.07207,8.795308046875,9.03052,8.845938046875Q8.988959999999999,8.896578046875,8.94265,8.942888046875Q8.896329999999999,8.989208046875,8.845690000000001,9.030758046875Q8.79506,9.072318046875,8.7406,9.108708046875Q8.68613,9.145098046874999,8.62837,9.175978046875Q8.570599999999999,9.206858046875,8.51008,9.231918046875Q8.44957,9.256988046875,8.38688,9.275998046875Q8.324200000000001,9.295018046875,8.25996,9.307798046875Q8.19571,9.320578046875,8.13053,9.326998046875Q8.065339999999999,9.333418046875,7.99984,9.333418046875Q7.93433,9.333418046875,7.86915,9.326998046875Q7.80396,9.320578046875,7.73972,9.307798046875Q7.67547,9.295018046875,7.61279,9.275998046875Q7.55011,9.256988046875,7.48959,9.231918046875Q7.42908,9.206858046875,7.37131,9.175978046875Q7.31354,9.145098046874999,7.25908,9.108708046875Q7.20461,9.072318046875,7.15398,9.030758046875Q7.10334,8.989208046875,7.05703,8.942888046875Q7.01071,8.896578046875,6.96916,8.845938046875Q6.9276,8.795308046875,6.89121,8.740838046875Q6.85482,8.686378046875,6.82394,8.628608046875Q6.79306,8.570838046875,6.768,8.510328046875Q6.74293,8.449808046875,6.72392,8.387128046875Q6.7049,8.324448046875,6.69212,8.260198046875Q6.67934,8.195958046874999,6.67292,8.130768046875Q6.6665,8.065588046875,6.6665,8.000078046875Q6.6665,7.934578046875,6.67292,7.869388046875Q6.67934,7.804208046875,6.69212,7.7399580468749996Q6.7049,7.675718046875,6.72392,7.613035046875Q6.74293,7.550353046875,6.768,7.4898370468749995Q6.79306,7.4293200468750005,6.82394,7.371552046875Q6.85482,7.313784046875,6.89121,7.259321046875Q6.9276,7.204858046875,6.96916,7.154224046875Q7.01071,7.103590046875,7.05703,7.057272046875Q7.10334,7.010955046875,7.15398,6.969401046875Q7.20461,6.927846046875,7.25908,6.891455046875Q7.31354,6.855064046875,7.37131,6.824186046875Q7.42908,6.793309046875,7.48959,6.768242046875Q7.55011,6.743175046875,7.61279,6.724161146875Q7.67547,6.705146346875,7.73972,6.692367546875Q7.80396,6.679588746875,7.86915,6.673168186875Q7.93433,6.666748046875,7.99984,6.666748046875Q8.065339999999999,6.666748046875,8.13053,6.673168186875Q8.19571,6.679588746875,8.25996,6.692367546875Q8.324200000000001,6.705146346875,8.38688,6.724161146875Q8.44957,6.743175046875,8.51008,6.768242046875Q8.570599999999999,6.793309046875,8.62837,6.824186046875Q8.68613,6.855064046875,8.7406,6.891455046875Q8.79506,6.927846046875,8.845690000000001,6.969401046875Q8.896329999999999,7.010955046875,8.94265,7.057272046875Q8.988959999999999,7.103590046875,9.03052,7.154224046875Q9.07207,7.204858046875,9.108460000000001,7.259321046875Q9.14485,7.313784046875,9.17573,7.371552046875Q9.206610000000001,7.4293200468750005,9.23168,7.4898370468749995Q9.25674,7.550353046875,9.27576,7.613035046875Q9.29477,7.675718046875,9.307549999999999,7.7399580468749996Q9.32033,7.804208046875,9.32675,7.869388046875Q9.333169999999999,7.934578046875,9.333169999999999,8.000078046875ZM14.0002,8.000078046875Q14.0002,8.065588046875,13.9937,8.130768046875Q13.9873,8.195958046874999,13.9745,8.260198046875Q13.9618,8.324448046875,13.9427,8.387128046875Q13.9237,8.449808046875,13.8987,8.510328046875Q13.8736,8.570838046875,13.8427,8.628608046875Q13.8118,8.686378046875,13.7755,8.740838046875Q13.7391,8.795308046875,13.6975,8.845938046875Q13.656,8.896578046875,13.6096,8.942888046875Q13.5633,8.989208046875,13.5127,9.030758046875Q13.4621,9.072318046875,13.4076,9.108708046875Q13.3531,9.145098046874999,13.2954,9.175978046875Q13.2376,9.206858046875,13.1771,9.231918046875Q13.1166,9.256988046875,13.0539,9.275998046875Q12.9912,9.295018046875,12.9269,9.307798046875Q12.8627,9.320578046875,12.7975,9.326998046875Q12.7323,9.333418046875,12.6668,9.333418046875Q12.6013,9.333418046875,12.5361,9.326998046875Q12.471,9.320578046875,12.4067,9.307798046875Q12.3425,9.295018046875,12.2798,9.275998046875Q12.2171,9.256988046875,12.1566,9.231918046875Q12.0961,9.206858046875,12.0383,9.175978046875Q11.98053,9.145098046874999,11.92607,9.108708046875Q11.8716,9.072318046875,11.82097,9.030758046875Q11.77034,8.989208046875,11.72402,8.942888046875Q11.6777,8.896578046875,11.63615,8.845938046875Q11.59459,8.795308046875,11.5582,8.740838046875Q11.52181,8.686378046875,11.49093,8.628608046875Q11.46006,8.570838046875,11.43499,8.510328046875Q11.40992,8.449808046875,11.39091,8.387128046875Q11.37189,8.324448046875,11.35911,8.260198046875Q11.34634,8.195958046874999,11.33992,8.130768046875Q11.3335,8.065588046875,11.3335,8.000078046875Q11.3335,7.934578046875,11.33992,7.869388046875Q11.34634,7.804208046875,11.35911,7.7399580468749996Q11.37189,7.675718046875,11.39091,7.613035046875Q11.40992,7.550353046875,11.43499,7.4898370468749995Q11.46006,7.4293200468750005,11.49093,7.371552046875Q11.52181,7.313784046875,11.5582,7.259321046875Q11.59459,7.204858046875,11.63615,7.154224046875Q11.6777,7.103590046875,11.72402,7.057272046875Q11.77034,7.010955046875,11.82097,6.969401046875Q11.8716,6.927846046875,11.92607,6.891455046875Q11.98053,6.855064046875,12.0383,6.824186046875Q12.0961,6.793309046875,12.1566,6.768242046875Q12.2171,6.743175046875,12.2798,6.724161146875Q12.3425,6.705146346875,12.4067,6.692367546875Q12.471,6.679588746875,12.5361,6.673168186875Q12.6013,6.666748046875,12.6668,6.666748046875Q12.7323,6.666748046875,12.7975,6.673168186875Q12.8627,6.679588746875,12.9269,6.692367546875Q12.9912,6.705146346875,13.0539,6.724161146875Q13.1166,6.743175046875,13.1771,6.768242046875Q13.2376,6.793309046875,13.2954,6.824186046875Q13.3531,6.855064046875,13.4076,6.891455046875Q13.4621,6.927846046875,13.5127,6.969401046875Q13.5633,7.010955046875,13.6096,7.057272046875Q13.656,7.103590046875,13.6975,7.154224046875Q13.7391,7.204858046875,13.7755,7.259321046875Q13.8118,7.313784046875,13.8427,7.371552046875Q13.8736,7.4293200468750005,13.8987,7.4898370468749995Q13.9237,7.550353046875,13.9427,7.613035046875Q13.9618,7.675718046875,13.9745,7.7399580468749996Q13.9873,7.804208046875,13.9937,7.869388046875Q14.0002,7.934578046875,14.0002,8.000078046875Z", fill: "currentColor", fillOpacity: 1 }) }) })
  ] }) })
] });

// src/components/message/RelatedQuestion.tsx
import { jsx as jsx67, jsxs as jsxs36 } from "react/jsx-runtime";
function RelatedQuestion(props) {
  const { loading, questions, onSend, onToggle } = props;
  return loading ? /* @__PURE__ */ jsx67("div", { className: "ui-w-[36px] ui-rounded-[8px] ui-overflow-hidden", children: /* @__PURE__ */ jsx67(
    "img",
    {
      className: "ui-w-[8px] ui-h-[8px] ui-animate-blink ui-text-yeah ui-opacity-50",
      src: QUESTION_LOADING_GIF,
      alt: "loading"
    }
  ) }) : /* @__PURE__ */ jsxs36("div", { className: "ui-w-fit", children: [
    /* @__PURE__ */ jsxs36("div", { className: "ui-mb-[12px] ui-flex ui-justify-between ui-items-center", children: [
      /* @__PURE__ */ jsx67("span", { className: "ui-text-[12px] ui-text-yeah-light", children: "\u63A8\u8350\u63D0\u95EE" }),
      /* @__PURE__ */ jsxs36(Popover, { children: [
        /* @__PURE__ */ jsx67(
          PopoverContent,
          {
            className: "!ui-p-0 !ui-border-0",
            style: { outline: "none" },
            children: /* @__PURE__ */ jsx67(
              "div",
              {
                className: "ui-bg-white ui-px-[16px] ui-py-[8px] ui-rounded-[8px] ui-text-[#17171d] ui-text-[14px] ui-shadow-[0px_8px_24px_0px_rgba(0,0,0,0.2)] ui-backdrop-blur-lg ui-cursor-pointer",
                onClick: () => onToggle(false),
                children: "\u672C\u6B21\u4F1A\u8BDD\u4E0D\u518D\u63A8\u8350"
              }
            )
          }
        ),
        /* @__PURE__ */ jsx67(PopoverTrigger, { className: "ui-border-0 ui-border-none", children: /* @__PURE__ */ jsx67(SvgMore, {}) })
      ] })
    ] }),
    questions.map((q, i) => /* @__PURE__ */ jsxs36(
      "div",
      {
        className: "ui-mb-[8px]  ui-max-w-[100%] ui-min-w-[302px] ui-w-fit ui-h-[32px] ui-px-[12px] ui-flex ui-items-center ui-justify-between ui-leading-[14px] ui-rounded-[8px] ui-border-[1px] ui-border-solid ui-border-[#e1e1e5] ui-border-opacity-80 ui-text-[12px] ui-text-[#17171d] hover:ui-bg-[#626999]/[0.08] ui-cursor-pointer",
        onClick: () => onSend(q),
        children: [
          /* @__PURE__ */ jsx67("p", { children: q }),
          /* @__PURE__ */ jsx67(SvgRightArrow, { className: "ui-ml-[28px] ui-shrink-0 ui-text-[#17171d]" })
        ]
      },
      i
    ))
  ] });
}

// src/components/message/TaskMessage.tsx
import { memo as memo6 } from "react";
import { Fragment as Fragment3, jsx as jsx68, jsxs as jsxs37 } from "react/jsx-runtime";
var TaskMessage = memo6((props) => {
  const { task, toDetail, ...restProps } = props;
  return /* @__PURE__ */ jsxs37(Fragment3, { children: [
    /* @__PURE__ */ jsxs37(
      "div",
      {
        className: "ui-p-[2px] ui-cursor-pointer ui-inline-block ui-rounded-full ui-text-[#fff] ui-bg-[#7B61FF] ui-text-[12px]/[12px]",
        onClick: toDetail,
        children: [
          /* @__PURE__ */ jsx68("span", { className: "ui-inline-block ui-bg-[#654AED] ui-rounded-full ui-py-[2px] ui-px-[6px]", children: "\u4EFB\u52A1" }),
          /* @__PURE__ */ jsx68("span", { className: "ui-px-[4px]", children: task.title })
        ]
      }
    ),
    task.status === "FAILED" ? /* @__PURE__ */ jsxs37("div", { className: "ui-bg-[#F9ECED] ui-mt-[8px] ui-text-[#FF5219] ui-text-[12px]/[18px] ui-p-[12px] ui-rounded-[12px]", children: [
      props.content,
      /* @__PURE__ */ jsx68(
        "span",
        {
          className: "ui-text-[#FF5219] ui-ml-[8px] ui-underline ui-font-500 ui-cursor-pointer",
          onClick: toDetail,
          children: "\u8BE6\u60C5"
        }
      )
    ] }) : /* @__PURE__ */ jsx68(MarkdownMessage, { className: "ui-mt-[6px]", ...restProps })
  ] });
});

// src/components/message/Message.tsx
import { Fragment as Fragment4, jsx as jsx69, jsxs as jsxs38 } from "react/jsx-runtime";
async function getClipboardDom(dom) {
  const tables = dom.querySelectorAll("table");
  tables.forEach((table, index) => {
    table.setAttribute("data-table-id", `table-${index}`);
  });
  const tableImages = await Promise.all(
    Array.from(tables).map(async (table, index) => {
      table.classList.add("draw");
      try {
        const tableHeader = table.querySelector("thead");
        const columnCount = tableHeader == null ? void 0 : tableHeader.querySelectorAll("th").length;
        const dataUrl = await toPng(table, {
          width: columnCount ? columnCount * 200 : table.offsetWidth,
          height: table.offsetHeight
        });
        table.classList.remove("draw");
        return { id: `table-${index}`, dataUrl };
      } catch (error) {
        console.error("\u5C06\u8868\u683C\u8F6C\u6362\u4E3A\u56FE\u7247\u65F6\u51FA\u9519:", error);
        table.classList.remove("draw");
        return null;
      }
    })
  );
  const clonedDom = dom.cloneNode(true);
  const videos = clonedDom == null ? void 0 : clonedDom.querySelectorAll("video");
  videos.forEach((video) => {
    var _a;
    const a = document.createElement("a");
    a.href = video.src;
    a.textContent = video.src;
    (_a = video.parentNode) == null ? void 0 : _a.replaceChild(a, video);
  });
  const anchors = clonedDom == null ? void 0 : clonedDom.querySelectorAll("a");
  anchors.forEach((anchor) => {
    const text = anchor.innerText;
    anchor.innerText = `${text}(${anchor.href})`;
  });
  tableImages.forEach((tableImage) => {
    if (tableImage) {
      const tableElement = clonedDom.querySelector(
        `[data-table-id="${tableImage.id}"]`
      );
      if (tableElement) {
        const img = document.createElement("img");
        img.src = tableImage.dataUrl;
        img.alt = "\u8868\u683C\u56FE\u7247";
        tableElement.parentNode && tableElement.parentNode.replaceChild(img, tableElement);
      }
    }
  });
  return clonedDom;
}
var Message = memo7((props) => {
  var _a, _b, _c, _d, _e, _f;
  const {
    // 用于插件详情页 回复信息撑开最大宽度
    id,
    feedback_id,
    allowLogger = false,
    responseExtend = false,
    position = "left",
    avatarInfo,
    messageType = "text",
    content = "",
    file,
    className,
    actions,
    header,
    footer,
    backgroundColor = "white",
    layout = "horizontal",
    form,
    tools = [],
    cursor,
    toolComponent: ToolComponent = ToolBar,
    metaData,
    task,
    suggestedPlugins = [],
    copilotMessageList = [],
    showRegenerateBtn = false,
    watermark,
    questionGuide,
    relatedQuestionInfo,
    onActionClick,
    onCodeCopy,
    onToolClick,
    onTaskClick,
    onHrefTagClick,
    onRegenerate,
    onQuestionSend,
    isWelcomeMessage,
    onFileClick,
    onRelatedQuestionsToggle,
    // reportRender,
    hideActions = { showOnHover: true },
    formMessageComponentMap,
    formDisabled,
    onFormSubmit,
    onFileUpload,
    pluginItemOnMessageRender,
    dislikeOnMessageRender
  } = props;
  const isStreaming = useMemo8(() => {
    if (!cursor)
      return false;
    if (!tools.length && !content) {
      return true;
    }
    return !content && tools.length > 0 && tools.every((v) => v.status === "success");
  }, [cursor, content, tools]);
  const [headerVisible, setHeaderVisible] = useState13(true);
  const messageContainerRef = useRef9(null);
  const { copyToClipboard: contentCopyToClipboard } = useCopyToClipboard_default();
  const containerClassNames = useMemo8(() => {
    return cn29("ui-relative ui-overflow-hidden", {
      // 'ui-rounded-tl-sm': position === 'left',
      "ui-rounded-tr-sm": position === "right",
      "w-100%": position === "left" && responseExtend
    });
  }, [position, cursor, responseExtend]);
  const showRegenerate = useMemo8(() => {
    return showRegenerateBtn && !cursor && !isWelcomeMessage;
  }, [showRegenerateBtn, cursor, isWelcomeMessage]);
  const copyToClipboard = async (content2) => {
    var _a2;
    if (typeof navigator.clipboard !== "undefined" && typeof ClipboardItem !== "undefined") {
      const markdownContent = (_a2 = messageContainerRef.current) == null ? void 0 : _a2.querySelector(
        ".chat-markdown-message"
      );
      if (!markdownContent)
        return;
      const dom = await getClipboardDom(markdownContent);
      const htmlBlob = new Blob([(dom == null ? void 0 : dom.innerHTML) || ""], {
        type: "text/html"
      });
      const textBlob = new Blob([(dom == null ? void 0 : dom.innerText) || ""], {
        type: "text/plain"
      });
      navigator.clipboard.write([
        new ClipboardItem({
          [htmlBlob.type]: htmlBlob,
          [textBlob.type]: textBlob
        })
      ]);
    } else {
      contentCopyToClipboard(content2);
    }
  };
  const handleFileClick = (file2) => {
    if ((file2 == null ? void 0 : file2.type) === FILE_MIME_TYPE_MAP2.reference) {
      return;
    }
    if ((file2 == null ? void 0 : file2.type) === FILE_MIME_TYPE_MAP2.webpage) {
      file2.url && (onHrefTagClick == null ? void 0 : onHrefTagClick(file2.url));
      return;
    }
    onFileClick == null ? void 0 : onFileClick(file2);
  };
  return /* @__PURE__ */ jsx69(
    "div",
    {
      ref: messageContainerRef,
      className: cn29("ui-flex ui-relative chat-message-container", className, {
        "ui-flex-row-reverse": position === "right" && layout === "horizontal",
        "ui-flex-col": layout === "vertical" && position === "left",
        "ui-flex-col ui-items-end": layout === "vertical" && position === "right",
        "ui-items-start": layout === "horizontal",
        "ui-w-[calc(100%-8px)]": layout === "horizontal" && position === "left"
      }),
      children: /* @__PURE__ */ jsxs38(
        "div",
        {
          className: "ui-relative ui-w-full",
          onMouseEnter: () => setHeaderVisible(true),
          onMouseLeave: () => setHeaderVisible(false),
          children: [
            /* @__PURE__ */ jsxs38(
              "div",
              {
                className: cn29(
                  "ui-flex ui-items-center ui-w-full ui-mb-[6px] ui-relative ui-gap-[6px]",
                  {
                    "ui-flex-row-reverse": position === "right" && layout === "horizontal",
                    "ui-flex-col-reverse": layout === "vertical" && position === "right",
                    "ui-flex-col": layout === "vertical" && position === "left"
                  }
                ),
                children: [
                  avatarInfo && /* @__PURE__ */ jsx69(
                    Avatar,
                    {
                      size: 22,
                      className: cn29("ui-shrink-0", {
                        "ui-mb-[8px]": layout === "vertical",
                        "ui-justify-start ui-flex-row-reverse": position === "right" && layout === "horizontal"
                      }),
                      ...avatarInfo,
                      name: layout === "vertical" ? avatarInfo.name : ""
                    }
                  ),
                  (avatarInfo == null ? void 0 : avatarInfo.name) && /* @__PURE__ */ jsx69("div", { className: "ui-text-[#8D8D99] ui-text-[14px]", children: avatarInfo == null ? void 0 : avatarInfo.name }),
                  header && /* @__PURE__ */ jsx69(
                    "div",
                    {
                      className: cn29("ui-text-[12px] ui-text-yeah-light/60  ", {
                        "ui-text-right ui-right-0": position === "right",
                        "ui-opacity-0": !headerVisible
                      }),
                      children: header
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ jsx69(
              MessageAction,
              {
                position,
                actions,
                onActionClick: (action) => {
                  if (action === "copy") {
                    copyToClipboard(content);
                    toast3.success("\u590D\u5236\u6210\u529F", {
                      id: "clipboard"
                    });
                  }
                  onActionClick == null ? void 0 : onActionClick(action, content, file);
                },
                children: /* @__PURE__ */ jsx69("div", { className: containerClassNames, children: /* @__PURE__ */ jsx69(
                  "div",
                  {
                    className: cn29("ui-relative", {
                      // 'ui-min-w-[86px]': position === 'left',
                    }),
                    children: /* @__PURE__ */ jsxs38(
                      "div",
                      {
                        className: cn29(
                          "__message-item",
                          "ui-relative ui-overflow-hidden ui-rounded-xl ui-py-[5px] ui-text-base/7 ui-text-yeah ui-box-border",
                          {
                            "ui-pb-[6px]": position === "left" && (showRegenerate || watermark),
                            "ui-rounded-tl-sm !ui-px-0 !ui-py-0": position === "left",
                            "ui-rounded-br-sm": position === "right",
                            "result-streaming": isStreaming,
                            "ui-px-[12px]": messageType !== "fetching",
                            "ui-flex-center ui-p-[7px]": cursor && messageType === "fetching"
                          }
                        ),
                        style: { backgroundColor },
                        children: [
                          /* @__PURE__ */ jsxs38("div", { children: [
                            ToolComponent && tools.map((v, i) => {
                              var _a2, _b2, _c2, _d2;
                              const isSearch2 = isSearch((_a2 = v == null ? void 0 : v.data) == null ? void 0 : _a2.function_code);
                              return /* @__PURE__ */ jsx69(
                                "div",
                                {
                                  className: "ui-mt-[6px] ui-mb-[4px]",
                                  onClick: isSearch2 ? () => {
                                    if (v.status === "error") {
                                      onToolClick == null ? void 0 : onToolClick(v);
                                    }
                                  } : () => onToolClick == null ? void 0 : onToolClick(v),
                                  children: /* @__PURE__ */ jsxs38(ToolComponent, { ...v, children: [
                                    messageType === "form" && form && ((_d2 = (_c2 = (_b2 = v == null ? void 0 : v.data) == null ? void 0 : _b2.metadata) == null ? void 0 : _c2.inputs_properties) == null ? void 0 : _d2.flowId) === form.flowId && /* @__PURE__ */ jsx69("div", { onClick: (e) => e.stopPropagation(), children: /* @__PURE__ */ jsx69(
                                      FormMessage,
                                      {
                                        recordId: form.recordId,
                                        flowId: form.flowId,
                                        isSubmit: form.isSubmit,
                                        formWelcome: form.formWelcome,
                                        formData: form.formData,
                                        formConfig: form.formConfig,
                                        disabled: formDisabled,
                                        formItemComponentMap: formMessageComponentMap,
                                        onFormSubmit,
                                        onFileUpload
                                      }
                                    ) }),
                                    isSearch2 && /* @__PURE__ */ jsx69(
                                      SearchToolContent,
                                      {
                                        onHrefTagClick,
                                        allowLogger,
                                        toolData: v,
                                        onToolClick
                                      }
                                    )
                                  ] })
                                },
                                i
                              );
                            }),
                            Boolean(copilotMessageList.length) && /* @__PURE__ */ jsx69(
                              CopilotToolsBar,
                              {
                                list: copilotMessageList
                              }
                            )
                          ] }),
                          messageType === "task" && task && /* @__PURE__ */ jsx69(
                            TaskMessage,
                            {
                              task,
                              toDetail: () => onTaskClick == null ? void 0 : onTaskClick(task, metaData),
                              content,
                              onCodeCopy,
                              renderHtml: (copilotMessageList == null ? void 0 : copilotMessageList.length) > 0,
                              file,
                              cursor,
                              onHrefTagClick,
                              onFileClick
                            }
                          ),
                          messageType === "fetching" && /* @__PURE__ */ jsx69(
                            "img",
                            {
                              className: "ui-w-[18px] ui-h-[18px]",
                              src: backgroundColor === "rgb(241,241,246)" ? GRAY_GIF_IMAGE : DEFAULT_GIF_IMAGE,
                              alt: "loading"
                            }
                          ),
                          messageType === "text" && /* @__PURE__ */ jsx69(
                            Text,
                            {
                              content,
                              file,
                              onFileClick,
                              fileClassName: backgroundColor !== "white" ? "ui-bg-white" : ""
                            }
                          ),
                          (messageType === "markdown" || messageType === "form" && (form == null ? void 0 : form.isSubmit)) && /* @__PURE__ */ jsx69(
                            MarkdownMessage,
                            {
                              content,
                              onCodeCopy,
                              renderHtml: (copilotMessageList == null ? void 0 : copilotMessageList.length) > 0,
                              file,
                              cursor,
                              onHrefTagClick,
                              onFileClick,
                              tools
                            }
                          ),
                          /* @__PURE__ */ jsx69(Fragment4, { children: (suggestedPlugins == null ? void 0 : suggestedPlugins.length) > 0 && suggestedPlugins.map((plugin) => /* @__PURE__ */ jsx69("div", { children: pluginItemOnMessageRender == null ? void 0 : pluginItemOnMessageRender(plugin) }, plugin.id)) }),
                          questionGuide && /* @__PURE__ */ jsx69(
                            QuestionGuideList,
                            {
                              questions: questionGuide,
                              onQuestionClick: (data) => onQuestionSend == null ? void 0 : onQuestionSend(data)
                            }
                          ),
                          footer && /* @__PURE__ */ jsx69(
                            "div",
                            {
                              className: cn29(
                                "ui-mt-[7px] ui-text-[12px] ui-text-yeah-light/60 ui-min-w-[200px]  ui-max-w-[708px] ui-break-words",
                                {
                                  "ui-text-right": position === "right"
                                }
                              ),
                              children: footer
                            }
                          ),
                          position !== "right" && !cursor && hideActions !== true && /* @__PURE__ */ jsxs38(
                            "div",
                            {
                              className: cn29(
                                "ui-flex ui-w-full ui-mt-[8px] ui-items-center ui-gap-[10.5px]",
                                { "ui-flex": showRegenerate || watermark }
                              ),
                              children: [
                                /* @__PURE__ */ jsxs38(
                                  "div",
                                  {
                                    className: cn29(
                                      "ui-items-center",
                                      typeof hideActions === "object" && !headerVisible ? "ui-hidden" : "ui-flex"
                                    ),
                                    children: [
                                      showRegenerate && /* @__PURE__ */ jsx69(
                                        ToolIcon,
                                        {
                                          IconSVG: SvgRegenerate,
                                          tooltip: "\u91CD\u65B0\u751F\u6210",
                                          onClick: onRegenerate
                                        }
                                      ),
                                      !isWelcomeMessage && /* @__PURE__ */ jsx69(
                                        ToolIcon,
                                        {
                                          IconSVG: SvgCopy2,
                                          tooltip: "\u590D\u5236",
                                          onClick: () => {
                                            copyToClipboard(content);
                                            toast3.success("\u590D\u5236\u6210\u529F", {
                                              id: "clipboard"
                                            });
                                            onActionClick == null ? void 0 : onActionClick("copy", content, file);
                                          }
                                        }
                                      ),
                                      dislikeOnMessageRender == null ? void 0 : dislikeOnMessageRender({
                                        trigger: /* @__PURE__ */ jsx69(
                                          ToolIcon,
                                          {
                                            IconSVG: SvgUnlike,
                                            tooltip: "\u4E0D\u6EE1\u610F",
                                            active: !!feedback_id
                                          }
                                        ),
                                        record_id: id,
                                        feedback_id
                                      })
                                    ]
                                  }
                                ),
                                /* @__PURE__ */ jsx69(
                                  "div",
                                  {
                                    className: cn29(
                                      "ui-text-[#8d8d99] ui-text-[9px]/[24px] ui-h-[24px] ui-ml-auto",
                                      {
                                        "ui-opacity-0": !watermark,
                                        "ui-hidden": cursor || isWelcomeMessage,
                                        "ui-opacity-100": watermark
                                      }
                                    ),
                                    children: watermark
                                  }
                                )
                              ]
                            }
                          )
                        ]
                      }
                    )
                  }
                ) })
              },
              "1"
            ),
            relatedQuestionInfo && /* @__PURE__ */ jsx69("div", { className: "ui-mt-[16px] ui-pr-[28px]", children: /* @__PURE__ */ jsx69(
              RelatedQuestion,
              {
                loading: relatedQuestionInfo.loading,
                questions: relatedQuestionInfo.questions,
                onSend: (q) => onQuestionSend == null ? void 0 : onQuestionSend(q),
                onToggle: (enable) => onRelatedQuestionsToggle == null ? void 0 : onRelatedQuestionsToggle(enable)
              }
            ) }),
            file && /* @__PURE__ */ jsx69("div", { className: "w-full ui-flex ui-justify-end", children: /* @__PURE__ */ jsx69(
              "div",
              {
                className: cn29({
                  "ui-max-w-[100px]": !!((_b = (_a = file == null ? void 0 : file.type) == null ? void 0 : _a.includes) == null ? void 0 : _b.call(_a, "image")),
                  "ui-max-w-full": !((_d = (_c = file == null ? void 0 : file.type) == null ? void 0 : _c.includes) == null ? void 0 : _d.call(_c, "image"))
                }),
                children: /* @__PURE__ */ jsx69(
                  File,
                  {
                    className: cn29(
                      "ui-mt-[10px] ui-w-full ui-max-w-full ui-pr-[10.5px] ui-bg-[#626999] ui-bg-opacity-[0.08] hover:!ui-bg-opacity-15"
                    ),
                    imageRender: !!((_f = (_e = file == null ? void 0 : file.type) == null ? void 0 : _e.includes) == null ? void 0 : _f.call(_e, "image")),
                    showToolTips: true,
                    name: file.name,
                    type: file.type,
                    icon: file.icon,
                    url: file.url,
                    onFileClick: handleFileClick
                  }
                )
              }
            ) })
          ]
        }
      )
    }
  );
});
Message.displayName = "Message";

// src/components/message/MessageSeparator.tsx
import { jsx as jsx70 } from "react/jsx-runtime";
function MessageSeparator({ content }) {
  return /* @__PURE__ */ jsx70("div", { className: "bty-message-separator ui-mt-[24px] ui-flex-center-y ", children: /* @__PURE__ */ jsx70("span", { className: "ui-mx-[10.5px] ui-shrink-0 ui-text-[12px] ui-text-yeah-light/60", children: content }) });
}

// src/components/messageInput/MessageInput.tsx
import {
  forwardRef as forwardRef11,
  memo as memo9,
  useEffect as useEffect10,
  useImperativeHandle as useImperativeHandle4,
  useMemo as useMemo15,
  useRef as useRef13,
  useState as useState17
} from "react";
import TextAreaAutoSize from "react-textarea-autosize";
import { ShortcutsFormModal } from "@bty/ui-components";
import useKeyPress2 from "ahooks/es/useKeyPress";
import toast4 from "react-hot-toast";
import { FILE_MIME_TYPE_MAP as FILE_MIME_TYPE_MAP3 } from "@bty/global-types/file";
import { cn as cn36 } from "@bty/util";
import { isBoolean } from "lodash-es";

// src/assets/svg/stop.svg
import * as React38 from "react";
import { jsx as jsx71, jsxs as jsxs39 } from "react/jsx-runtime";
var SvgStop = (props) => /* @__PURE__ */ jsxs39("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 32, height: 32, viewBox: "0 0 32 32", ...props, children: [
  /* @__PURE__ */ jsxs39("defs", { children: [
    /* @__PURE__ */ jsxs39("linearGradient", { x1: 0, y1: 0, x2: 0.7557175159454346, y2: 1, id: "master_svg0_12739_018352", children: [
      /* @__PURE__ */ jsx71("stop", { offset: "0%", stopColor: "#36CDFF", stopOpacity: 1 }),
      /* @__PURE__ */ jsx71("stop", { offset: "62.85714507102966%", stopColor: "#684AFF", stopOpacity: 1 }),
      /* @__PURE__ */ jsx71("stop", { offset: "100%", stopColor: "#963AFF", stopOpacity: 1 })
    ] }),
    /* @__PURE__ */ jsx71("clipPath", { id: "master_svg1_19391_240049", children: /* @__PURE__ */ jsx71("rect", { x: 8, y: 8, width: 16, height: 16, rx: 0 }) })
  ] }),
  /* @__PURE__ */ jsxs39("g", { children: [
    /* @__PURE__ */ jsx71("g", { children: /* @__PURE__ */ jsx71("rect", { x: 0, y: 0, width: 32, height: 32, rx: 16, fill: "url(#master_svg0_12739_018352)", fillOpacity: 1 }) }),
    /* @__PURE__ */ jsx71("g", { clipPath: "url(#master_svg1_19391_240049)", children: /* @__PURE__ */ jsx71("g", { children: /* @__PURE__ */ jsx71("rect", { x: 10, y: 10, width: 12, height: 12, rx: 2, fill: "#FFFFFF", fillOpacity: 1, style: {
      mixBlendMode: "passthrough"
    } }) }) })
  ] })
] });

// src/base/hooks/useChatLayoutMode.ts
import { useSize as useSize2 } from "ahooks";
import { useMemo as useMemo9 } from "react";
var MOBILE_MODE_WIDTH = 768;
function useChatLayoutMode() {
  const size = useSize2(document.querySelector("body"));
  const layoutMode = useMemo9(() => {
    return (size == null ? void 0 : size.width) && size.width <= MOBILE_MODE_WIDTH ? "mobile" : "desktop";
  }, [size]);
  return {
    layoutMode
  };
}

// src/components/messageInput/MessagePanel.tsx
import { useMemo as useMemo10 } from "react";
import { cn as cn30 } from "@bty/util";

// src/assets/svg/clear.svg
import * as React39 from "react";
import { jsx as jsx72, jsxs as jsxs40 } from "react/jsx-runtime";
var SvgClear = (props) => /* @__PURE__ */ jsxs40("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 20, height: 20, viewBox: "0 0 20 20", ...props, children: [
  /* @__PURE__ */ jsx72("defs", { children: /* @__PURE__ */ jsx72("clipPath", { id: "master_svg0_44_16348/44_6131", children: /* @__PURE__ */ jsx72("rect", { x: 0, y: 0, width: 20, height: 20, rx: 0 }) }) }),
  /* @__PURE__ */ jsx72("g", { clipPath: "url(#master_svg0_44_16348/44_6131)", children: /* @__PURE__ */ jsx72("g", { children: /* @__PURE__ */ jsxs40("g", { children: [
    /* @__PURE__ */ jsx72("g", { style: {
      opacity: 0
    }, children: /* @__PURE__ */ jsx72("rect", { x: 0, y: 0, width: 25, height: 25, rx: 0, fill: "#DCDCE0", fillOpacity: 1 }) }),
    /* @__PURE__ */ jsx72("g", { children: /* @__PURE__ */ jsx72("path", { d: "M14.8391,1.5011880546875C13.9127,0.9663350546875,12.7272,1.3199713546875,12.2452,2.2749410546875L10.56458,5.6049010546875L8.58128,4.4598410546875C7.95307,4.0971510546875,7.14979,4.3123810546875,6.7871,4.9405910546875L5.91148,6.4572010546875C5.79058,6.6666010546875,5.86233,6.9343710546875,6.07173,7.0552610546875L14.4131,11.8711310546875C14.6225,11.9920310546875,14.8903,11.9203310546875,15.0112,11.7109310546875L15.8868,10.1943010546875C16.249499999999998,9.5661010546875,16.0343,8.7628210546875,15.4061,8.4001210546875L13.4225,7.2549110546875L15.466,4.1344410546875C16.052,3.2395410546875,15.7655,2.0360410546875,14.8391,1.5011880546875ZM3.91182,10.3577110546875Q2.7739700000000003,11.4658310546875,1.249610782,12.3419310546875Q3.42354,14.3883310546875,5.66772,15.8665310546875Q6.43504,16.3720310546875,7.25489,16.8366310546875Q9.1692,16.1274310546875,10.34692,14.7861310546875Q9.8054,15.7853310546875,9.23634,16.6299310546875Q8.911819999999999,17.1115310546875,8.578330000000001,17.5428310546875Q9.55793,18.0348310546875,10.6055,18.4739310546875Q11.7401,16.9380310546875,12.478,15.6599310546875Q13.1398,14.5136310546875,13.8217,12.9872310546875C13.9126,12.7838310546875,13.833,12.5470310546875,13.6401,12.4356310546875L6.18496,8.1313410546875C5.97369,8.0093610546875,5.70712,8.0792410546875,5.57902,8.2868510546875Q4.88752,9.4075510546875,3.91182,10.3577110546875ZM18.0748,13.4886310546875C18.1102,13.5845310546875,18.1858,13.6600310546875,18.2817,13.6955310546875L18.5213,13.7842310546875C18.6587,13.8350310546875,18.75,13.9661310546875,18.75,14.1127310546875C18.75,14.2592310546875,18.6587,14.3903310546875,18.5213,14.4411310546875L18.2817,14.5298310546875C18.1858,14.5653310546875,18.1102,14.6409310546875,18.0748,14.7367310546875L17.9861,14.9763310546875C17.9352,15.1138310546875,17.8042,15.2050310546875,17.6576,15.2050310546875C17.5111,15.2050310546875,17.38,15.1138310546875,17.3291,14.9763310546875L17.2405,14.7367310546875C17.205,14.6409310546875,17.1294,14.5653310546875,17.0336,14.5298310546875L16.794,14.4411310546875C16.6565,14.3903310546875,16.5653,14.2592310546875,16.5653,14.1127310546875C16.5653,13.9661310546875,16.6565,13.8350310546875,16.794,13.7842310546875L17.0336,13.6955310546875C17.1294,13.6600310546875,17.205,13.5845310546875,17.2405,13.4886310546875L17.3291,13.2490310546875C17.38,13.1116310546875,17.5111,13.0203310546875,17.6576,13.0203310546875C17.8042,13.0203310546875,17.9352,13.1116310546875,17.9861,13.2490310546875L18.0748,13.4886310546875ZM15.841,16.0443310546875C15.8854,16.164131054687502,15.9798,16.2586310546875,16.0997,16.302931054687498L16.7187,16.5320310546875C16.8905,16.5956310546875,17.0046,16.7594310546875,17.0046,16.9426310546875C17.0046,17.125831054687502,16.8905,17.2896310546875,16.7187,17.3532310546875L16.0997,17.5823310546875C15.9798,17.6267310546875,15.8854,17.7211310546875,15.841,17.8410310546875L15.6119,18.4600310546875C15.5483,18.6318310546875,15.3845,18.7459310546875,15.2013,18.7459310546875C15.0181,18.7459310546875,14.8543,18.6318310546875,14.7907,18.4600310546875L14.5616,17.8410310546875C14.5173,17.7211310546875,14.4228,17.6267310546875,14.303,17.5823310546875L13.6839,17.3532310546875C13.5121,17.2896310546875,13.3981,17.125831054687502,13.3981,16.9426310546875C13.3981,16.7594310546875,13.5121,16.5956310546875,13.6839,16.5320310546875L14.303,16.302931054687498C14.4228,16.2586310546875,14.5173,16.164131054687502,14.5616,16.0443310546875L14.7907,15.4252310546875C14.8543,15.2534310546875,15.0181,15.1394310546875,15.2013,15.1394310546875C15.3845,15.1394310546875,15.5483,15.2534310546875,15.6119,15.4252310546875L15.841,16.0443310546875Z", fillRule: "evenodd", fill: "currentColor", fillOpacity: 1 }) })
  ] }) }) })
] });

// src/assets/svg/prompt-continue.svg
import * as React40 from "react";
import { jsx as jsx73, jsxs as jsxs41 } from "react/jsx-runtime";
var SvgPromptContinue = (props) => /* @__PURE__ */ jsxs41("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: [
  /* @__PURE__ */ jsx73("defs", { children: /* @__PURE__ */ jsx73("clipPath", { id: "master_svg0_642_7938", children: /* @__PURE__ */ jsx73("rect", { x: 0, y: 0, width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsxs41("g", { clipPath: "url(#master_svg0_642_7938)", children: [
    /* @__PURE__ */ jsx73("g", { children: /* @__PURE__ */ jsx73("path", { d: "M7.75098,7.51777L1.7804229999999999,3.5807551C1.6214650000000002,3.4760371,1.42323,3.472961,1.261615,3.5727047C1.0999652,3.672514,1.00000485951,3.859626,1.00000471225,4.062405L1.00000471225,11.93643C0.999210698,12.1397,1.0990656,12.32756,1.261037,12.4275C1.423008,12.52744,1.621767,12.52383,1.780616,12.41808L7.75117,8.481069999999999C8.08294,8.26233,8.08294,7.73651,7.75117,7.51777L7.75098,7.51777Z", fill: "#626999", fillOpacity: 1 }) }),
    /* @__PURE__ */ jsx73("g", { children: /* @__PURE__ */ jsx73("path", { d: "M14.75098,7.51777L8.780423,3.5807551C8.621465,3.4760371,8.42323,3.472961,8.261615,3.5727047C8.0999652,3.672514,8.00000485951,3.859626,8.00000471225,4.062405L8.00000471225,11.93643C7.999210698,12.1397,8.0990656,12.32756,8.261037,12.4275C8.423008,12.52744,8.621767,12.52383,8.780616,12.41808L14.75117,8.481069999999999C15.08294,8.26233,15.08294,7.73651,14.75117,7.51777L14.75098,7.51777Z", fill: "currentColor", fillOpacity: 1 }) })
  ] })
] });

// src/assets/svg/prompt-regenerate.svg
import * as React41 from "react";
import { jsx as jsx74, jsxs as jsxs42 } from "react/jsx-runtime";
var SvgPromptRegenerate = (props) => /* @__PURE__ */ jsxs42("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: [
  /* @__PURE__ */ jsx74("defs", { children: /* @__PURE__ */ jsx74("clipPath", { id: "master_svg0_44_17311", children: /* @__PURE__ */ jsx74("rect", { x: 0, y: 0, width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsx74("g", { children: /* @__PURE__ */ jsx74("g", { clipPath: "url(#master_svg0_44_17311)", children: /* @__PURE__ */ jsx74("g", { children: /* @__PURE__ */ jsx74("path", { d: "M2.371391,8.92848L4.87139,7.92848Q4.94059,7.9008,5.00492,7.86316Q5.06925,7.82553,5.1273,7.77878Q5.18534,7.73203,5.23581,7.67719Q5.28628,7.62234,5.32807,7.56063Q5.36985,7.49891,5.40202,7.43168Q5.434200000000001,7.36446,5.456049999999999,7.2932Q5.4779,7.22195,5.48895,7.14824Q5.5,7.07453,5.5,7L5.49999,6.99645Q5.49932,6.80571,5.42848,6.62861Q5.3546,6.44392,5.21568,6.30157Q5.0767500000000005,6.15921,4.89392,6.08085Q4.70526,6,4.5,6L4.48733,6.00008Q4.30133,6.00244,4.12861,6.07152L3.2383699999999997,6.42762Q3.59083,5.3381,4.46447,4.46447Q5.928929999999999,3,8,3Q10.07107,3,11.53553,4.46447Q11.67619,4.605119999999999,11.85996,4.68124Q12.0437,4.75736,12.2426,4.75736Q12.2667,4.75736,12.2907,4.7562Q12.4769,4.74725,12.6474,4.67178Q12.8179,4.59631,12.9497,4.46447Q13.0904,4.32381,13.1665,4.14004Q13.2426,3.95627,13.2426,3.7573600000000003Q13.2426,3.5584499999999997,13.1665,3.3746799999999997Q13.0904,3.1909,12.9497,3.05025Q10.8995,1,8,1.0000010000000001Q5.1005,1.0000010000000001,3.05025,3.05025Q1,5.10051,1,8Q1,8.19258,1.071523,8.37139Q1.1453980000000001,8.55608,1.284325,8.69843Q1.423252,8.84079,1.606081,8.91915Q1.78891,8.997499999999999,1.9878077,8.999929999999999Q2.186705,9.00235,2.371391,8.92848ZM11.12875,8.07147L11.12861,8.07152Q11.05941,8.0992,10.99508,8.13684Q10.93075,8.17447,10.8727,8.221219999999999Q10.81466,8.26797,10.76419,8.32281Q10.71372,8.37765,10.67193,8.43937Q10.63015,8.50109,10.59797,8.56832Q10.5658,8.635539999999999,10.54395,8.706800000000001Q10.5221,8.77805,10.51105,8.851759999999999Q10.5,8.92547,10.5,9L10.50001,9.00355Q10.50068,9.194289999999999,10.57152,9.37139Q10.6454,9.55608,10.78432,9.69843Q10.92325,9.84079,11.10608,9.91915Q11.29474,10,11.5,10L11.51267,9.99992Q11.69868,9.99756,11.87139,9.92848L11.87153,9.92842L12.7616,9.572379999999999Q12.4092,10.6619,11.53553,11.53553Q10.07107,13,8,13Q5.928929999999999,13,4.46447,11.53553Q4.32381,11.39488,4.14004,11.31876Q3.95627,11.24264,3.7573600000000003,11.24264Q3.5584499999999997,11.24264,3.3746799999999997,11.31876Q3.1909,11.39488,3.05025,11.53553Q2.9096,11.67619,2.8334799999999998,11.85996Q2.757359,12.0437,2.757359,12.2426Q2.757359,12.4416,2.8334799999999998,12.6253Q2.9096,12.8091,3.05025,12.9497Q5.1005,15,8,15Q10.8995,15,12.9497,12.9497Q15,10.8995,15,8Q15,7.80742,14.9285,7.62861Q14.8546,7.44392,14.7157,7.30157Q14.5767,7.15921,14.3939,7.08085Q14.2111,7.0025,14.0122,7.00007Q13.8133,6.99765,13.6286,7.07152L11.12875,8.07147Z", fillRule: "evenodd", fill: "currentColor", fillOpacity: 1 }) }) }) })
] });

// src/assets/svg/prompt-stop-generate.svg
import * as React42 from "react";
import { jsx as jsx75, jsxs as jsxs43 } from "react/jsx-runtime";
var SvgPromptStopGenerate = (props) => /* @__PURE__ */ jsxs43("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: [
  /* @__PURE__ */ jsx75("defs", { children: /* @__PURE__ */ jsx75("clipPath", { id: "master_svg0_44_16694", children: /* @__PURE__ */ jsx75("rect", { x: 0, y: 0, width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsx75("g", { clipPath: "url(#master_svg0_44_16694)", children: /* @__PURE__ */ jsx75("g", { children: /* @__PURE__ */ jsx75("path", { d: "M8,15Q8.17184,15,8.34347,14.9916Q8.51511,14.9831,8.686119999999999,14.9663Q8.85713,14.9494,9.02711,14.9242Q9.19709,14.899,9.36563,14.8655Q9.53417,14.832,9.70086,14.7902Q9.86755,14.7485,10.03199,14.6986Q10.19643,14.6487,10.35823,14.5908Q10.52002,14.5329,10.67878,14.4672Q10.83754,14.4014,10.99288,14.3279Q11.1482,14.2545,11.2998,14.1734Q11.4513,14.0924,11.5987,14.0041Q11.7461,13.9158,11.889,13.8203Q12.0319,13.7248,12.1699,13.6225Q12.3079,13.5201,12.4408,13.4111Q12.5736,13.3021,12.7009,13.1867Q12.8282,13.0713,12.9497,12.9497Q13.0713,12.8282,13.1867,12.7009Q13.3021,12.5736,13.4111,12.4408Q13.5201,12.3079,13.6225,12.1699Q13.7248,12.0319,13.8203,11.889Q13.9158,11.7461,14.0041,11.5987Q14.0924,11.4513,14.1734,11.2998Q14.2545,11.1482,14.3279,10.99288Q14.4014,10.83754,14.4672,10.67878Q14.5329,10.52002,14.5908,10.35823Q14.6487,10.19643,14.6986,10.03199Q14.7485,9.86755,14.7902,9.70086Q14.832,9.53417,14.8655,9.36563Q14.899,9.19709,14.9242,9.02711Q14.9494,8.85713,14.9663,8.686119999999999Q14.9831,8.51511,14.9916,8.34347Q15,8.17184,15,8Q15,7.82816,14.9916,7.65653Q14.9831,7.48489,14.9663,7.31388Q14.9494,7.14287,14.9242,6.97289Q14.899,6.80291,14.8655,6.63437Q14.832,6.46583,14.7902,6.29914Q14.7485,6.13245,14.6986,5.96801Q14.6487,5.80357,14.5908,5.64177Q14.5329,5.47998,14.4672,5.32122Q14.4014,5.16246,14.3279,5.00711Q14.2545,4.85177,14.1734,4.70022Q14.0924,4.5486699999999995,14.0041,4.40128Q13.9158,4.25389,13.8203,4.11101Q13.7248,3.96813,13.6225,3.8301Q13.5201,3.69208,13.4111,3.55925Q13.3021,3.42641,13.1867,3.29909Q13.0713,3.17176,12.9497,3.05025Q12.8282,2.92874,12.7009,2.81334Q12.5736,2.69794,12.4408,2.58893Q12.3079,2.4799100000000003,12.1699,2.3775500000000003Q12.0319,2.2751799999999998,11.889,2.17971Q11.7461,2.0842400000000003,11.5987,1.9959Q11.4513,1.907556,11.2998,1.826551Q11.1482,1.745546,10.99288,1.672075Q10.83754,1.598604,10.67878,1.532843Q10.52002,1.4670830000000001,10.35823,1.409191Q10.19643,1.3513,10.03199,1.301418Q9.86755,1.251535,9.70086,1.209781Q9.53417,1.168027,9.36563,1.134503Q9.19709,1.100979,9.02711,1.0757644Q8.85713,1.0505502,8.686119999999999,1.0337069Q8.51511,1.0168636,8.34347,1.0084318Q8.17184,1,8,1Q7.82816,1,7.65653,1.0084318Q7.48489,1.0168636,7.31388,1.0337069Q7.14287,1.0505502,6.97289,1.0757644Q6.80291,1.100979,6.63437,1.134503Q6.46583,1.168027,6.29914,1.209781Q6.13245,1.251535,5.96801,1.301418Q5.80357,1.3513,5.64177,1.409191Q5.47998,1.4670830000000001,5.32122,1.532843Q5.16246,1.598604,5.00711,1.672075Q4.85177,1.745546,4.70022,1.826551Q4.5486699999999995,1.907556,4.40128,1.995899Q4.25389,2.0842400000000003,4.11101,2.17971Q3.96813,2.2751799999999998,3.8301,2.3775500000000003Q3.69208,2.4799100000000003,3.55925,2.58893Q3.42641,2.69794,3.29909,2.81334Q3.17176,2.92874,3.05025,3.05025Q2.92874,3.17176,2.81334,3.29909Q2.69794,3.42641,2.58893,3.55925Q2.4799100000000003,3.69208,2.3775500000000003,3.8301Q2.2751799999999998,3.96813,2.17971,4.11101Q2.0842400000000003,4.25389,1.9959,4.40128Q1.907556,4.5486699999999995,1.826551,4.70022Q1.745546,4.85177,1.672075,5.00711Q1.598604,5.16246,1.532843,5.32122Q1.4670830000000001,5.47998,1.409191,5.64177Q1.3513,5.80357,1.301418,5.96801Q1.251535,6.13245,1.209781,6.29914Q1.168027,6.46583,1.134503,6.63437Q1.100979,6.80291,1.0757644,6.97289Q1.0505502,7.14287,1.0337069,7.31388Q1.0168636,7.48489,1.0084318,7.65653Q1,7.82816,1,8Q1,8.17184,1.0084318,8.34347Q1.0168636,8.51511,1.0337069,8.686119999999999Q1.0505502,8.85713,1.0757644,9.02711Q1.100979,9.19709,1.134503,9.36563Q1.168027,9.53417,1.209781,9.70086Q1.251535,9.86755,1.301418,10.03199Q1.3513,10.19643,1.409191,10.35823Q1.4670830000000001,10.52002,1.532843,10.67878Q1.598604,10.83754,1.672075,10.99288Q1.745546,11.1482,1.826551,11.2998Q1.907556,11.4513,1.995899,11.5987Q2.0842400000000003,11.7461,2.17971,11.889Q2.2751799999999998,12.0319,2.3775500000000003,12.1699Q2.4799100000000003,12.3079,2.58893,12.4408Q2.69794,12.5736,2.81334,12.7009Q2.92874,12.8282,3.05025,12.9497Q3.17176,13.0713,3.29909,13.1867Q3.42641,13.3021,3.55925,13.4111Q3.69208,13.5201,3.8301,13.6225Q3.96813,13.7248,4.11101,13.8203Q4.25389,13.9158,4.40128,14.0041Q4.5486699999999995,14.0924,4.70022,14.1734Q4.85177,14.2545,5.00711,14.3279Q5.16246,14.4014,5.32122,14.4672Q5.47998,14.5329,5.64177,14.5908Q5.80357,14.6487,5.96801,14.6986Q6.13245,14.7485,6.29914,14.7902Q6.46583,14.832,6.63437,14.8655Q6.80291,14.899,6.97289,14.9242Q7.14287,14.9494,7.31388,14.9663Q7.48489,14.9831,7.65653,14.9916Q7.82816,15,8,15ZM5,7Q4.90151,7,4.80491,7.01921Q4.70831,7.03843,4.617319999999999,7.07612Q4.52632,7.11381,4.4444300000000005,7.16853Q4.36254,7.22325,4.29289,7.29289Q4.22325,7.36254,4.1685300000000005,7.44443Q4.11381,7.52632,4.0761199999999995,7.61732Q4.03843,7.70831,4.01921,7.80491Q4,7.90151,4,8Q4,8.09849,4.01921,8.19509Q4.03843,8.29169,4.0761199999999995,8.38268Q4.11381,8.47368,4.1685300000000005,8.55557Q4.22325,8.63746,4.29289,8.70711Q4.36254,8.77675,4.4444300000000005,8.83147Q4.52632,8.88619,4.617319999999999,8.92388Q4.70831,8.96157,4.80491,8.98078Q4.90151,9,5,9L11,9Q11.0985,9,11.1951,8.98078Q11.2917,8.96157,11.3827,8.92388Q11.4737,8.88619,11.5556,8.83147Q11.6375,8.77675,11.7071,8.70711Q11.7767,8.63746,11.8315,8.55557Q11.8862,8.47368,11.9239,8.38268Q11.9616,8.29169,11.9808,8.19509Q12,8.09849,12,8Q12,7.90151,11.9808,7.80491Q11.9616,7.70831,11.9239,7.61732Q11.8862,7.52632,11.8315,7.44443Q11.7767,7.36254,11.7071,7.29289Q11.6375,7.22325,11.5556,7.16853Q11.4737,7.11381,11.3827,7.07612Q11.2917,7.03843,11.1951,7.01921Q11.0985,7,11,7L5,7Z", fillRule: "evenodd", fill: "currentColor", fillOpacity: 1 }) }) })
] });

// src/components/messageInput/MessagePanel.tsx
import { jsx as jsx76, jsxs as jsxs44 } from "react/jsx-runtime";
function MessagePanel({
  className,
  showActions,
  generating,
  size = 40,
  onActionClick
}) {
  const buttonStyle = useMemo10(() => {
    return {
      width: size,
      height: size,
      cursor: generating ? "not-allowed" : "pointer"
    };
  }, [size, generating]);
  if (!showActions) {
    return null;
  }
  let action;
  if (showActions.regenerate) {
    action = { label: "\u91CD\u65B0\u751F\u6210", icon: /* @__PURE__ */ jsx76(SvgPromptRegenerate, {}), type: "regenerate" };
  } else if (showActions.continue) {
    action = { label: "\u7EE7\u7EED\u751F\u6210", icon: /* @__PURE__ */ jsx76(SvgPromptContinue, {}), type: "continue" };
  } else if (showActions.stop) {
    action = { label: "\u505C\u6B62\u751F\u6210", icon: /* @__PURE__ */ jsx76(SvgPromptStopGenerate, {}), type: "stop" };
  }
  return /* @__PURE__ */ jsxs44("div", { className: cn30("ui-h-[56px] ui-flex-center-y", className), children: [
    showActions.clear && /* @__PURE__ */ jsx76(Tooltip2, { title: "\u6E05\u7A7A\u4F1A\u8BDD", children: /* @__PURE__ */ jsx76(
      "div",
      {
        style: buttonStyle,
        className: "ui-pointer-events-auto ui-flex ui-items-center ui-justify-center !ui-rounded-[12px] ui-border-yeah-light !ui-p-0 ui-text-xl !ui-text-yeah-icon_light/60 hover:ui-bg-[#f3f3f7] ui-cursor-pointer",
        onClick: (event) => {
          event.stopPropagation();
          onActionClick == null ? void 0 : onActionClick("clear");
        },
        children: /* @__PURE__ */ jsx76(SvgClear, {})
      }
    ) }),
    action && /* @__PURE__ */ jsxs44(
      Button,
      {
        className: "ui-pointer-events-auto ui-m-auto ui-h-[40px]  ui-rounded-[12px] ui-border-yeah-light ui-px-[10.5px] ui-py-0 ui-text-base !ui-text-yeah-icon_light/60 hover:ui-bg-[#f3f3f7]",
        variant: "outline",
        onClick: (event) => {
          event.stopPropagation();
          onActionClick == null ? void 0 : onActionClick(action.type);
        },
        children: [
          action.icon,
          /* @__PURE__ */ jsx76("span", { className: "ui-ml-[6px] ui-text-sm ui-font-medium ui-text-yeah", children: action.label })
        ]
      }
    )
  ] });
}
var MessagePanel_default = MessagePanel;

// src/components/messageInput/ShortcutTips.tsx
import { useMemo as useMemo11 } from "react";

// src/assets/svg/command.svg
import * as React43 from "react";
import { jsx as jsx77, jsxs as jsxs45 } from "react/jsx-runtime";
var SvgCommand = (props) => /* @__PURE__ */ jsxs45("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14", className: "1xeudtw3y__design-iconfont", width: 16, height: 16, ...props, children: [
  /* @__PURE__ */ jsx77("defs", { children: /* @__PURE__ */ jsx77("clipPath", { id: "1xeudtw3y__apfgicdff__hq9u5k3o9a", children: /* @__PURE__ */ jsx77("rect", { width: 14, height: 14, rx: 0 }) }) }),
  /* @__PURE__ */ jsx77("g", { clipPath: "url(#1xeudtw3y__apfgicdff__hq9u5k3o9a)", children: /* @__PURE__ */ jsx77("path", { d: "M4.7168,6.02927L4.7168,7.83399L3.89649,7.84082C2.713865,7.84764,1.75,8.77736,1.75,9.96677C1.75,11.14942,2.707028,12.1201,3.90332,12.1201C5.0791,12.1201,6.04298,11.14942,6.04298,9.96677L6.04298,9.16697L7.84082,9.16697L7.84082,9.96677C7.84082,11.14942,8.80472,12.1201,9.98731,12.1201C11.17678,12.1201,12.1338,11.14942,12.1338,9.96677C12.1338,8.77736,11.17678,7.84764,9.98731,7.84082L9.16697,7.83399L9.16697,6.02927L9.98731,6.02927C11.17678,6.02245,12.1338,5.08594,12.1338,3.89649C12.1338,2.713865,11.17678,1.75,9.98731,1.75C8.80472,1.75,7.84082,2.720702,7.84082,3.89649L7.84082,4.696289999999999L6.04298,4.696289999999999L6.04298,3.89649C6.04298,2.720702,5.0791,1.75,3.90332,1.75C2.707028,1.75,1.75,2.713865,1.75,3.89649C1.75,5.08594,2.713865,6.02245,3.89649,6.02927L4.7168,6.02927ZM3.9375,4.709960000000001C3.46582,4.709960000000001,3.09668,4.34765,3.09668,3.90332C3.09668,3.45215,3.45899,3.08985,3.90332,3.08985C4.33399,3.08985,4.709960000000001,3.45899,4.709960000000001,3.9375L4.709960000000001,4.709960000000001L3.9375,4.709960000000001ZM9.9463,4.709960000000001L9.17385,4.709960000000001L9.17385,3.9375C9.17385,3.45899,9.54981,3.08985,9.98731,3.08985C10.43163,3.08985,10.78712,3.45215,10.78712,3.90332C10.78712,4.34765,10.42481,4.709960000000001,9.9463,4.709960000000001ZM6.04981,7.84082L6.04981,6.02245L7.84082,6.02245L7.84082,7.84082L6.04981,7.84082ZM3.9375,9.15332L4.709960000000001,9.15332L4.709960000000001,9.92577C4.709960000000001,10.40427,4.33399,10.77347,3.90332,10.77347C3.45899,10.77347,3.09668,10.41116,3.09668,9.95995C3.09668,9.51562,3.46582,9.15332,3.9375,9.15332ZM9.9463,9.15332C10.42481,9.15332,10.78712,9.51562,10.78712,9.95995C10.78712,10.41116,10.43163,10.77347,9.98731,10.77347C9.54981,10.77347,9.17385,10.40427,9.17385,9.92577L9.17385,9.15332L9.9463,9.15332Z", fill: "currentColor" }) })
] });

// src/assets/svg/enter.svg
import * as React44 from "react";
import { jsx as jsx78 } from "react/jsx-runtime";
var SvgEnter = (props) => /* @__PURE__ */ jsx78("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14", className: "xtdbctnq3__design-iconfont", width: 128, height: 128, ...props, children: /* @__PURE__ */ jsx78("path", { d: "M8.191970000000001,3.7583293749999998Q8.21896,3.7583293749999998,8.24588,3.756309375L10.88439,3.756309375Q11.06388,3.756309375,11.06388,3.935799375L11.06388,7.525699375Q11.06388,7.705189375,10.88439,7.705189375L3.9513,7.705189375L5.22591,6.430579375Q5.24638,6.412969375,5.26546,6.393879375Q5.3156099999999995,6.343739375,5.35501,6.284779374999999Q5.3944,6.225809375,5.42154,6.160299375Q5.4486799999999995,6.094779375,5.46251,6.025229375Q5.47635,5.955679375,5.47635,5.884769374999999Q5.47635,5.813849375,5.46251,5.744299375000001Q5.4486799999999995,5.674749375,5.42154,5.609229375Q5.3944,5.543719375,5.35501,5.484759374999999Q5.3156099999999995,5.425789375,5.26546,5.375649375Q5.21532,5.325509375,5.156359999999999,5.2861093750000006Q5.09739,5.246709375,5.03188,5.219569375Q4.96636,5.192439375,4.89681,5.178599375Q4.82726,5.1647693750000006,4.756349999999999,5.1647693750000006Q4.68543,5.1647693750000006,4.615880000000001,5.178599375Q4.54633,5.192439375,4.48082,5.219569375Q4.4153,5.246709375,4.356339999999999,5.2861093750000006Q4.29737,5.325509375,4.24723,5.375649375Q4.22814,5.394739375,4.21054,5.415199375L1.710222,7.915519375Q1.6602190000000001,7.965519375,1.620932,8.024319375000001Q1.5816449,8.083109375,1.5545836,8.148449375Q1.5275222,8.213779375,1.5137264,8.283129375Q1.4999306926,8.352489375000001,1.4999306926,8.423199375Q1.4999306926,8.493919375,1.5137264,8.563269375Q1.5275222,8.632629375,1.5545836,8.697959375Q1.5816449,8.763289375,1.620932,8.822089375000001Q1.6602190000000001,8.880889374999999,1.710222,8.930889375L4.21054,11.431209375Q4.228149999999999,11.451669375,4.24723,11.470759375Q4.3485,11.572029375,4.48082,11.626839375Q4.61313,11.681639375,4.756349999999999,11.681639375Q4.89956,11.681639375,5.03188,11.626839375Q5.16419,11.572029375,5.26546,11.470759375Q5.3156099999999995,11.420609375,5.35501,11.361649375Q5.3944,11.302689375,5.42154,11.237169375Q5.4486799999999995,11.171659375,5.46251,11.102109375Q5.47635,11.032559375,5.47635,10.961639375Q5.47635,10.890729375,5.46251,10.821179375Q5.4486799999999995,10.751629375,5.42154,10.686109375Q5.3944,10.620589375,5.35501,10.561629375Q5.3156099999999995,10.502669375,5.26546,10.452529375Q5.24638,10.433439375,5.22591,10.415829375L3.95123,9.141149375000001L10.88439,9.141149375000001Q11.5535,9.141149375000001,12.0267,8.667999375Q12.4998,8.194839375,12.4998,7.525699375L12.4998,3.935799375Q12.4998,3.266661375,12.0267,2.7935063749999998Q11.5535,2.320351425,10.88439,2.320351425L8.24588,2.320351365Q8.21896,2.3183300495,8.191970000000001,2.3183300495Q8.12105,2.3183300495,8.0515,2.332164675Q7.98195,2.345999275,7.91644,2.373136775Q7.85092,2.400274275,7.79196,2.439672375Q7.73299,2.479069375,7.68285,2.529213375Q7.63271,2.579356375,7.59331,2.638319375Q7.55391,2.697282375,7.52677,2.762798375Q7.49964,2.828313375,7.4858,2.897865375Q7.47197,2.967416375,7.47197,3.038330375Q7.47197,3.109243375,7.4858,3.178795375Q7.49964,3.248346375,7.52677,3.3138623750000002Q7.55391,3.379379375,7.59331,3.438339375Q7.63271,3.497299375,7.68285,3.5474493750000002Q7.73299,3.597589375,7.79196,3.6369893749999997Q7.85092,3.6763893750000003,7.91644,3.703519375Q7.98195,3.730659375,8.0515,3.744499375Q8.12105,3.7583293749999998,8.191970000000001,3.7583293749999998Z", fillRule: "evenodd", fill: "currentColor" }) });

// src/assets/svg/shift.svg
import * as React45 from "react";
import { jsx as jsx79, jsxs as jsxs46 } from "react/jsx-runtime";
var SvgShift = (props) => /* @__PURE__ */ jsxs46("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 14 14", className: "qqr5jdo94__design-iconfont", width: 128, height: 128, ...props, children: [
  /* @__PURE__ */ jsx79("defs", { children: /* @__PURE__ */ jsx79("clipPath", { id: "qqr5jdo94__yyi0cdo1d__vhm6wqc9xa", children: /* @__PURE__ */ jsx79("rect", { width: 14, height: 14, rx: 0 }) }) }),
  /* @__PURE__ */ jsx79("g", { clipPath: "url(#qqr5jdo94__yyi0cdo1d__vhm6wqc9xa)", children: /* @__PURE__ */ jsx79("path", { d: "M5.45947390625,12.209L8.92530390625,12.209C9.81395390625,12.209,10.30617390625,11.68948,10.30617390625,10.8213L10.30617390625,8.64745L12.24760390625,8.64745C12.81500390625,8.64745,13.21140390625,8.3125,13.21140390625,7.79981C13.21140390625,7.47851,13.07470390625,7.26658,12.78080390625,6.96582L7.97511390625,2.112302C7.74265390625,1.879885,7.47607390625,1.75,7.18895390625,1.75C6.90183390625,1.75,6.63525390625,1.879885,6.40285390625,2.112302L1.59716690625,6.96582C1.29638890625,7.28029,1.16650390625,7.47168,1.16650390625,7.79981C1.16650390625,8.3125,1.5698269062499999,8.64745,2.13720590625,8.64745L4.07177390625,8.64745L4.07177390625,10.8213C4.07177390625,11.68948,4.57080390625,12.209,5.45947390625,12.209ZM5.90381390625,10.69822C5.74658390625,10.69822,5.63720390625,10.58884,5.63720390625,10.42481L5.63720390625,7.51269C5.63720390625,7.38967,5.58935390625,7.33495,5.45947390625,7.33495L3.39501390625,7.33495C3.37451390625,7.33495,3.36084390625,7.32812,3.36084390625,7.31447C3.36084390625,7.30077,3.36767390625,7.28712,3.38135390625,7.27347L7.13429390625,3.52051C7.14794390625,3.50684,7.16847390625,3.5,7.18895390625,3.5C7.20948390625,3.5,7.22996390625,3.50684,7.24367390625,3.52051L10.99660390625,7.27347C11.01025390625,7.28712,11.01707390625,7.30077,11.01707390625,7.31447C11.01707390625,7.32812,11.00342390625,7.33495,10.98289390625,7.33495L8.91847390625,7.33495C8.78857390625,7.33495,8.74073390625,7.38967,8.74073390625,7.51269L8.74073390625,10.42481C8.74073390625,10.58202,8.62453390625,10.69822,8.474093906250001,10.69822L5.90381390625,10.69822Z", fillRule: "evenodd", fill: "currentColor" }) })
] });

// src/components/messageInput/util.ts
var PLATFORM_OS = {
  MAC: "MAC",
  IOS: "IOS",
  LINUX: "LINUX",
  ANDROID: "ANDROID",
  WINDOWS: "WINDOWS"
};
var platformOSRegex = {
  [PLATFORM_OS.MAC]: /mac.*/i,
  [PLATFORM_OS.IOS]: /(?:iphone|ipod|ipad|Pike v.*)/i,
  [PLATFORM_OS.LINUX]: /(?:linux.*)/i,
  [PLATFORM_OS.ANDROID]: /android.*|aarch64|arm.*/i,
  [PLATFORM_OS.WINDOWS]: /win.*/i
};
function getPlatformOS() {
  const browserPlatform = typeof navigator !== "undefined" ? navigator.platform : null;
  if (browserPlatform) {
    const platformOSList = Object.entries(platformOSRegex);
    const platform = platformOSList.find(
      ([, regex]) => regex.test(browserPlatform)
    );
    return platform ? platform[0] : null;
  }
  return null;
}
function isMacOrIOS() {
  const platformOS = getPlatformOS();
  return platformOS === PLATFORM_OS.MAC || platformOS === PLATFORM_OS.IOS;
}

// src/components/messageInput/ShortcutTips.tsx
import { Fragment as Fragment5, jsx as jsx80, jsxs as jsxs47 } from "react/jsx-runtime";
function KeyIcon(props) {
  return /* @__PURE__ */ jsx80("div", { className: "ui-flex-center ui-p-[8px] ui-rounded-[4px] ui-h-[16px] ui-bg-[#f1f1f1] ui-text-[12px] ui-text-yeah ui-box-border", children: props.children });
}
var SHORTCUTS = {
  enter: {
    label: /* @__PURE__ */ jsx80("div", { children: /* @__PURE__ */ jsx80(KeyIcon, { children: /* @__PURE__ */ jsx80(SvgEnter, { className: "ui-shortcut-icon" }) }) }),
    desc: "\u53D1\u9001"
  },
  "shift + enter": {
    label: /* @__PURE__ */ jsx80("div", { className: "ui-flex ui-items-center", children: /* @__PURE__ */ jsxs47(KeyIcon, { children: [
      /* @__PURE__ */ jsx80(SvgShift, { className: "ui-shortcut-icon" }),
      /* @__PURE__ */ jsx80(SvgEnter, { className: "ui-shortcut-icon" })
    ] }) }),
    desc: "\u6362\u884C"
  },
  [isMacOrIOS() ? "Meta + k" : "shift + k"]: {
    label: /* @__PURE__ */ jsx80("div", { children: /* @__PURE__ */ jsx80(KeyIcon, { children: isMacOrIOS() ? /* @__PURE__ */ jsxs47(Fragment5, { children: [
      /* @__PURE__ */ jsx80(SvgCommand, { className: "ui-shortcut-icon" }),
      /* @__PURE__ */ jsx80("span", { className: "ui-ml-[8px] ui-text-yeah-light", children: "K" })
    ] }) : "Ctrl + K" }) }),
    desc: "\u53D1\u8D77\u65B0\u4F1A\u8BDD"
  }
};
var shortcuts = Object.entries(SHORTCUTS);
function ShortcutTips({ tips }) {
  const showTips = useMemo11(() => {
    if (!tips)
      return shortcuts;
    return shortcuts.filter(([key]) => tips.includes(key));
  }, []);
  return /* @__PURE__ */ jsx80(
    "div",
    {
      className: "ui-flex ui-items-center ui-p-[4px] ShortcutTipsWrapper ui-bg-white ui-bg-opacity-80 ui-rounded-md ui-box-border",
      style: { backdropFilter: "blur(10px)" },
      children: showTips.map(([key, { label, desc }], i) => /* @__PURE__ */ jsxs47("div", { className: "ui-flex ui-items-center", children: [
        label,
        /* @__PURE__ */ jsxs47("span", { className: "ui-text-[12px] ui-ml-[2px] ui-text-yeah-light", children: [
          desc,
          i === showTips.length - 1 ? "" : "\uFF0C"
        ] })
      ] }, key))
    }
  );
}

// src/components/messageInput/operations/FileButton.tsx
import { forwardRef as forwardRef9, useImperativeHandle as useImperativeHandle3, useMemo as useMemo13, useRef as useRef11 } from "react";
import { cn as cn32 } from "@bty/util";

// src/components/messageInput/FileUpload.tsx
import Upload2 from "rc-upload";
import { forwardRef as forwardRef8, useImperativeHandle as useImperativeHandle2, useMemo as useMemo12, useRef as useRef10 } from "react";
import prettyBytes2 from "pretty-bytes";
import { cn as cn31 } from "@bty/util";
import { Fragment as Fragment6, jsx as jsx81, jsxs as jsxs48 } from "react/jsx-runtime";
var MAX_FILE_SIZE = 150 * 1024 * 1024;
var ACCEPT_FILE_TYPE = [".txt", ",pdf", ".doc", ".docx"];
var FileUpload = forwardRef8(
  ({
    className,
    onlySelect,
    disabled = false,
    headers = {},
    children,
    maxSize = MAX_FILE_SIZE,
    params = {},
    beforeFileUpload,
    onSelect,
    onStart,
    onOk,
    onFail,
    fileAccept = ACCEPT_FILE_TYPE,
    getFileAction,
    onFileUpload
  }, ref) => {
    const uploadRef = useRef10(null);
    const prepareUploadRef = useRef10(null);
    const resolver = useRef10();
    const beforeUpload = async (file, uploadMethod) => {
      if (file.size > maxSize) {
        onFail == null ? void 0 : onFail(
          file,
          `\u6587\u4EF6\u5927\u5C0F\u4E3A${prettyBytes2(file.size)}\uFF0C\u8D85\u8FC7${Number.parseInt(
            `${maxSize / 1024 / 1024}`
          )}MB\u9650\u5236\uFF0C\u65E0\u6CD5\u4E0A\u4F20`
        );
        return false;
      }
      const res = await (beforeFileUpload == null ? void 0 : beforeFileUpload(file, [], uploadMethod));
      if (!res) {
        return false;
      }
      if (uploadMethod === "post") {
        return true;
      }
      if (onlySelect) {
        onSelect == null ? void 0 : onSelect(
          {
            name: file.name,
            type: file.type,
            size: file.size
          },
          file
        );
        return false;
      }
      return true;
    };
    const handleSuccess = (response, file) => {
      var _a, _b, _c, _d, _e, _f, _g;
      const upload_file_id = ((_a = response == null ? void 0 : response.data) == null ? void 0 : _a.upload_file_id) || "";
      const file_url = ((_b = response == null ? void 0 : response.data) == null ? void 0 : _b.file_url) || URL.createObjectURL(file);
      if (response.success) {
        onOk == null ? void 0 : onOk({
          name: ((_c = file == null ? void 0 : file.meta) == null ? void 0 : _c.title) || file.name,
          type: file.type,
          icon: (_d = file == null ? void 0 : file.meta) == null ? void 0 : _d.icon,
          size: file.size,
          upload_file_id,
          url: file_url,
          rawFile: file
        });
        (_g = resolver.current) == null ? void 0 : _g.call(resolver, {
          name: ((_e = file == null ? void 0 : file.meta) == null ? void 0 : _e.title) || file.name,
          icon: (_f = file == null ? void 0 : file.meta) == null ? void 0 : _f.icon,
          type: file.type,
          size: file.size,
          upload_file_id,
          url: file_url,
          rawFile: file
        });
        resolver.current = null;
      } else {
        onFail == null ? void 0 : onFail(file);
      }
    };
    const accept = useMemo12(() => {
      return fileAccept.join(",");
    }, [fileAccept]);
    const customUpload = (file) => {
      return new Promise((resolve) => {
        var _a, _b;
        resolver.current = resolve;
        (_b = (_a = uploadRef == null ? void 0 : uploadRef.current) == null ? void 0 : _a.uploader) == null ? void 0 : _b.onChange({
          target: {
            files: [file]
          }
        });
      });
    };
    const prepareUpload = (file) => {
      return new Promise((resolve) => {
        var _a, _b;
        resolver.current = resolve;
        (_b = (_a = prepareUploadRef == null ? void 0 : prepareUploadRef.current) == null ? void 0 : _a.uploader) == null ? void 0 : _b.onChange({
          target: {
            files: [file]
          }
        });
      });
    };
    const handleUpload = async (options) => {
      const { onSuccess, onError } = options;
      const file = options.file;
      const { data } = options;
      try {
        onStart == null ? void 0 : onStart({
          name: file.name,
          type: file.type,
          size: file.size
        });
        const res = await (onFileUpload == null ? void 0 : onFileUpload({
          ...data,
          file
        }));
        onSuccess == null ? void 0 : onSuccess(res, file);
      } catch (err) {
        onError == null ? void 0 : onError(err);
      }
    };
    useImperativeHandle2(
      ref,
      () => ({
        customUpload,
        prepareUpload
      }),
      [ref, customUpload, prepareUpload, uploadRef]
    );
    return /* @__PURE__ */ jsxs48(Fragment6, { children: [
      /* @__PURE__ */ jsx81(
        Upload2,
        {
          className,
          ref: prepareUploadRef,
          data: (file) => {
            const type = file instanceof Blob ? file.type : "text/plain";
            const fileAction = getFileAction == null ? void 0 : getFileAction(file);
            return {
              ...params,
              file_type: type,
              rawFile: file,
              file_action: fileAction
            };
          },
          accept,
          style: { cursor: disabled ? "not-allowed" : "pointer" },
          disabled,
          beforeUpload: (file) => {
            return beforeUpload(file, "post");
          },
          children
        }
      ),
      /* @__PURE__ */ jsx81(
        Upload2,
        {
          ref: uploadRef,
          className: cn31(className, "ui-hidden"),
          headers,
          style: { cursor: disabled ? "not-allowed" : "pointer" },
          disabled,
          customRequest: handleUpload,
          data: (file) => {
            var _a;
            const type = file instanceof Blob ? file.type : "text/plain";
            const file_data = file instanceof Blob && (file == null ? void 0 : file.type) === "application/marking-content+txt" ? (_a = file == null ? void 0 : file.meta) == null ? void 0 : _a.title : void 0;
            const fileAction = getFileAction == null ? void 0 : getFileAction(file);
            return {
              ...params,
              file_type: type,
              file_data,
              file_action: fileAction
            };
          },
          accept,
          beforeUpload: (file) => {
            return beforeUpload(file);
          },
          onStart: (file) => {
            onStart == null ? void 0 : onStart({
              name: file.name,
              type: file.type,
              size: file.size
            });
          },
          onSuccess: handleSuccess,
          onError: (_, body) => {
            let message = "\u4E0A\u4F20\u5931\u8D25\uFF0C\u8BF7\u91CD\u8BD5";
            if (body == null ? void 0 : body.message) {
              message = body == null ? void 0 : body.message;
            }
            onFail == null ? void 0 : onFail(void 0, message);
          },
          children
        }
      )
    ] });
  }
);
var FileUpload_default = FileUpload;

// src/assets/svg/prompt-add-file.svg
import * as React46 from "react";
import { jsx as jsx82, jsxs as jsxs49 } from "react/jsx-runtime";
var SvgPromptAddFile = (props) => /* @__PURE__ */ jsxs49("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 15.984390258789062, viewBox: "0 0 16 15.984390258789062", ...props, children: [
  /* @__PURE__ */ jsx82("defs", { children: /* @__PURE__ */ jsx82("clipPath", { id: "master_svg0_44_11314", children: /* @__PURE__ */ jsx82("rect", { x: 0, y: 0, width: 16, height: 15.984390258789062, rx: 0 }) }) }),
  /* @__PURE__ */ jsx82("g", { clipPath: "url(#master_svg0_44_11314)", children: /* @__PURE__ */ jsx82("g", { children: /* @__PURE__ */ jsx82("path", { d: "M9.353779856948853,13.034700214576722L14.046699856948852,7.966030214576721Q15.093599856948853,6.848480214576721,15.099999856948852,5.250570214576721Q15.106299856948853,3.6523802145767212,14.067799856948852,2.5249002145767214Q13.017999856948853,1.4000002145767212,11.546499856948852,1.4000002145767212Q10.075089856948853,1.4000002145767212,9.025669856948852,2.524420214576721L4.325649856948853,7.608510214576722Q3.6860798569488527,8.295410214576721,3.6860898569488527,9.274140214576722Q3.6860798569488527,10.25287021457672,4.325899856948853,10.940030214576721Q4.968479856948853,11.63500021457672,5.874729856948853,11.63500021457672Q6.780979856948853,11.63500021457672,7.423799856948852,10.939770214576722L11.920699856948852,6.077740214576721Q12.147199856948852,5.825170214576721,12.147199856948852,5.474710214576721Q12.147199856948852,5.124260214576721,11.921699856948852,4.872820214576722Q11.686499856948853,4.617280214576722,11.354199856948853,4.617280214576722Q11.021899856948853,4.617280214576722,10.787579856948852,4.871860214576721L6.290869856948852,9.73372021457672Q6.117939856948852,9.916430214576721,5.8782298569488525,9.916430214576721Q5.639479856948853,9.916430214576721,5.466199856948853,9.734350214576722Q5.299019856948853,9.541590214576722,5.299019856948853,9.274140214576722Q5.299019856948853,9.00643021457672,5.466529856948853,8.813540214576722L10.186129856948853,3.7309602145767213Q10.766589856948853,3.1147802145767214,11.574499856948853,3.1147802145767214Q12.382399856948853,3.1147802145767214,12.963399856948852,3.731480214576721Q13.540299856948852,4.3533302145767205,13.540299856948852,5.241550214576721Q13.540299856948852,6.129760214576721,12.962899856948853,6.752170214576721L8.270089856948854,11.820700214576721Q7.280239856948852,12.88130021457672,5.895709856948852,12.88130021457672Q4.511179856948853,12.88130021457672,3.5210598569488525,11.820400214576722Q2.5364998569488524,10.760130214576721,2.5364998569488524,9.247380214576722Q2.5364998569488524,7.734620214576721,3.5212298569488527,6.6741802145767215L6.9064298569488525,2.9967402145767212Q7.132769856948853,2.744340214576721,7.132769856948853,2.393886214576721Q7.132769856948853,2.043432214576721,6.907299856948852,1.7919952145767213L6.9061698569488525,1.7907322145767213L6.904999856948852,1.7895072145767212Q6.665639856948853,1.540143214576721,6.333149856948853,1.5478762145767213Q6.001639856948852,1.5555862145767212,5.772759856948853,1.8144152145767212L2.3468798569488527,5.475180214576721Q0.8999998569488525,7.035510214576721,0.8999998569488525,9.25503021457672Q0.8999998569488525,11.474500214576722,2.3465698569488525,13.03450021457672Q3.8047098569488527,14.60000021457672,5.850249856948852,14.60000021457672Q7.895779856948852,14.60000021457672,9.353779856948853,13.034700214576722Z", fillRule: "evenodd", fill: "currentColor", fillOpacity: 1 }) }) })
] });

// src/components/messageInput/operations/FileButton.tsx
import { jsx as jsx83, jsxs as jsxs50 } from "react/jsx-runtime";
var FileButton = forwardRef9((props, ref) => {
  const {
    disabled = false,
    uploading = false,
    fileAction,
    fileHeaders,
    fileParams,
    onFileOK,
    onFileFail,
    beforeFileUpload,
    fileAccept,
    getFileAction,
    onFileUpload,
    uploadFileConfig
  } = props;
  const fileUploadRef = useRef11(null);
  useImperativeHandle3(
    ref,
    () => ({
      customUpload: fileUploadRef == null ? void 0 : fileUploadRef.current.customUpload,
      prepareUpload: fileUploadRef == null ? void 0 : fileUploadRef.current.prepareUpload
    }),
    [ref, fileUploadRef]
  );
  const innerBtnDisabled = useMemo13(() => {
    var _a;
    if (uploadFileConfig && !uploadFileConfig.acceptsAllFileTypes && ((_a = uploadFileConfig == null ? void 0 : uploadFileConfig.fileAccepts) == null ? void 0 : _a.length) === 0) {
      return true;
    }
  }, [uploadFileConfig]);
  const title = useMemo13(() => {
    var _a, _b;
    if (uploadFileConfig && !uploadFileConfig.acceptsAllFileTypes) {
      if (((_a = uploadFileConfig.fileAccepts) == null ? void 0 : _a.length) === 0) {
        return /* @__PURE__ */ jsx83("p", { className: "c-[#17171D] ui-text-[12px] leading-[18px] max-w-[200px]", children: "\u5F53\u524DAgent\u4E0D\u652F\u6301\u5904\u7406\u6587\u4EF6" });
      }
      const fileNameStr = (_b = uploadFileConfig.allowFileTypeNameList) == null ? void 0 : _b.join("\u3001");
      return /* @__PURE__ */ jsx83("p", { className: "c-[#17171D] ui-text-[12px] leading-[18px] max-w-[200px]", children: `\u652F\u6301\u6587\u4EF6\uFF1A${fileNameStr}\uFF0C\u6700\u5927 100 MB` });
    }
    return /* @__PURE__ */ jsxs50("p", { className: "c-[#17171D] ui-text-[12px] leading-[18px]", children: [
      "\u652F\u6301\u6240\u6709\u6587\u4EF6\u683C\u5F0F\uFF0C\u6700\u5927100M",
      /* @__PURE__ */ jsx83("br", {}),
      "\u8BF7",
      " ",
      /* @__PURE__ */ jsx83(
        "span",
        {
          className: "font-bold ui-text-primary ui-cursor-pointer",
          onClick: (e) => {
            var _a2;
            e.stopPropagation();
            (_a2 = uploadFileConfig == null ? void 0 : uploadFileConfig.addFileProcessingPlugin) == null ? void 0 : _a2.call(uploadFileConfig);
          },
          children: "\u9009\u62E9\u63D2\u4EF6"
        }
      ),
      " ",
      "\u89E3\u6790\u6587\u4EF6"
    ] });
  }, [uploadFileConfig]);
  return /* @__PURE__ */ jsx83(
    Tooltip2,
    {
      arrowClassName: "ui-fill-[--while-popover]!",
      className: "bg-[#fff]",
      title,
      children: /* @__PURE__ */ jsx83("div", { children: /* @__PURE__ */ jsx83(
        FileUpload_default,
        {
          ref: fileUploadRef,
          fileAccept,
          disabled: disabled || innerBtnDisabled,
          headers: fileHeaders,
          params: fileParams,
          action: fileAction,
          onFail: onFileFail,
          onOk: onFileOK,
          beforeFileUpload,
          getFileAction,
          onFileUpload,
          className: "ui-shrink-0",
          children: /* @__PURE__ */ jsx83(
            "div",
            {
              className: cn32(
                "ui-btn-icon-only ui-flex-center ui-cursor-pointer hover:ui-bg-yeah-icon_light/8",
                {
                  "ui-opacity-40 hover:ui-opacity-40 !ui-cursor-not-allowed hover:!ui-bg-transparent": disabled || innerBtnDisabled
                }
              ),
              children: !uploading && /* @__PURE__ */ jsx83(
                SvgPromptAddFile,
                {
                  className: cn32("ui-text-[#17171D] ui-w-[16px] ui-h-[16px]", {
                    "!ui-text-[#17171D]": !disabled,
                    "!ui-text-[rgb(206,207,211)]": disabled
                  })
                }
              )
            }
          )
        }
      ) })
    }
  );
});

// src/components/messageInput/operations/SendButton.tsx
import { cn as cn33 } from "@bty/util";

// src/assets/svg/prompt-send.svg
import * as React47 from "react";
import { jsx as jsx84, jsxs as jsxs51 } from "react/jsx-runtime";
var SvgPromptSend = (props) => /* @__PURE__ */ jsxs51("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 20, height: 20, viewBox: "0 0 20 20", ...props, children: [
  /* @__PURE__ */ jsx84("defs", { children: /* @__PURE__ */ jsx84("clipPath", { id: "master_svg0_44_11303", children: /* @__PURE__ */ jsx84("rect", { x: 0, y: 0, width: 20, height: 20, rx: 0 }) }) }),
  /* @__PURE__ */ jsx84("g", { children: /* @__PURE__ */ jsx84("g", { clipPath: "url(#master_svg0_44_11303)", children: /* @__PURE__ */ jsx84("g", { children: /* @__PURE__ */ jsx84("path", { d: "M17.564967578125,10.77876C17.408467578125,11.11434,17.141867578125,11.38036,16.822567578125,11.5404L4.749627578125001,17.6336C3.8931375781249997,18.0524,2.859585578125,17.7108,2.424898578125,16.8719C2.233570078125,16.4668,2.1947614781249998,16.0095,2.327222478125,15.583L3.647577578125,11.28473C3.768467578125,10.89116,4.132007578125,10.62253,4.543747578125,10.62253L9.164647578124999,10.62253C9.504287578125,10.62116,9.782027578125,10.34674,9.789777578125001,9.997589999999999C9.787627578125,9.653839999999999,9.513317578125001,9.37598,9.164647578124999,9.37264L4.547147578125,9.37264C4.133787578125,9.37264,3.7692175781249997,9.10192,3.649687578125,8.70622L2.346753278125,4.39264C2.074155578125,3.4930000000000003,2.588745578125,2.533445,3.499347578125,2.2639328C3.920837578125,2.1314327,4.3767875781250005,2.1716476,4.769157578125,2.38112L16.822567578125,8.47428C17.664567578125002,8.904340000000001,18.003367578125,9.93915,17.564967578125,10.77876Z", fill: "#FFFFFF", fillOpacity: 1 }) }) }) })
] });

// src/components/messageInput/operations/SendButton.tsx
import { jsx as jsx85 } from "react/jsx-runtime";
function SendButton(props) {
  const { size = "normal", disabled = false, onClick } = props;
  return /* @__PURE__ */ jsx85(Tooltip2, { title: "\u53D1\u9001", children: /* @__PURE__ */ jsx85(
    "div",
    {
      className: cn33(
        "ui-chat-bg-linear ui-flex-center ui-cursor-pointer ui-text-white hover:ui-opacity-80",
        {
          "ui-btn-icon-only": size === "normal",
          "!ui-opacity-40 hover:!ui-opacity-40 !ui-cursor-not-allowed": disabled
        }
      ),
      onClick: () => !disabled && (onClick == null ? void 0 : onClick()),
      children: /* @__PURE__ */ jsx85(SvgPromptSend, { className: "ui-text-[20px] w-16px h-16px" })
    }
  ) });
}

// src/components/messageInput/ShortcutsForm.tsx
import { memo as memo8, useEffect as useEffect7, useMemo as useMemo14, useState as useState14 } from "react";
import { SchemaForm as SchemaForm2 } from "@bty/ui-components";
import useKeyPress from "ahooks/es/useKeyPress";
import { isUndefined } from "lodash-es";
import useMemoizedFn from "ahooks/es/useMemoizedFn";
import { cn as cn34 } from "@bty/util";
import { jsx as jsx86, jsxs as jsxs52 } from "react/jsx-runtime";
var TYPE_DISPLAY = /* @__PURE__ */ ((TYPE_DISPLAY2) => {
  TYPE_DISPLAY2["flow"] = "\u5DE5\u4F5C\u6D41";
  TYPE_DISPLAY2["plugin"] = "\u63D2\u4EF6";
  TYPE_DISPLAY2["prompt"] = "\u63D0\u793A\u8BCD";
  return TYPE_DISPLAY2;
})(TYPE_DISPLAY || {});
function setAutofocusFunctional(forms) {
  return forms.map(
    (form, index) => index === 0 && (form.type === "input" || form.type === "textarea") ? { ...form, autoFocus: true } : form
  );
}
function formatFormValue(options) {
  const { type, schema, title, values, prompt } = options;
  if (type === "prompt") {
    return prompt;
  }
  return `\u8FD0\u884C${TYPE_DISPLAY[type]}\uFF1A\u300C${title}\u300D

${schema.map((item) => {
    var _a;
    const v = isUndefined(values == null ? void 0 : values[item.name]) ? (_a = schema == null ? void 0 : schema.find((v2) => v2.name === item.name)) == null ? void 0 : _a.default : values == null ? void 0 : values[item.name];
    return v ? `${item.label}: ${v}` : "";
  }).join("\n\n")}
  `;
}
function initDefaultValues(arr) {
  return arr.reduce(
    (acc, { name, default: defaultValue }) => ({
      ...acc,
      [name]: defaultValue
    }),
    {}
  );
}
function hasRequiredValueEmpty(schema, allValues) {
  return Object.keys(allValues).some(
    (key) => {
      var _a;
      return !allValues[key] && ((_a = schema.find((v) => v.name === key)) == null ? void 0 : _a.required);
    }
  );
}
var ShortcutsForm = memo8(
  ({
    className,
    schema = [],
    onFileUpload,
    onSubmit,
    type,
    title,
    item,
    autoFocus = true
  }) => {
    const [form] = SchemaForm2.useForm();
    const [initialValues] = useState14(initDefaultValues(schema));
    const [disabled, setDisabled] = useState14(
      hasRequiredValueEmpty(schema, initialValues)
    );
    const handleSubmit = useMemoizedFn(async () => {
      var _a, _b;
      if (disabled)
        return;
      setDisabled(true);
      try {
        const values = await form.validateFields();
        const isPromptMode = type === "prompt";
        onSubmit == null ? void 0 : onSubmit(
          formatFormValue({
            type,
            schema,
            title,
            values,
            prompt: ((_a = item == null ? void 0 : item.meta) == null ? void 0 : _a.prompt) || ""
          }),
          !isPromptMode ? (_b = item == null ? void 0 : item.meta) == null ? void 0 : _b.function_id : ""
        );
      } catch (error) {
        console.log(error);
      } finally {
        setDisabled(false);
      }
    });
    useKeyPress("Enter", (e) => {
      e.preventDefault();
      handleSubmit();
    });
    const focusedAndFilteredSchema = useMemo14(() => {
      return autoFocus ? setAutofocusFunctional(schema.filter((v) => !v.hidden)) : schema.filter((v) => !v.hidden);
    }, [schema, autoFocus]);
    useEffect7(() => {
      if (!focusedAndFilteredSchema.length) {
        handleSubmit();
      }
    }, [focusedAndFilteredSchema, handleSubmit]);
    const onValuesChange = useMemoizedFn(
      (_, allValues) => {
        setDisabled(hasRequiredValueEmpty(schema, allValues || {}));
      }
    );
    return /* @__PURE__ */ jsxs52("div", { className: cn34(className), children: [
      /* @__PURE__ */ jsx86(
        SchemaForm2,
        {
          form,
          schema: focusedAndFilteredSchema,
          validateTrigger: "manual",
          initialValues,
          onValuesChange,
          fieldComponentsMap: getFormItemComponentMap(onFileUpload)
        }
      ),
      /* @__PURE__ */ jsx86("div", { className: "ui-flex ui-justify-end", children: /* @__PURE__ */ jsx86(SendButton, { disabled, onClick: handleSubmit }) })
    ] });
  }
);

// src/components/messageInput/hooks/useShortcutsForm.ts
import { useCallback as useCallback2, useEffect as useEffect8, useState as useState15 } from "react";
function useShortcutsForm(shortcuts2, preview) {
  const [shortcutsFormVisible, setShortcutsFormVisible] = useState15(
    preview ? shortcuts2.length < 0 : false
  );
  const [currentShortcutsCardItem, setCurrentShortcutsCardItem] = useState15();
  const openShortcutsForm = useCallback2((shortcut) => {
    setCurrentShortcutsCardItem(shortcut);
    setShortcutsFormVisible(true);
  }, []);
  const hideShortcutsForm = useCallback2(() => {
    setCurrentShortcutsCardItem(void 0);
    setShortcutsFormVisible(false);
  }, []);
  useEffect8(() => {
    preview && shortcuts2.length && openShortcutsForm(shortcuts2 == null ? void 0 : shortcuts2[0]);
  }, [shortcuts2, preview]);
  return {
    shortcutsFormVisible,
    currentShortcutsCardItem,
    openShortcutsForm,
    hideShortcutsForm
  };
}

// src/components/messageInput/operations/FileButtonWithPopover.tsx
import { forwardRef as forwardRef10 } from "react";
import * as Popover4 from "@radix-ui/react-popover";
import { cn as cn35 } from "@bty/util";

// src/assets/svg/warning.svg
import * as React48 from "react";
import { jsx as jsx87, jsxs as jsxs53 } from "react/jsx-runtime";
var SvgWarning = (props) => /* @__PURE__ */ jsxs53("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: [
  /* @__PURE__ */ jsx87("defs", { children: /* @__PURE__ */ jsx87("clipPath", { id: "master_svg0_108_4930", children: /* @__PURE__ */ jsx87("rect", { x: 0, y: 0, width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsx87("g", { clipPath: "url(#master_svg0_108_4930)", children: /* @__PURE__ */ jsx87("g", { children: /* @__PURE__ */ jsx87("path", { d: "M1,7.99912C1,4.13978,4.1401699999999995,1,8,1C11.8598,1,15,4.1415299999999995,15,8.00088C15,11.8602,11.8598,15,8,15C4.1401699999999995,15,1,11.8602,1,7.99912ZM7.12492,4.2079L7.12492,8.29072C7.12492,8.77391,7.51667,9.16561,7.99992,9.16561C8.483170000000001,9.16561,8.87492,8.77391,8.87492,8.29072L8.87492,4.2079C8.87492,3.72471,8.483170000000001,3.33301,7.99992,3.33301C7.51667,3.33301,7.12492,3.72471,7.12492,4.2079ZM7.99992,12.6652C8.64425,12.6652,9.16658,12.1429,9.16658,11.4987C9.16658,10.8544,8.64425,10.33213,7.99992,10.33213C7.35559,10.33213,6.83325,10.8544,6.83325,11.4987C6.83325,12.1429,7.35559,12.6652,7.99992,12.6652Z", fillRule: "evenodd", fill: "currentColor", fillOpacity: 1 }) }) })
] });

// src/components/messageInput/operations/FileButtonWithPopover.tsx
import { Fragment as Fragment7, jsx as jsx88, jsxs as jsxs54 } from "react/jsx-runtime";
var FileButtonWithPopover = forwardRef10((props) => {
  const { disabled = false, uploadFileConfig } = props;
  return /* @__PURE__ */ jsx88(Fragment7, { children: /* @__PURE__ */ jsxs54(Popover4.Root, { children: [
    /* @__PURE__ */ jsx88(Popover4.Trigger, { asChild: true, children: /* @__PURE__ */ jsx88(
      "div",
      {
        className: cn35(
          "ui-btn-icon-only ui-flex-center ui-cursor-pointer hover:ui-bg-yeah-icon_light/8",
          {
            "ui-opacity-40 hover:ui-opacity-40 !ui-cursor-not-allowed hover:!ui-bg-transparent": disabled
          }
        ),
        children: /* @__PURE__ */ jsx88(
          SvgPromptAddFile,
          {
            className: cn35("ui-text-[#17171D] ui-w-[16px] ui-h-[16px]", {
              "!ui-text-[#17171D]": !disabled,
              "!ui-text-[rgb(206,207,211)]": disabled
            })
          }
        )
      }
    ) }),
    /* @__PURE__ */ jsx88(Popover4.Portal, { children: /* @__PURE__ */ jsxs54(
      Popover4.Content,
      {
        side: "top",
        align: "end",
        alignOffset: -32,
        className: "ui-z-50 ui-w-[230px] ui-bg-white ui-rounded-xl ui-shadow-[0px_4px_24px_0px_rgba(0,0,0,0.12)] ui-p-[12px]",
        children: [
          /* @__PURE__ */ jsxs54("div", { className: "ui-flex", children: [
            /* @__PURE__ */ jsx88("div", { children: /* @__PURE__ */ jsx88(SvgWarning, { className: "ui-w-[14px] ui-h-[14px]   !ui-text-[#FD9700]" }) }),
            /* @__PURE__ */ jsxs54("div", { className: "ui-ml-[6px]", children: [
              /* @__PURE__ */ jsx88("div", { className: "ui-text-[12px] ui-leading-[16px] ui-font-medium ui-mb-[6px]", children: "Agent \u65E0\u6CD5\u5904\u7406\u6587\u4EF6" }),
              /* @__PURE__ */ jsxs54("div", { className: "ui-text-[12px] ui-leading-[20px]", children: [
                "\u8BF7\u6DFB\u52A0",
                /* @__PURE__ */ jsx88("span", { className: "ui-font-medium", children: "\u6587\u4EF6\u89E3\u6790\u63D2\u4EF6" }),
                "\u6216\u81EA\u5B9A\u4E49\u5DE5\u4F5C\u6D41\u540E\uFF0C\u518D\u4E0A\u4F20\u6587\u4EF6\u3002"
              ] })
            ] })
          ] }),
          /* @__PURE__ */ jsxs54("div", { className: "ui-flex ui-justify-end ui-mt-[8px]", children: [
            /* @__PURE__ */ jsx88(
              Popover4.Close,
              {
                className: cn35(
                  buttonVariants({ variant: "outline", size: "small" })
                ),
                children: "\u53D6\u6D88"
              }
            ),
            /* @__PURE__ */ jsx88(
              "div",
              {
                className: cn35(
                  buttonVariants({ variant: "default", size: "small" }),
                  "ui-ml-[8px] ui-cursor-pointer"
                ),
                onClick: () => {
                  var _a;
                  (_a = uploadFileConfig == null ? void 0 : uploadFileConfig.addFileProcessingPlugin) == null ? void 0 : _a.call(uploadFileConfig);
                },
                children: "\u6DFB\u52A0\u63D2\u4EF6"
              }
            )
          ] }),
          /* @__PURE__ */ jsx88(Popover4.Arrow, { className: "ui-fill-[--while-popover]" })
        ]
      }
    ) })
  ] }) });
});

// src/components/messageInput/ShortcutsPanel.tsx
import { useState as useState16, useRef as useRef12, useEffect as useEffect9 } from "react";
import { ShortcutsCard } from "@bty/ui-components";
import { useClickAway, useSize as useSize3 } from "ahooks";

// src/assets/svg/shortcut-more.svg
import * as React49 from "react";
import { jsx as jsx89 } from "react/jsx-runtime";
var SvgShortcutMore = (props) => /* @__PURE__ */ jsx89("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 10.66670036315918, height: 10.66670036315918, viewBox: "0 0 10.66670036315918 10.66670036315918", ...props, children: /* @__PURE__ */ jsx89("g", { children: /* @__PURE__ */ jsx89("path", { d: "M1,2.66667L1.66667,2.66667C2.21895,2.66667,2.66667,2.21895,2.66667,1.66667L2.66667,1C2.66667,0.447715,2.21895,0,1.66667,0L1,0C0.447715,0,0,0.447715,0,1L0,1.66667C0,2.21895,0.447715,2.66667,1,2.66667ZM5,10.6667L5.66667,10.6667C6.21895,10.6667,6.66667,10.219,6.66667,9.66667L6.66667,9C6.66667,8.44771,6.21895,8,5.66667,8L5,8C4.44772,8,4,8.44771,4,9L4,9.66667C4,10.219,4.44772,10.6667,5,10.6667ZM1,10.6667L1.66667,10.6667C2.21895,10.6667,2.66667,10.219,2.66667,9.66667L2.66667,9C2.66667,8.44771,2.21895,8,1.66667,8L1,8C0.447715,8,0,8.44771,0,9L0,9.66667C0,10.219,0.447715,10.6667,1,10.6667ZM1,6.66667L1.66667,6.66667C2.21895,6.66667,2.66667,6.21895,2.66667,5.66667L2.66667,5C2.66667,4.44772,2.21895,4,1.66667,4L1,4C0.447715,4,0,4.44772,0,5L0,5.66667C0,6.21895,0.447715,6.66667,1,6.66667ZM5,6.66667L5.66667,6.66667C6.21895,6.66667,6.66667,6.21895,6.66667,5.66667L6.66667,5C6.66667,4.44772,6.21895,4,5.66667,4L5,4C4.44772,4,4,4.44772,4,5L4,5.66667C4,6.21895,4.44772,6.66667,5,6.66667ZM8,1L8,1.66667C8,2.21895,8.44771,2.66667,9,2.66667L9.66667,2.66667C10.219,2.66667,10.6667,2.21895,10.6667,1.66667L10.6667,1C10.6667,0.447715,10.219,0,9.66667,0L9,0C8.44771,0,8,0.447715,8,1ZM5,2.66667L5.66667,2.66667C6.21895,2.66667,6.66667,2.21895,6.66667,1.66667L6.66667,1C6.66667,0.447715,6.21895,0,5.66667,0L5,0C4.44772,0,4,0.447715,4,1L4,1.66667C4,2.21895,4.44772,2.66667,5,2.66667ZM9,6.66667L9.66667,6.66667C10.219,6.66667,10.6667,6.21895,10.6667,5.66667L10.6667,5C10.6667,4.44772,10.219,4,9.66667,4L9,4C8.44771,4,8,4.44772,8,5L8,5.66667C8,6.21895,8.44771,6.66667,9,6.66667ZM9,10.6667L9.66667,10.6667C10.219,10.6667,10.6667,10.219,10.6667,9.66667L10.6667,9C10.6667,8.44771,10.219,8,9.66667,8L9,8C8.44771,8,8,8.44771,8,9L8,9.66667C8,10.219,8.44771,10.6667,9,10.6667Z", fill: "#626999", fillOpacity: 1, style: {
  mixBlendMode: "passthrough"
} }) }) });

// src/components/messageInput/ShortcutsPanel.tsx
import { jsx as jsx90, jsxs as jsxs55 } from "react/jsx-runtime";
var MORE_BUTTON_WIDTH = 38;
var CARD_WIDTH = 50;
function MoreItems({ children }) {
  const [open, setOpen] = useState16(false);
  const ref = useRef12(null);
  const buttonRef = useRef12(null);
  useClickAway(() => {
    open && setOpen(false);
  }, [ref, buttonRef]);
  return /* @__PURE__ */ jsxs55(Popover, { open, children: [
    /* @__PURE__ */ jsx90(
      PopoverContent,
      {
        className: "!ui-p-0 !ui-border-0 !ui-mr-[8px]",
        style: { outline: "none" },
        children: /* @__PURE__ */ jsx90(
          "div",
          {
            ref,
            className: "ui-bg-white ui-px-[4px] ui-box-border ui- ui-py-[8px] ui-rounded-[8px] ui-text-[#17171d] ui-text-[14px] ui-shadow-[0px_8px_24px_0px_rgba(0,0,0,0.2)] ui-backdrop-blur-lg ui-cursor-pointer",
            children
          }
        )
      }
    ),
    /* @__PURE__ */ jsx90(PopoverTrigger, { className: "ui-border-0 ui-border-none", children: /* @__PURE__ */ jsxs55(
      "div",
      {
        ref: buttonRef,
        onClick: () => setOpen(!open),
        className: "ui-cursor-pointer ui-bg-white ui-bg-opacity-[0.8] ui-border-solid ui-border-[1px] ui-border-[#E1E1E5] ui-border-opacity-[0.6] ui-rounded-[8px] hover:ui-bg-[#626999] hover:ui-bg-opacity-[0.08] ui-text-[12px] ui-flex ui-items-center ui-gap-[8px] ui-px-[8px] ui-py-[6px]",
        children: [
          /* @__PURE__ */ jsx90(SvgShortcutMore, {}),
          /* @__PURE__ */ jsx90("div", { children: "\u66F4\u591A" })
        ]
      }
    ) })
  ] });
}
function ShortcutsPanel({
  shortcuts: shortcuts2,
  className,
  onItemClick
}) {
  const [visibleShortcuts, setVisibleShortcuts] = useState16([]);
  const [hiddenShortcuts, setHiddenShortcuts] = useState16([]);
  const containerRef = useRef12(null);
  const size = useSize3(containerRef);
  useEffect9(() => {
    const handleResize = () => {
      if (size == null ? void 0 : size.width) {
        const containerWidth = ((size == null ? void 0 : size.width) || 0) - MORE_BUTTON_WIDTH;
        let totalWidth = 0;
        const visible = [];
        const hidden = [];
        const tempContainer = document.createElement("div");
        tempContainer.style.position = "absolute";
        tempContainer.style.visibility = "hidden";
        document.body.appendChild(tempContainer);
        shortcuts2.forEach((shortcut) => {
          const cardElement = document.createElement("div");
          cardElement.className = "ui-inline-block";
          tempContainer.appendChild(cardElement);
          cardElement.innerText = shortcut.meta.short_name;
          const cardWidth = cardElement.offsetWidth + CARD_WIDTH;
          if (totalWidth + cardWidth <= containerWidth) {
            visible.push(shortcut);
            totalWidth += cardWidth;
          } else {
            hidden.push(shortcut);
          }
        });
        document.body.removeChild(tempContainer);
        setVisibleShortcuts(visible);
        setHiddenShortcuts(hidden);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [shortcuts2, size == null ? void 0 : size.width]);
  return /* @__PURE__ */ jsxs55("div", { ref: containerRef, className, children: [
    visibleShortcuts.map((shortcut, index) => /* @__PURE__ */ jsx90(
      ShortcutsCard,
      {
        title: shortcut.meta.short_name,
        onClick: () => onItemClick == null ? void 0 : onItemClick(shortcut),
        icon: /* @__PURE__ */ jsx90(
          AppLogo,
          {
            size: 16,
            fillSize: 12,
            value: shortcut.icon,
            color: shortcut.color,
            type: "emoji",
            className: "!ui-rounded-[4px]"
          }
        ),
        formConfig: []
      },
      index
    )),
    hiddenShortcuts.length > 0 && /* @__PURE__ */ jsx90(MoreItems, { children: /* @__PURE__ */ jsx90("div", { children: hiddenShortcuts.map((shortcut, index) => /* @__PURE__ */ jsxs55(
      "div",
      {
        onClick: () => onItemClick == null ? void 0 : onItemClick(shortcut),
        className: "ui-px-[10px] ui-py-[8px] ui-rounded-[8px] ui-flex ui-gap-[8px] hover:ui-bg-[#626999] hover:ui-bg-opacity-[0.08] ui-text-[14px] ui-items-center",
        children: [
          /* @__PURE__ */ jsx90(
            AppLogo,
            {
              size: 16,
              fillSize: 12,
              value: shortcut.icon,
              color: shortcut.color,
              type: "emoji",
              className: "!ui-rounded-[4px]"
            }
          ),
          /* @__PURE__ */ jsx90("div", { children: shortcut.meta.short_name })
        ]
      },
      index
    )) }) })
  ] });
}

// src/components/messageInput/MessageInput.tsx
import { Fragment as Fragment8, jsx as jsx91, jsxs as jsxs56 } from "react/jsx-runtime";
var SUPPORT_ANALYSIS_FILE_TYPE = [".txt", ".pdf", ".docx"];
var NO_TIPS_SHORTCUTS_LENGTH = 4;
var MessageInput = forwardRef11((props, ref) => {
  var _a, _b;
  const {
    size = "normal",
    placeholder = "\u95EE\u6211\u4EFB\u4F55\u95EE\u9898...",
    value: _value = "",
    generating,
    prefix,
    fileAction,
    fileHeaders,
    fileParams,
    disabled,
    actions = [],
    shortcuts: shortcuts2 = [],
    remainFileWhenSubmit = false,
    hideHotKeyTips,
    inputTips,
    initialFocus = false,
    preview = false,
    textareaAutoFocus = true,
    file: initialFile,
    onBeforeFileUpload,
    onBeforeSubmit,
    onChange,
    onSubmit,
    onActionClick,
    className,
    style,
    onFileFail,
    onFileOK,
    onFileUpload,
    fileAccept,
    onFileClick,
    onCreateConversation,
    enabledSkills,
    uploadFileConfig
  } = props;
  const [file, setFile] = useState17();
  const [uploading, setUploading] = useState17(false);
  const [focused, setFocused] = useState17(initialFocus);
  const textAreaRef = useRef13(null);
  const fileBtnRef = useRef13(null);
  const selectionStartRef = useRef13();
  const currentFileAnalysisTypeRef = useRef13("FILE_URL");
  const handleChange = (content) => {
    onChange == null ? void 0 : onChange(content, file);
  };
  useEffect10(() => {
    if (initialFile && fileBtnRef.current) {
      setTimeout(() => {
        fileBtnRef.current.customUpload(initialFile);
      }, 300);
    }
  }, [initialFile, fileBtnRef.current]);
  useEffect10(() => {
    if (file == null ? void 0 : file.name) {
      currentFileAnalysisTypeRef.current = file == null ? void 0 : file.file_action;
    }
  }, [file]);
  const getFileAction = (rawFile) => {
    var _a2;
    if (rawFile == null ? void 0 : rawFile.meta)
      return "FILE_DATA";
    if (enabledSkills == null ? void 0 : enabledSkills.length) {
      const fileAction2 = currentFileAnalysisTypeRef.current || "FILE_URL";
      return fileAction2;
    } else {
      if ((_a2 = rawFile == null ? void 0 : rawFile.type) == null ? void 0 : _a2.includes("image")) {
        return "FILE_URL";
      }
      return "FILE_DATA";
    }
  };
  const getSupportAutoUploadFile = (file2) => {
    const hasEnableSkill = !!(enabledSkills == null ? void 0 : enabledSkills.length);
    let fileSupportSwitch = false;
    if (file2) {
      SUPPORT_ANALYSIS_FILE_TYPE.forEach((item) => {
        if (file2.name.includes(item) && hasEnableSkill) {
          fileSupportSwitch = true;
        }
      });
    }
    return fileSupportSwitch;
  };
  const autoUpload = (file2) => {
    return !getSupportAutoUploadFile(file2);
  };
  const handleFileOK = (file2) => {
    var _a2;
    setUploading(false);
    setFile(file2);
    onFileOK == null ? void 0 : onFileOK(file2);
    (_a2 = textAreaRef.current) == null ? void 0 : _a2.focus();
  };
  const handleFileFail = (file2, message) => {
    var _a2;
    setUploading(false);
    setFile(void 0);
    onFileFail == null ? void 0 : onFileFail(file2, message);
    if (message) {
      toast4.error(message, {
        id: "file-upload"
      });
    }
    (_a2 = textAreaRef.current) == null ? void 0 : _a2.focus();
  };
  const handleSubmit = async () => {
    if (generating) {
      return;
    }
    if (onBeforeSubmit) {
      const beforeSubmitResult = await onBeforeSubmit(_value, file);
      if (!beforeSubmitResult) {
        return;
      }
    }
    if (file == null ? void 0 : file.needUpload) {
      const customFile = await fileBtnRef.current.customUpload(file == null ? void 0 : file.rawFile);
      onSubmit == null ? void 0 : onSubmit(_value, {
        file: customFile
      });
    } else {
      onSubmit == null ? void 0 : onSubmit(_value, { file });
    }
    onChange == null ? void 0 : onChange("");
    !remainFileWhenSubmit && setFile(void 0);
  };
  const compositing = useRef13(false);
  const handleKeyDown = (event) => {
    if (generating) {
      if (event.code === "Enter") {
        event.preventDefault();
      }
      return;
    }
    if (event.code === "Enter") {
      event.preventDefault();
      if (compositing.current || event.altKey || event.ctrlKey || event.metaKey) {
        return;
      }
      if (event.shiftKey) {
        const { value, selectionStart, selectionEnd } = event.target;
        const newValue = `${value.slice(0, selectionStart)}
${value.slice(
          selectionEnd
        )}`;
        handleChange(newValue);
        selectionStartRef.current = selectionStart + 1;
        return;
      }
      ;
      (_value || file) && handleSubmit();
      if (!_value) {
        onChange == null ? void 0 : onChange("");
        !remainFileWhenSubmit && setFile(void 0);
      }
    }
  };
  const handlePaste = (event) => {
    const items = event.clipboardData.items;
    let fileFound = false;
    for (const item of items) {
      if (item.kind === "file") {
        const file2 = item.getAsFile();
        if (file2) {
          fileFound = true;
          fileBtnRef.current.prepareUpload(file2);
          break;
        }
      }
    }
    if (fileFound) {
      event.preventDefault();
    }
  };
  useEffect10(() => {
    const cursor = selectionStartRef.current;
    if (textAreaRef.current && (_value == null ? void 0 : _value.length) && typeof cursor === "number") {
      textAreaRef.current.selectionStart = cursor;
      textAreaRef.current.selectionEnd = cursor;
      selectionStartRef.current = void 0;
    }
  }, [_value]);
  const handleComposition = (event) => {
    if (event.type === "compositionstart") {
      compositing.current = true;
      return;
    }
    if (event.type === "compositionend") {
      compositing.current = false;
    }
  };
  const handleBeforeLoad = async (file2, list, uploadType = "normal") => {
    if (uploadType === "post") {
      const tempUrl = URL.createObjectURL(file2);
      setFile({
        name: file2.name,
        type: file2.type,
        size: file2.size,
        url: tempUrl,
        needUpload: true,
        rawFile: file2
      });
      if (autoUpload(file2)) {
        fileBtnRef.current.customUpload(file2);
      }
      return false;
    }
    setFile({
      name: "",
      type: "init",
      size: 0
    });
    setUploading(true);
    const res = await (onBeforeFileUpload == null ? void 0 : onBeforeFileUpload(file2, list));
    if (typeof res === "object") {
      if (!res.success) {
        handleFileFail(void 0, res.message);
      }
      return res.success;
    }
    if (!res) {
      handleFileFail(void 0);
    }
    return res;
  };
  const {
    shortcutsFormVisible,
    openShortcutsForm,
    hideShortcutsForm,
    currentShortcutsCardItem
  } = useShortcutsForm(shortcuts2, preview);
  useImperativeHandle4(
    ref,
    () => ({
      input: textAreaRef.current,
      setFile,
      hideShortcutsForm,
      openShortcutsForm
    }),
    [textAreaRef.current, setFile, hideShortcutsForm, openShortcutsForm]
  );
  useKeyPress2(
    isMacOrIOS() ? "meta.k" : "ctrl.k",
    () => onCreateConversation == null ? void 0 : onCreateConversation()
  );
  const { layoutMode } = useChatLayoutMode();
  const handleDrop = (e) => {
    e.preventDefault();
    const items = e.dataTransfer.files;
    for (const item of items) {
      if (item) {
        fileBtnRef.current.customUpload(item);
        break;
      }
    }
  };
  const showHotKeyTips = useMemo15(() => {
    if (isBoolean(hideHotKeyTips))
      return !hideHotKeyTips;
    if (layoutMode === "mobile" && shortcuts2.length) {
      return false;
    }
    return focused && shortcuts2.length <= NO_TIPS_SHORTCUTS_LENGTH;
  }, [shortcuts2, layoutMode, focused, hideHotKeyTips]);
  const fileComponent = useMemo15(() => {
    var _a2, _b2;
    return file && /* @__PURE__ */ jsx91("div", { className: "ui-self-start", children: /* @__PURE__ */ jsx91(
      File,
      {
        className: "ui-flex-1 ui-max-w-[100%]",
        previewSize: "thumbnail",
        onFileClick,
        imageRender: !!((_b2 = (_a2 = file == null ? void 0 : file.type) == null ? void 0 : _a2.includes) == null ? void 0 : _b2.call(_a2, "image")),
        icon: file == null ? void 0 : file.icon,
        ...file,
        size: ![
          FILE_MIME_TYPE_MAP3.webpage,
          FILE_MIME_TYPE_MAP3.reference
        ].includes(file.type) ? file.size : 0,
        suffix: /* @__PURE__ */ jsx91(
          "div",
          {
            className: cn36(
              "ui-absolute ui-right-[-6px] ui-top-[-6px] ui-h-[16px] ui-w-[16px] ui-rounded-[50%] ui-bg-[rgb(218,218,227)] ui-shrink-0 ui-cursor-pointer ui-text-yeah-icon_light ui-flex-center hover:!ui-text-[#ff5219]"
            ),
            children: /* @__PURE__ */ jsx91(
              SvgClose2,
              {
                className: "ui-w-[10px] ui-h-[10px] ui-fill-[#8D8D99]",
                onClick: (e) => {
                  var _a3;
                  e.stopPropagation();
                  setFile(void 0);
                  (_a3 = textAreaRef.current) == null ? void 0 : _a3.focus();
                }
              }
            )
          }
        )
      }
    ) });
  }, [file, onFileClick]);
  return /* @__PURE__ */ jsxs56(
    "div",
    {
      onDrop: !shortcutsFormVisible ? handleDrop : void 0,
      className: cn36("ui-relative", className),
      style,
      children: [
        shortcutsFormVisible && currentShortcutsCardItem && /* @__PURE__ */ jsx91(
          ShortcutsFormModal,
          {
            icon: /* @__PURE__ */ jsx91(
              AppLogo,
              {
                size: 18,
                value: currentShortcutsCardItem == null ? void 0 : currentShortcutsCardItem.icon,
                color: currentShortcutsCardItem == null ? void 0 : currentShortcutsCardItem.color,
                fillSize: 14,
                type: "emoji",
                className: "!ui-rounded-[4px]"
              }
            ),
            title: currentShortcutsCardItem == null ? void 0 : currentShortcutsCardItem.meta.short_name,
            onClose: hideShortcutsForm,
            children: /* @__PURE__ */ jsx91(
              ShortcutsForm,
              {
                onFileUpload,
                title: currentShortcutsCardItem.title,
                type: currentShortcutsCardItem == null ? void 0 : currentShortcutsCardItem.type,
                item: currentShortcutsCardItem,
                autoFocus: !preview,
                onSubmit: (value, shortcutFunctionId) => {
                  onSubmit == null ? void 0 : onSubmit(value, { shortcutFunctionId });
                  !remainFileWhenSubmit && setFile(void 0);
                  hideShortcutsForm();
                },
                schema: (_a = currentShortcutsCardItem == null ? void 0 : currentShortcutsCardItem.formConfig) == null ? void 0 : _a.map((v) => ({
                  ...v,
                  name: v.variableName
                }))
              }
            )
          }
        ),
        !shortcutsFormVisible && /* @__PURE__ */ jsxs56(Fragment8, { children: [
          !!shortcuts2.length && /* @__PURE__ */ jsxs56("div", { className: "ui-flex ui-items-center ui-mb-[8px] ui-gap-x-[16px]", children: [
            shortcuts2.length && prefix && /* @__PURE__ */ jsx91("div", { className: "ui-ml-[6px]", children: shortcuts2.length && prefix }),
            /* @__PURE__ */ jsx91(
              ShortcutsPanel,
              {
                className: cn36(
                  " ui-flex-1  ui-flex ui-flex-wrap ui-gap-[8px] ",
                  {
                    "ui-ml-[68px]": actions.includes("clear")
                  }
                ),
                shortcuts: shortcuts2,
                onItemClick: openShortcutsForm
              }
            )
          ] }),
          /* @__PURE__ */ jsxs56("div", { className: "ui-flex ui-items-center  ui-gap-[12px] ui-relative", children: [
            actions.includes("clear") && /* @__PURE__ */ jsx91(
              MessagePanel_default,
              {
                size: 56,
                generating,
                className: cn36(
                  "ui-pointer-events-none ui-rounded-[12px]  ui-box-border  ui-z-[1] ui-border-[#E1E1E5] ui-border ui-border-opacity-60 ui-shadow-[0px_4px_20px_0px_rgba(0,0,0,0.06)]",
                  { "!ui-cursor-not-allowed": disabled }
                ),
                showActions: {
                  clear: actions.includes("clear")
                },
                onActionClick: (action) => !generating && (onActionClick == null ? void 0 : onActionClick(action))
              }
            ),
            showHotKeyTips && /* @__PURE__ */ jsx91("div", { className: "ui-absolute ui-right-0 ui-top-[-30px] ui-z-[10]", children: /* @__PURE__ */ jsx91(ShortcutTips, { tips: inputTips }) }),
            !shortcuts2.length && prefix,
            /* @__PURE__ */ jsxs56(
              "div",
              {
                className: cn36(
                  "ui-relative chat-input-container ui-box-border ui-flex ui-justify-between ui-flex-1 ui-bg-white ui-rounded-[12px] ui-overflow-hidden",
                  {
                    "ui-p-[2px]": size === "normal",
                    "ui-items-center": !file,
                    "ui-items-end": file,
                    "ui-border-[#E1E1E5] ui-border ui-border-opacity-60 ui-shadow-[0px_4px_20px_0px_rgba(0,0,0,0.06)]": true
                  }
                ),
                children: [
                  /* @__PURE__ */ jsx91(
                    "div",
                    {
                      className: cn36("chat-input-background", {
                        "!ui-block": initialFocus
                      })
                    }
                  ),
                  /* @__PURE__ */ jsxs56("div", { className: "chat-input-wrapper  ui-flex-col ui-relative ui-px-[12px] ui-pl-[16px] ui-z-[2] ui-min-h-[50px] ui-py-[9px] ui-w-full ui-flex ui-justify-between  ui-bg-white ui-rounded-[10px] ui-box-border", children: [
                    file && /* @__PURE__ */ jsx91("div", { className: "ui-mb-[12px]", children: fileComponent }),
                    /* @__PURE__ */ jsxs56("div", { className: "ui-flex-1 ui-flex", children: [
                      /* @__PURE__ */ jsx91("div", { className: "ui-flex-1 ui-flex ui-overflow-hidden ui-items-center ui-flex-col ui-justify-center", children: /* @__PURE__ */ jsx91(
                        TextAreaAutoSize,
                        {
                          autoFocus: textareaAutoFocus,
                          onPaste: handlePaste,
                          wrap: "soft",
                          ref: textAreaRef,
                          onKeyDown: handleKeyDown,
                          className: cn36(
                            "ui-block ui-w-full ui-h-full ui-p-[0] placeholder:ui-align-middle ui-resize-none ui-border-0 ui-bg-white ui-text-[14px]/6 ui-outline-0 placeholder:ui-text-[#8d8d99] placeholder:ui-leading-[24px] ui-text-[#17171d] focus-visible:ui-outline-none disabled:placeholder:text-[#8d8d99]-40",
                            {
                              "ui-min-h-[24px]": size === "normal"
                            }
                          ),
                          value: _value,
                          placeholder,
                          minRows: 1,
                          maxRows: 6,
                          onChange: (event) => {
                            const content = event.target.value;
                            handleChange(content);
                          },
                          onCompositionStart: handleComposition,
                          onCompositionEnd: handleComposition,
                          onFocus: () => {
                            setFocused(true);
                          },
                          onBlur: () => {
                            setFocused(false);
                          }
                        }
                      ) }),
                      /* @__PURE__ */ jsxs56(
                        "div",
                        {
                          className: cn36("ui-flex ui-gap-[12px] ui-ml-[12px]", {
                            "ui-items-center": !file,
                            "ui-items-end": file
                          }),
                          children: [
                            (uploadFileConfig == null ? void 0 : uploadFileConfig.acceptsAllFileTypes) && ((_b = uploadFileConfig == null ? void 0 : uploadFileConfig.fileAccepts) == null ? void 0 : _b.length) === 0 ? /* @__PURE__ */ jsx91(
                              FileButtonWithPopover,
                              {
                                uploadFileConfig
                              }
                            ) : /* @__PURE__ */ jsx91(
                              FileButton,
                              {
                                ref: fileBtnRef,
                                beforeFileUpload: handleBeforeLoad,
                                fileAction,
                                uploading,
                                disabled: generating || disabled || !!file,
                                fileParams,
                                fileHeaders,
                                onFileOK: handleFileOK,
                                onFileFail: handleFileFail,
                                fileAccept,
                                getFileAction,
                                onFileUpload,
                                uploadFileConfig
                              }
                            ),
                            /* @__PURE__ */ jsxs56("div", { className: "ui-w-[32px] ui-h-[32px] ui-rounded-full ui-overflow-hidden", children: [
                              !generating && /* @__PURE__ */ jsx91(
                                SendButton,
                                {
                                  disabled: !_value && !file || generating || disabled,
                                  onClick: handleSubmit
                                }
                              ),
                              generating && actions.includes("stop") && /* @__PURE__ */ jsx91(Tooltip2, { title: "\u505C\u6B62\u751F\u6210", children: /* @__PURE__ */ jsx91(
                                SvgStop,
                                {
                                  className: "ui-cursor-pointer",
                                  onClick: () => onActionClick == null ? void 0 : onActionClick("stop")
                                }
                              ) })
                            ] })
                          ]
                        }
                      )
                    ] })
                  ] })
                ]
              }
            )
          ] })
        ] })
      ]
    }
  );
});
var MessageInput_default = memo9(MessageInput);

// src/components/messageList/MessageList.tsx
import { Virtuoso } from "react-virtuoso";
import {
  forwardRef as forwardRef12,
  memo as memo10,
  useEffect as useEffect11,
  useImperativeHandle as useImperativeHandle5,
  useMemo as useMemo16,
  useRef as useRef14
} from "react";
import { useOverlayScrollbars } from "overlayscrollbars-react";
import { jsx as jsx92 } from "react/jsx-runtime";
var INITIAL_FIRST_ITEM_INDEX = 1e4;
function toBottom(ref) {
  ref == null ? void 0 : ref.scrollToIndex({
    index: "LAST",
    align: "start",
    behavior: "auto"
  });
}
function MessageRenderer(_, message, hideActions, toolComponent, onMessageActionClick, onMessageToolClick, onHrefTagClick, onRegenerate, formMessageComponentMap, onFormSubmit) {
  return message.type === "separator" ? /* @__PURE__ */ jsx92(MessageSeparator, { content: message.content }) : /* @__PURE__ */ jsx92(
    Message,
    {
      className: "ui-max-w-[864px]",
      ...message,
      formMessageComponentMap,
      onFormSubmit,
      hideActions,
      toolComponent,
      onActionClick: onMessageActionClick,
      onHrefTagClick,
      onToolClick: onMessageToolClick,
      onRegenerate
    }
  );
}
var OverlayScrollbarOptions = {
  overflow: {
    x: "hidden"
  },
  scrollbars: {
    theme: "chat-list-scrollbar",
    autoHide: "leave",
    autoHideDelay: 1e3
  }
};
var MessageList = memo10(
  forwardRef12((props, ref) => {
    const {
      data = [],
      className,
      style = {},
      onLoadMore,
      toolComponent,
      hideMessageActions,
      onMessageActionClick,
      onMessageToolClick,
      onHrefTagClick,
      onRegenerate,
      paddingX = 96,
      needManualScrollToBottom = true,
      formMessageConfig
    } = props;
    const [initialize, osInstance] = useOverlayScrollbars({
      options: OverlayScrollbarOptions
    });
    const components = useMemo16(
      () => ({
        List: forwardRef12((props2, ref2) => {
          return /* @__PURE__ */ jsx92(
            "div",
            {
              className: "ui-mx-auto ui-max-w-[1080px]",
              ...props2,
              ref: ref2
            }
          );
        }),
        Item: ({ item: _, ...props2 }) => /* @__PURE__ */ jsx92(
          "div",
          {
            ...props2,
            style: {
              ...props2.style,
              paddingLeft: paddingX,
              paddingRight: paddingX,
              maxWidth: 864 + paddingX * 2
            },
            className: "ui-flex ui-flex-col ui-items-stretch ui-pb-[40px] last:ui-pb-[70px] first:ui-pt-[28px] ui-mx-auto"
          }
        )
      }),
      [props.data, paddingX]
    );
    const scrollerRootRef = useRef14(null);
    const scrollerRef = useRef14(null);
    const listRef = useRef14(null);
    const scrollerRefCallback = useRef14();
    if (scrollerRefCallback.current === void 0) {
      scrollerRefCallback.current = (ref2) => {
        scrollerRef.current = ref2;
      };
    }
    useImperativeHandle5(ref, () => listRef.current);
    useEffect11(() => {
      const root = scrollerRootRef.current;
      const scroller = scrollerRef.current;
      if (scroller && root) {
        initialize({
          target: root,
          elements: {
            viewport: scroller
          }
        });
      }
      return () => {
        var _a;
        return (_a = osInstance()) == null ? void 0 : _a.destroy();
      };
    }, []);
    const firstItemIndex = Array.isArray(data) && data.length ? Math.max(INITIAL_FIRST_ITEM_INDEX - data.length, 0) : 0;
    const isScrollingRef = useRef14(false);
    return /* @__PURE__ */ jsx92(
      "div",
      {
        ref: scrollerRootRef,
        className,
        style,
        "data-overlayscrollbars": "",
        children: /* @__PURE__ */ jsx92(
          Virtuoso,
          {
            ref: listRef,
            style: { height: "100%" },
            data,
            totalCount: data.length,
            firstItemIndex,
            initialTopMostItemIndex: needManualScrollToBottom ? 19 : 0,
            components,
            computeItemKey: (_, message) => {
              return message.id.toString();
            },
            itemContent: (_, message) => MessageRenderer(
              _,
              message,
              hideMessageActions ?? (_ === INITIAL_FIRST_ITEM_INDEX - 1 ? false : void 0),
              toolComponent,
              onMessageActionClick,
              onMessageToolClick,
              onHrefTagClick,
              onRegenerate,
              formMessageConfig == null ? void 0 : formMessageConfig.formMessageComponentMap,
              formMessageConfig == null ? void 0 : formMessageConfig.onMessageFormSubmit
            ),
            followOutput: "auto",
            startReached: onLoadMore,
            isScrolling: (isScrolling) => {
              isScrollingRef.current = isScrolling;
            },
            atBottomStateChange: (atBottom) => {
              if (needManualScrollToBottom && !atBottom && !isScrollingRef.current && data.length) {
                toBottom(listRef.current);
              }
            }
          }
        )
      }
    );
  })
);

// src/chat/Chat.tsx
import {
  forwardRef as forwardRef16,
  useEffect as useEffect17,
  useImperativeHandle as useImperativeHandle6,
  useMemo as useMemo19,
  useRef as useRef21,
  useState as useState24
} from "react";
import { isNil as isNil3, omit } from "lodash-es";
import { FilePreview } from "@bty/ui-components";
import { useKeyPress as useKeyPress3 } from "ahooks";
import { clsx as clsx3 } from "clsx";
import { Toaster } from "react-hot-toast";
import { cn as cn54 } from "@bty/util";

// src/base/hooks/useChatLayout.ts
import { useEffect as useEffect12, useState as useState18 } from "react";
var MAX_WIDTH = 864;
var MIN_PADDING = 16;
function useChatLayout({
  ref,
  fixedPadding
}) {
  const [paddingX, setPaddingX] = useState18(0);
  const [divSize, setDivSize] = useState18({ width: 0, height: 0 });
  const setPadding = (width) => {
    if (ref.current) {
      const containerWidth = width;
      if (containerWidth < MAX_WIDTH) {
        setPaddingX(MIN_PADDING);
        return;
      }
      const paddingX2 = (containerWidth - MAX_WIDTH) / 2;
      setPaddingX(paddingX2 < MIN_PADDING ? MIN_PADDING : paddingX2);
    }
  };
  useEffect12(() => {
    setPadding(divSize.width);
  }, [divSize]);
  useEffect12(() => {
    if (ref.current) {
      const observer = new ResizeObserver((entries) => {
        for (const entry of entries) {
          setDivSize({
            width: entry.contentRect.width,
            height: entry.contentRect.height
          });
        }
      });
      observer.observe(ref.current);
      return () => {
        observer.disconnect();
      };
    }
  }, [ref.current]);
  return {
    paddingX: fixedPadding ?? paddingX
  };
}

// src/components/modal/VariableModal.tsx
import { useForm } from "react-hook-form";
import { useState as useState19, useEffect as useEffect13 } from "react";
import { cn as cn40 } from "@bty/util";

// src/assets/svg/chat.svg
import * as React51 from "react";
import { jsx as jsx93 } from "react/jsx-runtime";
var SvgChat = (props) => /* @__PURE__ */ jsx93("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: /* @__PURE__ */ jsx93("g", { children: /* @__PURE__ */ jsx93("g", { children: /* @__PURE__ */ jsx93("path", { d: "M3.931961171875,1.19921875L12.067951171875,1.19921875C13.569051171875,1.19921875,14.799951171875,2.4142087500000002,14.799951171875,3.92552875L14.799951171875,10.08934875C14.799951171875,11.60071875,13.569051171875,12.81561875,12.067951171875,12.81561875L7.264411171875,12.81561875L5.343001171875,14.56401875C4.802601171875001,15.06781875,3.871921171875,14.71221875,3.871921171875,13.97141875L3.871921171875,12.78601875C2.4008311718749997,12.75641875,1.199951171875,11.54141875,1.199951171875,10.05971875L1.199951171875,3.92552875C1.199951171875,2.4142087500000002,2.4308611718749997,1.19921875,3.931961171875,1.19921875ZM5.745621171875,7.15422875Q5.749951171875,7.11022875,5.749951171875,7.06600875Q5.749951171875,7.02179875,5.745621171875,6.97779875Q5.741281171875,6.93379875,5.732661171875,6.89042875Q5.724031171875,6.84706875,5.711191171875,6.80475875Q5.698361171875,6.76244875,5.681441171875,6.72159875Q5.664521171875,6.68074875,5.643681171875,6.64175875Q5.622831171875,6.60276875,5.598271171875,6.56599875Q5.573711171875,6.52923875,5.545661171875,6.49505875Q5.517611171875,6.46087875,5.486341171875,6.42961875Q5.455081171875,6.39835875,5.420901171875,6.37030875Q5.386731171875,6.34225875,5.349961171875,6.31768875Q5.313201171875,6.29312875,5.274201171875,6.27228875Q5.235211171875,6.25144875,5.194371171875,6.23452875Q5.1535111718749995,6.21759875,5.111211171875,6.20476875Q5.068901171875,6.19193875,5.025531171875,6.18330875Q4.982171171875001,6.17467875,4.9381611718750005,6.17034875Q4.894171171875,6.16601875,4.849951171875,6.16601875Q4.805731171875,6.16601875,4.761731171875001,6.17034875Q4.717731171875,6.17467875,4.674371171875,6.18330875Q4.631001171875,6.19193875,4.588691171875,6.20476875Q4.546381171875,6.21759875,4.505531171875,6.23452875Q4.464691171875,6.25144875,4.425691171875,6.27228875Q4.386701171875,6.29312875,4.349941171875,6.31768875Q4.313171171875,6.34225875,4.2790011718750005,6.37030875Q4.2448211718749995,6.39835875,4.213551171875,6.42961875Q4.182291171875001,6.46087875,4.154241171875,6.49505875Q4.126191171875,6.52923875,4.101631171875,6.56599875Q4.077061171875,6.60276875,4.056221171875,6.64175875Q4.035381171875001,6.68074875,4.018461171875,6.72159875Q4.001541171875,6.76244875,3.988701171875,6.80475875Q3.975871171875,6.84706875,3.967241171875,6.89042875Q3.958621171875,6.93379875,3.954281171875,6.97779875Q3.949951171875,7.02179875,3.949951171875,7.06600875Q3.949951171875,7.11022875,3.954281171875,7.15422875Q3.958621171875,7.19822875,3.967241171875,7.24158875Q3.975871171875,7.28495875,3.988701171875,7.32726875Q4.001541171875,7.36957875,4.018461171875,7.41042875Q4.035381171875001,7.45127875,4.056221171875,7.49026875Q4.077061171875,7.52926875,4.101631171875,7.56602875Q4.126191171875,7.60278875,4.154241171875,7.63696875Q4.182291171875001,7.67114875,4.213551171875,7.70240875Q4.2448211718749995,7.73367875,4.2790011718750005,7.76171875Q4.313171171875,7.78976875,4.349941171875,7.81433875Q4.386701171875,7.83889875,4.425691171875,7.85974875Q4.464691171875,7.88058875,4.505531171875,7.89749875Q4.546381171875,7.91442875,4.588691171875,7.92725875Q4.631001171875,7.94009875,4.674371171875,7.94871875Q4.717731171875,7.95734875,4.761731171875001,7.96167875Q4.805731171875,7.96601875,4.849951171875,7.96601875Q4.894171171875,7.96601875,4.9381611718750005,7.96167875Q4.982171171875001,7.95734875,5.025531171875,7.94871875Q5.068901171875,7.94009875,5.111211171875,7.92725875Q5.1535111718749995,7.91442875,5.194371171875,7.89749875Q5.235211171875,7.88058875,5.274201171875,7.85974875Q5.313201171875,7.83889875,5.349961171875,7.81433875Q5.386731171875,7.78976875,5.420901171875,7.76171875Q5.455081171875,7.73367875,5.486341171875,7.70240875Q5.517611171875,7.67114875,5.545661171875,7.63696875Q5.573711171875,7.60278875,5.598271171875,7.56602875Q5.622831171875,7.52926875,5.643681171875,7.49026875Q5.664521171875,7.45127875,5.681441171875,7.41042875Q5.698361171875,7.36957875,5.711191171875,7.32726875Q5.724031171875,7.28495875,5.732661171875,7.24158875Q5.741281171875,7.19822875,5.745621171875,7.15422875ZM8.895501171875,7.15422875Q8.899831171875,7.11022875,8.899831171875,7.06600875Q8.899831171875,7.02179875,8.895501171875,6.97779875Q8.891171171875001,6.93379875,8.882541171875001,6.89042875Q8.873911171875001,6.84706875,8.861081171875,6.80475875Q8.848241171875,6.76244875,8.831331171875,6.72159875Q8.814411171875001,6.68074875,8.793561171875,6.64175875Q8.772721171875,6.60276875,8.748161171875001,6.56599875Q8.723591171875,6.52923875,8.695551171875,6.49505875Q8.667491171875,6.46087875,8.636231171875,6.42961875Q8.604971171875,6.39835875,8.570791171875001,6.37030875Q8.536611171875,6.34225875,8.499851171875001,6.31768875Q8.463081171875,6.29312875,8.424091171875,6.27228875Q8.385101171875,6.25144875,8.344251171875001,6.23452875Q8.303411171875,6.21759875,8.261091171875,6.20476875Q8.218781171875001,6.19193875,8.175421171875,6.18330875Q8.132051171875,6.17467875,8.088051171875,6.17034875Q8.044051171875001,6.16601875,7.999841171875,6.16601875Q7.955621171875,6.16601875,7.911621171875,6.17034875Q7.867621171875,6.17467875,7.824261171875,6.18330875Q7.780891171875,6.19193875,7.738581171875,6.20476875Q7.696271171875,6.21759875,7.655421171875,6.23452875Q7.614581171875,6.25144875,7.575581171875,6.27228875Q7.536591171875,6.29312875,7.499831171875,6.31768875Q7.463061171875,6.34225875,7.428881171875,6.37030875Q7.394701171875,6.39835875,7.363441171875,6.42961875Q7.332181171875,6.46087875,7.304131171875,6.49505875Q7.276081171875,6.52923875,7.251511171875,6.56599875Q7.226951171875,6.60276875,7.206111171875,6.64175875Q7.185261171875,6.68074875,7.168351171875,6.72159875Q7.151421171875,6.76244875,7.138591171875,6.80475875Q7.125751171875,6.84706875,7.117131171875,6.89042875Q7.108501171875,6.93379875,7.104171171875,6.97779875Q7.099831171875,7.02179875,7.099831171875,7.06600875Q7.099831171875,7.11022875,7.104171171875,7.15422875Q7.108501171875,7.19822875,7.117131171875,7.24158875Q7.125751171875,7.28495875,7.138591171875,7.32726875Q7.151421171875,7.36957875,7.168351171875,7.41042875Q7.185261171875,7.45127875,7.206111171875,7.49026875Q7.226951171875,7.52926875,7.251511171875,7.56602875Q7.276081171875,7.60278875,7.304131171875,7.63696875Q7.332181171875,7.67114875,7.363441171875,7.70240875Q7.394701171875,7.73367875,7.428881171875,7.76171875Q7.463061171875,7.78976875,7.499831171875,7.81433875Q7.536591171875,7.83889875,7.575581171875,7.85974875Q7.614581171875,7.88058875,7.655421171875,7.89749875Q7.696271171875,7.91442875,7.738581171875,7.92725875Q7.780891171875,7.94009875,7.824261171875,7.94871875Q7.867621171875,7.95734875,7.911621171875,7.96167875Q7.955621171875,7.96601875,7.999841171875,7.96601875Q8.044051171875001,7.96601875,8.088051171875,7.96167875Q8.132051171875,7.95734875,8.175421171875,7.94871875Q8.218781171875001,7.94009875,8.261091171875,7.92725875Q8.303411171875,7.91442875,8.344251171875001,7.89749875Q8.385101171875,7.88058875,8.424091171875,7.85974875Q8.463081171875,7.83889875,8.499851171875001,7.81433875Q8.536611171875,7.78976875,8.570791171875001,7.76171875Q8.604971171875,7.73367875,8.636231171875,7.70240875Q8.667491171875,7.67114875,8.695551171875,7.63696875Q8.723591171875,7.60278875,8.748161171875001,7.56602875Q8.772721171875,7.52926875,8.793561171875,7.49026875Q8.814411171875001,7.45127875,8.831331171875,7.41042875Q8.848241171875,7.36957875,8.861081171875,7.32726875Q8.873911171875001,7.28495875,8.882541171875001,7.24158875Q8.891171171875001,7.19822875,8.895501171875,7.15422875ZM12.045651171875,7.15422875Q12.050051171875,7.11022875,12.050051171875,7.06600875Q12.050051171875,7.02179875,12.045651171875,6.97779875Q12.041351171875,6.93379875,12.032751171875,6.89042875Q12.024151171875,6.84706875,12.011251171875,6.80475875Q11.998451171875,6.76244875,11.981551171875,6.72159875Q11.964651171875,6.68074875,11.943751171875,6.64175875Q11.922951171875,6.60276875,11.898451171875,6.56599875Q11.873851171875,6.52923875,11.845751171875,6.49505875Q11.817751171875,6.46087875,11.786451171875,6.42961875Q11.755151171875,6.39835875,11.721051171875,6.37030875Q11.686851171875,6.34225875,11.650051171875,6.31768875Q11.613251171875,6.29312875,11.574351171875,6.27228875Q11.535351171875,6.25144875,11.494451171875,6.23452875Q11.453651171875,6.21759875,11.411351171875,6.20476875Q11.369051171875,6.19193875,11.325551171875,6.18330875Q11.282251171875,6.17467875,11.238251171875,6.17034875Q11.194251171875,6.16601875,11.150031171875,6.16601875Q11.105821171875,6.16601875,11.061811171875,6.17034875Q11.017871171875,6.17467875,10.974471171875,6.18330875Q10.931131171875,6.19193875,10.888811171875,6.20476875Q10.846481171875,6.21759875,10.805651171875,6.23452875Q10.764811171875,6.25144875,10.725791171875,6.27228875Q10.686801171875,6.29312875,10.650041171875,6.31768875Q10.613271171875,6.34225875,10.579101171875,6.37030875Q10.544921171875,6.39835875,10.513661171875,6.42961875Q10.482391171875,6.46087875,10.454341171875,6.49505875Q10.426291171875,6.52923875,10.401731171875,6.56599875Q10.377161171875,6.60276875,10.356321171875,6.64175875Q10.335481171875,6.68074875,10.318561171875,6.72159875Q10.301641171875,6.76244875,10.288811171875,6.80475875Q10.275971171875,6.84706875,10.267341171875,6.89042875Q10.258721171875,6.93379875,10.254391171875,6.97779875Q10.250061171875,7.02179875,10.250061171875,7.06600875Q10.250061171875,7.11022875,10.254391171875,7.15422875Q10.258721171875,7.19822875,10.267341171875,7.24158875Q10.275971171875,7.28495875,10.288811171875,7.32726875Q10.301641171875,7.36957875,10.318561171875,7.41042875Q10.335481171875,7.45127875,10.356321171875,7.49026875Q10.377161171875,7.52926875,10.401731171875,7.56602875Q10.426291171875,7.60278875,10.454341171875,7.63696875Q10.482391171875,7.67114875,10.513661171875,7.70240875Q10.544921171875,7.73367875,10.579101171875,7.76171875Q10.613271171875,7.78976875,10.650041171875,7.81433875Q10.686801171875,7.83889875,10.725791171875,7.85974875Q10.764811171875,7.88058875,10.805651171875,7.89749875Q10.846481171875,7.91442875,10.888811171875,7.92725875Q10.931131171875,7.94009875,10.974471171875,7.94871875Q11.017871171875,7.95734875,11.061811171875,7.96167875Q11.105821171875,7.96601875,11.150031171875,7.96601875Q11.194251171875,7.96601875,11.238251171875,7.96167875Q11.282251171875,7.95734875,11.325551171875,7.94871875Q11.369051171875,7.94009875,11.411351171875,7.92725875Q11.453651171875,7.91442875,11.494451171875,7.89749875Q11.535351171875,7.88058875,11.574351171875,7.85974875Q11.613251171875,7.83889875,11.650051171875,7.81433875Q11.686851171875,7.78976875,11.721051171875,7.76171875Q11.755151171875,7.73367875,11.786451171875,7.70240875Q11.817751171875,7.67114875,11.845751171875,7.63696875Q11.873851171875,7.60278875,11.898451171875,7.56602875Q11.922951171875,7.52926875,11.943751171875,7.49026875Q11.964651171875,7.45127875,11.981551171875,7.41042875Q11.998451171875,7.36957875,12.011251171875,7.32726875Q12.024151171875,7.28495875,12.032751171875,7.24158875Q12.041351171875,7.19822875,12.045651171875,7.15422875Z", fillRule: "evenodd", fill: "currentColor" }) }) }) });

// src/shadcn/ui/form.tsx
import * as React53 from "react";
import { Slot as Slot2 } from "@radix-ui/react-slot";
import { Controller, FormProvider, useFormContext } from "react-hook-form";
import { cn as cn38 } from "@bty/util";

// src/shadcn/ui/label.tsx
import * as React52 from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cva as cva2 } from "class-variance-authority";
import { cn as cn37 } from "@bty/util";
import { jsx as jsx94 } from "react/jsx-runtime";
var labelVariants = cva2(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
);
var Label = React52.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx94(
  LabelPrimitive.Root,
  {
    ref,
    className: cn37(labelVariants(), className),
    ...props
  }
));
Label.displayName = LabelPrimitive.Root.displayName;

// src/shadcn/ui/form.tsx
import { jsx as jsx95 } from "react/jsx-runtime";
var FormFieldContext = React53.createContext(
  {}
);
function FormField({ ...props }) {
  return /* @__PURE__ */ jsx95(FormFieldContext.Provider, { value: { name: props.name }, children: /* @__PURE__ */ jsx95(Controller, { ...props }) });
}
var FormItemContext = React53.createContext(
  {}
);
function useFormField() {
  const fieldContext = React53.useContext(FormFieldContext);
  const itemContext = React53.useContext(FormItemContext);
  const { getFieldState, formState } = useFormContext();
  const fieldState = getFieldState(fieldContext.name, formState);
  if (!fieldContext) {
    throw new Error("useFormField should be used within <FormField>");
  }
  const { id } = itemContext;
  return {
    id,
    name: fieldContext.name,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`,
    ...fieldState
  };
}
var FormItem2 = React53.forwardRef(({ className, ...props }, ref) => {
  const id = React53.useId();
  return /* @__PURE__ */ jsx95(FormItemContext.Provider, { value: { id }, children: /* @__PURE__ */ jsx95("div", { ref, className, ...props }) });
});
FormItem2.displayName = "FormItem";
var FormLabel = React53.forwardRef(({ className, ...props }, ref) => {
  const { error, formItemId } = useFormField();
  return /* @__PURE__ */ jsx95(
    Label,
    {
      ref,
      className: cn38(error && "text-destructive", className),
      htmlFor: formItemId,
      ...props
    }
  );
});
FormLabel.displayName = "FormLabel";
var FormControl = React53.forwardRef(({ ...props }, ref) => {
  const { error, formItemId, formDescriptionId, formMessageId } = useFormField();
  return /* @__PURE__ */ jsx95(
    Slot2,
    {
      ref,
      id: formItemId,
      "aria-describedby": !error ? `${formDescriptionId}` : `${formDescriptionId} ${formMessageId}`,
      "aria-invalid": !!error,
      ...props
    }
  );
});
FormControl.displayName = "FormControl";
var FormDescription = React53.forwardRef(({ className, ...props }, ref) => {
  const { formDescriptionId } = useFormField();
  return /* @__PURE__ */ jsx95(
    "p",
    {
      ref,
      id: formDescriptionId,
      className: cn38("text-sm text-muted-foreground", className),
      ...props
    }
  );
});
FormDescription.displayName = "FormDescription";
var FormMessage2 = React53.forwardRef(({ className, children, ...props }, ref) => {
  const { error, formMessageId } = useFormField();
  const body = error ? String(error == null ? void 0 : error.message) : children;
  if (!body) {
    return null;
  }
  return /* @__PURE__ */ jsx95(
    "p",
    {
      ref,
      id: formMessageId,
      className: cn38("text-sm text-destructive", className),
      ...props,
      children: body
    }
  );
});
FormMessage2.displayName = "FormMessage";

// src/shadcn/ui/dialog.tsx
import * as React54 from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { cn as cn39 } from "@bty/util";
import { jsx as jsx96, jsxs as jsxs57 } from "react/jsx-runtime";
var Dialog = DialogPrimitive.Root;
function DialogPortal({ ...props }) {
  return /* @__PURE__ */ jsx96(DialogPrimitive.Portal, { ...props });
}
DialogPortal.displayName = DialogPrimitive.Portal.displayName;
var DialogOverlay = React54.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx96(
  DialogPrimitive.Overlay,
  {
    ref,
    className: cn39(
      "ui-absolute ui-inset-0 ui-z-50 ui-bg-[rgba(0,0,0,0.35)] data-[state=open]:ui-animate-in data-[state=closed]:ui-animate-out data-[state=closed]:ui-fade-out-0 ui-overflow-auto data-[state=open]:ui-fade-in-0",
      className
    ),
    ...props
  }
));
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
var DialogContent = React54.forwardRef(
  ({
    className,
    overlayClassName,
    close,
    container,
    children,
    onMaskClick,
    ...props
  }, ref) => /* @__PURE__ */ jsxs57(DialogPortal, { container, children: [
    /* @__PURE__ */ jsx96(
      DialogOverlay,
      {
        className: overlayClassName,
        onClick: () => {
          onMaskClick == null ? void 0 : onMaskClick();
        }
      }
    ),
    /* @__PURE__ */ jsxs57(
      DialogPrimitive.Content,
      {
        ref,
        className: cn39(
          "ui-absolute ui-left-0 ui-h-fit ui-right-0 ui-top-0 ui-bottom-0 ui-m-auto ui-z-50 ui-grid ui-max-w-lg ui-gap-[14px] ui-border  ui-border-[#E1E1E5] ui-border-opacity-60 ui-bg-background ui-p-[21px] ui-shadow-lg ui-duration-200 data-[state=open]:ui-animate-in data-[state=closed]:ui-animate-out data-[state=closed]:ui-fade-out-0 data-[state=open]:ui-fade-in-0 data-[state=closed]:ui-zoom-out-95 data-[state=open]:ui-zoom-in-95 ui-rounded-[8px]",
          className
        ),
        ...props,
        children: [
          children,
          close && /* @__PURE__ */ jsx96(DialogPrimitive.Close, { className: "ui-absolute ui-right-[12px] ui-top-[12px] ui-rounded-[4px] ui-opacity-70 ring-offset-background ui-transition-opacity hover:ui-opacity-100 focus:ui-outline-none focus:ui-ring-2 focus:ui-ring-ring focus:ui-ring-offset-2 disabled:ui-pointer-events-none data-[state=open]:ui-bg-accent data-[state=open]:ui-text-muted-foreground", children: /* @__PURE__ */ jsx96(X, { className: "h-[14px] w-[14px]" }) })
        ]
      }
    )
  ] })
);
DialogContent.displayName = DialogPrimitive.Content.displayName;
function DialogHeader({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx96(
    "div",
    {
      className: cn39(
        "flex flex-col space-y-[5.25px] text-center sm:text-left",
        className
      ),
      ...props
    }
  );
}
DialogHeader.displayName = "DialogHeader";
function DialogFooter({
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx96(
    "div",
    {
      className: cn39(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-[7px]",
        className
      ),
      ...props
    }
  );
}
DialogFooter.displayName = "DialogFooter";
var DialogTitle = React54.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx96(
  DialogPrimitive.Title,
  {
    ref,
    className: cn39(
      "text-lg font-semibold leading-none tracking-tight",
      className
    ),
    ...props
  }
));
DialogTitle.displayName = DialogPrimitive.Title.displayName;
var DialogDescription = React54.forwardRef(({ className, ...props }, ref) => /* @__PURE__ */ jsx96(
  DialogPrimitive.Description,
  {
    ref,
    className: cn39("text-sm text-muted-foreground", className),
    ...props
  }
));
DialogDescription.displayName = DialogPrimitive.Description.displayName;

// src/components/modal/VariableModal.tsx
import { jsx as jsx97, jsxs as jsxs58 } from "react/jsx-runtime";
function VariableModal(props) {
  const { open, container, onClose, onSubmit, variableConfigs, defaultValue } = props;
  const [loading, setLoading] = useState19(false);
  const formInstance = useForm();
  useEffect13(() => {
    const _defaultValue = {};
    variableConfigs == null ? void 0 : variableConfigs.forEach((item) => {
      _defaultValue[item.variable_name] = (defaultValue == null ? void 0 : defaultValue[item.variable_name]) ?? "";
    });
    formInstance.reset(_defaultValue);
  }, [variableConfigs, defaultValue]);
  const handleSubmit = async (values) => {
    if (!loading) {
      try {
        setLoading(true);
        await (onSubmit == null ? void 0 : onSubmit(values));
        setTimeout(() => {
          setLoading(false);
          onClose == null ? void 0 : onClose();
        }, 100);
      } catch (e) {
        setLoading(false);
        console.log("submit variable error:", e);
      }
    }
  };
  return /* @__PURE__ */ jsxs58(Dialog, { modal: false, open, children: [
    /* @__PURE__ */ jsx97(
      "div",
      {
        "data-state": open ? "open" : "closed",
        className: "ui-absolute  ui-inset-0 ui-z-40 ui-bg-[rgba(0,0,0,0.12)] data-[state=open]:ui-animate-in data-[state=closed]:ui-animate-out data-[state=closed]:ui-fade-out-0 data-[state=closed]:ui-hidden ui-overflow-auto data-[state=open]:ui-fade-in-0"
      }
    ),
    /* @__PURE__ */ jsx97(
      DialogContent,
      {
        close: null,
        container,
        className: "!ui-flex !ui-flex-col !ui-min-w-[auto] !ui-max-w-[750px] ui-w-[calc(100%-48px)]",
        children: /* @__PURE__ */ jsx97(FormProvider, { ...formInstance, children: /* @__PURE__ */ jsxs58("form", { onSubmit: formInstance.handleSubmit(handleSubmit), children: [
          variableConfigs.map((variable) => {
            const validate = variable.required ? formInstance.register(variable.variable_name, {
              required: `${variable.label}\u4E0D\u80FD\u4E3A\u7A7A`
            }) : {};
            return /* @__PURE__ */ jsx97(
              FormField,
              {
                control: formInstance.control,
                name: variable.variable_name,
                render: (fieldValue) => {
                  const { field } = fieldValue;
                  return /* @__PURE__ */ jsxs58(FormItem2, { className: "ui-flex ui-flex-col ui-mb-[20px]", children: [
                    /* @__PURE__ */ jsxs58(FormLabel, { className: "ui-text-yeah ui-text-[14px]", children: [
                      variable.label,
                      variable.required && /* @__PURE__ */ jsx97("span", { className: "ui-text-[16px] ui-text-[#FF5219] ui-relative ui-top-[3px] ui-left-[5px]", children: "*" })
                    ] }),
                    /* @__PURE__ */ jsx97(FormControl, { children: /* @__PURE__ */ jsx97(
                      "input",
                      {
                        ...validate,
                        ...field,
                        placeholder: variable.placeholder,
                        className: cn40(
                          "ui-text-yeah ui-border-[1px] ui-border-solid ui-border-white focus-within:ui-border-primary focus-within:ui-shadow-[0_0_0_2px_var(--input-shadow)] ui-text-[14px] ui-rounded-[8px] ui-bg-yeah-icon_light/6 ui-mt-[8px] ui-outline-0 ui-px-[8px] ui-py-[12px]",
                          {
                            "!ui-border-[#FF5219] !ui-shadow-[0_0_0_2px_var(--input-error-shadow)]": variable.variable_name in formInstance.formState.errors
                          }
                        )
                      }
                    ) }),
                    /* @__PURE__ */ jsx97(FormMessage2, { className: "form-message ui-text-[12px] ui-mt-[8px] ui-font-400 ui-text-[#FF5219]" })
                  ] });
                }
              },
              variable.variable_name
            );
          }),
          /* @__PURE__ */ jsx97("div", { className: "ui-flex ui-justify-center ui-mt-[30px]", children: /* @__PURE__ */ jsxs58(
            "button",
            {
              type: "submit",
              className: "ui-border-none ui-flex ui-items-center ui-bg-primary ui-rounded-[8px] ui-text-white ui-px-[28px] ui-text-[14px] ui-py-[13px] ui-font-500 ui-w-fit",
              children: [
                loading ? /* @__PURE__ */ jsx97(SvgLoading, { className: "ui-animate-rotate ui-text-white ui-opacity-50 ui-duration-500 ui-mr-[4px]" }) : /* @__PURE__ */ jsx97(SvgChat, { className: "ui-mr-[4px]" }),
                "\u5F00\u59CB\u4F1A\u8BDD"
              ]
            }
          ) })
        ] }) })
      }
    )
  ] });
}

// src/assets/svg/list-mobile.svg
import * as React55 from "react";
import { jsx as jsx98 } from "react/jsx-runtime";
var SvgListMobile = (props) => /* @__PURE__ */ jsx98("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: /* @__PURE__ */ jsx98("g", { children: /* @__PURE__ */ jsx98("path", { d: "M0,1L0,1Q0,0.901509,0.0192147,0.80491Q0.0384294,0.708311,0.0761205,0.617316Q0.113811,0.526322,0.16853,0.44443Q0.223249,0.362537,0.292893,0.292893Q0.362537,0.223249,0.44443,0.16853Q0.526322,0.113811,0.617316,0.0761205Q0.708311,0.0384294,0.80491,0.0192147Q0.901509,0,1,0L15,0Q15.0985,0,15.1951,0.0192147Q15.2917,0.0384294,15.3827,0.0761205Q15.4737,0.113811,15.5556,0.16853Q15.6375,0.223249,15.7071,0.292893Q15.7767,0.362537,15.8315,0.44443Q15.8862,0.526322,15.9239,0.617316Q15.9616,0.708311,15.9808,0.80491Q16,0.901509,16,1L16,1Q16,1.09849,15.9808,1.19509Q15.9616,1.29169,15.9239,1.38268Q15.8862,1.47368,15.8315,1.55557Q15.7767,1.63746,15.7071,1.70711Q15.6375,1.77675,15.5556,1.83147Q15.4737,1.88619,15.3827,1.92388Q15.2917,1.96157,15.1951,1.98079Q15.0985,2,15,2L1,2Q0.901509,2,0.80491,1.98079Q0.708311,1.96157,0.617316,1.92388Q0.526322,1.88619,0.44443,1.83147Q0.362537,1.77675,0.292893,1.70711Q0.223249,1.63746,0.16853,1.55557Q0.113811,1.47368,0.0761205,1.38268Q0.0384294,1.29169,0.0192147,1.19509Q0,1.09849,0,1ZM0,8L0,8Q0,7.90151,0.0192147,7.80491Q0.0384294,7.70831,0.0761205,7.61732Q0.113811,7.52632,0.16853,7.44443Q0.223249,7.36254,0.292893,7.29289Q0.362537,7.22325,0.44443,7.16853Q0.526322,7.11381,0.617316,7.07612Q0.708311,7.03843,0.80491,7.01921Q0.901509,7,1,7L15,7Q15.0985,7,15.1951,7.01922Q15.2917,7.03843,15.3827,7.07612Q15.4737,7.11381,15.5556,7.16853Q15.6375,7.22325,15.7071,7.29289Q15.7767,7.36254,15.8315,7.44443Q15.8862,7.52632,15.9239,7.61732Q15.9616,7.70831,15.9808,7.80491Q16,7.90151,16,8L16,8Q16,8.09849,15.9808,8.19509Q15.9616,8.29169,15.9239,8.38268Q15.8862,8.47368,15.8315,8.55557Q15.7767,8.63746,15.7071,8.70711Q15.6375,8.77675,15.5556,8.83147Q15.4737,8.88619,15.3827,8.92388Q15.2917,8.96157,15.1951,8.98078Q15.0985,9,15,9L1,9Q0.901509,9,0.80491,8.98078Q0.708311,8.96157,0.617316,8.92388Q0.526322,8.88619,0.44443,8.83147Q0.362537,8.77675,0.292893,8.70711Q0.223249,8.63746,0.16853,8.55557Q0.113811,8.47368,0.0761205,8.38268Q0.0384294,8.29169,0.0192147,8.19509Q0,8.09849,0,8ZM0,15L0,15Q0,14.9015,0.0192147,14.8049Q0.0384294,14.7083,0.0761205,14.6173Q0.113811,14.5263,0.16853,14.4444Q0.223249,14.3625,0.292893,14.2929Q0.362537,14.2232,0.44443,14.1685Q0.526322,14.1138,0.617316,14.0761Q0.708311,14.0384,0.80491,14.0192Q0.901509,14,1,14L15,14Q15.0985,14,15.1951,14.0192Q15.2917,14.0384,15.3827,14.0761Q15.4737,14.1138,15.5556,14.1685Q15.6375,14.2232,15.7071,14.2929Q15.7767,14.3625,15.8315,14.4444Q15.8862,14.5263,15.9239,14.6173Q15.9616,14.7083,15.9808,14.8049Q16,14.9015,16,15L16,15Q16,15.0985,15.9808,15.1951Q15.9616,15.2917,15.9239,15.3827Q15.8862,15.4737,15.8315,15.5556Q15.7767,15.6375,15.7071,15.7071Q15.6375,15.7767,15.5556,15.8315Q15.4737,15.8862,15.3827,15.9239Q15.2917,15.9616,15.1951,15.9808Q15.0985,16,15,16L1,16Q0.901509,16,0.80491,15.9808Q0.708311,15.9616,0.617316,15.9239Q0.526322,15.8862,0.44443,15.8315Q0.362537,15.7767,0.292893,15.7071Q0.223249,15.6375,0.16853,15.5556Q0.113811,15.4737,0.0761205,15.3827Q0.0384294,15.2917,0.0192147,15.1951Q0,15.0985,0,15Z", fill: "#17171D", fillOpacity: 1 }) }) });

// src/conversation-list/ConversationItem.tsx
import { useLayoutEffect, useRef as useRef15, useState as useState20 } from "react";
import { useClickAway as useClickAway2 } from "ahooks";
import { cn as cn42 } from "@bty/util";

// src/assets/svg/edit.svg
import * as React56 from "react";
import { jsx as jsx99 } from "react/jsx-runtime";
var SvgEdit = (props) => /* @__PURE__ */ jsx99("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: /* @__PURE__ */ jsx99("g", { children: /* @__PURE__ */ jsx99("g", { children: /* @__PURE__ */ jsx99("path", { d: "M12.7275,3.65989L11.38769,2.35918C10.8944,1.880273,10.09461,1.880273,9.601320000000001,2.35918L3.03424,8.73472C2.795572,8.966429999999999,2.66235,9.28123,2.664289,9.6089L2.673734,11.20525C2.6767149999999997,11.70908,3.09668,12.1168,3.61565,12.1197L5.25995,12.1289C5.5974699999999995,12.1307,5.92173,12.0014,6.1604,11.7697L12.7275,5.394159999999999C13.2208,4.91525,13.2208,4.13879,12.7275,3.65989ZM14,13.3868C14,13.0482,13.7172,12.7737,13.3684,12.7737L2.631579,12.7737C2.282768,12.7737,2,13.0482,2,13.3868C2,13.7255,2.282768,14,2.631579,14L13.3684,14C13.7172,14,14,13.7255,14,13.3868Z", fillRule: "evenodd", fill: "currentColor", fillOpacity: 1 }) }) }) });

// src/base/components/popover/index.tsx
import * as Popover5 from "@radix-ui/react-popover";
import { cn as cn41 } from "@bty/util";
import { jsx as jsx100, jsxs as jsxs59 } from "react/jsx-runtime";
var PopoverTrigger2 = Popover5.Trigger;
var PopoverRoot = Popover5.Root;
var PopoverClose = Popover5.Close;
function PopoverContent2(props) {
  return /* @__PURE__ */ jsx100(Popover5.Portal, { container: props.container, children: /* @__PURE__ */ jsxs59(
    Popover5.Content,
    {
      side: "top",
      className: cn41("PopoverContent", props.className),
      sideOffset: 5,
      children: [
        props.children,
        /* @__PURE__ */ jsx100(Popover5.Arrow, { className: "PopoverArrow" })
      ]
    }
  ) });
}

// src/conversation-list/ConversationItem.tsx
import { Fragment as Fragment9, jsx as jsx101, jsxs as jsxs60 } from "react/jsx-runtime";
var DATASET_TYPE = "delete";
function ConversationItem({
  className,
  actionWrapClassName,
  selected,
  content = "",
  onClick,
  id,
  onDelete,
  onEditSave,
  isTitleTyping = false,
  unReadCount
}) {
  const [operationVisible, setOperationVisible] = useState20(false);
  const [popoverOpen, setPopoverOpen] = useState20(false);
  const [title, setTitle] = useState20(content);
  const containerRef = useRef15(null);
  useLayoutEffect(() => {
    setTitle(content);
  }, [content]);
  const inputRef = useRef15(null);
  const [editingValue, setEditingValue] = useState20("");
  const [mode, setMode] = useState20("view");
  const handleToggleMode = (mode2) => {
    setMode(mode2);
    if (mode2 === "edit") {
      setEditingValue(content);
    }
  };
  useClickAway2(() => {
    mode === "edit" && handleToggleMode("view");
  }, inputRef);
  const handleEditChange = (e) => {
    setEditingValue(e.target.value);
  };
  const handleChangeTitle = () => {
    if (editingValue == null ? void 0 : editingValue.length) {
      setMode("view");
      setTitle(editingValue);
      onEditSave == null ? void 0 : onEditSave(id, editingValue);
    }
  };
  return /* @__PURE__ */ jsxs60(
    "div",
    {
      ref: containerRef,
      className: cn42(
        "ui-relative  ui-flex ui-items-center ui-h-[40px] ui-justify-between ui-mb-[4px] ui-cursor-pointer ui-rounded-lg hover:ui-bg-yeah-icon_light/8",
        className,
        { "!ui-bg-primary-light/8": selected }
      ),
      onClick: (e) => {
        if (e.target.dataset.type === DATASET_TYPE)
          return;
        onClick == null ? void 0 : onClick(id);
      },
      onMouseEnter: () => setOperationVisible(true),
      onMouseLeave: () => setOperationVisible(false),
      children: [
        /* @__PURE__ */ jsx101("div", { className: "ui-px-[12px] ui-flex ui-items-center ui-overflow-hidden ui-box-border", children: mode === "view" ? /* @__PURE__ */ jsxs60(Fragment9, { children: [
          /* @__PURE__ */ jsx101(
            "div",
            {
              className: cn42("ui-mr-[12px]", {
                "ui-text-yeah-primary": selected,
                "ui-text-yeah-icon_light": !selected
              }),
              children: /* @__PURE__ */ jsx101(SvgChat, { className: "ui-block" })
            }
          ),
          /* @__PURE__ */ jsx101(
            "span",
            {
              className: cn42(
                "ui-truncate ui-text-yeah ui-leading-[16px] ui-text-[14px]",
                {
                  "title-typing": isTitleTyping,
                  "ui-font-medium": selected
                }
              ),
              children: title
            }
          )
        ] }) : /* @__PURE__ */ jsxs60("div", { className: "ui-h-[40px] ui-flex-center-y ui-flex ui-justify-between", children: [
          /* @__PURE__ */ jsx101(
            Input,
            {
              ref: inputRef,
              className: " ui-h-[32px] ui-flex-1 ui-rounded-md ui-border ui-border-primary ui-text-[14px]/[16px] ui-font-medium ui-text-yeah",
              value: editingValue,
              autoFocus: true,
              onFocus: (e) => e.target.select(),
              onChange: handleEditChange,
              onKeyDown: (event) => {
                if (event.code === "Enter") {
                  if (!(editingValue == null ? void 0 : editingValue.length)) {
                    setMode("view");
                  }
                  handleChangeTitle();
                }
              }
            }
          ),
          /* @__PURE__ */ jsx101(
            "div",
            {
              className: "ui-h-[24px] ui-flex-center ui-w-[24px] ui-rounded ui-p-0 ui-text-[16px] !ui-text-yeah-icon_light/60 hover:ui-bg-pale-foreground",
              onClick: (event) => {
                event.stopPropagation();
                handleChangeTitle();
              },
              children: /* @__PURE__ */ jsx101(SvgCheckMark, {})
            }
          )
        ] }) }),
        !!unReadCount && /* @__PURE__ */ jsx101("span", { className: "ui-mr-[8px] ui-flex ui-items-center ui-justify-center ui-font-[sans-serif] ui-min-w-[16px] ui-leading-[16px] ui-h-[16px] ui-px-[4px] ui-text-[12px] ui-text-white ui-bg-[#ff5219] ui-rounded-[10px]", children: /* @__PURE__ */ jsx101("span", { className: "ui-relative ui-left-[-0.5px]", children: unReadCount }) }),
        /* @__PURE__ */ jsxs60(
          "div",
          {
            className: cn42(
              "ui-absolute ui-top-[8px] ui-right-[8px] ui-w-[98px] ui-flex ui-justify-end ui-gap-[4px] ui-text-yeah-light ui-text-opacity-80 ui-bg-linear-[17.5px] data-[select=true]:ui-bg-linear-[21px]",
              (operationVisible || popoverOpen) && mode === "view" ? "" : "ui-hidden",
              actionWrapClassName
            ),
            "data-select": selected,
            children: [
              /* @__PURE__ */ jsx101(
                "div",
                {
                  className: "ui-flex ui-items-center ui-justify-center ui-h-[24px] ui-w-[24px] ui-rounded ui-p-0 ui-text-[16px] !ui-text-yeah-icon_light/60 ",
                  onClick: (e) => {
                    e.stopPropagation();
                    handleToggleMode("edit");
                  },
                  children: /* @__PURE__ */ jsx101(SvgEdit, {})
                }
              ),
              /* @__PURE__ */ jsxs60(PopoverRoot, { onOpenChange: (open) => setPopoverOpen(open), children: [
                /* @__PURE__ */ jsx101(PopoverTrigger2, { className: "ui-border-0", children: /* @__PURE__ */ jsx101(
                  "div",
                  {
                    "data-type": DATASET_TYPE,
                    className: "ui-flex ui-items-center ui-justify-center ui-h-[24px] ui-w-[24px] ui-rounded ui-p-0 ui-text-[16px] !ui-text-yeah-icon_light/60",
                    children: /* @__PURE__ */ jsx101(SvgTrash, { "data-type": DATASET_TYPE })
                  }
                ) }),
                /* @__PURE__ */ jsx101(
                  PopoverContent2,
                  {
                    className: "ui-w-[280px] ui-box-border",
                    container: document.querySelector("#bty-popup-body"),
                    children: /* @__PURE__ */ jsxs60("div", { children: [
                      /* @__PURE__ */ jsx101("p", { className: "ui-m-0 ui-mb-[16px] ui-text-sm ui-font-medium ui-text-yeah", children: "\u4F1A\u8BDD\u5220\u9664\u540E\u65E0\u6CD5\u6062\u590D\uFF0C\u662F\u5426\u786E\u8BA4\u5220\u9664\uFF1F" }),
                      /* @__PURE__ */ jsxs60("div", { className: "ui-flex ui-justify-end", children: [
                        /* @__PURE__ */ jsx101(PopoverClose, { className: "ui-border-0", children: /* @__PURE__ */ jsx101(
                          "div",
                          {
                            "data-type": DATASET_TYPE,
                            className: "ui-flex ui-h-[32px] ui-text-[14px] ui-w-[60px] ui-items-center ui-justify-center ui-rounded-md ui-border ui-border-gray-300 ui-border-opacity-80 ui-bg-white ui-p-0 ui-font-semibold !ui-text-yeah hover:ui-bg-yeah-icon_light/8",
                            children: "\u53D6\u6D88"
                          }
                        ) }),
                        /* @__PURE__ */ jsx101(PopoverClose, { className: "ui-border-0", children: /* @__PURE__ */ jsx101(
                          "div",
                          {
                            className: "ui-ml-[10.5px] ui-flex ui-text-[14px]  ui-h-[32px]  ui-w-[60px] ui-items-center ui-justify-center ui-rounded-md ui-bg-[#FF5219] ui-text-white hover:ui-bg-opacity-80",
                            onClick: () => onDelete == null ? void 0 : onDelete(id),
                            children: "\u5220\u9664"
                          }
                        ) })
                      ] })
                    ] })
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}

// src/conversation-list/ConversationList.tsx
import { useEffect as useEffect14, useMemo as useMemo17, useRef as useRef16 } from "react";
import { clsx } from "clsx";
import dayjs2 from "dayjs";
import Scrollbar2 from "smooth-scrollbar";

// src/assets/svg/new-conversation.svg
import * as React57 from "react";
import { jsx as jsx102 } from "react/jsx-runtime";
var SvgNewConversation = (props) => /* @__PURE__ */ jsx102("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 14.40000057220459, height: 14.175500869750977, viewBox: "0 0 14.40000057220459 14.175500869750977", ...props, children: /* @__PURE__ */ jsx102("g", { children: /* @__PURE__ */ jsx102("path", { d: "M12.7992,1.6L12.7992,0L11.1992,0L11.1992,1.6L9.6,1.6L9.6,3.2L11.1992,3.2L11.1992,4.8L12.7992,4.8L12.7992,3.2L14.4,3.2L14.4,1.6L12.7992,1.6ZM8,1.6L1.6,1.6C0.716344,1.6,0,2.31634,0,3.2L0,11.2C0,12.0837,0.716344,12.8,1.6,12.8L5.2,12.8L6.70024,14.0002C6.99242,14.2339,7.40758,14.2339,7.69976,14.0002L9.2,12.8L12.8,12.8C13.6837,12.8,14.4,12.0837,14.4,11.2L14.4,6.4L12.8,6.4L12.8,10.4C12.8,10.8418,12.4418,11.2,12,11.2L9.2,11.2L7.69976,12.4002C7.40758,12.6339,6.99242,12.6339,6.70024,12.4002L5.2,11.2L2.4,11.2C1.95817,11.2,1.6,10.8418,1.6,10.4L1.6,4C1.6,3.55817,1.95817,3.2,2.4,3.2L8,3.2L8,1.6ZM4.8,8C5.24183,8,5.6,7.64183,5.6,7.2C5.6,6.75817,5.24183,6.4,4.8,6.4C4.35817,6.4,4,6.75817,4,7.2C4,7.64183,4.35817,8,4.8,8ZM7.2,8C7.64183,8,8,7.64183,8,7.2C8,6.75817,7.64183,6.4,7.2,6.4C6.75817,6.4,6.4,6.75817,6.4,7.2C6.4,7.64183,6.75817,8,7.2,8ZM9.6,8C10.0418,8,10.4,7.64183,10.4,7.2C10.4,6.75817,10.0418,6.4,9.6,6.4C9.15817,6.4,8.8,6.75817,8.8,7.2C8.8,7.64183,9.15817,8,9.6,8Z", fillRule: "evenodd", fill: "currentColor" }) }) });

// src/conversation-list/ConversationList.tsx
import { jsx as jsx103, jsxs as jsxs61 } from "react/jsx-runtime";
var TIME_GROUPS = [
  {
    key: "inOneWeek",
    threshold: 0
  },
  {
    key: "aWeekAgo",
    label: "1\u5468\u524D",
    threshold: 7
  },
  {
    key: "aMonthAgo",
    label: "1\u4E2A\u6708\u524D",
    threshold: 30
  },
  {
    key: "threeMonthsAgo",
    label: "3\u4E2A\u6708\u524D",
    threshold: 90
  },
  {
    key: "sixMonthsAgo",
    label: "6\u4E2A\u6708\u524D",
    threshold: 180
  },
  {
    key: "oneYearAgo",
    label: "1\u5E74\u524D",
    threshold: 365
  }
];
function ConversationList({
  className,
  currentConversation,
  conversations,
  onCreate,
  layout,
  // loading,
  // collapsed,
  // typingTitle,
  // typingFinished,
  // onCollapse,
  onConversationClick,
  onConversationEdit,
  unReadMessageConversationCountMap
}) {
  const conversationGroups = useMemo17(() => {
    if (!(conversations == null ? void 0 : conversations.length)) {
      return [];
    }
    const groups = TIME_GROUPS.reduce((map, value) => {
      map[value.key] = {
        label: value.label,
        data: []
      };
      return map;
    }, {});
    conversations.forEach((item) => {
      const delta = dayjs2().diff(dayjs2(item.latest_create_time), "day");
      const foundGroup = TIME_GROUPS.find((value, index, values) => {
        if (index === values.length - 1) {
          return delta >= value.threshold;
        }
        return delta >= value.threshold && delta < values[index + 1].threshold;
      });
      if (foundGroup) {
        groups[foundGroup.key].data.push(item);
      }
    });
    return Object.keys(groups).map((key) => ({
      key,
      ...groups[key]
    }));
  }, [conversations]);
  const handleConversationRename = async (id, title) => {
    onConversationEdit("update", { id, name: title });
  };
  const handleConversationDelete = async (id) => {
    if (!id) {
      return;
    }
    onConversationEdit("delete", { id });
  };
  const handleConversationClick = (id) => {
    if (!id) {
      return;
    }
    onConversationClick == null ? void 0 : onConversationClick(id);
  };
  const scrollRef = useRef16(null);
  useEffect14(() => {
    if (scrollRef.current) {
      Scrollbar2.init(scrollRef.current, {
        damping: 0.5,
        // continuousScrolling: true,
        alwaysShowTracks: false
      });
    }
  }, [scrollRef.current]);
  const list = conversationGroups.map(
    (group) => group.data.length ? /* @__PURE__ */ jsxs61("div", { className: "group", children: [
      /* @__PURE__ */ jsx103("span", { className: "ui-block ui-pl-[12px] text-font_1  ui-text-[12px]/[36px] ui-font-semibold", children: group.label }),
      group.data.map((conversation) => {
        const selected = (currentConversation == null ? void 0 : currentConversation.conversation_id) === conversation.conversation_id;
        return /* @__PURE__ */ jsx103(
          ConversationItem,
          {
            id: conversation.conversation_id,
            className: "ui-bg-transparent last:ui-mb-0",
            actionWrapClassName: "",
            selected,
            content: conversation.title,
            unReadCount: (unReadMessageConversationCountMap == null ? void 0 : unReadMessageConversationCountMap[conversation.conversation_id]) ?? 0,
            onClick: handleConversationClick,
            onEditSave: handleConversationRename,
            onDelete: handleConversationDelete
          },
          conversation.conversation_id
        );
      })
    ] }, group.key) : void 0
  );
  return /* @__PURE__ */ jsxs61("div", { className: "ui-flex ui-flex-col ui-h-full ui-overflow-hidden ui-relative conversation-list-popup", children: [
    /* @__PURE__ */ jsx103(
      "div",
      {
        ref: scrollRef,
        className: clsx(
          "ui-flex ui-flex-1 ui-flex-col border-right after:ui-border-[rgba(225,225,229,0.6)]",
          className
        ),
        children: /* @__PURE__ */ jsx103("div", { className: "ui-flex-1 ui-pt-[0px] ui-p-[16px] ui-overflow-x-hidden ui-overflow-y-auto", children: list.length ? list : /* @__PURE__ */ jsx103("div", { className: "ui-text-center ui-text-yeah-light ui-text-opacity-60 ui-text-[14px]/[20px] ui-mt-[60px]", children: "\u6682\u65E0\u4F1A\u8BDD" }) })
      }
    ),
    layout === "mobile" && /* @__PURE__ */ jsxs61(Button, { className: "ui-m-[16px]", onClick: onCreate, children: [
      /* @__PURE__ */ jsx103(SvgNewConversation, { className: "ui-mr-[6px]" }),
      " \u65B0\u5EFA\u4F1A\u8BDD"
    ] })
  ] });
}

// src/conversation-list/ConversationListPopup.tsx
import { cn as cn44 } from "@bty/util";

// src/base/components/Popup/Popup.tsx
import { useEffect as useEffect15, useRef as useRef17 } from "react";
import Scrollbar3 from "smooth-scrollbar";
import { cn as cn43 } from "@bty/util";

// src/assets/svg/close-2.svg
import * as React58 from "react";
import { jsx as jsx104 } from "react/jsx-runtime";
var SvgClose22 = (props) => /* @__PURE__ */ jsx104("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, className: "nkxe8gwx6__design-iconfont", ...props, children: /* @__PURE__ */ jsx104("path", { fillRule: "evenodd", d: "M12.007 3.026q-.4 0-.684.284L8 6.632 4.677 3.31q-.284-.284-.684-.284-.4 0-.684.284-.283.283-.283.683 0 .4.284.684L6.633 8l-3.324 3.323q-.283.284-.283.684 0 .4.283.683.284.284.684.284.4 0 .684-.284L8 9.367l3.323 3.323q.284.284.684.284.4 0 .683-.284.284-.283.284-.683 0-.4-.284-.684L9.367 8l3.323-3.323q.284-.284.284-.684 0-.4-.284-.683-.283-.284-.683-.284Z" }) });

// src/base/components/Popup/Popup.tsx
import { Fragment as Fragment10, jsx as jsx105, jsxs as jsxs62 } from "react/jsx-runtime";
var Popup = ({
  open,
  title,
  onClose,
  children,
  className,
  hideCloseIcon,
  bodyStyle
}) => {
  const scrollRef = useRef17(null);
  useEffect15(() => {
    if (scrollRef.current) {
      Scrollbar3.init(scrollRef.current, {
        damping: 0.5,
        // continuousScrolling: true,
        alwaysShowTracks: false
      });
    }
  });
  return /* @__PURE__ */ jsxs62(Fragment10, { children: [
    open && /* @__PURE__ */ jsx105(
      "div",
      {
        onClick: onClose,
        className: "ui-bg-black ui-bg-opacity-50 ui-fixed ui-top-0 ui-left-0 ui-right-0 ui-bottom-0 ui-z-50"
      }
    ),
    /* @__PURE__ */ jsx105(
      "div",
      {
        id: "bty-popup-body",
        className: cn43(
          "ui-fixed ui-z-50 ui-inset-0 ui-flex ui-justify-center ui-items-end ui-transition-transform",
          {
            "ui-translate-y-0": open,
            "ui-translate-y-full": !open
          }
        ),
        children: /* @__PURE__ */ jsxs62(
          "div",
          {
            className: "ui-w-full  ui-flex ui-flex-col  ui-max-h-[85%] ui-rounded-t-lg ui-shadow-lg ui-overflow-hidden ui-relative ui-bg-white",
            onClick: (e) => e.stopPropagation(),
            style: bodyStyle,
            children: [
              (hideCloseIcon && title || !hideCloseIcon) && /* @__PURE__ */ jsx105("header", { className: "ui-py-[16px] ui-h-[50px] ui-flex ui-justify-center ui-items-center ui-text-[16px] ui-font-bold ui-relative", children: /* @__PURE__ */ jsx105("div", { children: title }) }),
              !hideCloseIcon && /* @__PURE__ */ jsx105(
                SvgClose22,
                {
                  className: "ui-absolute  ui-right-[16px] ui-top-[16px] ui-cursor-pointer",
                  onClick: onClose
                }
              ),
              /* @__PURE__ */ jsx105(
                "div",
                {
                  className: cn43("ui-overflow-hidden ui-flex-1 ui-flex", className),
                  children: /* @__PURE__ */ jsx105(
                    "div",
                    {
                      ref: scrollRef,
                      className: "ui-overflow-auto ui-w-full ui-flex-1",
                      children
                    }
                  )
                }
              )
            ]
          }
        )
      }
    )
  ] });
};
var Popup_default = Popup;

// src/conversation-list/ConversationListPopup.tsx
import { jsx as jsx106 } from "react/jsx-runtime";
function ConversationListPopup({
  open,
  onClose,
  children
}) {
  const { layoutMode } = useChatLayoutMode();
  const handleClose = () => {
    onClose == null ? void 0 : onClose();
    localStorage.setItem("conversationListCollapsed", "");
  };
  return layoutMode === "mobile" ? /* @__PURE__ */ jsx106(
    Popup_default,
    {
      open,
      onClose: handleClose,
      title: "\u5386\u53F2\u4F1A\u8BDD",
      className: "conversation-list-popup",
      bodyStyle: {
        minHeight: "75vh"
      },
      children
    }
  ) : /* @__PURE__ */ jsx106(
    "div",
    {
      className: cn44(
        "ui-w-[264px] ui-h-full ui-shrink-0 ui-transition-[width]",
        !open ? "!ui-w-0 ui-overflow-hidden" : ""
      ),
      children
    }
  );
}

// src/header/ChatHeader.tsx
import { cn as cn46 } from "@bty/util";

// src/assets/svg/agent-detail.svg
import * as React60 from "react";
import { jsx as jsx107, jsxs as jsxs63 } from "react/jsx-runtime";
var SvgAgentDetail = (props) => /* @__PURE__ */ jsxs63("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className: "q52m6ont5__design-iconfont", width: 16, height: 16, ...props, children: [
  /* @__PURE__ */ jsx107("defs", { children: /* @__PURE__ */ jsx107("clipPath", { id: "q52m6ont5__bbiwty9rx__4agl84e6za", children: /* @__PURE__ */ jsx107("rect", { width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsx107("g", { clipPath: "url(#q52m6ont5__bbiwty9rx__4agl84e6za)", children: /* @__PURE__ */ jsx107("path", { d: "M8,15.5C12.1421,15.5,15.5,12.1421,15.5,8C15.5,3.85786,12.1421,0.5,8,0.5C3.85786,0.5,0.5,3.85786,0.5,8C0.5,12.1421,3.85786,15.5,8,15.5ZM12.1719,3.82807Q13.9,5.55614,13.9,8Q13.9,10.44386,12.1719,12.1719Q10.44386,13.9,8,13.9Q5.55614,13.9,3.82807,12.1719Q2.1,10.44386,2.1,8Q2.1,5.55614,3.82807,3.82807Q5.55614,2.1,8,2.1Q10.44386,2.1,12.1719,3.82807ZM8.11542,3.77904C8.30967,3.59309,8.54709,3.5001,8.81688,3.5001C9.09747,3.5001,9.3241,3.59309,9.51835,3.77904C9.71261,3.965,9.80974,4.19228,9.80974,4.45055C9.80974,4.70883,9.71261,4.9361,9.51835,5.12206C9.3241,5.30801,9.08667,5.401,8.81688,5.401C8.54709,5.401,8.32046,5.30801,8.12621,5.12206C7.93195,4.9361,7.83482,4.70883,7.83482,4.45055C7.83482,4.19228,7.92115,3.965,8.11542,3.77904ZM9.23755,6.47556L8.82746,6.47556L6.55039,6.8268L6.46406,7.08508L6.53302,7.08346L6.65072,7.07636C6.66842,7.07538,6.68528,7.07475,6.70147,7.07475C6.85256,7.07475,6.97127,7.11607,7.0576,7.18838C7.14394,7.2607,7.18711,7.34335,7.18711,7.43632C7.18711,7.59129,7.14394,7.80824,7.0576,8.10783L6.11871,11.1968C6.04317,11.4447,6,11.641,6,11.8063C6,12.0439,6.08633,12.2505,6.25901,12.4055C6.43168,12.5604,6.6691,12.6431,6.96048,12.6431C7.7267,12.6431,8.44975,12.075,9.12963,10.9488L8.90301,10.8249C8.62242,11.2381,8.37421,11.5274,8.17995,11.6927C8.1152,11.7546,8.03966,11.7856,7.95333,11.7856C7.91016,11.7856,7.86699,11.765,7.82383,11.7236C7.78066,11.6823,7.75907,11.641,7.75907,11.5894C7.75907,11.5646,7.76296,11.5314,7.77043,11.4902L7.7901,11.3969C7.79415,11.3796,7.79857,11.3615,7.80336,11.3424L7.83643,11.2178L7.87778,11.0728L9.23755,6.47556Z", fillRule: "evenodd" }) })
] });

// src/header/MoreMenu.tsx
import { useRef as useRef18, useState as useState21 } from "react";
import { useClickAway as useClickAway3 } from "ahooks";
import { cn as cn45 } from "@bty/util";
import { jsx as jsx108, jsxs as jsxs64 } from "react/jsx-runtime";
function MoreMenu({ items }) {
  const [open, setOpen] = useState21(false);
  const ref = useRef18(null);
  const buttonRef = useRef18(null);
  useClickAway3(() => {
    open && setOpen(false);
  }, [ref, buttonRef]);
  return /* @__PURE__ */ jsxs64(Popover, { open, children: [
    /* @__PURE__ */ jsx108(
      PopoverContent,
      {
        className: "!ui-p-0 !ui-border-0 !ui-mr-[8px]",
        style: { outline: "none" },
        children: /* @__PURE__ */ jsx108(
          "div",
          {
            ref,
            className: "ui-bg-white ui-px-[4px] ui-box-border ui-w-[124px] ui- ui-py-[8px] ui-rounded-[8px] ui-text-[#17171d] ui-text-[14px] ui-shadow-[0px_8px_24px_0px_rgba(0,0,0,0.2)] ui-backdrop-blur-lg ui-cursor-pointer",
            children: items.filter((v) => v.icon).map((item, index) => /* @__PURE__ */ jsx108(
              "button",
              {
                className: "ui-inline-flex  ui-items-center ui-px-[8px] ui-justify-center ui-w-full ui-h-[38px] hover:ui-bg-[rgba(98,105,153,0.08)] ui-rounded-md ui-bg-transparent ui-border-0",
                onClick: () => {
                  var _a;
                  setOpen(false);
                  (_a = item.onClick) == null ? void 0 : _a.call(item);
                },
                children: /* @__PURE__ */ jsxs64("div", { className: "ui-flex ui-w-full ui-items-center ", children: [
                  item.icon,
                  /* @__PURE__ */ jsx108("div", { className: "ui-ml-[4px]", children: item.label })
                ] })
              },
              index
            ))
          }
        )
      }
    ),
    /* @__PURE__ */ jsx108(PopoverTrigger, { className: "ui-border-0 ui-border-none", children: /* @__PURE__ */ jsx108(
      "button",
      {
        ref: buttonRef,
        className: cn45(
          "ui-flex ui-ml-[30px] ui-items-center ui-justify-center ui-w-[32px] ui-h-[32px] hover:ui-bg-[rgba(98,105,153,0.08)] ui-rounded-md ui-bg-transparent ui-border-none"
        ),
        children: /* @__PURE__ */ jsx108(
          SvgMore,
          {
            onClick: (e) => {
              e.stopPropagation();
              setOpen(true);
            }
          }
        )
      }
    ) })
  ] });
}

// src/header/ChatHeader.tsx
import { Fragment as Fragment11, jsx as jsx109, jsxs as jsxs65 } from "react/jsx-runtime";
function ChatHeader({
  collapsed,
  hideDefaultSuffix = false,
  prefix,
  suffix,
  taskIcon,
  notificationCount,
  title,
  description,
  icon,
  onCollapse
}) {
  const handleHistoryListCollapse = () => {
    localStorage.setItem(
      "conversationListCollapsed",
      !collapsed.history ? "" : "1"
    );
    onCollapse("history", !collapsed.history);
  };
  const handleBotDetailCollapse = () => {
    onCollapse("bot", !collapsed.bot);
  };
  const handleNewConversationCollapse = () => {
    onCollapse("newConversation", !collapsed.newConversation);
  };
  const handleTaskCollapse = () => {
    onCollapse("task", !collapsed.task);
  };
  const { layoutMode } = useChatLayoutMode();
  return /* @__PURE__ */ jsxs65("header", { className: "ui-box-border ui-flex ui-items-center ui-justify-between ui-h-[64px] ui-px-[16px]  ui-relative", children: [
    layoutMode === "desktop" && /* @__PURE__ */ jsx109(
      "div",
      {
        className: cn46(
          "ui-h-[64px] ui-w-[264px] ui-transition-[width] !ui-absolute ui-left-0 ui-top-0 border-right after:ui-border-[rgba(225,225,229,0.6)] ui-z-0 ui-pointer-events-none",
          {
            "!ui-w-0 ui-overflow-hidden": collapsed.history
          }
        )
      }
    ),
    /* @__PURE__ */ jsxs65("div", { className: "ui-flex ", children: [
      !!prefix && prefix,
      /* @__PURE__ */ jsxs65(Fragment11, { children: [
        /* @__PURE__ */ jsxs65(
          "button",
          {
            className: "ui-relative md:ui-inline-flex sm:ui-hidden ui-hidden ui-items-center ui-justify-center ui-w-[32px] ui-h-[32px] hover:ui-bg-[rgba(98,105,153,0.08)] ui-rounded-md ui-bg-transparent ui-border-0",
            onClick: handleHistoryListCollapse,
            children: [
              /* @__PURE__ */ jsx109(SvgListMobile, { className: "ui-text-yeah ui-text-[12px] ui-w-[12px]" }),
              !!notificationCount && /* @__PURE__ */ jsx109("span", { className: "ui-absolute ui-right-[-7px] ui-top-[4px] ui-mr-[8px] ui-flex ui-items-center ui-justify-center ui-font-[sans-serif] ui-min-w-[14px] ui-leading-[14px] ui-h-[14px] ui-px-[4px] ui-text-[12px] ui-text-white ui-bg-[#ff5219] ui-rounded-[10px]", children: /* @__PURE__ */ jsx109("span", { className: "ui-relative ui-left-[0px] ui-text-[12px]", children: notificationCount }) })
            ]
          }
        ),
        collapsed.newConversation && /* @__PURE__ */ jsx109(
          Tooltip2,
          {
            title: /* @__PURE__ */ jsxs65("div", { className: "ui-flex ui-items-center", children: [
              /* @__PURE__ */ jsx109("span", { children: "\u5F00\u542F\u65B0\u4F1A\u8BDD" }),
              /* @__PURE__ */ jsxs65("span", { className: "ui-inline-flex ui-items-center ui-ml-[4px] ui-h-[16px] ui-p-[2px] ui-rounded-[4px] ui-bg-opacity-[8]", children: [
                /* @__PURE__ */ jsx109(SvgCommand, {}),
                " K"
              ] })
            ] }),
            children: layoutMode === "desktop" && /* @__PURE__ */ jsx109("button", { className: "ui-inline-flex ui-items-center ui-justify-center ui-w-[32px] ui-h-[32px] hover:ui-bg-[rgba(98,105,153,0.08)] ui-rounded-md ui-bg-transparent ui-border-0", children: /* @__PURE__ */ jsx109(
              SvgNewConversation,
              {
                onClick: handleNewConversationCollapse,
                className: "ui-text-yeah ui-text-[16px]"
              }
            ) })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx109(
      "div",
      {
        className: cn46("ui-flex ui-gap-[8px]", {
          "ui-flex-1 ui-overflow-hidden": layoutMode === "mobile"
        }),
        children: /* @__PURE__ */ jsxs65("div", { className: "ui-flex ui-w-full  ui-items-center ui-gap-[8px]", children: [
          /* @__PURE__ */ jsx109(
            "img",
            {
              src: icon,
              className: "ui-w-[28px] ui-h-[28px] ui-rounded-full ui-gap-[4px]"
            }
          ),
          /* @__PURE__ */ jsxs65("div", { className: "ui-flex-1 ui-overflow-hidden", children: [
            /* @__PURE__ */ jsx109("div", { className: "ui-font-bold ui-text-[16px] ui-leading-[1]", children: title }),
            description && /* @__PURE__ */ jsx109("div", { className: "ui-text-[12px] ui-text-[#8D8D99] ui-leading-[1] ui-mt-[4px] ui-truncate", children: description })
          ] })
        ] })
      }
    ),
    /* @__PURE__ */ jsxs65("div", { className: " ui-justify-end ui-flex ui-flex-items-center", children: [
      suffix,
      /* @__PURE__ */ jsx109("div", { className: "md:ui-flex md:ui-items-center sm:ui-hidden ui-hidden ", children: taskIcon && /* @__PURE__ */ jsx109(
        "button",
        {
          className: cn46(
            "ui-inline-flex ui-items-center ui-justify-center ui-w-full ui-px-[8px] ui-h-[32px] hover:ui-bg-[rgba(98,105,153,0.08)] ui-rounded-md ui-bg-transparent ui-border-none"
          ),
          onClick: handleTaskCollapse,
          children: taskIcon
        }
      ) }),
      !hideDefaultSuffix && /* @__PURE__ */ jsxs65(Fragment11, { children: [
        /* @__PURE__ */ jsx109("div", { className: "md:ui-block sm:ui-hidden ui-hidden", children: /* @__PURE__ */ jsx109(Tooltip2, { title: "Agent \u8BE6\u60C5", children: /* @__PURE__ */ jsx109(
          "button",
          {
            className: cn46(
              "ui-inline-flex ui-items-center ui-justify-center ui-w-[38px] ui-h-[32px] hover:ui-bg-[rgba(98,105,153,0.08)] ui-rounded-md ui-bg-transparent ui-border-none",
              {
                "ui-bg-[rgba(98,105,153,0.08)]": !collapsed.bot
              }
            ),
            onClick: handleBotDetailCollapse,
            children: /* @__PURE__ */ jsx109(SvgAgentDetail, { className: "ui-text-yeah ui-text-[16px]" })
          }
        ) }) }),
        /* @__PURE__ */ jsx109("div", { className: "md:!ui-hidden sm:!ui-inline-flex ui-inline-flex", children: /* @__PURE__ */ jsx109(
          MoreMenu,
          {
            items: [
              // {
              //   icon: <CollapseIcon />,
              //   label: '历史会话',
              //   onClick: handleHistoryListCollapse,
              // },
              {
                icon: taskIcon,
                label: "",
                onClick: handleTaskCollapse
              },
              {
                icon: /* @__PURE__ */ jsx109(SvgAgentDetail, {}),
                label: "\u8BE6\u60C5",
                onClick: handleBotDetailCollapse
              }
            ]
          }
        ) })
      ] })
    ] })
  ] });
}

// src/chat/Chat.tsx
import "@bty/ui-components/dist/index.css";

// src/agent-profile/AgentProfile.tsx
import { useState as useState22 } from "react";
import { clsx as clsx2 } from "clsx";

// src/assets/svg/skill-collapse.svg
import * as React61 from "react";
import { jsx as jsx110 } from "react/jsx-runtime";
var SvgSkillCollapse = (props) => /* @__PURE__ */ jsx110("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16.000000834337925, height: 16.000000834337925, viewBox: "0 0 16.000000834337925 16.000000834337925", ...props, children: /* @__PURE__ */ jsx110("g", { transform: "matrix(-1,-5.2146120310681e-8,5.2146120310681e-8,-1,31.999999165662032,32.000002503013775)", children: /* @__PURE__ */ jsx110("g", { children: /* @__PURE__ */ jsx110("path", { d: "M21.00428,23.830130834337925C20.63505,24.081790834337923,20.111082,24.053830834337923,19.776243,23.746250834337925C19.4079192,23.407910834337926,19.4079192,22.859360834337924,19.776243,22.521020834337925L23.33309,19.253753834337925L23.43887,19.169868834337926C23.8081,18.918212734337924,24.33207,18.946174534337924,24.66691,19.253753834337925L28.22376,22.521020834337925L28.315080000000002,22.618190834337923C28.58904,22.957360834337926,28.5586,23.438670834337927,28.22376,23.746250834337925L28.11798,23.830130834337925C27.74875,24.081790834337923,27.22478,24.053830834337923,26.88994,23.746250834337925L23.99928,21.091980834337924L21.11006,23.746250834337925L21.00428,23.830130834337925ZM21.00428,28.830130834337925C20.63505,29.081800834337926,20.111082,29.053800834337927,19.776243,28.746250834337925C19.4079192,28.407910834337926,19.4079192,27.859360834337927,19.776243,27.521020834337925L23.33309,24.253750834337925L23.43887,24.169870834337924C23.8081,23.918210834337927,24.33207,23.946170834337927,24.66691,24.253750834337925L28.22376,27.521020834337925L28.315080000000002,27.618190834337923C28.58904,27.957360834337926,28.5586,28.438670834337927,28.22376,28.746250834337925L28.11798,28.830130834337925C27.74875,29.081800834337926,27.22478,29.053800834337927,26.88994,28.746250834337925L23.99928,26.091980834337924L21.11006,28.746250834337925L21.00428,28.830130834337925Z", fillRule: "evenodd", fill: "#8D8D99", fillOpacity: 1 }) }) }) });

// src/assets/svg/skill.svg
import * as React62 from "react";
import { jsx as jsx111 } from "react/jsx-runtime";
var SvgSkill = (props) => /* @__PURE__ */ jsx111("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className: "k40sfg0hd__design-iconfont", width: 16, height: 16, ...props, children: /* @__PURE__ */ jsx111("path", { d: "M8.74794265625,4.2526399999999995L11.58832265625,1.411902C10.92570265625,1.139921,10.21630265625,1,9.50000265625,1C6.46243265625,1,4.00000265625,3.46243,4.00000265625,6.5C4.00000265625,7.40004,4.22088265625,8.28633,4.64326265625,9.08111L1.70852665625,11.5802C0.88023265625,12.2856,0.82972865625,13.5475,1.59900665625,14.3168C2.35848265625,15.0762,3.60106265625,15.0382,4.31264265625,14.2336L6.87701265625,11.3342C7.68224265625,11.7712,8.58386265625,12,9.50000265625,12C12.53752265625,12,15.00002265625,9.53757,15.00002265625,6.5C15.00002265625,5.78562,14.86082265625,5.07808,14.59022265625,4.41692L11.75152265625,7.25594C10.97051265625,8.03706,9.70412265625,8.03709,8.92304265625,7.25601L8.74802265625,7.08099C7.96700265625,6.29997,7.96696265625,5.0337,8.74794265625,4.2526399999999995Z", fill: "#626999", fillRule: "evenodd", fillOpacity: 0.60000002 }) });

// src/assets/svg/dataset.svg
import * as React63 from "react";
import { jsx as jsx112 } from "react/jsx-runtime";
var SvgDataset = (props) => /* @__PURE__ */ jsx112("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className: "5iv0v8vct__design-iconfont", width: 16, height: 16, ...props, children: /* @__PURE__ */ jsx112("path", { d: "M3,10L3,8.5L1.2,8.5C1.089543,8.5,1,8.41046,1,8.3L1,7.7C1,7.58954,1.089543,7.5,1.2,7.5L3,7.5L3,6L1.2,6C1.089543,6,1,5.91046,1,5.8L1,5.2C1,5.08954,1.089543,5,1.2,5L3,5L3,4C3,3.44772,3.44772,3,4,3L5,3L5,1.2C5,1.089543,5.08954,1,5.2,1L5.8,1C5.91046,1,6,1.089543,6,1.2L6,3L7.5,3L7.5,1.2C7.5,1.089543,7.58954,1,7.7,1L8.3,1C8.41046,1,8.5,1.089543,8.5,1.2L8.5,3L10,3L10,1.2C10,1.089543,10.08954,1,10.2,1L10.8,1C10.91046,1,11,1.089543,11,1.2L11,3L12,3C12.5523,3,13,3.44772,13,4L13,5L14.8,5C14.9105,5,15,5.08954,15,5.2L15,5.8C15,5.91046,14.9105,6,14.8,6L13,6L13,7.5L14.8,7.5C14.9105,7.5,15,7.58954,15,7.7L15,8.3C15,8.41046,14.9105,8.5,14.8,8.5L13,8.5L13,10L14.8,10C14.9105,10,15,10.08954,15,10.2L15,10.8C15,10.91046,14.9105,11,14.8,11L13,11L13,12C13,12.5523,12.5523,13,12,13L11,13L11,14.8C11,14.9105,10.91046,15,10.8,15L10.2,15C10.08954,15,10,14.9105,10,14.8L10,13L8.5,13L8.5,14.8C8.5,14.9105,8.41046,15,8.3,15L7.7,15C7.58954,15,7.5,14.9105,7.5,14.8L7.5,13L6,13L6,14.8C6,14.9105,5.91046,15,5.8,15L5.2,15C5.08954,15,5,14.9105,5,14.8L5,13L4,13C3.44772,13,3,12.5523,3,12L3,11L1.2,11C1.089543,11,1,10.91046,1,10.8L1,10.2C1,10.08954,1.089543,10,1.2,10L3,10ZM7.64146,10.06572L10.71217,6.99501C10.79027,6.91691,10.79027,6.79027,10.71217,6.71217L10.2879,6.28791C10.2098,6.2098,10.08317,6.2098,10.00506,6.28791L7.64146,8.65151C7.56335,8.729610000000001,7.43672,8.729610000000001,7.35862,8.65151L5.99501,7.28791C5.91691,7.2098,5.79027,7.2098,5.71217,7.28791L5.28791,7.71217C5.2098,7.79027,5.2098,7.91691,5.28791,7.99501L7.35862,10.06572C7.43672,10.14383,7.56335,10.14383,7.64146,10.06572Z", fill: "#626999", fillRule: "evenodd", fillOpacity: 0.60000002 }) });

// src/assets/svg/agentgo.svg
import * as React64 from "react";
import { jsx as jsx113, jsxs as jsxs66 } from "react/jsx-runtime";
var SvgAgentgo = (props) => /* @__PURE__ */ jsxs66("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16", ...props, children: [
  /* @__PURE__ */ jsx113("defs", { children: /* @__PURE__ */ jsx113("clipPath", { id: "master_svg0_4918_31100", children: /* @__PURE__ */ jsx113("rect", { x: 0, y: 0, width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsx113("g", { clipPath: "url(#master_svg0_4918_31100)", children: /* @__PURE__ */ jsx113("g", { children: /* @__PURE__ */ jsx113("g", { children: /* @__PURE__ */ jsx113("path", { d: "M10.20711,1.5C9.76165,1.5,9.53857,2.038571,9.85355,2.353554L11.09099,3.59099L7.49459,7.18738C7.29933,7.38265,7.29933,7.69923,7.49459,7.89449L8.20154,8.60144C8.39681,8.796710000000001,8.71339,8.796710000000001,8.90865,8.60144L12.505,5.005050000000001L13.6464,6.14645C13.9614,6.46143,14.5,6.23835,14.5,5.79289L14.5,2C14.5,1.723858,14.2761,1.5,14,1.5L10.20711,1.5ZM8,14.5C11.21445,14.5,13.9161,12.1578,14.4172,9.0359C14.4634,8.748280000000001,14.232,8.5,13.9407,8.5L11.8971,8.5C11.6486,8.5,11.44112,8.68615,11.37556,8.9259C10.96465,10.42857,9.59305,11.5,8,11.5C6.067,11.5,4.5,9.933,4.5,8C4.5,6.40695,5.57143,5.03535,7.0741,4.62444C7.31385,4.55888,7.5,4.35144,7.5,4.10289L7.5,2.0593209999999997C7.5,1.768021,7.25172,1.5366174,6.9641,1.5827842C3.84222,2.0838900000000002,1.5,4.785550000000001,1.5,8C1.5,11.5899,4.41015,14.5,8,14.5Z", fillRule: "evenodd", fill: "#626999", fillOpacity: 0.6000000238418579 }) }) }) })
] });

// src/agent-profile/AgentProfile.tsx
import { Fragment as Fragment12, jsx as jsx114, jsxs as jsxs67 } from "react/jsx-runtime";
var DEFAULT_SKILL_DISPLAY_COUNT = 10;
function AgentProfile({
  className,
  agent,
  collapsed,
  hideCloseButton = false,
  actions = [],
  onCollapse
}) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const [skillsExpanded, setSkillsExpanded] = useState22(false);
  const handleCollapse = () => {
    onCollapse(!collapsed);
  };
  const renderSectionHeader = (title, icon) => /* @__PURE__ */ jsxs67("span", { className: "ui-items-center ui-flex ui-gap-[6px] ui-p-[16px] ui-pb-[8px]", children: [
    icon,
    /* @__PURE__ */ jsx114("span", { className: "ui-text-[14px]/[16px] ui-text-yeah ui-font-semibold", children: title })
  ] });
  const flows = (_b = (_a = agent == null ? void 0 : agent.config) == null ? void 0 : _a.flows) == null ? void 0 : _b.map((el) => ({
    name: el.name,
    description: el.description,
    icon: el.icon,
    color: el.color
  }));
  const utilities = (_d = (_c = agent == null ? void 0 : agent.config) == null ? void 0 : _c.utility) == null ? void 0 : _d.map((el) => ({
    name: el.display_name,
    description: el.description,
    icon: el.metadata.icon,
    color: el.metadata.color
  }));
  const skills = [...flows ?? [], ...utilities ?? []];
  const wechatApp = (_f = (_e = agent == null ? void 0 : agent.config) == null ? void 0 : _e.agent_auth_app) == null ? void 0 : _f.find(
    (item) => item.auth_app_source === "weixin_kf"
  );
  const hasMemory = !!((_h = (_g = agent == null ? void 0 : agent.config) == null ? void 0 : _g.dataset) == null ? void 0 : _h.length) || !!((_k = (_j = (_i = agent == null ? void 0 : agent.config) == null ? void 0 : _i.database) == null ? void 0 : _j.table_list) == null ? void 0 : _k.length);
  return /* @__PURE__ */ jsxs67(
    "div",
    {
      className: clsx2(
        className,
        "ui-relative ui-pt-[34px] border-left after:ui-border-[rgba(225,225,229,0.6)] ui-bg-[#f7f7fa] ui-flex ui-flex-col ui-items-stretch ui-text-[14px]"
      ),
      children: [
        !hideCloseButton && /* @__PURE__ */ jsx114(
          "button",
          {
            className: "ui-absolute ui-top-[24px] ui-right-[16px] ui-inline-flex ui-items-center ui-justify-center hover:ui-bg-[rgba(98,105,153,0.08)] ui-rounded-md ui-bg-transparent ui-w-[24px] ui-h-[24px] ui-text-[16px] ui-border-0",
            onClick: handleCollapse,
            children: /* @__PURE__ */ jsx114(SvgClose22, {})
          }
        ),
        /* @__PURE__ */ jsxs67("div", { className: "ui-overflow-y-scroll ui-p-[16px]", children: [
          /* @__PURE__ */ jsxs67("section", { className: "ui-flex ui-flex-col ui-text-center", children: [
            /* @__PURE__ */ jsx114(
              Avatar,
              {
                className: "ui-shrink-0 ui-mx-auto",
                size: 80,
                icon: agent == null ? void 0 : agent.icon,
                color: agent == null ? void 0 : agent.color
              }
            ),
            /* @__PURE__ */ jsx114("span", { className: "ui-my-[12px] ui-text-[16px]/[20px] ui-text-yeah ui-font-semibold ui-break-all", children: agent == null ? void 0 : agent.name }),
            /* @__PURE__ */ jsx114("span", { className: "ui-mb-[12px] ui-text-center ui-text-[14px]/[20px] ui-text-[#3f3f44]", children: agent == null ? void 0 : agent.description }),
            /* @__PURE__ */ jsxs67("span", { className: "ui-mb-[8px] ui-text-[14px] ui-text-yeah-light ui-break-all", children: [
              "\u5F00\u53D1\u8005\uFF1A",
              agent == null ? void 0 : agent.developer
            ] }),
            (agent == null ? void 0 : agent.workspace_name) ? /* @__PURE__ */ jsxs67("span", { className: "ui-text-[14px] ui-text-yeah-light ui-break-all", children: [
              "\u7A7A\u95F4\uFF1A",
              agent.workspace_name
            ] }) : null
          ] }),
          !!actions.length && /* @__PURE__ */ jsx114("section", { className: "ui-mt-[16px] ui-w-full", children: actions.map((action, index) => /* @__PURE__ */ jsx114(
            Button,
            {
              variant: action.buttonType || "outline",
              className: "ui-w-full ui-mb-[8px]",
              onClick: () => {
                var _a2;
                return agent && ((_a2 = action.event) == null ? void 0 : _a2.call(action, agent));
              },
              children: action.content
            },
            index.toString()
          )) }),
          skills.length ? /* @__PURE__ */ jsxs67("section", { className: "ui-mt-[30px] ui-pb-[16px] ui-bg-white ui-rounded-lg", children: [
            renderSectionHeader(
              /* @__PURE__ */ jsxs67(Fragment12, { children: [
                "\u6280\u80FD",
                /* @__PURE__ */ jsx114("span", { className: "ui-text-yeah-light ui-font-normal ui-ml-[8px]", children: skills.length })
              ] }),
              /* @__PURE__ */ jsx114(SvgSkill, {})
            ),
            /* @__PURE__ */ jsx114("ul", { className: "ui-m-0 ui-mt-[8px] ui-p-0 ui-text-[14px]", children: skills.slice(
              0,
              skillsExpanded ? void 0 : DEFAULT_SKILL_DISPLAY_COUNT
            ).map((item, index) => {
              var _a2;
              return /* @__PURE__ */ jsxs67(
                "li",
                {
                  className: "ui-flex ui-items-center ui-px-[16px] last-of-type:ui-mb-0 ui-mb-[16px]",
                  children: [
                    ((_a2 = item == null ? void 0 : item.icon) == null ? void 0 : _a2.startsWith("http")) ? /* @__PURE__ */ jsx114(
                      "img",
                      {
                        className: "ui-w-[24px] ui-h-[24px] ui-rounded-md",
                        src: item.icon
                      }
                    ) : /* @__PURE__ */ jsx114(
                      "div",
                      {
                        className: "ui-flex-center ui-w-[24px] ui-h-[24px] ui-rounded-md ui-text-[16px] ui-text-center",
                        style: { backgroundColor: item.color },
                        children: item.icon
                      }
                    ),
                    /* @__PURE__ */ jsx114("span", { className: "ui-ml-[8px] ui-text-[14px] ui-text-yeah ui-break-all", children: item.name })
                  ]
                },
                index.toString()
              );
            }) }),
            skills.length > DEFAULT_SKILL_DISPLAY_COUNT && /* @__PURE__ */ jsxs67(
              "div",
              {
                className: "ui-flex ui-items-center ui-mt-[16px] ui-px-[16px] ui-cursor-pointer",
                onClick: () => setSkillsExpanded(!skillsExpanded),
                children: [
                  /* @__PURE__ */ jsx114("span", { className: "ui-text-yeah-light", children: skillsExpanded ? "\u6536\u8D77" : "\u5C55\u5F00\u5168\u90E8" }),
                  /* @__PURE__ */ jsx114(
                    SvgSkillCollapse,
                    {
                      className: clsx2("ui-ml-[8px] ui-text-yeah-light", {
                        "ui-rotate-180": skillsExpanded
                      })
                    }
                  )
                ]
              }
            )
          ] }) : null,
          hasMemory && /* @__PURE__ */ jsxs67("section", { className: "ui-mt-[16px] ui-bg-white ui-rounded-lg", children: [
            renderSectionHeader("\u8BB0\u5FC6", /* @__PURE__ */ jsx114(SvgDataset, {})),
            /* @__PURE__ */ jsxs67("ul", { className: "ui-mt-[8px] ui-pl-0", children: [
              ((_m = (_l = agent.config) == null ? void 0 : _l.dataset) == null ? void 0 : _m.length) ? /* @__PURE__ */ jsxs67("li", { className: "ui-flex ui-items-center ui-px-[16px] ui-pb-[16px]", children: [
                /* @__PURE__ */ jsx114("span", { className: "ui-w-[24px] ui-h-[24px] ui-mr-[8px] ui-bg-linear-8 ui-text-[14px]/[24px] ui-text-center ui-rounded-[6px]", children: "\u{1F4D1}" }),
                /* @__PURE__ */ jsxs67("span", { className: "ui-text-yeah", children: [
                  agent.config.dataset.length,
                  "\u4E2A\u4E13\u4E1A\u6587\u6863"
                ] })
              ] }) : null,
              ((_p = (_o = (_n = agent.config) == null ? void 0 : _n.database) == null ? void 0 : _o.table_list) == null ? void 0 : _p.length) ? /* @__PURE__ */ jsxs67("li", { className: "ui-flex ui-items-center ui-px-[16px] ui-pb-[16px]", children: [
                /* @__PURE__ */ jsx114("span", { className: "ui-w-[24px] ui-h-[24px] ui-mr-[8px] ui-bg-linear-8 ui-text-[14px]/[24px] ui-text-center ui-rounded-[6px]", children: "\u{1F4CA}" }),
                /* @__PURE__ */ jsxs67("span", { className: "ui-text-yeah", children: [
                  agent.config.database.table_list.length,
                  "\u4E2A\u6570\u636E\u5E93\u8868"
                ] })
              ] }) : null
            ] })
          ] }),
          !!wechatApp && /* @__PURE__ */ jsxs67("section", { className: "ui-mt-[16px] ui-bg-white ui-rounded-lg", children: [
            renderSectionHeader("Agent Go", /* @__PURE__ */ jsx114(SvgAgentgo, {})),
            /* @__PURE__ */ jsx114("div", { className: "ui-mt-[8px] ui-px-[16px] ui-pb-[16px]" })
          ] })
        ] })
      ]
    }
  );
}

// src/agent-profile/AgentProfilePopup.tsx
import { cn as cn47 } from "@bty/util";
import { jsx as jsx115 } from "react/jsx-runtime";
function AgentProfilePopup({
  open,
  onClose,
  children
}) {
  const { layoutMode } = useChatLayoutMode();
  return layoutMode === "mobile" ? /* @__PURE__ */ jsx115(
    Popup_default,
    {
      open,
      onClose,
      bodyStyle: { backgroundColor: "rgb(247, 247, 250)", minHeight: "60vh" },
      children
    }
  ) : /* @__PURE__ */ jsx115(
    "div",
    {
      className: cn47(
        "ui-w-[300px] ui-h-full ui-shrink-0 ui-transition-[width]",
        !open ? "!ui-w-0 ui-overflow-hidden" : ""
      ),
      children
    }
  );
}

// src/powered-by/PoweredBy.tsx
import { cn as cn48 } from "@bty/util";
import { jsx as jsx116, jsxs as jsxs68 } from "react/jsx-runtime";
function PoweredBy({ className }) {
  return /* @__PURE__ */ jsxs68(
    "p",
    {
      className: cn48(
        "ui-text-yeah-light ui-text-[14px] ui-cursor-pointer ui-flex ui-justify-center ui-items-center",
        className
      ),
      onClick: () => window.open("https://www.betteryeah.com/"),
      children: [
        /* @__PURE__ */ jsx116(
          "img",
          {
            className: "ui-h-[18px] ui-w-[18px] ui-inline-block ui-mr-[3.5px]",
            src: "https://resource.bantouyan.com/battleyeah-ai/chat-mobile/powered-by-betteryeah.svg",
            alt: ""
          }
        ),
        "Powered by BetterYeah"
      ]
    }
  );
}

// src/bot-list/BotList.tsx
import { memo as memo13, useMemo as useMemo18, useState as useState23 } from "react";
import { groupBy, isNull, isUndefined as isUndefined2 } from "lodash-es";
import { cn as cn51 } from "@bty/util";

// src/hooks/useScrollbar.ts
import { useEffect as useEffect16, useRef as useRef19 } from "react";
import Scrollbar4 from "smooth-scrollbar";
function useScrollBar(options) {
  const scrollRef = useRef19(null);
  const scrollBar = useRef19();
  const init = () => {
    if (scrollRef.current) {
      scrollBar.current = Scrollbar4.init(
        scrollRef.current,
        Object.assign(
          {
            damping: 0.5
          },
          options
        )
      );
    }
  };
  useEffect16(init, [scrollRef.current]);
  return {
    scrollBar,
    scrollRef
  };
}

// src/bot-list/SingleGroupBotList.tsx
import { useBoolean as useBoolean2 } from "ahooks";
import { memo as memo12 } from "react";
import { cn as cn50 } from "@bty/util";

// src/bot-list/BotItem.tsx
import { memo as memo11, useRef as useRef20 } from "react";
import useMemoizedFn2 from "ahooks/es/useMemoizedFn";
import { useBoolean, useClickAway as useClickAway4, useHover as useHover2 } from "ahooks";
import { cn as cn49 } from "@bty/util";
import { jsx as jsx117, jsxs as jsxs69 } from "react/jsx-runtime";
var BotItem = memo11(
  ({
    label,
    selected,
    icon,
    color,
    value,
    notificationCount,
    hoverStyle,
    selectedStyle,
    pined,
    onClick,
    onPinedChange,
    onRemove
  }) => {
    const ref = useRef20(null);
    const handleClick = useMemoizedFn2(() => {
      onClick == null ? void 0 : onClick(value);
    });
    const handlePinedChange = useMemoizedFn2(() => {
      onPinedChange == null ? void 0 : onPinedChange(value, pined ? "cancel" : "pin");
    });
    const handleRemove = useMemoizedFn2(() => {
      onRemove == null ? void 0 : onRemove(value);
    });
    const isHover = useHover2(ref);
    const [popoverVisible, { toggle, setFalse: hidePopover }] = useBoolean(false);
    useClickAway4(hidePopover, ref);
    return /* @__PURE__ */ jsxs69(
      "div",
      {
        ref,
        style: selected ? selectedStyle : isHover ? hoverStyle : void 0,
        onClick: handleClick,
        className: cn49(
          "ui-box-border ui-p-[7px] ui-flex ui-items-center ui-justify-between ui-h-[46px] ui-rounded-lg hover:ui-bg-[#626999]/[0.08]",
          {
            "ui-bg-[#7b61ff]/[0.08]": selected
          }
        ),
        children: [
          /* @__PURE__ */ jsxs69("div", { className: "ui-flex ui-items-center ui-flex-1 ui-overflow-hidden ui-select-none", children: [
            /* @__PURE__ */ jsx117(
              AppLogo,
              {
                value: icon || "",
                color,
                type: "emoji",
                size: 30,
                className: "ui-rounded-full",
                fillSize: 12
              }
            ),
            /* @__PURE__ */ jsxs69("div", { className: "ui-truncate ui-ml-[7px] ui-text-[14px]", children: [
              " ",
              label
            ] })
          ] }),
          !!notificationCount && !isHover && !popoverVisible && /* @__PURE__ */ jsx117("div", { className: "ui-w-[16px] ui-text-[12px] ui-rounded-full ui-h-[16px] ui-bg-[#ff5219] ui-flex ui-items-center ui-justify-center ui-text-white", children: notificationCount }),
          /* @__PURE__ */ jsxs69(Popover, { open: popoverVisible, children: [
            /* @__PURE__ */ jsx117(
              PopoverContent,
              {
                className: "!ui-p-0 !ui-border-0 ui-ml-[-104px]",
                style: { outline: "none" },
                children: /* @__PURE__ */ jsxs69("div", { className: "ui-bg-white ui-min-w-[126px] ui-py-[4px] ui-px-[4px] ui-rounded-[8px] ui-text-[#17171d] ui-shadow-[0px_8px_24px_0px_rgba(0,0,0,0.2)] ui-backdrop-blur-lg ui-cursor-pointer", children: [
                  /* @__PURE__ */ jsx117(
                    "div",
                    {
                      className: "ui-h-[36px] ui-rounded-[8px] ui-px-[10px] ui-flex ui-items-center hover:ui-bg-[#626999]/[0.08] ui-text-[14px]",
                      onClick: handlePinedChange,
                      children: pined ? "\u53D6\u6D88\u7F6E\u9876" /* PINED_TEXT */ : "\u7F6E\u9876" /* UNPIN_TEXT */
                    }
                  ),
                  /* @__PURE__ */ jsx117(
                    "div",
                    {
                      className: "ui-text-[#FF5219] ui-rounded-[8px] ui-text-[14px] ui-px-[10px] ui-h-[36px] ui-flex ui-items-center hover:ui-bg-[#626999]/[0.08]",
                      onClick: handleRemove,
                      children: "\u79FB\u9664"
                    }
                  )
                ] })
              }
            ),
            /* @__PURE__ */ jsx117(PopoverTrigger, { className: "ui-border-0 ui-border-none", children: /* @__PURE__ */ jsx117(
              "div",
              {
                className: cn49(
                  "ui-w-[24px] ui-h-[24px] ui-rounded-[6px] ui-flex ui-items-center ui-justify-center  hover:ui-bg-[#626999] hover:ui-bg-opacity-[0.12]",
                  {
                    "ui-block": isHover || popoverVisible,
                    "ui-hidden": !isHover && !popoverVisible
                  }
                ),
                children: /* @__PURE__ */ jsx117(
                  SvgMore,
                  {
                    onClick: (e) => {
                      e.stopPropagation();
                      toggle();
                    },
                    className: cn49({
                      "ui-block": isHover || popoverVisible,
                      "ui-hidden": !isHover && !popoverVisible
                    })
                  }
                )
              }
            ) })
          ] })
        ]
      }
    );
  }
);

// src/bot-list/SingleGroupBotList.tsx
import { jsx as jsx118, jsxs as jsxs70 } from "react/jsx-runtime";
var SingleGroupBotList = memo12(
  ({
    list = [],
    label,
    selectedId,
    initialCollapsed,
    filterValue,
    onChange,
    notificationMap,
    ...restActionProps
  }) => {
    const [collapsed, { toggle }] = useBoolean2(initialCollapsed);
    return /* @__PURE__ */ jsxs70("div", { className: "ui-cursor-pointer", children: [
      /* @__PURE__ */ jsxs70(
        "div",
        {
          className: "ui-h-[28px] ui-flex ui-items-center ui-justify-between ui-text-[14px] ui-text-[#8D8D99]  ui-mb-[7px]",
          onClick: toggle,
          children: [
            /* @__PURE__ */ jsx118("div", { className: "ui-select-none", children: label }),
            /* @__PURE__ */ jsx118(
              SvgArrowDown,
              {
                className: cn50("ui-text-[24px] ui-scale-125 ui-mr-[10.5px]", {
                  "ui-rotate-180": !collapsed
                })
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx118(
        "div",
        {
          className: cn50(
            "ui-flex ui-flex-col ui-gap-[7px] ui-transition-[height] ui-overflow-hidden",
            {
              "ui-h-0": collapsed,
              "ui-h-auto": !collapsed
            }
          ),
          children: list.filter(
            (v) => {
              var _a, _b;
              return filterValue ? (_b = (_a = v.label) == null ? void 0 : _a.toLocaleLowerCase()) == null ? void 0 : _b.includes(filterValue == null ? void 0 : filterValue.toLocaleLowerCase()) : true;
            }
          ).map((item) => /* @__PURE__ */ jsx118(
            BotItem,
            {
              ...item,
              pined: label === "\u7F6E\u9876" /* UNPIN_TEXT */,
              selected: item.value === selectedId,
              onClick: onChange,
              notificationCount: notificationMap == null ? void 0 : notificationMap[item.value],
              ...restActionProps
            },
            item.value
          ))
        }
      )
    ] });
  }
);

// src/bot-list/BotList.tsx
import { jsx as jsx119, jsxs as jsxs71 } from "react/jsx-runtime";
var groupPriority = {
  ["\u7F6E\u9876" /* UNPIN_TEXT */]: -1,
  \u6700\u8FD1\u4F7F\u7528: 1
};
var BotList = memo13(
  ({
    rootClassName,
    list,
    selectedId: _selectedId,
    className,
    prefix,
    filterValue,
    hideSearch,
    ...restActionProps
  }) => {
    var _a, _b, _c;
    const groupedList = useMemo18(
      () => groupBy(
        (list || []).filter(
          (v) => {
            var _a2;
            return filterValue ? (_a2 = v.label) == null ? void 0 : _a2.includes(filterValue) : true;
          }
        ),
        "group"
      ),
      [list, filterValue]
    );
    const { scrollRef } = useScrollBar();
    const [searchValue, setSearchValue] = useState23("");
    const sortedGroupList = useMemo18(
      () => Object.entries(groupedList).sort((a) => groupPriority[a[0]]),
      [groupedList]
    );
    const selectedId = _selectedId || `${(_c = (_b = (_a = sortedGroupList == null ? void 0 : sortedGroupList[0]) == null ? void 0 : _a[1]) == null ? void 0 : _b[0]) == null ? void 0 : _c.value}`;
    return /* @__PURE__ */ jsxs71("div", { className: cn51("ui-h-full ui-flex ui-flex-col", rootClassName), children: [
      isUndefined2(prefix) ? /* @__PURE__ */ jsx119("div", { className: "ui-relative ui-pt-[26px] ui-pb-[16px] ui-px-[28px] ui-text-[16px] ui-font-600 ui-cursor-pointer", children: "\u5BF9\u8BDD" }) : isNull(prefix) ? null : prefix,
      /* @__PURE__ */ jsx119("div", { className: "ui-flex ui-w-full ui-px-[16px] ui-pb-[16px]", children: !hideSearch && /* @__PURE__ */ jsx119(
        Input,
        {
          className: "ui-flex-1 !ui-h-[32px]",
          placeholder: "\u641C\u7D22 agent",
          value: searchValue,
          onChange: (e) => setSearchValue(e.target.value)
        }
      ) }),
      /* @__PURE__ */ jsxs71(
        "div",
        {
          ref: scrollRef,
          className: cn51(
            "ui-flex-1 ui-box-border ui-relative ui-h-full ui-overflow-y-auto ui-overflow-x-hidden",
            className
          ),
          children: [
            /* @__PURE__ */ jsx119("div", { className: "ui-absolute ui-left-0 ui-top-0 ui-w-full ui-h-full ui-z-1" }),
            /* @__PURE__ */ jsx119("div", { className: "ui-absolute ui-left-0 ui-top-0 ui-w-full ui-h-full ui-z-10", children: /* @__PURE__ */ jsx119("div", { className: "ui-flex ui-flex-col ui-gap-[17.5px] ui-px-[20px] ", children: sortedGroupList.map(([label, _list]) => /* @__PURE__ */ jsx119(
              SingleGroupBotList,
              {
                label,
                initialCollapsed: false,
                selectedId,
                filterValue: searchValue,
                list: _list,
                ...restActionProps
              },
              label
            )) }) })
          ]
        }
      )
    ] });
  }
);

// src/welcome/Welcome.tsx
import { memo as memo14 } from "react";
import { cn as cn52 } from "@bty/util";
import { jsx as jsx120, jsxs as jsxs72 } from "react/jsx-runtime";
var columnsCount = 2;
var Welcome = memo14((props) => {
  const { avatar, title, welcomeMessage, quickQuestions, onQuestionSend } = props;
  return /* @__PURE__ */ jsx120("div", { className: "ui-w-full ui-h-full ui-pt-[90px] ui-min-h-fit ui-overflow-auto ui-text-[14px]", children: /* @__PURE__ */ jsxs72("div", { className: "ui-max-w-[900px] ui-px-[46px] ui-h-full ui-of-auto ui-mx-auto ui-text-center", children: [
    /* @__PURE__ */ jsx120(
      "img",
      {
        src: avatar,
        alt: "",
        className: "ui-w-[100px] ui-h-[100px] ui-rounded-full ui-inline-block"
      }
    ),
    /* @__PURE__ */ jsx120("h3", { className: "ui-text-[18px] ui-font-600 ui-mt-[16px]", children: title }),
    (welcomeMessage == null ? void 0 : welcomeMessage.trim()) && /* @__PURE__ */ jsx120("p", { className: "ui-font-400 ui-leading-[21px] ui-mt-[16px]", children: welcomeMessage }),
    /* @__PURE__ */ jsx120("div", { className: "ui-flex ui-gap-[8px] ui-mt-[16px] ui-w-full ui-pb-[20px] ui-justify-center ui-flex-col", children: quickQuestions.length <= 5 ? quickQuestions.map((item, index) => {
      return /* @__PURE__ */ jsx120(
        QuestionItem,
        {
          onClick: () => onQuestionSend == null ? void 0 : onQuestionSend(item),
          content: item
        },
        `agent-quick-question-${index}-${item}`
      );
    }) : (
      // 分栏瀑布流
      new Array(columnsCount).fill(null).map((_, columnIndex) => {
        const columns = quickQuestions.filter(
          (_2, questionIndex) => questionIndex % columnsCount === columnIndex
        );
        return /* @__PURE__ */ jsx120(
          "div",
          {
            className: "ui-flex ui-flex-col ui-gap-[8px] flex-1",
            children: columns.map((item, index) => /* @__PURE__ */ jsx120(
              QuestionItem,
              {
                onClick: () => onQuestionSend == null ? void 0 : onQuestionSend(item),
                content: item
              },
              `agent-quick-question-${columnIndex}-${index}-${item}`
            ))
          },
          `question-row-${columnIndex}`
        );
      })
    ) })
  ] }) });
});
function QuestionItem(props) {
  return /* @__PURE__ */ jsxs72(
    "div",
    {
      onClick: props.onClick,
      className: cn52(
        "ui-text-left ui-flex ui-items-center ui-px-[12px] ui-py-[13.5px] ui-bg-[#fff]",
        "[&_img]:ui-block [&_img]:ui-h-[80px] [&_.rc-image-wrap]:ui-block [&_img]:ui-w-auto ",
        "ui-border-[#e7e7ea] ui-border-[1px] ui-rounded-[12px]",
        "ui-cursor-pointer ui-box-border ui-leading-[21px] [&_*]:ui-leading-[21px] hover:ui-bg-[rgba(98,105,153,0.08)]",
        props.className
      ),
      children: [
        /* @__PURE__ */ jsx120(
          MarkdownMessage,
          {
            className: "ui-flex-1",
            content: props.content,
            imagePreview: false,
            cursor: false
          }
        ),
        /* @__PURE__ */ jsx120(SvgRightArrow, { className: "ui-ml-[28px] ui-shrink-0 ui-text-yeah-primary" })
      ]
    }
  );
}

// src/components/TaskPopup.tsx
import { cloneElement as cloneElement2 } from "react";
import { cn as cn53 } from "@bty/util";
import { jsx as jsx121 } from "react/jsx-runtime";
function TaskPopup({ open, onClose, children }) {
  const { layoutMode } = useChatLayoutMode();
  const childrenWithProps = open && children ? cloneElement2(children, {
    ...(children == null ? void 0 : children.props) || {},
    layout: layoutMode,
    onClose: () => {
      var _a, _b;
      ;
      (_b = (_a = children == null ? void 0 : children.props) == null ? void 0 : _a.onClose) == null ? void 0 : _b.call(_a);
      onClose == null ? void 0 : onClose();
    }
  }) : null;
  return layoutMode === "mobile" ? /* @__PURE__ */ jsx121(
    Popup_default,
    {
      open,
      onClose,
      hideCloseIcon: true,
      bodyStyle: { minHeight: "70%" },
      children: childrenWithProps
    }
  ) : /* @__PURE__ */ jsx121(
    "div",
    {
      className: cn53(
        "ui-shrink-0 ui-transition-[width] ui-overflow-hidden ui-border-left after:ui-border-l-line after:ui-border-opacity-[0.6]",
        {
          "!ui-w-0": !open,
          "ui-w-[380px]": open
        }
      ),
      children: childrenWithProps
    }
  );
}

// src/chat/Chat.tsx
import { jsx as jsx122, jsxs as jsxs73 } from "react/jsx-runtime";
var Chat = forwardRef16((props, ref) => {
  var _a, _b;
  const {
    staticPreview = false,
    agent,
    features,
    conversationList,
    showPlaceholder = false,
    showWelcome = true,
    // hiddenPadding = false,
    messageHistoryLoading,
    data = [],
    placeholder,
    inputValue,
    toolComponent,
    generating,
    fileAction,
    fileHeaders,
    fileParams,
    onInputChange,
    title = "",
    disabled = false,
    background = "rgba(247, 247, 250, 0.6)",
    actions = [],
    botList = [],
    botId,
    inputTips,
    paddingX: _paddingX,
    loggerComponent: LoggerComponent,
    shortcuts: shortcuts2,
    uniqueId,
    headerProps = {},
    inputProps = {},
    agentProfileProps = {},
    // conversationId,
    onBeforeSubmit,
    onSubmit,
    onInputActionClick,
    onMessageActionClick,
    onMessageTaskClick,
    onBotChange,
    onBotPinedChange,
    onBotRemove,
    // onMessageToolClick,
    onLoadMore,
    onBeforeFileUpload,
    onFileFail,
    onFileOK,
    onHrefTagClick,
    enabledSkills,
    onQuestionSend,
    onVariableSubmit,
    variableConfigs,
    defaultVariableValue,
    onRelatedQuestionsToggle,
    onConversationClick,
    onConversationCreate,
    onConversationUpdate,
    onConversationDelete,
    unReadMessageConversationCountMap,
    onFileUpload,
    hiddenVarModal = false,
    formMessageConfig,
    uploadFileConfig,
    pluginItemOnMessageRender,
    taskInfo,
    dislikeOnMessageRender
  } = props;
  const [variableModalOpen, setVariableModalOpen] = useState24(false);
  const messageListRef = useRef21(null);
  const messageInputRef = useRef21(null);
  const messageInputContainerRef = useRef21(null);
  const [flowLoggerVisible, setFlowLoggerVisible] = useState24(false);
  const [dialogConfig, setDialogConfig] = useState24({
    open: false,
    url: "",
    type: ""
  });
  const allowLogger = useMemo19(() => {
    return !isNil3(LoggerComponent);
  }, [LoggerComponent]);
  const fileAccept = useMemo19(() => {
    const ACCEPT_FILE_TYPE2 = [".txt", ".pdf", ".doc", ".docx"];
    if (uploadFileConfig == null ? void 0 : uploadFileConfig.acceptsAllFileTypes) {
      return ["*"];
    }
    return (uploadFileConfig == null ? void 0 : uploadFileConfig.fileAccepts) || ACCEPT_FILE_TYPE2;
  }, [uploadFileConfig]);
  const [agentProfileCollapsed, setAgentProfileCollapsed] = useState24(true);
  const [taskCollapsed, setTaskCollapsed] = useState24(false);
  useImperativeHandle6(ref, () => {
    var _a2, _b2;
    return {
      list: messageListRef.current,
      input: (_a2 = messageInputRef.current) == null ? void 0 : _a2.input,
      setFile: (_b2 = messageInputRef.current) == null ? void 0 : _b2.setFile,
      modal: {
        showVariableModal: () => setVariableModalOpen(true),
        hideVariableModal: () => setVariableModalOpen(false)
      },
      hideAgentProfile: () => setAgentProfileCollapsed(true),
      showTask: () => setTaskCollapsed(true)
    };
  }, [messageListRef.current, messageInputRef.current]);
  const containerRef = useRef21(null);
  const { paddingX } = useChatLayout({
    ref: containerRef,
    fixedPadding: _paddingX
  });
  const [task, setTask] = useState24({});
  const { layoutMode } = useChatLayoutMode();
  const handleMessageTaskClick = (task2) => {
    if (task2.status === "loading") {
      return;
    }
    setFlowLoggerVisible(true);
    setTask(task2);
  };
  useKeyPress3("esc", () => {
    setDialogConfig({ ...dialogConfig, open: false });
  });
  const [conversationListCollapsed, setConversationListCollapsed] = useState24(
    !localStorage.getItem("conversationListCollapsed")
  );
  const currentConversation = (features == null ? void 0 : features.conversationList) ? conversationList == null ? void 0 : conversationList.find((el) => el.conversation_id === uniqueId) : void 0;
  useEffect17(() => {
    if ((features == null ? void 0 : features.conversationList) && layoutMode === "mobile") {
      setConversationListCollapsed(true);
    }
  }, [layoutMode]);
  return /* @__PURE__ */ jsxs73(
    "div",
    {
      className: clsx3("ui-w-full ui-h-full", {
        "ui-flex": features == null ? void 0 : features.botList
      }),
      children: [
        (features == null ? void 0 : features.botList) && /* @__PURE__ */ jsx122("div", { className: "ui-border-r-[rgba(225,225,229,0.6)] ui-border-r-[1px]", children: /* @__PURE__ */ jsx122(
          BotList,
          {
            selectedId: botId,
            ...props.botListProps,
            list: botList,
            className: "ui-w-[266px] ui-shrink-0",
            onChange: onBotChange,
            onPinedChange: onBotPinedChange,
            onRemove: onBotRemove
          }
        ) }),
        /* @__PURE__ */ jsxs73(
          "div",
          {
            className: clsx3("ui-w-full ui-h-full ui-relative", {
              "ui-flex": (features == null ? void 0 : features.agentProfile) || (features == null ? void 0 : features.conversationList)
            }),
            style: { backgroundColor: background },
            children: [
              /* @__PURE__ */ jsxs73("div", { className: "ui-w-full ui-h-full ui-bg-opacity-60 ui-flex ui-flex-col ui-relative", children: [
                (features == null ? void 0 : features.header) && (title || /* @__PURE__ */ jsx122(
                  ChatHeader,
                  {
                    ...headerProps,
                    icon: agent == null ? void 0 : agent.icon,
                    title: agent == null ? void 0 : agent.name,
                    collapsed: {
                      bot: agentProfileCollapsed,
                      newConversation: !!features.conversationList,
                      history: features.conversationList === true ? conversationListCollapsed : false,
                      task: taskCollapsed
                    },
                    onCollapse: (type, collapsed) => {
                      var _a2;
                      (_a2 = headerProps == null ? void 0 : headerProps.onCollapse) == null ? void 0 : _a2.call(headerProps, type, collapsed);
                      if (type === "bot") {
                        setTaskCollapsed(false);
                        setAgentProfileCollapsed(collapsed);
                        return;
                      }
                      if (type === "history") {
                        setConversationListCollapsed(collapsed);
                      }
                      if (type === "newConversation") {
                        onConversationCreate == null ? void 0 : onConversationCreate();
                      }
                      if (type === "task") {
                        setTaskCollapsed(false);
                        setTaskCollapsed(collapsed);
                      }
                    }
                  }
                )),
                /* @__PURE__ */ jsxs73("div", { className: "ui-flex ui-flex-1 ui-overflow-hidden", children: [
                  (features == null ? void 0 : features.conversationList) && /* @__PURE__ */ jsx122(
                    ConversationListPopup,
                    {
                      open: !conversationListCollapsed,
                      onClose: () => {
                        setConversationListCollapsed(!conversationListCollapsed);
                      },
                      children: /* @__PURE__ */ jsx122(
                        ConversationList,
                        {
                          className: "ui-w-full ui-h-full",
                          onCreate: () => {
                            onConversationCreate == null ? void 0 : onConversationCreate();
                            setConversationListCollapsed(!conversationListCollapsed);
                          },
                          unReadMessageConversationCountMap,
                          layout: layoutMode,
                          collapsed: conversationListCollapsed,
                          currentConversation,
                          conversations: conversationList,
                          onCollapse: setConversationListCollapsed,
                          onConversationClick: (id) => {
                            onConversationClick == null ? void 0 : onConversationClick(id);
                            layoutMode === "mobile" && setConversationListCollapsed(true);
                          },
                          onConversationEdit: (action, value) => {
                            if (action === "create") {
                              onConversationCreate == null ? void 0 : onConversationCreate();
                              return;
                            }
                            if (action === "update") {
                              onConversationUpdate == null ? void 0 : onConversationUpdate(value.id, value.name);
                              return;
                            }
                            if (action === "delete") {
                              onConversationDelete == null ? void 0 : onConversationDelete(value.id);
                            }
                          }
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ jsxs73("div", { className: "ui-w-full ui-flex ui-flex-col ui-relative ui-min-w-0", children: [
                    !hiddenVarModal && !!(variableConfigs == null ? void 0 : variableConfigs.length) && /* @__PURE__ */ jsx122(
                      VariableModal,
                      {
                        open: variableModalOpen,
                        defaultValue: defaultVariableValue,
                        variableConfigs,
                        onClose: () => setVariableModalOpen(false),
                        onSubmit: onVariableSubmit,
                        container: containerRef.current
                      }
                    ),
                    showPlaceholder ? /* @__PURE__ */ jsx122("div", { className: "ui-h-full ui-w-full ui-flex-center", children: /* @__PURE__ */ jsx122("div", { className: "ui-text-yeah-light-60", children: placeholder }) }) : /* @__PURE__ */ jsxs73(
                      "div",
                      {
                        className: "ui-w-full ui-h-full ui-flex-1 ui-overflow-hidden ui-relative",
                        ref: containerRef,
                        children: [
                          !messageHistoryLoading && !data.length && agent && showWelcome && /* @__PURE__ */ jsx122(
                            Welcome,
                            {
                              avatar: agent.icon,
                              title: agent.name,
                              onQuestionSend,
                              welcomeMessage: agent.welcome_message,
                              quickQuestions: ((_b = (_a = agent.config) == null ? void 0 : _a.rule) == null ? void 0 : _b.question_guide) ?? []
                            }
                          ),
                          /* @__PURE__ */ jsx122(
                            OriginMessageList,
                            {
                              initialNotScroll: staticPreview,
                              allowLogger,
                              ref: messageListRef,
                              data,
                              paddingX,
                              toolComponent,
                              generating,
                              uniqueId,
                              onMessageActionClick,
                              onMessageToolClick: handleMessageTaskClick,
                              onMessageTaskClick,
                              onHrefTagClick,
                              pluginItemOnMessageRender,
                              dislikeOnMessageRender,
                              onLoadMore,
                              onRegenerate: () => {
                                onInputActionClick == null ? void 0 : onInputActionClick("regenerate");
                              },
                              onQuestionSend,
                              onFileClick: (data2) => {
                                setDialogConfig({ ...data2, open: true });
                              },
                              onFileUpload,
                              onRelatedQuestionsToggle,
                              formMessageConfig
                            }
                          )
                        ]
                      }
                    ),
                    !staticPreview && !showPlaceholder && /* @__PURE__ */ jsx122(
                      "div",
                      {
                        ref: messageInputContainerRef,
                        className: "ui-flex ui-justify-center ui-items-center ui-box-border ",
                        style: { padding: `0 ${paddingX}px 20px` },
                        children: /* @__PURE__ */ jsx122("div", { className: "ui-w-full ui-relative", children: /* @__PURE__ */ jsx122(
                          MessageInput_default,
                          {
                            ...inputProps,
                            ref: messageInputRef,
                            className: "ui-w-full",
                            generating,
                            actions,
                            inputTips,
                            shortcuts: shortcuts2,
                            disabled,
                            value: inputValue,
                            fileAction,
                            prefix: layoutMode === "mobile" && /* @__PURE__ */ jsx122(
                              SvgListMobile,
                              {
                                className: "ui-cursor-pointer ui-w-[14px]",
                                onClick: () => {
                                  var _a2;
                                  (_a2 = headerProps == null ? void 0 : headerProps.onCollapse) == null ? void 0 : _a2.call(headerProps, "history", false);
                                  setConversationListCollapsed(false);
                                }
                              }
                            ),
                            fileHeaders,
                            fileParams,
                            fileAccept,
                            onChange: onInputChange,
                            onBeforeSubmit,
                            onSubmit,
                            onActionClick: onInputActionClick,
                            onBeforeFileUpload,
                            onFileFail,
                            onFileOK,
                            enabledSkills,
                            onFileUpload,
                            onCreateConversation: onConversationCreate,
                            uploadFileConfig
                          }
                        ) })
                      }
                    ),
                    (features == null ? void 0 : features.showPoweredBy) && /* @__PURE__ */ jsx122(PoweredBy, { className: "ui-mt-0 ui-mb-[20px]" })
                  ] })
                ] })
              ] }),
              (features == null ? void 0 : features.agentProfile) && /* @__PURE__ */ jsx122(
                AgentProfilePopup,
                {
                  open: !agentProfileCollapsed,
                  onClose: () => setAgentProfileCollapsed(!agentProfileCollapsed),
                  children: /* @__PURE__ */ jsx122(
                    AgentProfile,
                    {
                      ...agentProfileProps,
                      hideCloseButton: layoutMode === "mobile",
                      className: cn54("ui-h-full", {
                        "!ui-pt-0": layoutMode === "mobile"
                      }),
                      agent: typeof features.agentProfile === "object" && features.agentProfile.workspace === false ? omit(agent, "workspace_name") : agent,
                      collapsed: agentProfileCollapsed,
                      onCollapse: setAgentProfileCollapsed
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx122(TaskPopup, { open: taskCollapsed, onClose: () => setTaskCollapsed(false), children: taskInfo }),
              /* @__PURE__ */ jsx122(Dialog, { modal: true, open: dialogConfig.open, children: /* @__PURE__ */ jsxs73(
                DialogContent,
                {
                  close: null,
                  onMaskClick: () => {
                    setDialogConfig({ ...dialogConfig, open: false });
                  },
                  className: "ui-overflow-auto !ui-w-[90vw] !ui-max-w-[100vw] !ui-h-[90%] ui-p-[0px] ui-border-[0px]",
                  children: [
                    /* @__PURE__ */ jsx122(
                      "div",
                      {
                        className: "ui-absolute ui-right-[12px] ui-top-[12px] ui-z-[99] ui-cursor-pointer",
                        onClick: () => {
                          setDialogConfig({ ...dialogConfig, open: false });
                        },
                        children: /* @__PURE__ */ jsx122(SvgClose2, {})
                      }
                    ),
                    /* @__PURE__ */ jsx122(
                      FilePreview,
                      {
                        url: dialogConfig.url,
                        mimetype: dialogConfig.type
                      }
                    )
                  ]
                }
              ) })
            ]
          }
        ),
        flowLoggerVisible && LoggerComponent && /* @__PURE__ */ jsx122(
          LoggerComponent,
          {
            onClose: () => setFlowLoggerVisible(false),
            task,
            title: task == null ? void 0 : task.title,
            status: task == null ? void 0 : task.status
          }
        ),
        /* @__PURE__ */ jsx122(Toaster, {})
      ]
    }
  );
});

// src/chat/Message.tsx
import "@bty/ui-components/dist/index.css";
import { forwardRef as forwardRef17, useState as useState25 } from "react";
import { FilePreview as FilePreview2 } from "@bty/ui-components";
import { useKeyPress as useKeyPress4, useMemoizedFn as useMemoizedFn3 } from "ahooks";
import { jsx as jsx123, jsxs as jsxs74 } from "react/jsx-runtime";
var ChatMessage = forwardRef17(
  (props, ref) => {
    const {
      uniqueId,
      paddingX,
      data,
      generating,
      toolComponent,
      loggerComponent: LoggerComponent,
      onRegenerate,
      onHrefTagClick,
      onMessageActionClick,
      onQuestionSend,
      onLoadMore,
      onRelatedQuestionsToggle,
      formMessageConfig,
      pluginItemOnMessageRender,
      dislikeOnMessageRender
    } = props;
    const [flowLoggerVisible, setFlowLoggerVisible] = useState25(false);
    const [dialogConfig, setDialogConfig] = useState25({
      open: false,
      url: "",
      type: ""
    });
    const [task, setTask] = useState25({});
    const handleMessageTaskClick = useMemoizedFn3((task2) => {
      if (task2.status === "loading") {
        return;
      }
      setFlowLoggerVisible(true);
      setTask(task2);
    });
    const handleDialogOpen = useMemoizedFn3((data2) => {
      setDialogConfig({ ...data2, open: true });
    });
    const handleDialogClose = useMemoizedFn3(() => {
      setDialogConfig({ ...dialogConfig, open: false });
    });
    useKeyPress4("esc", handleDialogClose);
    return /* @__PURE__ */ jsxs74("div", { className: "ui-w-full ui-h-full ui-flex-1 ui-overflow-hidden ui-relative", children: [
      /* @__PURE__ */ jsx123(
        OriginMessageList,
        {
          ref,
          paddingX,
          uniqueId,
          data,
          generating,
          toolComponent,
          onMessageActionClick,
          onMessageToolClick: handleMessageTaskClick,
          onHrefTagClick,
          onLoadMore,
          onRegenerate,
          onQuestionSend,
          onFileClick: handleDialogOpen,
          onRelatedQuestionsToggle,
          formMessageConfig,
          pluginItemOnMessageRender,
          dislikeOnMessageRender
        }
      ),
      /* @__PURE__ */ jsx123(Dialog, { modal: true, open: dialogConfig.open, children: /* @__PURE__ */ jsxs74(
        DialogContent,
        {
          close: null,
          onMaskClick: handleDialogClose,
          className: "ui-overflow-auto !ui-w-[90vw] !ui-max-w-[100vw] !ui-h-[90%] ui-p-[0px] ui-border-[0px]",
          children: [
            /* @__PURE__ */ jsx123(
              "div",
              {
                className: "ui-absolute ui-right-[12px] ui-top-[12px] ui-z-[99] ui-cursor-pointer",
                onClick: () => {
                  setDialogConfig({ ...dialogConfig, open: false });
                },
                children: /* @__PURE__ */ jsx123(SvgClose2, {})
              }
            ),
            /* @__PURE__ */ jsx123(
              FilePreview2,
              {
                url: dialogConfig.url,
                mimetype: dialogConfig.type
              }
            )
          ]
        }
      ) }),
      flowLoggerVisible && LoggerComponent && /* @__PURE__ */ jsx123(
        LoggerComponent,
        {
          onClose: () => setFlowLoggerVisible(false),
          task,
          title: task == null ? void 0 : task.title,
          status: task == null ? void 0 : task.status
        }
      )
    ] });
  }
);
export {
  Avatar,
  BotList,
  Chat,
  ConversationList as ChatHistory,
  ConversationItem as ChatHistoryItem,
  ChatMessage,
  Message,
  MessageInput_default as MessageInput,
  MessageList,
  MessageSeparator,
  OriginMessageList,
  ToolBar,
  getFormItemComponentMap
};
